import { useEffect, useMemo, useState, useRef, useCallback, lazy, Suspense, Fragment } from "react";
import { toast } from "sonner";
import "@/App.css";
import "./tf_colors.css";
import axios from "axios";
import { LayoutDashboard, ReceiptText, WalletCards, Factory, Plus, Search, Printer, LogOut, X, Trash2, ChevronLeft, Eye, Copy, Pencil, Ban, ChevronDown, ChevronUp, Package, ArrowUp, ArrowDown, Settings, Users, AlertTriangle, Clock, CheckCircle2, PackageOpen, Wallet, Phone, Lock, ShoppingCart, Truck, AlertCircle, ChevronRight, Bell, UserX, Mail, ShieldCheck, Calendar, Upload, Workflow, Image as ImageIcon, User as UserIcon, Sliders, Layers, Palette, Ruler, Sun, Moon, Sparkles, Calculator, TrendingUp, TrendingDown, Star, FileDown, RefreshCw, Loader2 } from "lucide-react";
import { QRCodeSVG } from "qrcode.react";
import Barcode from "react-barcode";
import DatePickerID from "./date-picker-id";
import { ProductionDeadlineField, SEW_ROUTE } from "./offline_deadline";
import { TikTokConnectionCard } from "./tiktok_connection";
import { ProductionQueue } from "./production_queue";
import { DeadlineMiniChart } from "./production_queue";
import { MonitorThumb } from "./production_monitoring";
import { ProductionQueueAdminToko } from "./production_admin_toko";
import { StockModule } from "./stock";
import { ProductFilesPanel } from "./product_files";
import { MockupPreviewModal } from "./mockup_preview";
import { HistoryPanel } from "./history_panel";
import { AdminTokoSidebar, OWNER_MENU } from "./admin_sidebar";
import WarehousePage from "./warehouse_module";
import ShopeeModule from "./shopee_module";
import TokopediaPage from "./tokopedia_page";
import { useChannel, setChannel, TokopediaBanner, ChannelScope } from "./channel";
// Tim desainer marketplace → kanal yang boleh diakses (tab Shopee/Tokopedia tetap terpisah).
const MP_DESIGNER_TEAMS = { "Shopee": ["shopee"], "Tokopedia": ["tokopedia"], "Shopee + Tokopedia": ["shopee", "tokopedia"] };
import { SourceTab } from "./marketplace_brand";
import { getWithRetry, describeLoadError } from "./resilient_get";
import { OwnerControlCenter } from "./owner_control_center";
import { ProductionMonitoring } from "./production_monitoring";
import { HoldManagerPage } from "./hold_cancel_panel";
import { PeriodPicker, formatPeriodLabel } from "./period_picker";
import { Menu as MenuIcon } from "lucide-react";
import { MoreHorizontal } from "lucide-react";
import { STAGE_TEAM_LABEL, STAGE_DIVISION_LABEL } from "./production_config";
import { notify } from "./modal_center";
import { RepeatOrderBadge, RepeatOrderFields } from "./repeat_order";
import { NotaGroupPanel, NotaGroupSourcePicker, attachToSourceGroup, identityDiff } from "./nota_group";
import { BordirTasksPanel } from "./bordir_tasks";
import { BordirShiftSettings } from "./bordir_shift_settings";
import { computeAutoPrice, isAutoPriceEligible, priceSignature, autoPriceLabel, autoPriceNeedsSleeve, autoPriceNeedsDtfSize, DTF_SIZES, materialForProduct, sizeUpcharge, sizeUpchargeSummary, sleeveAddFor, extraPointRate } from "./pricing";
import { undoReverse, undoDeferred } from "./undo_bar";
import { AccountMenu, LOGOUT_CONFIRM } from "./account_menu";
import { MyMistakesButton } from "./my_mistakes";
import { canShowCompleteOverride, canShowOwnerAmbil } from "./offline_order_actions";
import { useAutoRefresh, RefreshIndicator, useDirtyGuard, useRefreshShortcut } from "./use_auto_refresh";
import { OperatorBordirPerformance } from "./bordir_operator_performance";
import { DesainPerformaPanel } from "./bordir_performance";
import { OwnerManualMenu } from "./owner_manual";
import AiEvalLab from "./ai_eval_lab/AiEvalLab";
import AiBetaPanel from "./ai_beta/AiBetaPanel";
import OrderNoCheckPanel from "./order_no_check/OrderNoCheckPanel";
const MarketplaceOrdersPage = lazyNamed(() => import("./marketplace_module"), "MarketplaceOrdersPage");
const CashClosingPage = lazyNamed(() => import("./cash_closing"), "CashClosingPage");
const WorkshopSettingsPage = lazyNamed(() => import("./workshop_settings"), "WorkshopSettingsPage");
const ScanNotaPage = lazy(() => import("./scan_nota"));
const ShopeeMockupMonitor = lazyNamed(() => import("./shopee_mockup_monitor"), "ShopeeMockupMonitor");
const ShopeeConnectionStatus = lazy(() => import("./shopee_connection_status"));
const PerformancePage = lazyNamed(() => import("./performance"), "PerformancePage");

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const PRODUCTS = ["Polo PE","Polo CVC","Polo CVC Custom","Polo CVC Kombinasi","Kaos Combed","Kemeja PDH","Kemeja PDL","Kemeja Kombinasi","Workshirt","Jersey","Jaket","Rompi","Topi","Topi Bucket","Bordir Satuan","DTF","Tambahan Kerah Jersey","Produk Lainnya"];
const SIZES = ["XS","S","M","L","XL","2XL","3XL","4XL","5XL","Custom"];
const PAYMENT_METHODS = ["Cash","QRIS","Debit","BCA CV","BCA Pribadi","BRI","Transfer Lainnya"];
const ACTIVE_WORK_STATUSES = ["Menunggu Pembayaran","Menunggu Desain","Menunggu Bahan","Diproses"];
const DONE_WORK_STATUSES = ["Selesai","Diambil","Dikirim"];
const ALL_WORK_STATUSES = [...ACTIVE_WORK_STATUSES, ...DONE_WORK_STATUSES];
const WORK_STATUS_ROLES = new Set(["owner","admin","produksi"]);
const money = value => new Intl.NumberFormat("id-ID", { style:"currency", currency:"IDR", maximumFractionDigits:0 }).format(Number(value)||0);
const moneyShort = value => {
  // Iter 66 — Format ringkas konsisten: "Rp4,1 jt" / "Rp1,2 M" / "Rp450 rb" / "Rp450".
  const v = Number(value) || 0;
  const fmt = (n, d=1) => n.toFixed(d).replace(".", ",").replace(/,0$/, "");
  if (Math.abs(v) >= 1e9) return "Rp" + fmt(v/1e9) + " M";
  if (Math.abs(v) >= 1e6) return "Rp" + fmt(v/1e6) + " jt";
  if (Math.abs(v) >= 1e3) return "Rp" + Math.round(v/1e3) + " rb";
  return "Rp" + Math.round(v);
};
const ID_MONTHS = ["Jan","Feb","Mar","Apr","Mei","Jun","Jul","Agu","Sep","Okt","Nov","Des"];
const fmtDateID = iso => {
  if (!iso) return "—";
  const s = String(iso).slice(0,10);
  const [y,m,d] = s.split("-");
  if (!y || !m || !d) return iso;
  return `${parseInt(d,10)} ${ID_MONTHS[parseInt(m,10)-1] || m} ${y}`;
};
const fmtDateTimeID = iso => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return `${fmtDateID(iso)} ${d.toLocaleTimeString("id-ID",{hour:"2-digit",minute:"2-digit",timeZone:"Asia/Jakarta"})}`;
  } catch { return iso; }
};
const localDate = () => new Intl.DateTimeFormat("en-CA", { timeZone:"Asia/Jakarta" }).format(new Date());
const localTime = () => new Intl.DateTimeFormat("id-ID", { timeZone:"Asia/Jakarta", hour:"2-digit", minute:"2-digit" }).format(new Date());
const fmtDT = iso => {
  if (!iso) return "—";
  try { return new Intl.DateTimeFormat("id-ID", { timeZone:"Asia/Jakarta", day:"2-digit", month:"short", year:"numeric", hour:"2-digit", minute:"2-digit" }).format(new Date(iso)) + " WIB"; }
  catch { return iso; }
};
const fmtDate = iso => {
  if (!iso) return "—";
  try { return new Intl.DateTimeFormat("id-ID", { timeZone:"Asia/Jakarta", day:"numeric", month:"long", year:"numeric" }).format(new Date(iso)); }
  catch { return iso; }
};
const dashVal = v => (v === 0 || v) ? v : "—";
const maskWA = wa => { const s = String(wa||""); return s.length > 6 ? `${s.slice(0,4)}••••${s.slice(-3)}` : s || "—"; };
// Hilangkan nol di depan pada input angka (mis. "0150000" -> "150000"); tetap izinkan "0" tunggal & string kosong
const stripZero = v => { const s = String(v ?? ""); if (s === "") return ""; if (/^0+$/.test(s)) return "0"; return s.replace(/^0+(?=\d)/, ""); };
const productTemplate = () => ({ _id: (typeof crypto !== "undefined" && crypto.randomUUID) ? crypto.randomUUID() : `p-${Date.now()}-${Math.random().toString(36).slice(2,9)}`, name:PRODUCTS[0], material:materialForProduct(PRODUCTS[0]), color:"", sleeve:"Tidak Berlaku", sizes:[{ size:"M", quantity:1 }], unit_price:0, discount:0, note:"", production_route:"", setting_fee:0, pricing_key:"", collar_model:"", collar_note:"" });
const paymentTemplate = () => ({ amount:0, method:"Cash", reference:"", note:"", proof:null });

// ===== Cetak via PDF (satu-satunya sumber cetak, sinkron dengan Unduh PDF) =====
const isMobileUA = () => /iPhone|iPad|iPod|Android/i.test(typeof navigator !== "undefined" ? navigator.userAgent : "");
async function printPdfFromUrl(url) {
  // Ambil PDF dengan cookie sesi
  const res = await fetch(url, { credentials: "include", cache: "no-store" });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const blob = await res.blob();
  const blobUrl = URL.createObjectURL(blob);
  const mobile = isMobileUA();
  if (mobile) {
    // Di HP, iframe.print() PDF sering diblokir. Buka di tab baru + petunjuk singkat.
    const w = window.open(blobUrl, "_blank");
    if (!w) {
      notify.warning({ title:"Popup diblokir browser", message:"Aktifkan popup lalu ulangi, atau gunakan menu Unduh PDF A5." });
      URL.revokeObjectURL(blobUrl);
      return { mode: "blocked" };
    }
    // Bersihkan URL setelah beberapa detik (dokumen sudah dimuat browser)
    setTimeout(() => { try { URL.revokeObjectURL(blobUrl); } catch {} }, 60000);
    return { mode: "mobile-tab" };
  }
  // Desktop: iframe tersembunyi, tunggu load, panggil print()
  return new Promise((resolve, reject) => {
    const iframe = document.createElement("iframe");
    iframe.style.position = "fixed"; iframe.style.right = "0"; iframe.style.bottom = "0";
    iframe.style.width = "0"; iframe.style.height = "0"; iframe.style.border = "0"; iframe.style.visibility = "hidden";
    iframe.setAttribute("aria-hidden", "true");
    let done = false;
    const cleanup = () => { try { document.body.removeChild(iframe); } catch {} try { URL.revokeObjectURL(blobUrl); } catch {} };
    const triggerPrint = () => {
      if (done) return; done = true;
      setTimeout(() => {
        try {
          iframe.contentWindow.focus();
          iframe.contentWindow.print();
          setTimeout(cleanup, 15000);
          resolve({ mode: "desktop-iframe" });
        } catch (e) {
          cleanup();
          const w = window.open(blobUrl, "_blank");
          if (w) resolve({ mode: "desktop-tab" }); else reject(e);
        }
      }, 400);
    };
    iframe.onload = triggerPrint;
    iframe.onerror = () => { done = true; cleanup(); reject(new Error("iframe load error")); };
    // Fallback: sebagian browser/headless tidak menembakkan onload untuk PDF blob → paksa setelah 3 detik
    setTimeout(triggerPrint, 3000);
    iframe.src = blobUrl;
    document.body.appendChild(iframe);
  });
}

// Iter 146 — Download PDF (Nota/SPK) via fetch dengan cookie sesi.
//   Sebelumnya: <a href="..."> — cookies HttpOnly kadang tidak diteruskan pada
//     new-window/new-tab (misal Safari, browser embedded), sehingga endpoint
//     mengembalikan JSON 401 dan browser menyimpannya sebagai file .pdf.
//   Sekarang: validasi HTTP status + Content-Type sebelum membuat blob. Jika
//     bukan application/pdf → tampilkan pesan jelas (bukan simpan JSON).
async function downloadPdfFromUrl(url, filename) {
  let res;
  try {
    res = await fetch(url, { credentials: "include", cache: "no-store", headers: { Accept: "application/pdf" } });
  } catch (err) {
    notify.error({ title: "Unduh PDF gagal", message: "Cek koneksi internet lalu coba lagi." });
    return false;
  }
  if (!res.ok) {
    let msg = "Gagal mengunduh PDF.";
    try {
      const clone = res.clone();
      const j = await clone.json();
      if (j && j.detail) msg = j.detail;
    } catch {}
    if (res.status === 401) {
      notify.error({ title: "Sesi berakhir", message: "Silakan login ulang lalu coba unduh kembali." });
    } else if (res.status === 403) {
      notify.error({ title: "Akses ditolak", message: msg });
    } else {
      notify.error({ title: `Unduh PDF gagal (${res.status})`, message: msg });
    }
    return false;
  }
  const ct = (res.headers.get("content-type") || "").toLowerCase();
  if (!ct.includes("application/pdf")) {
    // Server merespons 200 tapi bukan PDF (mis. rewriter mengembalikan HTML/JSON).
    let hint = "Server tidak mengembalikan file PDF.";
    try {
      const clone = res.clone();
      const t = await clone.text();
      if (t && t.trim().startsWith("{")) { try { const j = JSON.parse(t); if (j.detail) hint = j.detail; } catch {} }
    } catch {}
    notify.error({ title: "Unduh PDF gagal", message: hint });
    return false;
  }
  const blob = await res.blob();
  const blobUrl = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = filename || "Nota.pdf";
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  setTimeout(() => { try { URL.revokeObjectURL(blobUrl); } catch {} try { a.remove(); } catch {} }, 500);
  return true;
}

// ===== Kategori Nota untuk Dashboard Admin =====
// Menghitung berdasarkan aturan status/deadline/produksi/pembayaran yang sudah ada.
// Draft & Dibatalkan diabaikan (dilakukan di pemanggil).
// Iter 221k/221k2 — Rule canonical status-driven.
//   unpaid (Belum Lunas) mirror sumber /api/receivables:
//     remaining>0 AND order_status != "Dibatalkan"
//     — semua status termasuk Diambil/Dikirim dgn tunggakan tetap dihitung utk konsistensi Total Piutang tile.
//   Cats operasional (active/wip/overdue/near/ready) tetap status-driven per spec user.
// Iter 238 — `wip` (Sedang Diproses) berbasis production_stage per product:
//   Order dianggap "Sedang Diproses" kalau punya ≥1 product dgn stage aktif
//   (bukan Selesai/Perlu Diperiksa/kosong). Sebelumnya berbasis order_status
//   ∈ _WIP_STATES; hasil audit Live 2026-09-25 menunjukkan status Live-nya
//   "Menunggu Pembayaran" walau produknya benar-benar berjalan di pipeline.
const _INACTIVE_STAGES = new Set(["", "Selesai", "Perlu Diperiksa"]);
const hasActiveProductionProduct = (o) => {
  const arr = Array.isArray(o?.products) ? o.products : [];
  for (const p of arr) {
    const st = String(p?.production_stage || "").trim();
    if (!_INACTIVE_STAGES.has(st)) return true;
  }
  return false;
};
// Iter 223 — Produk Polosan (Siap Stok / Perlu Jahit) tidak lewat workflow produksi custom,
// jadi otomatis dianggap production-complete. Konsisten dgn backend `is_product_production_done`.
const POLOSAN_ROUTES = new Set(["Polosan Siap Stok", "Polosan Perlu Jahit"]);
const isProductProductionDone = (p) => {
  if (!p) return false;
  if (p.production_stage === "Selesai") return true;
  return POLOSAN_ROUTES.has(p.production_route);
};
// Iter 250 — Single source-of-truth "Terlambat".
//   Terlambat = deadline lewat AND masih ada proses produksi aktif yang belum tuntas.
//   Exclude order_status {Menunggu Finalisasi, Selesai, Diambil, Dikirim, Dibatalkan}.
//   Exclude Real Draft (Draft & !is_migrated).
//   Stage "Perlu Diperiksa" = legacy import artifact (audit Live 2026-09-26: 403 record,
//   semua is_migrated=true, 0 non-migrated) → BUKAN proses produksi aktif → exclude.
//   Route Polosan (Siap Stok / Perlu Jahit) auto-done.
const LATE_EXCLUDED_STATUS = new Set(["Menunggu Finalisasi", "Selesai", "Diambil", "Dikirim", "Dibatalkan"]);
const LATE_INACTIVE_STAGES = new Set(["Selesai", "Perlu Diperiksa"]);
const isProductActiveProduction = (p) => {
  if (!p) return false;
  const stage = String(p.production_stage || "").trim();
  if (LATE_INACTIVE_STAGES.has(stage)) return false;
  if (POLOSAN_ROUTES.has(p.production_route)) return false;
  return true;
};
const isOrderLate = (o, todayISO) => {
  if (!o) return false;
  const status = o.order_status || "";
  if (LATE_EXCLUDED_STATUS.has(status)) return false;
  if (status === "Draft" && !o.is_migrated) return false;
  const deadline = o.deadline || "";
  if (!deadline || deadline >= todayISO) return false;
  const prods = Array.isArray(o.products) ? o.products : [];
  if (prods.length === 0) return false;
  return prods.some(isProductActiveProduction);
};
const attentionCats = (o, todayISO) => {
  const cats = new Set();
  const status = o.order_status || "";
  if (status === "Dibatalkan") return cats;

  const remaining = Number(o.remaining ?? Math.max(0, Number(o.grand_total||0) - Number(o.paid||0)));
  // "unpaid" berlaku untuk SEMUA non-Dibatalkan dgn remaining>0 (mirror /api/receivables & Total Piutang tile).
  if (remaining > 0) cats.add("unpaid");

  // Iter 500 — "near" (Deadline Hari Ini) via single source-of-truth `isOrderLate`.
  //   Dulu H-0..H-2; sekarang HANYA H-0 (deadline == hari ini) sesuai permintaan
  //   user agar KPI Admin Toko fokus pada tanggal jatuh tempo yang sama persis.
  //   Order Terlambat sudah di-exclude lebih dulu via `isOrderLate` (if-else).
  //   Exclude order_status {Menunggu Finalisasi, Selesai, Diambil, Dikirim, Dibatalkan},
  //   Real Draft, dan stage "Perlu Diperiksa" (legacy artifact, bukan produksi aktif).
  const deadline = o.deadline || "";
  const _allProdDone = Array.isArray(o.products) && o.products.length > 0
    && o.products.every(isProductProductionDone);
  const _isRealDraft = status === "Draft" && !o.is_migrated;
  if (isOrderLate(o, todayISO)) {
    cats.add("overdue");
  } else if (deadline && deadline === todayISO && !_allProdDone && !_isRealDraft
             && !LATE_EXCLUDED_STATUS.has(status)) {
    cats.add("near");
  }

  // Final histori (Diambil/Dikirim) & Draft & picked-up → tidak masuk operasional lain (active/wip/ready).
  //   Iter 235 semantic tetap: order sudah diambil pelanggan tidak muncul di operational tiles.
  if (status === "Diambil" || status === "Dikirim" || status === "Draft" || o.pickup_status === "Diambil") return cats;

  // Selesai + Belum Diambil → ready (unpaid sudah handled di atas).
  if (status === "Selesai") {
    if (o.pickup_status !== "Diambil") cats.add("ready");
    return cats;
  }

  // Non-final non-Draft non-Selesai → operasional aktif
  cats.add("active");
  if (hasActiveProductionProduct(o)) cats.add("wip");
  return cats;
};
// Iter 585 — Deadline Hari Ini: nota aktif (bukan Draft/Batal/Dikirim, belum diambil), deadline internal = hari ini.
const isDeadlineTodayActive = (o, today) => !!(o.deadline && o.deadline === today && o.pickup_status !== "Diambil"
  && !["Dibatalkan", "Dikirim", "Draft"].includes(o.order_status));
// Tidak aktif = batal, atau sudah diambil/dikirim DAN lunas (nota bertagihan tetap tampil di pemantauan).
const isInactiveOrder = (o) => o.order_status === "Dibatalkan"
  || ((o.pickup_status === "Diambil" || o.order_status === "Dikirim") && !((o.remaining || 0) > 0));
const CAT_LABEL = { active:"Pesanan Aktif", overdue:"Terlambat", near:"Deadline Hari Ini", wip:"Sedang Diproduksi", ready:"Selesai — Belum Diambil", unpaid:"Belum Lunas", "needs-review":"Perlu Review (Migrasi)" };
const CAT_CLASS = { active:"cat-active", overdue:"cat-overdue", near:"cat-near", wip:"cat-wip", ready:"cat-ready", unpaid:"cat-unpaid" };


function Field({ label, required, children, hidden }) {
  return <label className="field-label" style={hidden ? { display: "none" } : undefined} aria-hidden={hidden || undefined}>
    <span className="field-label-text">{label}{required && <b className="required" aria-label="wajib">*</b>}</span>
    {children}
  </label>;
}

// Iter 201/203 — Helper terpusat: harga efektif per baris variasi. Digunakan oleh
//   ProductCard subtotal DAN form-level total useMemo agar Ringkasan konsisten dengan
//   tampilan per baris. Rules:
//     • Manual (row.price_manual===true && row.unit_price>0) → row.unit_price
//     • Kalkulator (item.auto_price_base>0)                 → autoBase + max(rowPts-1,0)*rate + sleeveAdd + sizeUpcharge
//     • Fallback legacy (nota lama)                         → item.unit_price + sizeUpcharge
//   `globalEmbroideryPoints` = order.embroidery_points untuk nota lama tanpa titik per baris.
function computeRowEffective(item, row, globalEmbroideryPoints) {
  if (!item || !row) return 0;
  const isManual = row.price_manual === true || row._manual === true; // _manual legacy fallback
  if (isManual && Number(row.unit_price || 0) > 0) return Number(row.unit_price);
  const autoBase = Number(item.auto_price_base ?? item._priceAutoBase ?? 0);
  if (autoBase > 0) {
    const rp = (row.embroidery_points !== null && row.embroidery_points !== undefined)
      ? Number(row.embroidery_points)
      : Number(globalEmbroideryPoints || 0);
    const rate = Number(item.auto_price_rate ?? item._priceExtraRate ?? 0);
    const extra = Math.max((Number.isFinite(rp) ? rp : 0) - 1, 0) * rate;
    const slv = sleeveAddFor(item.name, item.material, row.variant, item.pricing_key);
    const upc = sizeUpcharge(item.name, row.size);
    return autoBase + extra + slv + upc;
  }
  // Iter 584 — Tanpa hasil kalkulator & bukan Manual → 0 = "Harga Belum Tersedia".
  //   Tidak ada fallback diam-diam (Harga Satuan Default / harga baris lama).
  return 0;
}
const priceRefKey = (row) => `${row.size || ""}|${row.variant || ""}|${row.embroidery_points ?? ""}`;

// Iter 203 — Baris siap untuk auto-price?
//   • Perlu size non-empty; qty ≥ 1
//   • Bila produk butuh lengan (Polo PE/PDH/Workshirt) → variant harus "Panjang" atau "Pendek"
//   • Bila proses mengandung Bordir → embroidery_points harus bilangan bulat ≥ 1
function rowReadyForAutoPrice(item, row) {
  if (!item || !row) return false;
  if (!row.size || !String(row.size).trim()) return false;
  if (Number(row.quantity || 0) < 1) return false;
  const needsSleeve = autoPriceNeedsSleeve(item.name, item.material, item.pricing_key);
  if (needsSleeve && !(row.variant === "Panjang" || row.variant === "Pendek")) return false;
  const routeStr = String(item.production_route || "");
  const hasBordir = routeStr === "Bordir" || routeStr.startsWith("Bordir + Sablon");
  if (hasBordir) {
    const rp = row.embroidery_points;
    if (rp === null || rp === undefined) return false;
    if (!Number.isInteger(Number(rp)) || Number(rp) < 1) return false;
  }
  return true;
}

function Login({ onLogin, onOperator }) {
  const [mode, setMode] = useState("admin"); // "admin" | "operator"
  const [email,setEmail]=useState(""),[password,setPassword]=useState(""),[error,setError]=useState("");
  const [ops, setOps] = useState([]);
  const [opId, setOpId] = useState("");
  const [pin, setPin] = useState("");
  const [showForgot, setShowForgot] = useState(false);
  const loginRef = useRef(null);
  useEffect(() => { if (mode === "operator") axios.get(`${API}/operators/public`).then(r=>setOps(r.data||[])).catch(()=>{}); }, [mode]);
  // Iter 348 — Sembunyikan banner "Pasang TAMFARIS" saat form login sedang di-fokuskan
  //   (daftar nama / input PIN / email terbuka) agar banner tidak menutupi UI.
  //   Flag di body dibersihkan saat Login unmount.
  useEffect(() => {
    const el = loginRef.current;
    if (!el) return;
    let armed = true;
    const onFocusIn = () => { if (armed) document.body.classList.add("login-active-focus"); };
    const onFocusOut = () => {
      setTimeout(() => {
        if (!armed) return;
        if (!document.activeElement || !el.contains(document.activeElement)) {
          document.body.classList.remove("login-active-focus");
        }
      }, 0);
    };
    el.addEventListener("focusin", onFocusIn);
    el.addEventListener("focusout", onFocusOut);
    return () => {
      armed = false;
      el.removeEventListener("focusin", onFocusIn);
      el.removeEventListener("focusout", onFocusOut);
      document.body.classList.remove("login-active-focus");
    };
  }, []);
  const submitAdmin = async e => { e.preventDefault(); setError(""); try { const r = await axios.post(`${API}/auth/login`, { email, password }, { withCredentials:true }); onLogin(r.data); } catch(err) { setError(err.response?.data?.detail||"Login gagal"); } };
  const submitOperator = async e => { e.preventDefault(); setError(""); if (!opId) return setError("Pilih pengguna"); if (!/^\d{6}$/.test(pin)) return setError("PIN harus 6 digit angka"); try { const r = await axios.post(`${API}/operators/pin-login`, { operator_id: opId, pin }, { withCredentials:true }); onOperator(r.data); } catch(err) { setError(err.response?.data?.detail||"PIN salah"); } };
  return <main className="login" ref={loginRef}>
    <div className="login-mark" aria-label="Logo TAMFARIS"><img src="/logo-tamfaris.jpg" alt="Logo TAMFARIS" draggable="false"/></div>
    {/* Iter 348 — Identitas tampilan: TAMFARIS — Sistem Operasional (compact, mobile-friendly). */}
    <h1 className="login-title">TAMFARIS</h1>
    <p className="login-subtitle">Sistem Operasional</p>
    <p className="muted login-desc">Kelola pesanan, produksi, dan pembayaran.</p>
    <div className="login-mode-tabs" data-testid="login-mode-tabs">
      <button type="button" data-testid="login-mode-admin" className={`mode-tab ${mode==="admin"?"active":""}`} onClick={()=>{setMode("admin");setError("");}}>Owner / Admin Kantor</button>
      <button type="button" data-testid="login-mode-operator" className={`mode-tab ${mode==="operator"?"active":""}`} onClick={()=>{setMode("operator");setError("");}}>Admin Toko / Operator</button>
    </div>
    {mode === "admin" ? <form onSubmit={submitAdmin}>
      <Field label="Email"><input data-testid="login-email-input" value={email} onChange={e=>setEmail(e.target.value)}/></Field>
      <Field label="Kata sandi"><input data-testid="login-password-input" type="password" value={password} onChange={e=>setPassword(e.target.value)}/></Field>
      {error&&<div className="alert" data-testid="login-error">{error}</div>}
      <button data-testid="login-submit-button" className="primary full">Masuk ke aplikasi</button>
      <button type="button" data-testid="login-forgot-btn" className="link-btn" onClick={()=>setShowForgot(true)} style={{background:"transparent",border:"0",color:"#2563eb",fontWeight:600,marginTop:10,cursor:"pointer",fontSize:13,textDecoration:"underline"}}>Lupa Password?</button>
    </form> : <form onSubmit={submitOperator}>
      <Field label="Pilih nama pengguna">
        <OperatorCombobox ops={ops} value={opId} onChange={id=>{setOpId(id);setPin("");setError("");}}/>
      </Field>
      <Field label="PIN (6 digit)"><input data-testid="operator-pin-input" inputMode="numeric" maxLength={6} value={pin} onChange={e=>setPin(e.target.value.replace(/\D/g,"").slice(0,6))} placeholder="••••••" style={{letterSpacing:"6px",fontFamily:"Space Mono, monospace"}}/></Field>
      {error&&<div className="alert" data-testid="operator-login-error">{error}</div>}
      <button data-testid="operator-login-btn" className="primary full">Masuk sebagai pengguna</button>
    </form>}
    <small>{mode === "admin" ? "Untuk Owner & Admin Kantor. Login pakai email dan kata sandi." : "Untuk Admin Toko & Operator produksi. Pilih nama lalu masukkan PIN 6 digit."}</small>
    {showForgot && <ForgotPasswordModal defaultEmail={email} onClose={()=>setShowForgot(false)}/>}
  </main>;
}

// Iter 347 — Combobox pencarian untuk pemilihan nama operator pada halaman login.
//   - Hanya mengubah UI pemilih nama; nilai internal tetap operator.id (sama seperti <select>).
//   - Grouping per divisi (team) dipertahankan; hanya operator aktif ditampilkan (defense-in-depth
//     walau endpoint /operators/public sudah filter active).
//   - Case-insensitive filter, keyboard nav (ArrowUp/Down/Enter/Escape), tutup pada outside click.
//   - Tinggi list dibatasi + scrollable agar aman saat keyboard HP terbuka.
//   - Tidak menyimpan PIN atau melakukan login otomatis.
function OperatorCombobox({ ops, value, onChange }) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const [activeIdx, setActiveIdx] = useState(-1);
  const wrapperRef = useRef(null);
  const inputRef = useRef(null);
  const listRef = useRef(null);
  const selected = useMemo(() => ops.find(o => String(o.id) === String(value)) || null, [ops, value]);

  // Filter aktif + case-insensitive match pada nama operator.
  const q = query.trim().toLowerCase();
  const filtered = useMemo(() => {
    const base = ops.filter(o => o.active !== false);
    if (!q) return base;
    return base.filter(o => String(o.name || "").toLowerCase().includes(q));
  }, [ops, q]);
  // Group by team, pertahankan urutan pertama kemunculan tim.
  const grouped = useMemo(() => {
    const map = new Map();
    for (const op of filtered) {
      const team = op.team || "Lainnya";
      if (!map.has(team)) map.set(team, []);
      map.get(team).push(op);
    }
    return Array.from(map.entries());
  }, [filtered]);
  // Flat list untuk keyboard nav (urut sesuai render).
  const flat = useMemo(() => grouped.flatMap(([, list]) => list), [grouped]);

  useEffect(() => {
    if (!open) return;
    const onDocClick = (e) => { if (wrapperRef.current && !wrapperRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, [open]);
  // Iter 348 — Tandai body "combobox-open" supaya banner Pasang TAMFARIS tersembunyi.
  useEffect(() => {
    if (open) document.body.classList.add("combobox-open");
    else document.body.classList.remove("combobox-open");
    return () => document.body.classList.remove("combobox-open");
  }, [open]);
  useEffect(() => { if (open) setTimeout(() => inputRef.current?.focus(), 20); }, [open]);
  useEffect(() => { setActiveIdx(flat.length > 0 ? 0 : -1); }, [q, flat.length]);

  const pick = (op) => {
    onChange(op.id);
    setOpen(false);
    setQuery("");
    setActiveIdx(-1);
  };
  const onKeyDown = (e) => {
    if (e.key === "ArrowDown") { e.preventDefault(); setActiveIdx(i => Math.min(flat.length - 1, (i < 0 ? 0 : i + 1))); }
    else if (e.key === "ArrowUp") { e.preventDefault(); setActiveIdx(i => Math.max(0, i - 1)); }
    else if (e.key === "Enter") {
      if (activeIdx >= 0 && flat[activeIdx]) { e.preventDefault(); pick(flat[activeIdx]); }
    }
    else if (e.key === "Escape") { e.preventDefault(); setOpen(false); }
  };
  // Scroll item aktif ke dalam viewport list.
  useEffect(() => {
    if (!open || activeIdx < 0 || !listRef.current) return;
    const el = listRef.current.querySelector(`[data-op-flat-idx="${activeIdx}"]`);
    if (el && typeof el.scrollIntoView === "function") el.scrollIntoView({ block: "nearest" });
  }, [activeIdx, open]);

  return <div className="op-combobox" ref={wrapperRef}>
    <button
      type="button"
      className="op-combobox-trigger"
      data-testid="operator-select"
      aria-haspopup="listbox"
      aria-expanded={open}
      onClick={() => setOpen(v => !v)}
    >
      <span className={`op-combobox-value ${selected ? "" : "op-combobox-placeholder"}`} data-testid="operator-select-value">
        {selected ? selected.name : "— Pilih nama pengguna —"}
      </span>
      <ChevronDown size={16} aria-hidden="true" className="op-combobox-chev"/>
    </button>
    {open && <div className="op-combobox-panel" role="dialog" aria-label="Pilih operator">
      <div className="op-combobox-search">
        <Search size={14} aria-hidden="true"/>
        <input
          ref={inputRef}
          data-testid="operator-search-input"
          value={query}
          onChange={e => setQuery(e.target.value)}
          onKeyDown={onKeyDown}
          placeholder="Cari nama pengguna…"
          autoComplete="off"
        />
      </div>
      <div className="op-combobox-list" role="listbox" aria-label="Daftar operator" ref={listRef}>
        {grouped.length === 0 && (
          <div className="op-combobox-empty" data-testid="operator-search-empty">Nama tidak ditemukan</div>
        )}
        {grouped.map(([team, list]) => (
          <div key={team} className="op-combobox-group">
            <div className="op-combobox-group-head">{team}</div>
            {list.map(op => {
              const flatIdx = flat.indexOf(op);
              const isActive = flatIdx === activeIdx;
              const isSelected = String(op.id) === String(value);
              return <div
                key={op.id}
                role="option"
                aria-selected={isSelected}
                data-testid={`operator-option-${op.id}`}
                data-op-flat-idx={flatIdx}
                className={`op-combobox-option ${isActive ? "is-active" : ""} ${isSelected ? "is-selected" : ""}`}
                onMouseEnter={() => setActiveIdx(flatIdx)}
                onMouseDown={(e) => { e.preventDefault(); pick(op); }}
              >
                {op.name}
              </div>;
            })}
          </div>
        ))}
      </div>
    </div>}
  </div>;
}

function ForgotPasswordModal({ defaultEmail, onClose }) {
  // Iter 54 — Alur Lupa Password Owner/Admin: input email login → kirim OTP ke recovery email → input kode+password baru.
  const [step, setStep] = useState("request"); // request | reset
  const [emailAddr, setEmailAddr] = useState(defaultEmail || "");
  const [code, setCode] = useState("");
  const [newPw, setNewPw] = useState("");
  const [confirmPw, setConfirmPw] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [info, setInfo] = useState("");
  const send = async (e) => {
    e && e.preventDefault(); setErr(""); setInfo("");
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailAddr)) { setErr("Format email tidak valid."); return; }
    setBusy(true);
    try {
      const r = await axios.post(`${API}/auth/forgot-password`, { email: emailAddr.trim().toLowerCase() });
      setInfo(r.data?.message || "Jika email terdaftar dan memiliki email recovery terverifikasi, kode 6 digit telah dikirim.");
      setStep("reset");
    } catch (e) {
      setErr(e.response?.data?.detail || "Gagal mengirim permintaan.");
    } finally { setBusy(false); }
  };
  const reset = async (e) => {
    e && e.preventDefault(); setErr("");
    if (!/^\d{6}$/.test(code)) { setErr("Kode wajib 6 digit angka."); return; }
    if (newPw.length < 6) { setErr("Password baru minimal 6 karakter."); return; }
    if (newPw !== confirmPw) { setErr("Konfirmasi password tidak cocok."); return; }
    setBusy(true);
    try {
      await axios.post(`${API}/auth/reset-password`, {
        email: emailAddr.trim().toLowerCase(), code, new_password: newPw, confirm_password: confirmPw,
      });
      await notify.success({ title:"Password berhasil direset", message:"Silakan login dengan password baru Anda.", primaryLabel:"Ke Halaman Login" });
      onClose();
    } catch (e) { setErr(e.response?.data?.detail || "Reset gagal. Periksa kode & coba lagi."); }
    finally { setBusy(false); }
  };
  return <div className="modal-overlay" data-testid="forgot-password-modal" onClick={onClose}>
    <div className="modal" onClick={e=>e.stopPropagation()} style={{maxWidth:440}}>
      <h3 style={{margin:"0 0 6px",display:"flex",alignItems:"center",gap:8}}><Mail size={18}/>Lupa Password Owner</h3>
      <p className="muted small" style={{margin:"0 0 12px"}}>Masukkan email login Anda. Kode 6 digit akan dikirim ke <strong>email recovery terverifikasi</strong>. Fitur ini hanya untuk akun Owner/Admin (bukan operator PIN).</p>
      {err && <div className="op-hard-delete-err" data-testid="forgot-error" role="alert">{err}</div>}
      {info && step === "reset" && <div style={{background:"#eff6ff",border:"1px solid #bfdbfe",color:"#1e40af",padding:"9px 12px",borderRadius:8,fontSize:12,marginBottom:12}} data-testid="forgot-info">{info}</div>}
      {step === "request" ? <form onSubmit={send}>
        <Field label="Email Login" required>
          <input type="email" data-testid="forgot-email-input" value={emailAddr} onChange={e=>setEmailAddr(e.target.value)} autoFocus autoComplete="username" placeholder="owner@tamfaris.id"/>
        </Field>
        <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
          <button type="button" className="soft-btn" onClick={onClose} disabled={busy}>Batal</button>
          <button type="submit" className="primary" data-testid="forgot-send-btn" disabled={busy}>{busy?"Mengirim…":"Kirim Kode"}</button>
        </div>
      </form> : <form onSubmit={reset}>
        <Field label="Kode 6 Digit dari Email" required>
          <input type="text" inputMode="numeric" maxLength={6} data-testid="forgot-code-input" value={code} onChange={e=>setCode(e.target.value.replace(/\D/g,""))} autoFocus style={{fontSize:20,letterSpacing:6,fontWeight:700,textAlign:"center"}}/>
        </Field>
        <Field label="Password Baru (min. 6 karakter)" required>
          <input type="password" data-testid="forgot-new-pw" value={newPw} onChange={e=>setNewPw(e.target.value)} autoComplete="new-password"/>
        </Field>
        <Field label="Konfirmasi Password Baru" required>
          <input type="password" data-testid="forgot-confirm-pw" value={confirmPw} onChange={e=>setConfirmPw(e.target.value)} autoComplete="new-password"/>
        </Field>
        <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
          <button type="button" className="soft-btn" onClick={()=>{ setStep("request"); setErr(""); setCode(""); setNewPw(""); setConfirmPw(""); }} disabled={busy}>Kirim Ulang Kode</button>
          <button type="submit" className="primary" data-testid="forgot-reset-btn" disabled={busy}>{busy?"Mereset…":"Reset Password"}</button>
        </div>
      </form>}
    </div>
  </div>;
}

function MasterCombo({ testId, value, onChange, options, placeholder, optionGroups }) {
  // Kombinasi dropdown + input manual "Lainnya".
  // Iter 528 — Dukungan optional `optionGroups` = [{label, options:[...]}, ...] untuk
  //   menampilkan dropdown bergrup (mis. "★ Dari Stok · CC 24S" + "• Warna Generik").
  //   Bila `optionGroups` diisi, prop `options` diabaikan untuk rendering tapi tetap
  //   dipakai sebagai fallback untuk deteksi "Lainnya"/manual.
  // Iter 531 — Sinkronkan state `manual` setiap kali daftar listed berubah (mis. operator
  //   mengganti bahan di ProductCard). Jika nilai lama tidak lagi ada di daftar baru,
  //   otomatis beralih ke mode manual tanpa menghapus value — konsisten dengan arahan
  //   "pertahankan input manual + pergantian bahan memperbarui pilihan dengan benar".
  const flatFromGroups = useMemo(() => {
    if (!Array.isArray(optionGroups)) return null;
    const seen = new Set(), out = [];
    for (const g of optionGroups) {
      for (const o of (g.options || [])) {
        const k = String(o || "").trim().toUpperCase();
        if (!k || seen.has(k)) continue;
        seen.add(k); out.push(o);
      }
    }
    return out;
  }, [optionGroups]);
  const flatOptions = flatFromGroups || options || [];
  const listed = flatOptions.filter(o => o !== "Lainnya");
  const listedUpperKey = listed.map(x => String(x).toUpperCase()).join("|");
  const isLainnyaNow = Boolean(value) && !listed.map(x=>String(x).toUpperCase()).includes(String(value).toUpperCase());
  const [manual, setManual] = useState(isLainnyaNow);
  useEffect(() => {
    // Nilai saat ini tidak ada di daftar baru → paksa mode manual (tetap simpan value).
    if (isLainnyaNow && !manual) setManual(true);
    // Nilai sekarang muncul di daftar (karena bahan diganti ke bahan yang menyertakannya)
    // → keluar dari mode manual agar select-nya menampilkan pilihan yg sesuai.
    else if (!isLainnyaNow && manual && value) setManual(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, listedUpperKey]);
  const selectValue = manual ? "Lainnya" : (value || "");
  return <div className="master-combo">
    <select data-testid={testId} value={selectValue} onChange={e=>{
      const v = e.target.value;
      if (v === "Lainnya") { setManual(true); onChange(""); }
      else { setManual(false); onChange(v); }
    }}>
      <option value="">{placeholder || "Pilih"}</option>
      {Array.isArray(optionGroups) && optionGroups.length > 0
        ? optionGroups.map((g, gi) => {
            const opts = (g.options || []).filter(o => o !== "Lainnya");
            if (opts.length === 0) return null;
            return <optgroup key={`${g.label}-${gi}`} label={g.label} data-testid={`${testId}-group-${gi}`}>
              {opts.map(o => <option key={`${g.label}-${o}`} value={o}>{o}</option>)}
            </optgroup>;
          })
        : listed.map(o=><option key={o}>{o}</option>)
      }
      <option value="Lainnya">Lainnya…</option>
    </select>
    {manual && <input data-testid={`${testId}-manual`} value={value||""} onChange={e=>onChange(e.target.value)} placeholder="Ketik manual" className="master-combo-manual"/>}
  </div>;
}

// Iter 203 — Kalkulator harga sekarang REAKTIF di ProductCard (via useEffect). Komponen ini
// tinggal menampilkan hint status: label kalkulator, total pcs, aturan tambahan ukuran.
// Tidak ada tombol Hitung Harga & tidak ada peringatan "detail berubah" — harga per variasi
// selalu mengikuti detail terbaru secara idempoten (base + tambahan, tidak menumpuk).
function AutoPriceHint({ item, index, orderType }) {
  const totalQty = (item.sizes || []).reduce((a, s) => a + Number(s.quantity || 0), 0);
  const eligible = isAutoPriceEligible({
    orderType,
    productName: item.name,
    material: item.material,
    productionRoute: item.production_route,
    pricingKey: item.pricing_key,
  });
  if (!eligible) {
    if (orderType === "Custom" && item.production_route === "Bordir") {
      return (
        <div className="auto-price-wrap" data-testid={`auto-price-wrap-${index}`}>
          <span className="muted small auto-price-note" data-testid={`auto-price-manual-hint-${index}`}>
            <AlertTriangle size={12}/> Kalkulator belum tersedia untuk produk ini — isi harga manual per variasi.
          </span>
        </div>
      );
    }
    return null;
  }
  const variantLabel = autoPriceLabel(item.name, item.material, item.pricing_key) || item.name;
  const needsSleeve = autoPriceNeedsSleeve(item.name, item.material, item.pricing_key);
  const upchargeSummary = sizeUpchargeSummary(item.name);
  return (
    <div className="auto-price-wrap" data-testid={`auto-price-wrap-${index}`}>
      <span className="auto-price-badge" data-testid={`auto-price-badge-${index}`}>
        <Calculator size={13}/> Kalkulator aktif
      </span>
      <span className="muted small auto-price-hint" data-testid={`auto-price-hint-${index}`}>
        {variantLabel} · total {totalQty} pcs · Titik bordir mengikuti masing-masing variasi{needsSleeve ? " · varian per baris" : ""}
        {upchargeSummary ? ` · ${upchargeSummary}` : ""}
      </span>
    </div>
  );
}




function ProductCard({ item, index, onChange, onRemove, canRemove, productNames, pricingKeyByProductName, categoryByProductName, materialNames, colorNames, sizeNames, routeChoice, orderType, customType, embroideryPoints, oldPricesForProduct, stockColorsByMaterial, customColorsByMaterial }) {
  const [showOptions, setShowOptions] = useState(Number(item.discount)>0 || !!(item.note && item.note.trim()));
  const [settingOn, setSettingOn] = useState(Number(item.setting_fee)>0);
  useEffect(() => { if (Number(item.setting_fee) > 0 && !settingOn) setSettingOn(true); /* eslint-disable-next-line */ }, [item.setting_fee]);
  // Iter 150 — Sinkronisasi `pricing_key` dari master saat master_products selesai load.
  //   Menghindari kondisi awal form di mana `item.pricing_key === ""` padahal produk default
  //   sudah punya kunci di master (nota baru selalu Polo PE by default).
  //   Sync HANYA bila pricing_key kosong; nota lama yang menyimpan pricing_key eksplisit
  //   tidak ditimpa.
  useEffect(() => {
    if (item.pricing_key) return;
    const pk = pricingKeyByProductName && pricingKeyByProductName[item.name];
    if (pk) onChange({ ...item, pricing_key: pk });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pricingKeyByProductName, item.name]);

  // Iter 528 — Dropdown warna di MasterCombo diprioritaskan ke warna stok yang sesuai
  //   dengan bahan dipilih. Kalau bahan belum dipilih / tidak ada varian stok, fallback
  //   ke master_colors generik saja (tanpa menampilkan warna bahan lain).
  // Iter 530 — Tambah 1 grup di tengah: "Master Warna Khusus Bahan Ini" (custom scope=materials)
  //   agar warna custom muncul tanpa duplikasi dengan stok maupun generik.
  // Iter 531 — Prioritas visual: warna stok muncul paling atas sebagai pilihan utama; warna
  //   umum (16 generik) dipindah ke grup "Warna Lainnya / Custom" ketika bahan punya warna
  //   stok, agar operator tidak keliru memilih "Hitam" alih-alih "JET BLACK".
  //   Catatan: tidak ada mapping/samaan otomatis antar nama warna — murni perubahan label
  //   grup. Operator tetap bisa ketik manual (combobox "Lainnya").
  const colorOptionGroups = useMemo(() => {
    const groups = [];
    const matRaw = (item.material || "").trim();
    const matNorm = matRaw.replace(/\s+/g, " ").toUpperCase();
    const stockListRaw = matNorm && stockColorsByMaterial ? (stockColorsByMaterial[matNorm] || []) : [];
    const stockList = Array.isArray(stockListRaw) ? stockListRaw : [];
    if (matRaw && stockList.length > 0) {
      groups.push({ label: `★ Dari Stok · ${matRaw}`, options: stockList });
    }
    // Master Warna Khusus Bahan Ini (scope_materials match)
    const customListRaw = matNorm && customColorsByMaterial ? (customColorsByMaterial[matNorm] || []) : [];
    const customList = Array.isArray(customListRaw) ? customListRaw : [];
    const stockUpper = new Set(stockList.map(x => String(x).toUpperCase()));
    const customDedup = customList.filter(n => n && !stockUpper.has(String(n).toUpperCase()));
    if (matRaw && customDedup.length > 0) {
      groups.push({ label: `✎ Master Warna Khusus · ${matRaw}`, options: customDedup });
    }
    // master_colors generik (buang "Lainnya" — MasterCombo yg handle)
    const generic = (colorNames || []).filter(n => n && n !== "Lainnya");
    // Hilangkan duplikat case-insensitive dengan stockList + customDedup
    const customUpper = new Set(customDedup.map(x => String(x).toUpperCase()));
    const genericDedup = generic.filter(n => !stockUpper.has(String(n).toUpperCase()) && !customUpper.has(String(n).toUpperCase()));
    if (genericDedup.length > 0) {
      // Iter 531 — Saat bahan punya warna stok, label grup umum berubah menjadi "Warna
      //   Lainnya / Custom" untuk menandai bahwa ini adalah pilihan sekunder/custom.
      //   Saat bahan belum dipilih atau tidak ada stok, label tetap "Warna Umum".
      const genericLabel = (matRaw && stockList.length > 0)
        ? "• Warna Lainnya / Custom"
        : "• Warna Umum";
      groups.push({ label: genericLabel, options: genericDedup });
    }
    return groups;
  }, [item.material, colorNames, stockColorsByMaterial, customColorsByMaterial]);

  // Iter 203 — Kalkulator REAKTIF: menghitung ulang `auto_price_base` + `auto_price_rate`
  //   setiap kali detail produk / total pcs berubah. Idempoten (hanya update state bila
  //   nilainya benar-benar berubah). Baris manual (row.price_manual) tetap dilindungi karena
  //   auto base tidak menyentuh row.unit_price manual.
  //   • Bila produk tidak eligible (Polos / bukan Bordir / tidak ada pricing_key) → clear
  //     auto base agar Ringkasan pakai row.unit_price manual saja.
  //   • Bila eligible tapi totalQty < 1 → tidak update (menunggu user mengisi jumlah).
  const totalQtyForAuto = (item.sizes || []).reduce((a, s) => a + Number(s.quantity || 0), 0);
  const autoEligible = isAutoPriceEligible({
    orderType,
    productName: item.name,
    material: item.material,
    productionRoute: item.production_route,
    pricingKey: item.pricing_key,
  });
  useEffect(() => {
    if (!autoEligible) {
      // Iter 205 — Non-eligible (Sablon / Bordir+Sablon / Jahit / dsb, atau produk tanpa
      //   pricing_key). Bila SEBELUMNYA proses ini eligible (auto_price_base/rate terisi),
      //   BERSIHKAN sisa harga kalkulator supaya tidak ikut subtotal / disimpan:
      //     • auto_price_base & auto_price_rate → null
      //     • item.unit_price → 0 (sebelumnya di-mirror ke autoBase pada useEffect eligible)
      //     • row.unit_price non-manual → 0 (row manual dilindungi via `price_manual === true`)
      //   Bila `wasAuto === false` (mis. nota lama Sablon manual, tidak pernah punya auto
      //   fields), JANGAN sentuh apapun — hindari menghitung ulang nota lama saat dibuka.
      const wasAuto = item.auto_price_base != null || item.auto_price_rate != null;
      if (wasAuto) {
        const clearedSizes = (item.sizes || []).map(s => {
          if (s.price_manual === true) return s; // manual dilindungi
          if (!(Number(s.unit_price || 0) > 0)) return s;
          return { ...s, unit_price: 0 };
        });
        onChange({
          ...item,
          auto_price_base: null,
          auto_price_rate: null,
          unit_price: 0,
          sizes: clearedSizes,
        });
      }
      return;
    }
    if (totalQtyForAuto < 1) return;
    // Iter 208 — Bila varian butuh dtf_size (Kaos Combed 24s), skip kalau belum dipilih.
    const needsDtf = autoPriceNeedsDtfSize(item.name, item.material, item.pricing_key);
    if (needsDtf && !DTF_SIZES.includes(String(item.dtf_size || "").trim())) {
      // clear auto fields kalau sebelumnya sudah ter-set (mis. ganti dtf_size ke kosong).
      if (item.auto_price_base != null) {
        onChange({ ...item, auto_price_base: null, auto_price_rate: null, unit_price: 0 });
      }
      return;
    }
    // Hitung base BARE (pure product base tanpa tambahan): panggil kalkulator dgn
    //   embroideryPoints=1 (extra=0) & sleeve="Pendek" (add=0). Efektif per baris ditambah
    //   sleeve/upcharge/points on-the-fly di `computeRowEffective`.
    const res = computeAutoPrice({
      orderType,
      productName: item.name,
      material: item.material,
      productionRoute: item.production_route,
      pricingKey: item.pricing_key,
      totalQty: totalQtyForAuto,
      embroideryPoints: 1,
      sleeve: "Pendek",
      dtfSize: item.dtf_size,
    });
    if (!res.ok) return;
    const nextBase = Number(res.price);
    // Iter 208 — DTF tidak pakai extraPointRate; simpan 0.
    const nextRate = needsDtf ? 0 : Number(extraPointRate(totalQtyForAuto) || 0);
    if (
      Number(item.auto_price_base || 0) === nextBase &&
      Number(item.auto_price_rate || 0) === nextRate
    ) return;
    onChange({ ...item, auto_price_base: nextBase, auto_price_rate: nextRate, unit_price: nextBase });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    item.name,
    item.material,
    item.production_route,
    item.pricing_key,
    item.dtf_size,
    orderType,
    autoEligible,
    totalQtyForAuto,
  ]);
  const total = item.sizes.reduce((sum,row)=>sum+Number(row.quantity||0),0);
  // Iter 56 — Subtotal memakai harga per-ukuran. Fallback ke unit_price produk saat 0.
  // Iter 143 — Fallback sekarang MENAMBAHKAN size_upcharge (2XL/3XL/4XL/5XL) supaya:
  //   1. Baris ukuran auto langsung tampil harga efektif (bukan angka 0/default polos).
  //   2. Bila user ubah "Harga satuan default", semua baris auto ikut terupdate tanpa
  //      pernah disalin ke unit_price (menghindari harga khusus yang tidak bisa update).
  //   3. Nota lama tidak berubah karena pricing_version di backend di-set 2 hanya untuk
  //      order baru yang dibuat via form ini.
  // Iter 148/149/201 — Subtotal produk memakai harga efektif yang sama dgn tampilan baris,
  //   dan sama dengan form-level total useMemo (via helper `computeRowEffective`).
  const _rowEffective = (row) => computeRowEffective(item, row, embroideryPoints);
  const sizesGross = (item.sizes || []).reduce((sum, row) => sum + Number(row.quantity || 0) * _rowEffective(row), 0);
  const subtotal = Math.max(0, sizesGross - Number(item.discount||0)) + Number(item.setting_fee||0);
  const change = (key, value) => onChange({ ...item, [key]:value });
  const changeSize = (row, key, value) => {
    const sizes = item.sizes.map((s, i) => {
      if (i !== row) return s;
      const patch = { ...s, [key]: value };
      // Iter 148/203 — Edit `unit_price` menandai baris sebagai manual atau melepas manual.
      //   • value > 0 → price_manual = true (harga diketik admin, dilindungi).
      //   • value == 0/kosong → price_manual = false (baris kembali otomatis).
      //   Perubahan size/variant/points tidak mengubah status price_manual — baris otomatis
      //   tetap otomatis dan effective dihitung ulang tanpa menumpuk.
      if (key === "unit_price") {
        if (Number(value) > 0 && !(s.price_manual === true || s._manual === true)) {
          // Iter 584 — catat nilai otomatis saat admin menimpa (untuk jejak & peringatan tinjau).
          patch.price_auto_ref = computeRowEffective(item, { ...s, price_manual: false, _manual: false, unit_price: 0 }, embroideryPoints) || null;
          patch.price_manual_ref = priceRefKey(s);
        }
        if (Number(value) <= 0) {
          patch.price_manual = false;
          delete patch.price_auto_ref; delete patch.price_manual_ref;
          delete patch._manual; // legacy
          delete patch._priceAuto; // legacy
        } else {
          patch.price_manual = true;
        }
      }
      return patch;
    });
    onChange({ ...item, sizes });
  };
  // Iter 148/149/201 — Hitung harga efektif per baris on-the-fly. Delegasi ke helper
  //   `computeRowEffective` supaya konsisten dengan Ringkasan total di form.
  const effectiveFor = (row) => computeRowEffective(item, row, embroideryPoints);
  const sizeList = (sizeNames && sizeNames.length ? sizeNames : SIZES).filter(s => s !== "Lainnya");

  // Iter 207 — Grouping VIEW: kelompokkan `item.sizes` per (color|variant|embroidery_points).
  //   Data model per baris TIDAK berubah — setiap ukuran tetap menyimpan warna/lengan/titik/harga/manual-flag.
  //   Ini murni tampilan supaya user tidak perlu input warna+lengan+titik berulang untuk ukuran berbeda.
  //   Nota lama dengan struktur `sizes[]` yang berbeda-beda akan otomatis membentuk grup sesuai kombinasinya.
  const groups = (() => {
    const map = new Map();
    const order = [];
    (item.sizes || []).forEach((s, idx) => {
      const color = (s.color != null ? s.color : (item.color || ""));
      const variant = s.variant || "";
      const rawPts = s.embroidery_points;
      const pts = (rawPts === null || rawPts === undefined || rawPts === "") ? "" : String(Number(rawPts));
      const key = `${color}|${variant}|${pts}`;
      if (!map.has(key)) {
        map.set(key, { key, color, variant, embroidery_points: (rawPts === null || rawPts === undefined || rawPts === "") ? null : Number(rawPts), indices: [] });
        order.push(key);
      }
      map.get(key).indices.push(idx);
    });
    return order.map(k => map.get(k));
  })();

  // Update warna/lengan/titik pada SEMUA baris dalam satu grup sekaligus.
  const updateGroupField = (grp, key, value) => {
    const sizes = item.sizes.map((s, idx) => grp.indices.includes(idx) ? { ...s, [key]: value } : s);
    onChange({ ...item, sizes });
  };

  // Tambah ukuran BARU pada grup ini (mewarisi warna/lengan/titik grup). Tanpa harga manual.
  const addSizeToGroup = (grp) => {
    const used = new Set(grp.indices.map(idx => item.sizes[idx].size));
    const next = sizeList.find(s => !used.has(s)) || "";
    const newRow = { size: next, quantity: 1, color: grp.color, variant: grp.variant };
    if (grp.embroidery_points !== null && grp.embroidery_points !== undefined) {
      newRow.embroidery_points = grp.embroidery_points;
    }
    onChange({ ...item, sizes: [...item.sizes, newRow] });
  };

  // Tambah VARIASI (kartu baru). Salin warna+titik dari grup PERTAMA sekali; lengan kosong (dipilih user).
  //   Harga manual TIDAK disalin.
  const addVariationGroup = () => {
    const firstGrp = groups[0];
    const defColor = firstGrp ? firstGrp.color : (item.color || "");
    const defPoints = firstGrp && firstGrp.embroidery_points != null ? firstGrp.embroidery_points : null;
    const newRow = { size: "", quantity: 1, color: defColor, variant: "" };
    if (defPoints !== null) newRow.embroidery_points = defPoints;
    onChange({ ...item, sizes: [...item.sizes, newRow] });
  };
  const names = productNames && productNames.length ? productNames : PRODUCTS;
  // Jika nama tersimpan tidak ada di daftar aktif (misal produk lama nonaktif), tetap tampilkan agar Nota lama tidak berubah
  const options = names.includes(item.name) ? names : [item.name, ...names];
  const isLainnya = item.name === "Lainnya" || item.name === "Produk Lainnya";
  return <article className="product-card" data-testid={`product-card-${index}`}>
    <div className="card-head">
      <div><span className="card-kicker">PRODUK {String(index+1).padStart(2,"0")}</span><h3>{isLainnya && item.custom_name ? item.custom_name : item.name}</h3></div>
      {canRemove && <button type="button" data-testid={`remove-product-${index}`} className="danger-icon" onClick={async ()=>{ const ok = await notify.confirm({ title:"Hapus produk ini?", message:"Produk beserta ukuran & catatannya akan dihapus dari nota ini.", primaryLabel:"Ya, Hapus Produk", secondaryLabel:"Batal", danger:true }); if (ok) onRemove(); }}><Trash2 size={18}/></button>}
    </div>
    <div className="fields">
      <Field label="Nama produk" required>
        <select data-testid={`product-name-${index}`} value={item.name} onChange={e=>{
          // Iter 137 — Auto-map bahan berdasar pilihan produk. Bila tidak ada mapping,
          // kosongkan material agar tidak membawa bahan dari produk sebelumnya.
          // Iter 150 — Ikut set `pricing_key` dari master supaya kalkulator terhubung
          // via kunci stabil, bukan pencocokan teks nama.
          const newName = e.target.value;
          const mappedMat = materialForProduct(newName);
          const pkey = (pricingKeyByProductName && pricingKeyByProductName[newName]) || "";
          // Iter 221m — Auto-set production_route + init sizes utk Jasa Bordir/Sablon.
          //   Field lain (color/sleeve/dtf_size dll.) di-reset supaya form simple bersih.
          if (newName === "Jasa Bordir" || newName === "Jasa Sablon") {
            const defaultRoute = newName === "Jasa Bordir" ? "Bordir" : "Sablon (DTF)";
            const defaultSablonType = newName === "Jasa Sablon" ? "DTF" : "";
            onChange({
              ...item,
              name: newName,
              material: "",  // reset — akan dipakai sbg "Jenis pakaian"
              pricing_key: "",  // selalu manual
              production_route: defaultRoute,
              sablon_type: defaultSablonType,
              process_mode: newName === "Jasa Bordir" ? "Bordir" : "Sablon",
              color: "",
              sleeve: "Tidak Berlaku",
              embroidery_points: 0,
              dtf_size: "",
              sizes: [{ size: "N/A", quantity: 0, unit_price: 0 }],
              quantity: 0,
              unit_price: 0,
              is_customer_material: true,
            });
            return;
          }
          // Iter 276 — Jersey category → auto-set production_route "Jersey/Sublim"
          //   (alur Mockup → Sublim → Selesai, bypass Rido/Gudang). collar_model
          //   direset ke "" saat ganti produk supaya tidak salah bawa antar-varian.
          // Iter 278 — Auto-set process_mode="Sublim" + sleeve otomatis mengikuti nama produk:
          //   Atasan/One Set Pendek → Pendek; Atasan/One Set Panjang → Panjang;
          //   Celana Jersey → tidak ada lengan; Jersey Baseball → pilihan tetap ke user.
          const cat = (categoryByProductName && categoryByProductName[newName]) || "";
          if (cat === "Jersey") {
            let autoSleeve = null;
            if (newName === "Atasan Jersey Pendek" || newName === "One Set Jersey Pendek") autoSleeve = "Pendek";
            else if (newName === "Atasan Jersey Panjang" || newName === "One Set Jersey Panjang") autoSleeve = "Panjang";
            else if (newName === "Celana Jersey") autoSleeve = "";  // tidak berlaku
            // Jersey Baseball → autoSleeve tetap null (biarkan pilihan user existing)
            const patch = {
              ...item,
              name: newName,
              material: mappedMat,
              pricing_key: "",
              production_route: "Jersey/Sublim",
              process_mode: "Sublim",
              sablon_type: "",
              collar_model: "",
              collar_note: "",
            };
            if (autoSleeve !== null) {
              patch.sleeve = autoSleeve || "Tidak Berlaku";
              patch.sizes = (item.sizes || []).map(sz => ({ ...sz, variant: autoSleeve }));
            }
            onChange(patch);
            return;
          }
          // Non-Jersey: reset process_mode="Sublim" residu supaya tidak nyangkut,
          //   dan clear collar_model/note. process_mode lain (Bordir/Sablon/dst) di-derive dari route/legacyMode.
          const cleanProcess = (item.process_mode === "Sublim") ? "" : (item.process_mode || "");
          onChange({ ...item, name: newName, material: mappedMat, pricing_key: pkey, collar_model: "", collar_note: "", process_mode: cleanProcess });
        }}>
          {options.map(p => (
            <option key={p} value={p}>{p}</option>
          ))}
        </select>
        {/* Iter 150 — Badge kecil di bawah select supaya user tahu status saat ini. */}
        <span className={`price-mode-badge ${item.pricing_key ? "auto" : "manual"}`} data-testid={`price-mode-badge-${index}`}>
          {item.pricing_key ? "Harga otomatis" : "Harga manual"}
        </span>
        {/* Iter 221l — Badge "Bahan Customer" utk Jasa Bordir/Jasa Sablon. */}
        {(item.name === "Jasa Bordir" || item.name === "Jasa Sablon") && (
          <span
            className="price-mode-badge"
            data-testid={`customer-material-badge-${index}`}
            style={{marginLeft:6, background:"#fff4d9", color:"#7a5100", borderColor:"#e6c46b"}}
          >Bahan Pelanggan</span>
        )}
      </Field>
      {/* Iter 276 — Model Kerah untuk atasan Jersey. Muncul HANYA untuk:
          Atasan Jersey Pendek/Panjang, One Set Jersey Pendek/Panjang, Jersey Baseball.
          Celana Jersey tidak butuh kerah — field disembunyikan. */}
      {(categoryByProductName && categoryByProductName[item.name]) === "Jersey"
        && item.name !== "Celana Jersey" && (
        <div style={{display:"grid", gridTemplateColumns: (item.collar_model === "Lainnya" ? "1fr 1fr" : "1fr"), gap:8}}>
          <Field label="Model Kerah" required>
            <select data-testid={`collar-model-${index}`} value={item.collar_model || ""}
              onChange={e=>onChange({ ...item, collar_model: e.target.value, collar_note: e.target.value === "Lainnya" ? (item.collar_note || "") : "" })}>
              <option value="">Pilih model kerah…</option>
              <option value="O-neck">O-neck</option>
              <option value="V-neck">V-neck</option>
              <option value="Kerah Polo">Kerah Polo</option>
              <option value="Lainnya">Lainnya (isi keterangan)</option>
            </select>
          </Field>
          {item.collar_model === "Lainnya" && <Field label="Keterangan Kerah" required>
            <input type="text" data-testid={`collar-note-${index}`}
              value={item.collar_note || ""}
              onChange={e=>onChange({ ...item, collar_note: e.target.value })}
              placeholder="Contoh: kerah shanghai, kerah cina, kerah bulat lebar…"/>
          </Field>}
        </div>
      )}
      {/* Iter 221m — SIMPLE FORM khusus Jasa Bordir & Jasa Sablon (Bahan Customer).
          HIDE: Jalur (Polosan), Polosan Siap Stok, Variasi (Warna·Lengan·Ukuran), Tambah Variasi, dsb.
          Data lain (sizes[0].size="N/A", production_route auto) di-set otomatis di onChange & backend. */}
      {(item.name === "Jasa Bordir" || item.name === "Jasa Sablon") ? (() => {
        const JENIS_PAKAIAN = ["Kaos","Polo","Kemeja","Jaket","Topi","Tas","Lainnya"];
        const UKURAN_SABLON = ["A5","A4","A3","A3+","Custom"];
        const JENIS_SABLON = ["DTF","Plastisol","Lainnya"];
        const row0 = (item.sizes && item.sizes[0]) || { size:"N/A", quantity:0, unit_price:0 };
        const isBordir = item.name === "Jasa Bordir";
        const setSimple = (patch) => {
          // Sinkronkan sizes[0] + item.quantity + item.unit_price supaya schema tetap valid.
          //   embroidery_points disimpan di sizes[0] (per-variasi pattern Iter 149).
          const merged = { ...item, ...patch };
          const q = Number(patch.quantity ?? row0.quantity ?? 0);
          const p = Number(patch.unit_price ?? row0.unit_price ?? 0);
          const pts = Number(patch.embroidery_points ?? item.embroidery_points ?? 0);
          merged.quantity = q;
          merged.unit_price = p;
          merged.embroidery_points = pts;  // simpan juga di product-level untuk UI state
          // Iter 584 — harga Jasa diketik admin → baris Manual (satu sumber harga, tanpa fallback).
          merged.sizes = [{ size:"N/A", quantity:q, unit_price:p, price_manual: p > 0, embroidery_points: pts || undefined }];
          onChange(merged);
        };
        return <div className="fields" data-testid={`jasa-simple-form-${index}`} style={{gridColumn:"1 / -1", display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(200px, 1fr))", gap:12, marginTop:10}}>
          <Field label="Jenis pakaian">
            <select
              data-testid={`jasa-jenis-pakaian-${index}`}
              value={item.material || ""}
              onChange={e=>setSimple({ material: e.target.value })}
              aria-label="Jenis pakaian pelanggan"
            >
              <option value="">Pilih jenis…</option>
              {JENIS_PAKAIAN.map(j => <option key={j} value={j}>{j}</option>)}
            </select>
          </Field>
          <Field label="Qty (pcs)" required>
            <input
              type="number" min="1"
              data-testid={`jasa-qty-${index}`}
              value={row0.quantity || ""}
              onChange={e=>setSimple({ quantity: Number(e.target.value || 0) })}
              placeholder="Jumlah pcs"
            />
          </Field>
          <Field label="Harga per pcs (Rp)" required>
            <input
              type="number" min="0"
              data-testid={`jasa-harga-${index}`}
              value={row0.unit_price || ""}
              onChange={e=>setSimple({ unit_price: Number(e.target.value || 0) })}
              placeholder="Harga jasa per pcs"
            />
          </Field>
          {!isBordir && <Field label="Ukuran sablon (opsional)">
            <select
              data-testid={`jasa-sablon-size-${index}`}
              value={item.dtf_size || ""}
              onChange={e=>setSimple({ dtf_size: e.target.value })}
            >
              <option value="">Tidak dipilih</option>
              {UKURAN_SABLON.map(u => <option key={u} value={u}>{u}</option>)}
            </select>
          </Field>}
          {!isBordir && <Field label="Jenis sablon (opsional)">
            <select
              data-testid={`jasa-sablon-type-${index}`}
              value={item.sablon_type || ""}
              onChange={e=>{
                const val = e.target.value;
                setSimple({
                  sablon_type: val,
                  production_route: val === "DTF" ? "Sablon (DTF)"
                    : val === "Plastisol" ? "Sablon (Plastisol)"
                    : "Sablon/DTF"
                });
              }}
            >
              <option value="">Tidak dipilih</option>
              {JENIS_SABLON.map(j => <option key={j} value={j}>{j}</option>)}
            </select>
          </Field>}
          {isBordir && <Field label="Titik bordir (opsional)">
            <input
              type="number" min="0"
              data-testid={`jasa-titik-${index}`}
              value={item.embroidery_points || ""}
              onChange={e=>setSimple({ embroidery_points: Number(e.target.value || 0) })}
              placeholder="mis. 3"
            />
          </Field>}
          <Field label="Catatan (opsional)">
            <input
              data-testid={`jasa-note-${index}`}
              value={item.note || ""}
              onChange={e=>setSimple({ note: e.target.value })}
              placeholder="Instruksi khusus, warna benang, dll"
            />
          </Field>
          <div style={{gridColumn:"1 / -1", padding:"10px 12px", background:"#faf7ea", border:"1px solid #e6c46b", borderRadius:8, fontSize:13, color:"#7a5100"}}>
            <strong>Jasa {isBordir ? "Bordir" : "Sablon"} — Bahan Pelanggan.</strong> Tidak mengurangi stok TAMFARIS.
            Jalur produksi otomatis: <strong>{item.production_route || (isBordir ? "Bordir" : "Sablon")}</strong>.
          </div>
        </div>;
      })() : null}
      {isLainnya && <Field label="Nama produk manual" required>
        <input data-testid={`product-custom-name-${index}`} value={item.custom_name || ""} onChange={e=>change("custom_name",e.target.value)} placeholder="Tulis nama produk"/>
      </Field>}
      {/* Iter 278 — Jersey: proses tetap "Sublim" (tidak perlu pilih Bordir/Sablon/Jahit). */}
      {(categoryByProductName && categoryByProductName[item.name]) === "Jersey" && (
        <Field label={<><Workflow size={13} className="field-icon" aria-hidden="true"/>Proses Produk</>}>
          <input
            type="text"
            value="Sublim"
            readOnly
            data-testid={`product-proses-jersey-${index}`}
            aria-label="Proses produk Jersey (Sublim)"
            style={{background:"#faf7ea", border:"1px solid #e6c46b", color:"#7a5100", fontWeight:600}}
          />
          <p className="muted small" style={{marginTop:4}}>Jersey otomatis melewati Mockup → Sublim (Ahmad Rifky) → Finalisasi Shella. Tidak melalui Gudang.</p>
        </Field>
      )}
      {/* Iter 59 — Proses Produk 6 pilihan single-select untuk Custom. Polos tetap pakai dropdown legacy di bawah. */}
      {/* Iter 221m — HIDE Proses Produk/Jalur untuk Jasa Bordir/Sablon (Bahan Customer). */}
      {/* Iter 278 — Bypass untuk Jersey (sudah di-render di atas sebagai Field tetap). */}
      {orderType === "Custom" && item.name !== "Jasa Bordir" && item.name !== "Jasa Sablon"
        && (categoryByProductName && categoryByProductName[item.name]) !== "Jersey"
        && (() => {
        const pr = item.production_route || "";
        // Priority: process_mode tersimpan (dari save/edit) → fallback derive dari production_route.
        const legacyMode = pr === "Bordir" ? "Bordir"
          : pr.startsWith("Bordir + Sablon") ? "Bordir+Sablon"
          : (pr.startsWith("Sablon (") || pr === "Sablon/DTF" || pr === "Sablon/DTF + Press") ? "Sablon"
          : pr === "Polosan Perlu Jahit" ? "Jahit"
          : "";
        const mode = item.process_mode || legacyMode;
        const t = String(customType||"").trim().toLowerCase();
        const derivedTypeFallback = t === "dtf" ? "DTF" : (t === "plastisol" ? "Plastisol" : "");
        const sType = item.sablon_type ||
          (pr === "Sablon (DTF)" || pr === "Bordir + Sablon (DTF)" ? "DTF"
          : pr === "Sablon (Plastisol)" || pr === "Bordir + Sablon (Plastisol)" ? "Plastisol"
          : derivedTypeFallback);
        // Mapping mode → production_route (backend tetap pakai route existing).
        const deriveRoute = (m, st) => {
          if (m === "Bordir") return "Bordir";
          if (m === "Sablon") return st ? `Sablon (${st})` : "Sablon/DTF";
          if (m === "Bordir+Sablon") return st ? `Bordir + Sablon (${st})` : "";
          if (m === "Jahit") return "Polosan Perlu Jahit";
          if (m === "Jahit+Bordir") return "Bordir"; // Gudang stage mencakup jahit sebelum Bordir
          if (m === "Jahit+Sablon") return st ? `Sablon (${st})` : "Sablon/DTF"; // Gudang di Sablon Paralel mencakup jahit
          return "";
        };
        const pickMode = (m) => {
          const needsType = (m === "Sablon" || m === "Bordir+Sablon" || m === "Jahit+Sablon");
          // Iter 208 — Fix radio DTF/Plastisol auto-checked tapi state kosong.
          // Bila mode butuh jenis sablon, default ke sType existing (atau derived dari
          // form.custom_type), fallback "DTF" supaya production_route langsung
          // "Sablon (DTF)" — bukan "Sablon/DTF" ambigu yang bikin radio visually
          // checked tetapi klik user tidak fire onChange.
          const keepType = needsType ? (sType || derivedTypeFallback || "DTF") : "";
          onChange({ ...item, process_mode: m, production_route: deriveRoute(m, keepType), sablon_type: keepType });
        };
        const pickType = (val) => {
          const m = mode || "Sablon";
          onChange({ ...item, sablon_type: val, production_route: deriveRoute(m, val), process_mode: m });
        };
        const needType = mode === "Sablon" || mode === "Bordir+Sablon" || mode === "Jahit+Sablon";
        const opts = [
          { id: "Bordir", label: "Bordir", hint: "Desain bordir → bordir pada garment." },
          { id: "Sablon", label: "Sablon", hint: "Pilih jenis: DTF atau Plastisol." },
          { id: "Bordir+Sablon", label: "Bordir + Sablon", hint: "Bordir dan sablon dalam 1 produk." },
          { id: "Jahit", label: "Jahit", hint: "Jahit garment dari bahan dasar." },
          { id: "Jahit+Bordir", label: "Jahit + Bordir", hint: "Jahit polos lalu bordir." },
          { id: "Jahit+Sablon", label: "Jahit + Sablon", hint: "Jahit polos lalu sablon." },
        ];
        return <Field label={<><Workflow size={13} className="field-icon" aria-hidden="true"/>Proses Produk</>} required>
          {/* Iter 206 — Layout responsif:
              • Desktop / tablet lebar (≥821px): 3 × 2 kartu
              • Tablet sedang (641–820px)       : 2 × 3 kartu
              • HP / sempit (≤640px)            : dropdown + hint singkat
              Cards & select bind ke `mode` yang sama → state konsisten saat resize/rotate. */}
          <div className="proses-produk-multi" data-testid={`product-proses-wrap-${index}`}>
            {opts.map(o => (
              <label key={o.id} data-mode={o.id.toLowerCase()} className={`proses-opt ${mode===o.id?"active":""}`} data-testid={`product-proses-${o.id.toLowerCase().replace("+","-plus-")}-${index}`}>
                <input type="radio" name={`proses-mode-${index}`} checked={mode===o.id} onChange={()=>pickMode(o.id)}/>
                <span className="proses-opt-title"><span className="proses-dot" aria-hidden="true"/>{o.label}</span>
                <small className="muted">{o.hint}</small>
                {mode===o.id && <CheckCircle2 className="sablon-type-check" size={18} aria-hidden="true"/>}
              </label>
            ))}
          </div>
          <select
            className="proses-produk-select"
            data-testid={`product-proses-select-${index}`}
            aria-label="Proses produk"
            value={mode}
            onChange={e=>pickMode(e.target.value)}
          >
            <option value="" disabled>Pilih proses produk…</option>
            {opts.map(o => <option key={o.id} value={o.id}>{o.label}</option>)}
          </select>
          {mode && (
            <p className="proses-mobile-hint muted" data-testid={`product-proses-hint-${index}`}>
              {opts.find(o=>o.id===mode)?.hint || ""}
            </p>
          )}
          {needType && <div className="sablon-type-radio" data-testid={`product-sablon-type-wrap-${index}`} style={{marginTop:10}}>
            <label className={`sablon-type-opt ${sType==="DTF"?"active":""}`} data-testid={`product-sablon-type-dtf-${index}`}>
              <input type="radio" name={`sablon-type-${index}`} checked={sType==="DTF"} onChange={()=>pickType("DTF")}/>
              <span>DTF</span>
              <small className="muted">Transfer film + Mesin Press.</small>
              {sType==="DTF" && <CheckCircle2 className="sablon-type-check" size={18} aria-hidden="true"/>}
            </label>
            <label className={`sablon-type-opt ${sType==="Plastisol"?"active":""}`} data-testid={`product-sablon-type-plastisol-${index}`}>
              <input type="radio" name={`sablon-type-${index}`} checked={sType==="Plastisol"} onChange={()=>pickType("Plastisol")}/>
              <span>Plastisol</span>
              <small className="muted">Sablon plastisol tanpa mesin press.</small>
              {sType==="Plastisol" && <CheckCircle2 className="sablon-type-check" size={18} aria-hidden="true"/>}
            </label>
          </div>}
        </Field>;
      })()}
      {orderType !== "Custom" && item.name !== "Jasa Bordir" && item.name !== "Jasa Sablon"
        && (categoryByProductName && categoryByProductName[item.name]) !== "Jersey"
        && routeChoice && routeChoice.options && routeChoice.options.length > 0 && <Field label={routeChoice.label || "Jalur produksi"} required>
        <select
          data-testid={`product-route-${index}`}
          value={
            item.production_route === "Sablon/DTF + Press" ? "Sablon/DTF"
            : item.production_route === "Sablon (DTF)" || item.production_route === "Sablon (Plastisol)" ? "Sablon/DTF"
            : (item.production_route || "")
          }
          onChange={e=>{
            const v = e.target.value;
            // Reset flag press bila user pindah dari Sablon/DTF ke jalur lain.
            change("production_route", v);
          }}
        >
          <option value="">Pilih jalur…</option>
          {routeChoice.options.map(r=><option key={r} value={r}>{r === "Non-Produksi" ? "Non-Produksi / Biaya Tambahan" : r}</option>)}
        </select>
        {item.production_route === "Non-Produksi" && <small style={{display:"block",marginTop:4,fontSize:12,opacity:.8}} data-testid={`product-nonprod-hint-${index}`}>Biaya tambahan (XXL, bordir, setting, dll.): tercatat di nota, pembayaran &amp; laporan — tidak membuat pekerjaan produksi dan tidak dihitung stok/pcs.</small>}
      </Field>}
      {orderType !== "Custom" && item.name !== "Jasa Bordir" && item.name !== "Jasa Sablon" && (() => {
        // Iter 44/51 — Jenis Sablon (DTF/Plastisol) — hanya berlaku untuk Polos route lama yg tidak di-Custom.
        // Untuk Custom, radio DTF/Plastisol sudah dirender di dalam Proses Produk multi-select di atas.
        const t = String(customType||"").trim().toLowerCase();
        const isAutoSablon = orderType === "Custom" && (t === "dtf" || t === "sablon" || t === "plastisol");
        const isSelectedSablon = ["Sablon/DTF","Sablon/DTF + Press","Sablon (DTF)","Sablon (Plastisol)"].includes(item.production_route);
        if (!isAutoSablon && !isSelectedSablon) return null;
        const currentType = item.sablon_type ||
          (item.production_route === "Sablon (DTF)" ? "DTF"
          : item.production_route === "Sablon (Plastisol)" ? "Plastisol"
          : item.production_route === "Sablon/DTF + Press" ? "DTF"
          : t === "plastisol" ? "Plastisol"
          : t === "dtf" ? "DTF"
          : "");
        const setType = (val) => {
          onChange({
            ...item,
            sablon_type: val,
            production_route: val === "DTF" ? "Sablon (DTF)" : val === "Plastisol" ? "Sablon (Plastisol)" : item.production_route,
          });
        };
        return <Field label="Jenis Sablon" required>
          <div className="sablon-type-radio" data-testid={`product-sablon-type-wrap-${index}`}>
            <label className={`sablon-type-opt ${currentType==="DTF"?"active":""}`} data-testid={`product-sablon-type-dtf-${index}`}>
              <input
                type="radio"
                name={`sablon-type-${index}`}
                checked={currentType==="DTF"}
                onChange={()=>setType("DTF")}
              />
              <span>DTF</span>
              <small className="muted">Paralel Ibnu + Rido → Mesin Press.</small>
              {currentType==="DTF" && <CheckCircle2 className="sablon-type-check" size={18} aria-hidden="true"/>}
            </label>
            <label className={`sablon-type-opt ${currentType==="Plastisol"?"active":""}`} data-testid={`product-sablon-type-plastisol-${index}`}>
              <input
                type="radio"
                name={`sablon-type-${index}`}
                checked={currentType==="Plastisol"}
                onChange={()=>setType("Plastisol")}
              />
              <span>Plastisol</span>
              <small className="muted">Paralel Ibnu + Rido, tanpa press.</small>
              {currentType==="Plastisol" && <CheckCircle2 className="sablon-type-check" size={18} aria-hidden="true"/>}
            </label>
          </div>
        </Field>;
      })()}
      {/* Iter 208 — Dropdown Ukuran Sablon DTF: hanya tampil bila varian butuh dtf_size
          (Kaos Combed 24s + Sablon DTF). Di-clear otomatis saat produk/proses berubah ke
          non-DTF (useEffect di atas). */}
      {autoPriceNeedsDtfSize(item.name, item.material, item.pricing_key) && item.production_route === "Sablon (DTF)" && (
        <Field label="Ukuran sablon DTF" required>
          <select
            data-testid={`product-dtf-size-${index}`}
            value={item.dtf_size || ""}
            onChange={e => onChange({ ...item, dtf_size: e.target.value })}
            aria-label="Ukuran sablon DTF"
          >
            <option value="" disabled>Pilih ukuran DTF…</option>
            {DTF_SIZES.map(s => <option key={s} value={s}>{s}</option>)}
          </select>
        </Field>
      )}
      {/* Iter 137 — Dropdown Bahan dihapus. Bahan diambil otomatis dari pemetaan
          nama produk (materialForProduct). Data bahan nota lama tetap terlindungi. */}
      {/* Iter 147 — Warna produk-level dihapus (dipindah ke per-variasi). `item.color` di state
          tetap dijaga sebagai fallback nota lama. */}
    </div>
    {/* Iter 221m — Skip blok Variasi (Warna·Lengan·Ukuran) untuk Jasa Bordir/Sablon (Bahan Customer). */}
    {item.name !== "Jasa Bordir" && item.name !== "Jasa Sablon" && (() => { const hasBordir = /bordir/i.test(String(item.production_route || "")); return <>
    <div className="variation-head">
      <span><Palette size={14} aria-hidden="true"/>Variasi produk (Warna · Lengan{hasBordir ? " · Titik" : ""})</span>
      <strong>Total {total} pcs</strong>
    </div>
    {groups.map((grp, gIdx) => (
      <section
        className="variation-group"
        key={`${grp.key}-${gIdx}`}
        data-testid={`variation-group-${index}-${gIdx}`}
      >
        {/* Iter 207 — Header kartu variasi: warna+lengan(+titik) diisi sekali untuk semua ukuran di dalamnya. */}
        <div className={`variation-group-head ${hasBordir ? "with-points" : ""}`}>
          <Field label="Warna">
            <MasterCombo
              testId={`variation-group-color-${index}-${gIdx}`}
              value={grp.color}
              onChange={v => updateGroupField(grp, "color", v)}
              options={colorNames || []}
              optionGroups={colorOptionGroups}
              placeholder="Pilih warna"
            />
          </Field>
          {/* Iter 278 — Celana Jersey tidak memerlukan lengan. Sembunyikan field.
              Atasan/One Set Jersey Pendek/Panjang: lengan ditetapkan otomatis dari nama produk
              saat pilih di dropdown Nama produk; input Lengan disembunyikan supaya user
              tidak mengganti manual (data variant tetap tersimpan). */}
          {item.name !== "Celana Jersey"
            && item.name !== "Atasan Jersey Pendek" && item.name !== "Atasan Jersey Panjang"
            && item.name !== "One Set Jersey Pendek" && item.name !== "One Set Jersey Panjang"
            && <Field label="Lengan">
            <select
              data-testid={`variation-group-variant-${index}-${gIdx}`}
              value={grp.variant}
              onChange={e => updateGroupField(grp, "variant", e.target.value)}
              aria-label="Lengan variasi"
            >
              <option value="">—</option>
              <option value="Panjang">Panjang</option>
              <option value="Pendek">Pendek</option>
            </select>
          </Field>}
          {hasBordir && (
            <Field label="Titik bordir">
              <input
                data-testid={`variation-group-points-${index}-${gIdx}`}
                type="number"
                inputMode="numeric"
                min="0"
                placeholder="titik"
                value={grp.embroidery_points !== null && grp.embroidery_points !== undefined ? grp.embroidery_points : ""}
                onChange={e => {
                  const raw = e.target.value;
                  const nextPts = raw === "" ? null : (Number.isFinite(Number(raw)) ? Number(raw) : null);
                  updateGroupField(grp, "embroidery_points", nextPts);
                }}
                aria-label="Titik bordir variasi"
              />
            </Field>
          )}
          {groups.length > 1 && (
            <button
              type="button"
              className="danger-icon variation-group-remove"
              data-testid={`variation-group-remove-${index}-${gIdx}`}
              aria-label="Hapus variasi ini"
              title="Hapus variasi ini"
              onClick={async () => {
                const ok = await notify.confirm({
                  title: "Hapus variasi ini?",
                  message: `Semua ukuran di variasi ${grp.color || "tanpa warna"} · ${grp.variant || "tanpa lengan"} akan dihapus.`,
                  primaryLabel: "Ya, Hapus",
                  secondaryLabel: "Batal",
                  danger: true,
                });
                if (!ok) return;
                const toRemove = new Set(grp.indices);
                onChange({ ...item, sizes: item.sizes.filter((_, n) => !toRemove.has(n)) });
              }}
            ><Trash2 size={16}/></button>
          )}
        </div>
        {/* Header kolom tabel ukuran (desktop). Mobile: labels via data-label pada .var-cell. */}
        <div className="variation-sizes-head" aria-hidden="true">
          <span>Ukuran</span>
          <span className="col-right">Jumlah</span>
          <span className="col-right">Harga/pcs</span>
          <span className="col-right">Subtotal</span>
          <span/>
        </div>
        {grp.indices.map(i => {
          const row = item.sizes[i];
          const inList = sizeList.includes(row.size);
          const rowIsCustom = row.custom === true || (row.size !== "" && !inList);
          const selectValue = rowIsCustom ? "__lainnya__" : row.size;
          const setRow = (patch) => { const sizes = item.sizes.map((s, n) => n === i ? { ...s, ...patch } : s); onChange({ ...item, sizes }); };
          // Iter 207 — Dedup di dalam grup: tidak boleh ada 2 ukuran identik dalam 1 grup
          //   (warna+lengan+titik sudah sama). Antar grup boleh sama (nota lama campuran).
          const isDupInGroup = (nextSize) => grp.indices.some(n => n !== i && String(item.sizes[n].size || "").trim().toLowerCase() === String(nextSize || "").trim().toLowerCase() && nextSize);
          const warnDup = () => notify.warning({ title: "Ukuran duplikat", message: "Ukuran ini sudah ada di variasi (kartu) ini. Ubah ukuran atau tambah jumlah pada baris yang sudah ada." });
          const hasCalcBase = Number(item.auto_price_base ?? item._priceAutoBase ?? 0) > 0;
          const effective = effectiveFor(row);
          const isManual = (row.price_manual === true || row._manual === true) && Number(row.unit_price || 0) > 0;
          const isCalc = !isManual && hasCalcBase;
          const isEligibleAuto = autoEligible;
          const rowReady = rowReadyForAutoPrice(item, row);
          const showIncomplete = !isManual && ((isEligibleAuto && (!hasCalcBase || !rowReady)) || (!isEligibleAuto && effective <= 0));
          const incompleteText = isEligibleAuto ? "Harga Belum Tersedia · lengkapi detail" : "Harga Belum Tersedia · isi harga";
          const autoNow = isManual ? computeRowEffective(item, { ...row, price_manual: false, _manual: false, unit_price: 0 }, embroideryPoints) : 0;
          const needsReview = isManual && row.price_manual_ref != null && (priceRefKey(row) !== row.price_manual_ref
            || (autoNow > 0 && Number(row.price_auto_ref || 0) > 0 && autoNow !== Number(row.price_auto_ref)));
          const useAuto = async () => {
            if (!(rowReady && autoNow > 0)) {
              notify.warning({ title: "Harga otomatis belum tersedia", message: `Baris ${row.size || "khusus"} belum bisa dihitung otomatis. Harga manual Rp${Number(row.unit_price).toLocaleString("id-ID")} tetap dipakai.` });
              return;
            }
            const ok = await notify.confirm({ title: `Gunakan harga otomatis untuk ${row.size || "baris ini"}?`,
              message: `Harga manual Rp${Number(row.unit_price).toLocaleString("id-ID")} akan diganti harga otomatis Rp${autoNow.toLocaleString("id-ID")} per pcs. Hanya baris ini yang berubah.`,
              primaryLabel: "Ya, gunakan otomatis", secondaryLabel: "Batal" });
            if (ok) changeSize(i, "unit_price", 0);
          };
          const displayPrice = isManual ? Number(row.unit_price) : (showIncomplete ? 0 : effective);
          const rowSubtotal = displayPrice * Number(row.quantity || 0);
          return <div className={`variation-size-row ${isManual ? "is-manual" : (isCalc ? "is-calc" : "is-auto")}`} key={i} data-testid={`variation-row-${index}-${i}`}>
            <div className="var-cell var-size" data-label="Ukuran">
              <select data-testid={`size-select-${index}-${i}`} value={selectValue} onChange={e => {
                const v = e.target.value;
                if (v === "__lainnya__") { setRow({ size: "", custom: true }); return; }
                if (isDupInGroup(v)) { warnDup(); return; }
                setRow({ size: v, custom: false });
              }}>
                <option value="">Pilih ukuran</option>
                {sizeList.map(s => <option key={s} value={s}>{s}</option>)}
                {!inList && row.size !== "" && !rowIsCustom && <option value={row.size}>{row.size}</option>}
                <option value="__lainnya__">Lainnya…</option>
              </select>
              {rowIsCustom && <input data-testid={`size-manual-${index}-${i}`} value={row.size} onChange={e => {
                const v = e.target.value;
                if (isDupInGroup(v)) { warnDup(); return; }
                setRow({ size: v, custom: true });
              }} placeholder="Ketik ukuran khusus" className="size-manual-input"/>}
            </div>
            <div className="var-cell var-qty" data-label="Jumlah">
              <input data-testid={`size-quantity-${index}-${i}`} type="number" inputMode="numeric" min="1" aria-label={`Jumlah ${row.size||"khusus"}`} value={row.quantity} onChange={e => changeSize(i, "quantity", stripZero(e.target.value))}/>
            </div>
            <div className="var-cell var-price" data-label="Harga/pcs">
              <div className="size-price-wrap">
                <input
                  data-testid={`size-price-${index}-${i}`}
                  type="number"
                  inputMode="numeric"
                  min="0"
                  aria-label={`Harga satuan ${row.size||"khusus"}`}
                  placeholder={showIncomplete ? "Lengkapi detail…" : (effective > 0 ? `Rp${effective.toLocaleString("id-ID")}` : "Harga")}
                  value={isManual ? row.unit_price : ""}
                  onChange={e => changeSize(i, "unit_price", stripZero(e.target.value))}
                  className={`size-price-input ${isManual ? "size-price-manual" : (isCalc ? "size-price-calc" : "size-price-auto")}`}
                />
                <span className={`size-price-mode ${isManual ? "manual" : (showIncomplete ? "pending" : (isCalc ? "calc" : "auto"))}`} data-testid={`size-price-mode-${index}-${i}`}>
                  {isManual ? (
                    <>
                      <span>Manual · Rp{Number(row.unit_price).toLocaleString("id-ID")}</span>
                      <button type="button" className="size-price-reset" data-testid={`size-price-reset-${index}-${i}`}
                        title={rowReady && autoNow > 0 ? `Gunakan harga otomatis (Rp${autoNow.toLocaleString("id-ID")})` : "Harga otomatis belum tersedia"}
                        aria-label={`Gunakan harga otomatis untuk variasi ${row.size || "khusus"}`}
                        onClick={useAuto}>Gunakan otomatis</button>
                    </>
                  ) : showIncomplete ? (<span>{incompleteText}</span>) : (<span>Otomatis · Rp{effective.toLocaleString("id-ID")}</span>)}
                </span>
                {needsReview && <span className="size-price-review" role="alert" data-testid={`size-price-review-${index}-${i}`}>
                  Detail/jumlah berubah — tinjau harga manual{autoNow > 0 ? ` (otomatis sekarang Rp${autoNow.toLocaleString("id-ID")})` : ""}</span>}
                {/* Iter 214 — Chip snapshot harga: tampilkan Δ vs harga baris di nota lama */}
                {oldPricesForProduct && !isManual && !showIncomplete && effective > 0 && oldPricesForProduct[String(i)] !== undefined && oldPricesForProduct[String(i)] !== effective && (() => {
                  const oldP = Number(oldPricesForProduct[String(i)] || 0);
                  const delta = effective - oldP;
                  const isUp = delta > 0;
                  return <span className={`price-delta-chip ${isUp ? "up" : "down"}`} data-testid={`price-delta-chip-${index}-${i}`} title={`Harga lama: Rp${oldP.toLocaleString("id-ID")}`}>
                    {isUp ? <TrendingUp size={11} aria-hidden="true"/> : <TrendingDown size={11} aria-hidden="true"/>}
                    {isUp ? "+" : "−"}Rp{Math.abs(delta).toLocaleString("id-ID")}
                    <span className="price-delta-chip-old">vs Rp{oldP.toLocaleString("id-ID")}</span>
                  </span>;
                })()}
              </div>
            </div>
            <div className="var-cell var-subtotal" data-label="Subtotal" data-testid={`variation-subtotal-${index}-${i}`}>
              {showIncomplete ? <span className="muted small">—</span> : <>Rp{rowSubtotal.toLocaleString("id-ID")}</>}
            </div>
            <div className="var-cell var-action">
              {item.sizes.length > 1 && <button type="button" data-testid={`remove-size-${index}-${i}`} className="danger-icon" aria-label="Hapus ukuran" title="Hapus ukuran ini" onClick={() => change("sizes", item.sizes.filter((_, n) => n !== i))}><X size={16}/></button>}
            </div>
          </div>;
        })}
        <button
          type="button"
          className="add-link variation-add-size"
          data-testid={`add-size-in-group-${index}-${gIdx}`}
          onClick={() => addSizeToGroup(grp)}
        ><Plus size={15}/>Tambah ukuran</button>
      </section>
    ))}
    <button
      type="button"
      className="add-link variation-add-group"
      data-testid={`add-size-${index}`}
      onClick={addVariationGroup}
    ><Plus size={15}/>Tambah variasi</button>
    </>; })()}
    <div className="fields single-col">
      {/* Iter 201 — Field "Harga satuan default" disembunyikan dari UI Aurel supaya form
          lebih sederhana. Nilainya tetap disimpan di DOM (hidden) sebagai:
            • Fallback effectiveFor(row) untuk variasi tanpa Hitung Harga dan tanpa manual.
            • Kompatibilitas nota lama yang menyimpan harga di level produk (bukan per row).
          Semua variasi baku sekarang: kalkulator (Hitung Harga) atau manual per baris. */}
      {/* Iter 584 — Field "Harga satuan default" dihapus dari form. item.unit_price tetap
          disimpan sebagai nilai internal (cermin kalkulator) — tidak bisa diketik admin. */}
      {/* Iter 131 — Tombol "Hitung Harga" (PDH biasa + Bordir). Manual click, tidak ada auto-fill. */}
      <AutoPriceHint item={item} index={index} orderType={orderType}/>
    </div>
    <div className="setting-fee-toggle" data-testid={`product-setting-toggle-wrap-${index}`} style={{display: orderType === "Polos" ? "none" : undefined}}>
      <label className="setting-fee-label">
        <input type="checkbox" data-testid={`product-setting-toggle-${index}`} checked={settingOn} onChange={e=>{ const on = e.target.checked; setSettingOn(on); change("setting_fee", on ? (Number(item.setting_fee)>0 ? item.setting_fee : 15000) : 0); }}/>
        <span>Tambahkan biaya setting</span>
      </label>
      {settingOn && <input data-testid={`product-setting-fee-${index}`} type="number" inputMode="numeric" min="0" value={item.setting_fee} onChange={e=>change("setting_fee",stripZero(e.target.value))} placeholder="15000" className="setting-fee-input"/>}
    </div>
    <button type="button" data-testid={`product-options-toggle-${index}`} className="options-toggle" onClick={()=>setShowOptions(v=>!v)} aria-expanded={showOptions}>
      <span className="options-toggle-label">Diskon &amp; keterangan</span>
      <span className="options-toggle-chev" aria-hidden="true">{showOptions ? <ChevronUp size={15}/> : <ChevronDown size={15}/>}</span>
    </button>
    {showOptions && <div className="options-block" data-testid={`product-options-block-${index}`}>
      <div className="fields single-col">
        <Field label="Diskon produk"><input data-testid={`product-discount-${index}`} type="number" inputMode="numeric" min="0" value={item.discount} onChange={e=>change("discount",stripZero(e.target.value))}/></Field>
      </div>
      <Field label="Keterangan produk"><textarea data-testid={`product-note-${index}`} value={item.note} onChange={e=>change("note",e.target.value)}/></Field>
    </div>}
    <div className="subtotal-line"><span>Subtotal Produk</span><strong data-testid={`product-subtotal-${index}`}>{money(subtotal)}</strong></div>
  </article>;
}

// Iter 345 — Format rupiah "Rp25.000" display; nilai disimpan sebagai angka (25000).
//   Tidak mengubah validasi, perhitungan, atau yang dikirim ke backend (filter > 0 di save).
const formatIDRInput = n => {
  const num = Number(n) || 0;
  if (num === 0) return "";
  return "Rp" + num.toLocaleString("id-ID");
};
const parseIDRInput = s => {
  const digits = String(s || "").replace(/\D/g, "");
  return digits === "" ? 0 : Number(digits);
};
// Label tampilan metode: "Cash" → "Tunai" (nilai internal tetap "Cash").
const paymentMethodLabel = m => m === "Cash" ? "Tunai" : m;

function PaymentRowItem({ row, i, update, onRemove }) {
  // Iter 345 — Ekspansi otomatis "Detail tambahan" bila sudah ada data agar admin tidak
  //   kehilangan konteks saat edit nota existing / melipat menu.
  const [showDetails, setShowDetails] = useState(!!(row.reference || row.note || row.proof));
  const fileInputRef = useRef(null);
  const isCash = row.method === "Cash";
  const proofInput = (
    <>
      <input
        ref={fileInputRef}
        data-testid={`payment-proof-${i}`}
        type="file"
        accept="image/*"
        capture="environment"
        onChange={e=>update(i,"proof", e.target.files?.[0] || null)}
        style={{display:"none"}}
      />
      <div className="pay-upload-wrap">
        <button type="button" className="soft-btn pay-upload-btn" data-testid={`payment-upload-btn-${i}`} onClick={()=>fileInputRef.current?.click()}>
          <Upload size={14} aria-hidden="true"/>{row.proof ? "Ganti bukti" : "Unggah bukti"}
        </button>
        {row.proof && <span className="pay-upload-name" data-testid={`payment-proof-name-${i}`} title={row.proof.name}>{row.proof.name}</span>}
      </div>
    </>
  );
  return <div className="payment-card">
    <div className="card-head">
      <strong>Transaksi {i+1}</strong>
      <button
        type="button"
        data-testid={`remove-payment-${i}`}
        className="danger-icon"
        aria-label="Hapus input pembayaran"
        title="Hapus input pembayaran"
        onClick={onRemove}
      ><X size={16}/></button>
    </div>
    <div className="fields">
      <Field label="Nominal pembayaran">
        <input
          data-testid={`payment-amount-${i}`}
          type="text"
          inputMode="numeric"
          placeholder="Rp0"
          value={formatIDRInput(row.amount)}
          onChange={e=>update(i,"amount", parseIDRInput(e.target.value))}
        />
      </Field>
      <Field label="Metode">
        <select data-testid={`payment-method-${i}`} value={row.method} onChange={e=>update(i,"method", e.target.value)}>
          {PAYMENT_METHODS.map(m=><option key={m} value={m}>{paymentMethodLabel(m)}</option>)}
        </select>
      </Field>
      {/* Non-Tunai: Nomor referensi + Bukti pembayaran selalu terlihat (aturan existing). */}
      {!isCash && <>
        <Field label="Nomor referensi">
          <input data-testid={`payment-reference-${i}`} value={row.reference} onChange={e=>update(i,"reference", e.target.value)}/>
        </Field>
        <Field label="Bukti pembayaran">{proofInput}</Field>
      </>}
    </div>
    {/* Detail tambahan — folded. Untuk Tunai, memuat referensi/bukti; untuk non-Tunai hanya catatan. */}
    <button
      type="button"
      className="options-toggle pay-details-toggle"
      aria-expanded={showDetails}
      data-testid={`payment-details-toggle-${i}`}
      onClick={()=>setShowDetails(v=>!v)}
    >
      <span className="options-toggle-label">Detail tambahan</span>
      <span className="options-toggle-chev" aria-hidden="true">{showDetails ? <ChevronUp size={15}/> : <ChevronDown size={15}/>}</span>
    </button>
    {showDetails && <div className="options-block pay-details-block">
      {isCash && <>
        <Field label="Nomor referensi">
          <input data-testid={`payment-reference-${i}`} value={row.reference} onChange={e=>update(i,"reference", e.target.value)}/>
        </Field>
        <Field label="Bukti pembayaran">{proofInput}</Field>
      </>}
      <Field label="Catatan pembayaran"><textarea data-testid={`payment-note-${i}`} value={row.note} onChange={e=>update(i,"note", e.target.value)}/></Field>
    </div>}
  </div>;
}

function PaymentRows({ rows, setRows }) {
  const update = (i, key, value) => setRows(rows.map((row,n)=>n===i?{...row,[key]:value}:row));
  if (rows.length === 0) {
    return <div className="payment-empty">
      <p className="muted small">Belum ada pembayaran. Nota dapat disimpan tanpa pembayaran (masuk ke daftar piutang).</p>
      <button type="button" data-testid="add-initial-payment-button" className="soft-btn add-product-btn" onClick={()=>setRows([paymentTemplate()])}>
        <Plus size={16}/>Tambah pembayaran awal
      </button>
    </div>;
  }
  return <div className="payment-list">
    {rows.map((row,i)=>
      <PaymentRowItem
        key={i}
        row={row}
        i={i}
        update={update}
        onRemove={()=>setRows(rows.filter((_,n)=>n!==i))}
      />
    )}
    <button type="button" data-testid="add-payment-button" className="soft-btn" onClick={()=>setRows([...rows,paymentTemplate()])}><Plus size={16}/>Tambah transaksi</button>
  </div>;
}

// Iter 213 — Autocomplete pelanggan (nama + WhatsApp) dari riwayat order.
// Debounced fetch ke GET /api/customers/suggest?q=... — trigger saat user mengetik ≥ 2 karakter.
// Klik saran → onPick({name, whatsapp, company, count}).
// Keyboard: ↓/↑ navigasi, Enter apply, Esc close.
function CustomerAutocomplete({ testId, field, value, onChange, onPick, inputProps }) {
  const [suggestions, setSuggestions] = useState([]);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(-1);
  const [loading, setLoading] = useState(false);
  const wrapperRef = useRef(null);
  const debounceRef = useRef(null);

  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    const q = String(value || "").trim();
    if (q.length < 2) { setSuggestions([]); return; }
    setLoading(true);
    debounceRef.current = setTimeout(async () => {
      try {
        const res = await axios.get(`${API}/customers/suggest`, { params: { q, limit: 8 } });
        setSuggestions(Array.isArray(res.data) ? res.data : []);
      } catch (e) {
        setSuggestions([]);
      } finally {
        setLoading(false);
      }
    }, 300);
    return () => { if (debounceRef.current) clearTimeout(debounceRef.current); };
  }, [value]);

  useEffect(() => {
    const onDocClick = (e) => { if (wrapperRef.current && !wrapperRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);

  const showList = open && suggestions.length > 0;
  const pick = (c) => {
    onPick(c);
    setOpen(false);
    setActive(-1);
  };
  const onKeyDown = (e) => {
    if (!showList) return;
    if (e.key === "ArrowDown") { e.preventDefault(); setActive(a => Math.min(suggestions.length - 1, a + 1)); }
    else if (e.key === "ArrowUp") { e.preventDefault(); setActive(a => Math.max(0, a - 1)); }
    else if (e.key === "Enter" && active >= 0) { e.preventDefault(); pick(suggestions[active]); }
    else if (e.key === "Escape") { setOpen(false); setActive(-1); }
  };

  return <div className="customer-autocomplete" ref={wrapperRef}>
    <input
      {...(inputProps || {})}
      data-testid={testId}
      value={value}
      onChange={e => { onChange(e.target.value); setOpen(true); setActive(-1); }}
      onFocus={() => setOpen(true)}
      onKeyDown={onKeyDown}
      autoComplete="off"
    />
    {showList && <ul className="customer-suggest-list" data-testid={`${testId}-suggest`} role="listbox">
      {suggestions.map((c, i) => (
        <li
          key={`${c.name}__${c.whatsapp}`}
          role="option"
          aria-selected={i === active}
          data-testid={`${testId}-suggest-item-${i}`}
          className={`customer-suggest-item ${i === active ? "is-active" : ""}`}
          onMouseEnter={() => setActive(i)}
          onMouseDown={(e) => { e.preventDefault(); pick(c); }}
        >
          <div className="customer-suggest-primary">
            <strong>{field === "whatsapp" ? c.whatsapp : c.name}</strong>
            {c.count > 1 && <span className="customer-suggest-badge" title={`${c.count} pesanan sebelumnya`}>×{c.count}</span>}
          </div>
          <div className="customer-suggest-secondary">
            {field === "whatsapp" ? c.name : c.whatsapp}
            {c.company && <span className="customer-suggest-company"> · {c.company}</span>}
          </div>
          {/* Iter 223 — tampilkan alias bila WA ini pernah dipakai dengan nama berbeda. */}
          {Array.isArray(c.aliases) && c.aliases.length > 0 && (
            <div className="customer-suggest-aliases" data-testid={`${testId}-suggest-item-${i}-aliases`}>
              <span className="customer-suggest-aliases-label">juga dikenal sbg:</span>
              {c.aliases.slice(0, 3).map((al, ai) => (
                <span key={ai} className="customer-suggest-alias-chip">{al}</span>
              ))}
              {c.aliases.length > 3 && <span className="customer-suggest-aliases-more">+{c.aliases.length - 3}</span>}
            </div>
          )}
        </li>
      ))}
    </ul>}
    {loading && open && value.trim().length >= 2 && suggestions.length === 0 && <div className="customer-suggest-empty">Mencari…</div>}
  </div>;
}



function OrderForm({ user, onClose, onSaved, initialFromOrder }) {
  // Iter 212 — Salin Nota Lama: seed initial state dari order lama bila `initialFromOrder` disediakan.
  //   Reset: order_number, deadline, order_date/time, payments, production status per produk.
  //   Preserve: customer info, produk detail (nama/warna/lengan/ukuran/qty/dtf_size/route),
  //              baris manual (price_manual=true) beserta unit_price-nya.
  //   Recompute: baris otomatis (unit_price=0, auto_price_base=null → kalkulator recompute
  //              dengan tarif yang berlaku).
  const seedFromOrder = (src) => {
    if (!src) return null;
    const templateProduct = productTemplate();
    const products = (src.products || []).map(p => {
      // Preserve id baru supaya key React tidak konflik.
      const newId = (typeof crypto !== "undefined" && crypto.randomUUID) ? crypto.randomUUID() : `p-${Date.now()}-${Math.random().toString(36).slice(2,9)}`;
      const rows = (p.sizes || []).map(s => {
        const isManual = s.price_manual === true || s._manual === true;
        return {
          size: s.size || "",
          quantity: Number(s.quantity || 0),
          color: s.color || p.color || "",
          variant: s.variant || (p.sleeve && p.sleeve !== "Tidak Berlaku" ? p.sleeve : ""),
          embroidery_points: (s.embroidery_points === null || s.embroidery_points === undefined) ? null : Number(s.embroidery_points),
          unit_price: isManual ? Number(s.unit_price || 0) : 0,
          price_manual: !!isManual,
        };
      });
      return {
        _id: newId,
        name: p.name || templateProduct.name,
        custom_name: p.custom_name || "",
        material: p.material || "",
        color: p.color || "",
        sleeve: p.sleeve || "Tidak Berlaku",
        sizes: rows.length > 0 ? rows : templateProduct.sizes,
        unit_price: 0,           // Reset — kalkulator akan re-derive
        auto_price_base: null,   // Reset — kalkulator akan re-derive
        auto_price_rate: null,
        discount: Number(p.discount || 0),
        note: p.note || "",
        production_route: p.production_route || "",
        process_mode: p.process_mode || "",
        sablon_type: (p.production_route === "Sablon (DTF)" || p.production_route === "Bordir + Sablon (DTF)") ? "DTF"
                    : (p.production_route === "Sablon (Plastisol)" || p.production_route === "Bordir + Sablon (Plastisol)") ? "Plastisol"
                    : "",
        dtf_size: p.dtf_size || "",
        setting_fee: Number(p.setting_fee || 0),
        pricing_key: p.pricing_key || "",
        // Iter 276 — Model kerah Jersey ikut dibawa saat duplikasi/edit nota.
        collar_model: p.collar_model || "",
        collar_note: p.collar_note || "",
      };
    });
    return {
      customer_name: src.customer_name || "",
      whatsapp: src.whatsapp || "",
      company: src.company || "",
      order_date: localDate(),  // baru
      order_time: localTime(),  // baru
      deadline: "",             // WAJIB diisi ulang (user brief)
      production_deadline: "", production_deadline_manual: false,
      order_type: src.order_type || "Polos",
      source: "Offline",
      admin: user.name,
      products: products.length > 0 ? products : [productTemplate()],
      custom_type: src.custom_type || "",
      design_position: src.design_position || "",
      design_size: src.design_size || "",
      embroidery_points: Number(src.embroidery_points || 0),
      design_filename: "",       // reset file
      design_note: src.design_note || "",
      design_status: "Belum Dibuat", // reset status produksi
      setting_fee: 0,
      additional_fee: Number(src.additional_fee || 0),
      invoice_discount: Number(src.invoice_discount || 0),
      shipping: Number(src.shipping || 0),
      ppn: !!src.ppn,
      // Iter 391 — Saat duplikasi, auto-populate penanda Repeat Order:
      //   `repeat_ref` = nomor nota lama (sumber). Admin boleh matikan toggle bila bukan repeat.
      is_repeat_order: true,
      repeat_ref: src.order_number || "",
    };
  };
  const [form,setForm]=useState(() => seedFromOrder(initialFromOrder) || {customer_name:"",whatsapp:"",company:"",order_date:localDate(),order_time:localTime(),deadline:"",production_deadline:"",production_deadline_manual:false,order_type:"Polos",source:"Offline",admin:user.name,products:[productTemplate()],custom_type:"",design_position:"",design_size:"",embroidery_points:0,design_filename:"",design_note:"",design_status:"Belum Dibuat",setting_fee:0,additional_fee:0,invoice_discount:0,shipping:0,ppn:false,is_repeat_order:false,repeat_ref:""});
  const [duplicatedFrom] = useState(initialFromOrder?.order_number || null);
  // Iter 583 — Pesanan tambahan → Grup Nota (dihubungkan SETELAH nota tersimpan).
  const [groupLink, setGroupLink] = useState({ enabled: false, source: null, confirmMismatch: false });
  // Iter 214 — Snapshot harga lama untuk baris otomatis. Digunakan untuk membandingkan
  // dengan tarif berlaku sekarang (setelah kalkulator recompute). Key: `pi__si`.
  const [oldPricesMap] = useState(() => {
    if (!initialFromOrder) return null;
    const map = {};
    (initialFromOrder.products || []).forEach((p, pi) => {
      (p.sizes || []).forEach((s, si) => {
        // Hanya track baris otomatis (bukan manual) supaya diff bermakna.
        if (!s.price_manual && !s._manual) {
          map[`${pi}__${si}`] = Number(s.unit_price || 0);
        }
      });
    });
    return map;
  });
  const [payments,setPayments]=useState([]);
  const [designFile,setDesignFile]=useState(null);
  const [saving,setSaving]=useState(false);
  const [showPreview,setShowPreview]=useState(false);
  // Iter 211 — Auto-save draft ke localStorage tiap 30 detik supaya progress tidak hilang
  //   saat jaringan putus / tab tertutup tak sengaja. Restore banner tampil saat form dibuka
  //   ulang bila draft <24 jam ada di localStorage.
  const AUTOSAVE_KEY = `tam_nota_draft_v1__${user.name || "anon"}`;
  const [autoSavedAt, setAutoSavedAt] = useState(null); // Date | null — display "Tersimpan · HH:MM"
  const [restoreInfo, setRestoreInfo] = useState(null); // {form, payments, at} atau null
  // Mount: cek localStorage untuk draft yang belum di-restore
  useEffect(() => {
    // Iter 212 — Skip restore prompt kalau form sedang dari duplikat (jangan overwrite duplikat).
    if (initialFromOrder) return;
    try {
      const raw = localStorage.getItem(AUTOSAVE_KEY);
      if (!raw) return;
      const parsed = JSON.parse(raw);
      if (!parsed || !parsed.form || !parsed.at) return;
      // Buang draft yang lebih dari 24 jam
      const age = Date.now() - Number(parsed.at || 0);
      if (age > 24 * 60 * 60 * 1000) { localStorage.removeItem(AUTOSAVE_KEY); return; }
      // Skip kalau draft sepenuhnya kosong (produk default 1 baris + tanpa nama/WA)
      const isEmpty = !parsed.form.customer_name && !parsed.form.whatsapp
        && !parsed.form.deadline
        && (parsed.form.products || []).every(p => !p.name && (p.sizes || []).every(s => !s.size || !Number(s.quantity)));
      if (isEmpty) { localStorage.removeItem(AUTOSAVE_KEY); return; }
      setRestoreInfo(parsed);
    } catch (e) { /* corrupt draft → abaikan */ }
  }, [AUTOSAVE_KEY, initialFromOrder]);
  // Interval 30 detik: simpan snapshot ke localStorage
  useEffect(() => {
    if (restoreInfo) return; // Jangan overwrite draft yang menunggu restore
    const snapshot = () => {
      try {
        // Skip snapshot kalau form 100% kosong (biar tidak polusi storage saat baru buka)
        const isEmpty = !form.customer_name && !form.whatsapp && !form.deadline
          && (form.products || []).every(p => !p.name && (p.sizes || []).every(s => !s.size || !Number(s.quantity)));
        if (isEmpty) return;
        localStorage.setItem(AUTOSAVE_KEY, JSON.stringify({ form, payments, at: Date.now() }));
        setAutoSavedAt(new Date());
      } catch (e) { /* quota exceeded → abaikan */ }
    };
    const t = setInterval(snapshot, 30000);
    return () => clearInterval(t);
  }, [form, payments, AUTOSAVE_KEY, restoreInfo]);
  const clearAutoSave = () => { try { localStorage.removeItem(AUTOSAVE_KEY); } catch(e) {} setAutoSavedAt(null); };
  // Iter 213 — Terapkan saran pelanggan (klik dari dropdown autocomplete)
  const applyCustomerSuggestion = (c) => {
    setForm(f => ({ ...f, customer_name: c.name || f.customer_name, whatsapp: c.whatsapp || f.whatsapp, company: c.company || f.company }));
    notify.success({ title: "Data pelanggan terisi", message: `${c.name}${c.company ? ` · ${c.company}` : ""}${c.count > 1 ? ` (${c.count} pesanan sebelumnya)` : ""}` });
    setWaMatchHint(null);  // reset warning: user sudah gunakan existing
  };

  // Iter 221n — Warning "Nomor WA sudah terdaftar" saat input manual (debounced lookup).
  //   Tidak memblokir simpan — hanya kasih hint & tombol "Gunakan existing".
  const [waMatchHint, setWaMatchHint] = useState(null);  // {name, whatsapp, company, count}|null
  const [waMatchDismissed, setWaMatchDismissed] = useState(false);
  useEffect(() => {
    if (waMatchDismissed) return;  // user sudah pilih "Tetap simpan sbg baru"
    const wa = String(form.whatsapp || "").replace(/[^0-9]/g, "");
    if (wa.length < 8) { setWaMatchHint(null); return; }
    // Kalau nama sudah match dgn hint saat ini, skip warning
    const t = setTimeout(async () => {
      try {
        const r = await axios.get(`${API}/customers/lookup`, { params: { wa }, withCredentials: true });
        if (r.data?.found) {
          const p = r.data.primary;
          // Kalau nama form sudah match primary → user sepertinya sudah pakai existing
          if (String(form.customer_name || "").trim().toLowerCase() === String(p.name || "").trim().toLowerCase()) {
            setWaMatchHint(null);
          } else {
            setWaMatchHint(p);
          }
        } else {
          setWaMatchHint(null);
        }
      } catch { setWaMatchHint(null); }
    }, 500);
    return () => clearTimeout(t);
  }, [form.whatsapp, form.customer_name, waMatchDismissed]);
  const applyRestore = () => {
    if (!restoreInfo) return;
    setForm(restoreInfo.form);
    setPayments(restoreInfo.payments || []);
    setAutoSavedAt(new Date(restoreInfo.at));
    setRestoreInfo(null);
    notify.success({ title: "Draft dipulihkan", message: "Data terakhir Anda sudah dikembalikan. Lanjutkan edit atau simpan." });
  };
  const discardRestore = () => {
    setRestoreInfo(null);
    clearAutoSave();
  };
  const [masterProducts,setMasterProducts]=useState([]);
  const [masterMaterials,setMasterMaterials]=useState([]);
  const [masterColors,setMasterColors]=useState([]);
  const [masterSizes,setMasterSizes]=useState([]);
  useEffect(()=>{
    const reload = () => {
      axios.get(`${API}/master/products?active_only=true`,{withCredentials:true}).then(r=>setMasterProducts(r.data||[])).catch(()=>{});
      axios.get(`${API}/master/materials?active_only=true`,{withCredentials:true}).then(r=>setMasterMaterials(r.data||[])).catch(()=>{});
      axios.get(`${API}/master/colors?active_only=true`,{withCredentials:true}).then(r=>setMasterColors(r.data||[])).catch(()=>{});
      axios.get(`${API}/master/sizes?active_only=true`,{withCredentials:true}).then(r=>setMasterSizes(r.data||[])).catch(()=>{});
    };
    reload();
    window.addEventListener("master-updated", reload);
    window.addEventListener("focus", reload);
    return () => { window.removeEventListener("master-updated", reload); window.removeEventListener("focus", reload); };
  },[]);
  const productNames = useMemo(()=>{
    const list = masterProducts.map(p=>p.name);
    if (list.length === 0) return PRODUCTS;
    if (!list.includes("Lainnya")) list.push("Lainnya");
    return list;
  },[masterProducts]);
  // Iter 150 — Map nama produk → pricing_key (stabil) untuk menghubungkan pilihan
  //   dropdown ke tabel kalkulator. Nama kosong / "Lainnya" tidak punya pricing_key.
  const pricingKeyByProductName = useMemo(()=>{
    const map = {};
    for (const p of masterProducts) {
      if (p && p.name && p.pricing_key) map[p.name] = p.pricing_key;
    }
    return map;
  },[masterProducts]);
  // Iter 276 — Map nama produk → category (mis. "Jersey"). Dipakai form nota
  //   untuk auto-set production_route "Jersey/Sublim" & memicu UI Model Kerah.
  const categoryByProductName = useMemo(()=>{
    const map = {};
    for (const p of masterProducts) {
      if (p && p.name && p.category) map[p.name] = p.category;
    }
    return map;
  },[masterProducts]);
  const materialNames = useMemo(()=>masterMaterials.map(p=>p.name),[masterMaterials]);
  const colorNames = useMemo(()=>masterColors.map(p=>p.name),[masterColors]);
  // Iter 528 — Cache warna per bahan dari stock_variants (read-only, dedup case-insensitive).
  //   Dipakai ProductCard untuk memprioritaskan warna sesuai bahan yang dipilih operator,
  //   tanpa menduplikasi 94 warna ke master_colors.
  const [colorsByMaterial, setColorsByMaterial] = useState({});   // { "COTTON COMBED 24S": ["ABU MUDA", ...] }
  const [colorsByMaterialLoading, setColorsByMaterialLoading] = useState({}); // { "COTTON COMBED 24S": true }
  // Iter 530 — Cache warna master_colors custom per bahan (scope_materials). Dedup di frontend
  //   dengan daftar `colorsByMaterial` dari stok agar tidak muncul duplikat. Backend sudah
  //   case-insensitive match pada scope_materials, kita hanya perlu dedup pada nama.
  const [customColorsByMaterial, setCustomColorsByMaterial] = useState({}); // { "COTTON COMBED 24S": ["Khaki Doff", ...] }
  const _normMaterial = useCallback((s)=>String(s||"").trim().replace(/\s+/g," ").toUpperCase(),[]);
  const requestColorsForMaterial = useCallback(async (materialRaw) => {
    const key = _normMaterial(materialRaw);
    if (!key) return;
    // Sudah di cache atau sedang loading? skip.
    setColorsByMaterial(prev => {
      if (prev[key] !== undefined) return prev;
      return prev;
    });
    setColorsByMaterialLoading(prev => {
      if (prev[key]) return prev;
      // start 2 fetch paralel: by-material (stok) + master/colors?for_material (custom)
      (async () => {
        try {
          const [stockRes, customRes] = await Promise.allSettled([
            axios.get(`${API}/master/colors/by-material`, {
              params: { material: materialRaw },
              withCredentials: true,
            }),
            axios.get(`${API}/master/colors`, {
              params: { for_material: materialRaw, active_only: true },
              withCredentials: true,
            }),
          ]);
          const stockNames = stockRes.status === "fulfilled" && Array.isArray(stockRes.value?.data)
            ? stockRes.value.data.map(x => x && x.name).filter(Boolean) : [];
          // Hanya master_colors yang scope-nya spesifik ke bahan ini (bukan "Umum").
          //   Backend return umum + scoped — kita filter yang punya scope_materials sesuai.
          const normTarget = _normMaterial(materialRaw);
          const customNames = customRes.status === "fulfilled" && Array.isArray(customRes.value?.data)
            ? customRes.value.data
                .filter(d => Array.isArray(d.scope_materials) && d.scope_materials.length > 0
                  && d.scope_materials.some(m => _normMaterial(m) === normTarget))
                .map(d => d.name)
                .filter(Boolean)
            : [];
          setColorsByMaterial(p => ({ ...p, [key]: stockNames }));
          setCustomColorsByMaterial(p => ({ ...p, [key]: customNames }));
        } catch (_) {
          // Gagal fetch (403/404/network) → simpan [] agar tidak retry terus-menerus.
          setColorsByMaterial(p => ({ ...p, [key]: [] }));
          setCustomColorsByMaterial(p => ({ ...p, [key]: [] }));
        } finally {
          setColorsByMaterialLoading(p => { const n={...p}; delete n[key]; return n; });
        }
      })();
      return { ...prev, [key]: true };
    });
  }, [_normMaterial]);
  // Trigger fetch untuk setiap bahan unik yang dipilih di form (debounced via dep)
  useEffect(() => {
    const unique = new Set();
    for (const p of form.products || []) {
      const m = (p && p.material) ? String(p.material).trim() : "";
      if (m) unique.add(m);
    }
    for (const m of unique) requestColorsForMaterial(m);
  }, [form.products, requestColorsForMaterial]);
  const sizeNames = useMemo(()=>{
    const list = masterSizes.map(p=>p.name);
    if (list.length === 0) return SIZES;
    if (!list.includes("Lainnya")) list.push("Lainnya");
    return list;
  },[masterSizes]);
  const set = (key,value) => setForm(old=>({...old,[key]:value}));
  // Iter 58/59 — Derive Custom processes from products (auto-sync form.custom_type ke backend agar kompatibel).
  const customProcesses = useMemo(() => {
    const routes = form.products.map(p => p.production_route || "");
    const modes = form.products.map(p => p.process_mode || "");
    const hasBordir = modes.some(m => m === "Bordir" || m === "Bordir+Sablon" || m === "Jahit+Bordir")
      || routes.some(r => r === "Bordir" || r.startsWith("Bordir + Sablon"));
    const hasSablon = modes.some(m => m === "Sablon" || m === "Bordir+Sablon" || m === "Jahit+Sablon")
      || routes.some(r => r.startsWith("Sablon (") || r.startsWith("Bordir + Sablon") || r === "Sablon/DTF" || r === "Sablon/DTF + Press");
    const hasJahit = modes.some(m => m === "Jahit" || m === "Jahit+Bordir" || m === "Jahit+Sablon")
      || routes.some(r => r === "Polosan Perlu Jahit");
    const sablonTypes = Array.from(new Set(routes.map(r => {
      if (r === "Sablon (DTF)" || r === "Bordir + Sablon (DTF)") return "DTF";
      if (r === "Sablon (Plastisol)" || r === "Bordir + Sablon (Plastisol)") return "Plastisol";
      return "";
    }).filter(Boolean)));
    return { hasBordir, hasSablon, hasJahit, sablonTypes };
  }, [form.products]);
  useEffect(() => {
    if (form.order_type !== "Custom") return;
    const { hasBordir, hasSablon, hasJahit, sablonTypes } = customProcesses;
    const multi = [hasBordir, hasSablon, hasJahit].filter(Boolean).length > 1;
    const derived = multi ? "Kombinasi"
      : hasBordir ? "Bordir"
      : hasSablon ? (sablonTypes[0] || "DTF")
      : hasJahit ? "Jahit"
      : "";
    if (derived !== form.custom_type) setForm(old => ({ ...old, custom_type: derived }));
  }, [form.order_type, customProcesses, form.custom_type]);
  const total = useMemo(()=>form.products.reduce((sum,p)=>{
    // Iter 201 — Ringkasan grand-total memakai `computeRowEffective` yang identik dengan
    //   subtotal per produk di ProductCard. Ini memastikan Manual + Kalkulator (autoBase +
    //   sleeveAdd + upcharge + extraPts) + fallback default konsisten antara Ringkasan,
    //   PDF, dan backend total. Fallback lama `p.unit_price` tanpa upcharge/sleeve/points
    //   telah menyebabkan under-report saat Hitung Harga aktif.
    const gross = (p.sizes || []).reduce((a,s)=>{
      const q = Number(s.quantity||0);
      return a + q * computeRowEffective(p, s, form.embroidery_points);
    }, 0);
    return sum + Math.max(0, gross - Number(p.discount||0));
  },0),[form.products, form.embroidery_points]);
  // Iter 214 — Ringkasan perubahan harga otomatis (mode duplikat). Hitung berapa baris
  // yang naik / turun / sama vs snapshot lama, dan total selisih rupiah unit-price × qty.
  const priceDeltas = useMemo(() => {
    if (!oldPricesMap) return null;
    let up = 0, down = 0, same = 0;
    let totalDeltaAmount = 0;
    form.products.forEach((p, pi) => {
      (p.sizes || []).forEach((s, si) => {
        const key = `${pi}__${si}`;
        if (!(key in oldPricesMap)) return; // hanya baris yang dulu otomatis
        if (s.price_manual || s._manual) return; // user set manual → skip
        const oldPrice = Number(oldPricesMap[key] || 0);
        const newPrice = computeRowEffective(p, s, form.embroidery_points);
        if (!newPrice || newPrice <= 0) return; // belum siap
        const qty = Number(s.quantity || 0);
        if (newPrice > oldPrice) { up++; totalDeltaAmount += (newPrice - oldPrice) * qty; }
        else if (newPrice < oldPrice) { down++; totalDeltaAmount += (newPrice - oldPrice) * qty; }
        else { same++; }
      });
    });
    return { up, down, same, totalDeltaAmount };
  }, [oldPricesMap, form.products, form.embroidery_points]);
  const pcs = form.products.reduce((sum,p)=>sum+p.sizes.reduce((a,s)=>a+Number(s.quantity||0),0),0);
  const productSetting = form.products.reduce((sum,p)=>sum+Number(p.setting_fee||0),0);
  // Iter 136 — Bug fix: biaya setting HANYA dari checkbox per-produk. Sebelumnya
  // legacySetting auto-inject Rp 15.000 saat Custom+Bordir+qty<4 walaupun checkbox mati,
  // menyebabkan biaya setting muncul lagi tiap kali nota dibuka ulang. Field `form.setting_fee`
  // di root selalu 0 (tidak ada UI utk set langsung), sehingga menghapus legacy aman.
  const setting = productSetting;
  const base = total + setting + Number(form.additional_fee||0) - Number(form.invoice_discount||0) + Number(form.shipping||0);
  const tax = form.ppn ? base*.11 : 0;
  const grand = Math.max(0, base+tax);
  const paid = payments.reduce((sum,p)=>sum+Number(p.amount||0),0);
  // Iterasi 14 — Jalur produksi otomatis dari jenis Nota, per-produk hanya bila ambigu (Polos atau Custom Kombinasi/kosong)
  const routeChoiceForProducts = (() => {
    if (form.order_type === "Polos") return { label:"Jalur (Polosan)", options:["Polosan Siap Stok","Polosan Harus Belanja","Polosan Perlu Jahit","Non-Produksi"] };
    const t = String(form.custom_type||"").trim().toLowerCase();
    if (form.order_type === "Custom" && (t === "" || t === "kombinasi")) return { label:"Jalur produksi", options:["Bordir","Sablon/DTF","Polosan Siap Stok","Polosan Harus Belanja","Polosan Perlu Jahit"] };
    return null; // otomatis di backend
  })();
  const save = async status => {
    if (saving) return;
    // ── Validasi wajib — modal warning modern ──
    if (!form.customer_name.trim() || !form.whatsapp.trim()) { notify.warning({ title:"Data belum lengkap", message:"Nama pemesan dan nomor WhatsApp wajib diisi." }); return; }
    if (!form.deadline) { notify.warning({ title:"Deadline belum dipilih", message:"Deadline Customer wajib dipilih agar antrean bisa dijadwalkan." }); return; }
    if (form.deadline < form.order_date) { notify.warning({ title:"Deadline tidak valid", message:"Deadline tidak boleh lebih awal dari tanggal pesanan." }); return; }
    if (form.production_deadline && form.production_deadline > form.deadline) { notify.warning({ title:"Deadline Produksi tidak valid", message:"Deadline Produksi tidak boleh melewati Deadline Customer." }); return; }
    if (paid > grand) { notify.warning({ title:"Pembayaran melebihi total", message:"Nominal pembayaran melebihi grand total pesanan." }); return; }
    if (groupLink.enabled && !groupLink.source) { notify.warning({ title:"Nota sumber belum dipilih", message:"Pilih nota sebelumnya, atau matikan pilihan \"Pesanan tambahan dari nota sebelumnya\"." }); return; }
    if (groupLink.enabled && groupLink.source && identityDiff(groupLink.source, form.customer_name, form.whatsapp).length && !groupLink.confirmMismatch) {
      notify.warning({ title:"Identitas pelanggan berbeda", message:"Nama/WhatsApp berbeda dengan nota sumber. Centang konfirmasi pada bagian Pesanan tambahan, atau pilih nota sumber lain." }); return;
    }
    for (const p of form.products) {
      if ((p.name === "Lainnya" || p.name === "Produk Lainnya") && !(p.custom_name && p.custom_name.trim())) {
        notify.warning({ title:"Nama produk manual belum diisi", message:"Nama produk manual wajib diisi jika memilih 'Lainnya'." }); return;
      }
      for (const s of (p.sizes || [])) {
        if (!s.size || !String(s.size).trim()) { notify.warning({ title:"Nama ukuran kosong", message:"Nama ukuran wajib diisi pada setiap baris ukuran." }); return; }
      }
      const _pIdx = form.products.indexOf(p) + 1;
      const _isJasa = p.name === "Jasa Bordir" || p.name === "Jasa Sablon";
      if (form.order_type === "Custom" && !_isJasa && (categoryByProductName && categoryByProductName[p.name]) !== "Jersey" && !p.production_route) {
        notify.warning({ title: "Proses produk belum dipilih", message: `Pilih Proses Produk (Bordir / Sablon / Jahit…) untuk Produk ${_pIdx}${p.name ? ` (${p.name})` : ""}. Tanpa proses, kolom titik bordir tidak tampil dan titik tidak tersimpan.` }); return;
      }
      if (status !== "Draft" && /bordir/i.test(String(p.production_route || "")) && !(Number(form.embroidery_points || 0) > 0)) {
        const _miss = (p.sizes || []).filter(s => Number(s.quantity || 0) > 0 && (s.embroidery_points === null || s.embroidery_points === undefined || s.embroidery_points === "" || !Number.isInteger(Number(s.embroidery_points)) || Number(s.embroidery_points) < 0));
        if (_miss.length) {
          notify.warning({ title: "Titik bordir belum diisi", message: `Isi jumlah titik bordir untuk Produk ${_pIdx}${p.name ? ` (${p.name})` : ""} variasi ${_miss.map(s => s.size || "-").join(", ")}. Isi 0 bila memang tanpa titik.` }); return;
        }
      }
      if (routeChoiceForProducts && !p.production_route) {
        // Iter 58 — untuk Custom UI baru, label yang tampil adalah "Proses Produk", bukan "Jalur produksi".
        const isCustomProses = form.order_type === "Custom";
        notify.warning({
          title: isCustomProses ? "Proses produk belum dipilih" : "Jalur produksi belum dipilih",
          message: isCustomProses
            ? "Pilih salah satu proses produk (Bordir / Sablon / Bordir + Sablon) dan jenis Sablon bila perlu."
            : "Pilih jalur produksi untuk setiap produk."
        }); return;
      }
      // Iter 44 — jika effective jalur Sablon (baik auto-derive dari custom_type=DTF/Sablon,
      // maupun pilihan manual "Sablon/DTF"), wajib pilih Jenis Sablon (DTF/Plastisol).
      const _ct = String(form.custom_type||"").trim().toLowerCase();
      const _isAutoSablon = form.order_type === "Custom" && (_ct === "dtf" || _ct === "sablon" || _ct === "plastisol");
      const _needsSablonType = _isAutoSablon || p.production_route === "Sablon/DTF" || p.production_route === "Sablon/DTF + Press";
      const _hasNewRoute = p.production_route === "Sablon (DTF)" || p.production_route === "Sablon (Plastisol)"
        || p.production_route === "Bordir + Sablon (DTF)" || p.production_route === "Bordir + Sablon (Plastisol)";
      if (_needsSablonType && !_hasNewRoute) {
        notify.warning({ title:"Jenis Sablon belum dipilih", message:"Pilih Jenis Sablon (DTF atau Plastisol) untuk setiap produk sablon." }); return;
      }
      // Iter 58 — Bordir + Sablon: jika mode dipilih tapi jenis Sablon belum, route akan kosong ("");
      // validasi generic di atas menangkap kondisi ini. Blok legacy "Bordir + Sablon (?)" tidak dipakai lagi.

      // Iter 203 — Validasi kelengkapan harga per variasi. Setiap variasi harus:
      //   • Manual dengan unit_price > 0, ATAU
      //   • Otomatis DAN kalkulator eligible DAN detail lengkap (size + variant bila needsSleeve
      //     + titik bila proses Bordir), ATAU
      //   • Manual pada produk yang tidak eligible auto (harga wajib > 0).
      const _elig = isAutoPriceEligible({
        orderType: form.order_type, productName: p.name, material: p.material,
        productionRoute: p.production_route, pricingKey: p.pricing_key,
      });
      for (const s of (p.sizes || [])) {
        const isManual = s.price_manual === true || s._manual === true;
        if (isManual) {
          if (!(Number(s.unit_price || 0) > 0)) {
            notify.warning({ title: "Harga manual belum diisi", message: `Isi harga manual > 0 untuk variasi ${s.size || "khusus"}, atau matikan mode manual dengan klik "Gunakan otomatis".` });
            return;
          }
          continue;
        }
        if (_elig) {
          if (!rowReadyForAutoPrice(p, s)) {
            notify.warning({ title: "Detail variasi belum lengkap", message: `Lengkapi ukuran/lengan/titik bordir pada variasi ${s.size || "(baris kosong)"} agar harga otomatis dapat dihitung.` });
            return;
          }
          if (!(Number(p.auto_price_base || 0) > 0)) {
            notify.warning({ title: "Kalkulator belum siap", message: "Harga otomatis belum terhitung. Pastikan total jumlah & detail variasi valid." });
            return;
          }
        } else {
          // Produk tidak eligible auto → variasi wajib punya harga manual > 0.
          if (!(Number(s.unit_price || 0) > 0)) {
            notify.warning({ title: "Harga variasi belum diisi", message: `Produk ini belum memiliki kalkulator otomatis — isi harga manual pada variasi ${s.size || "(baris kosong)"}.` });
            return;
          }
        }
      }
    }
    // ── Konfirmasi modern (khusus Simpan Nota final, bukan Draft) ──
    if (status !== "Draft") {
      const ok = await notify.confirm({
        title: "Simpan nota ini?",
        message: "Pastikan data pesanan, pembayaran, dan deadline sudah benar.",
        primaryLabel: "Ya, Simpan Nota",
        secondaryLabel: "Cek Kembali",
      });
      if (!ok) return;
    } else {
      const ok = await notify.confirm({
        title: "Simpan sebagai Draft?",
        message: "Draft belum masuk antrean produksi. Anda tetap bisa mengubah setelah menyimpan.",
        primaryLabel: "Ya, Simpan Draft",
        secondaryLabel: "Batal",
      });
      if (!ok) return;
    }
    setSaving(true);
    try {
      const payload = {
        ...form,
        order_status: status,
        setting_fee: setting,
        // Iter 143 — Semua nota baru dibuat dengan aturan harga v2 (fallback = default + upcharge).
        // Nota lama tanpa field ini dianggap v1 oleh backend (tidak berubah).
        pricing_version: 2,
        payments: payments.filter(p=>Number(p.amount)>0).map(p=>({amount:Number(p.amount),method:p.method,reference:p.reference,note:p.note,recorded_by:user.name})),
        products: form.products.map(p=>{
          // Iter 203 — Strip HANYA field legacy `_priceSig/_priceAuto/_priceAutoBase/_priceExtraRate`.
          //   Field baru `auto_price_base` / `auto_price_rate` (product) & `price_manual` (row) TETAP
          //   dikirim ke backend supaya buka nota kembali langsung tahu status Manual/Otomatis
          //   tanpa menebak dari nominal.
          const {_id, custom_name, _priceSig, _priceAuto, _priceAutoBase, _priceExtraRate, ...rest} = p;
          const finalName = ((p.name==="Lainnya"||p.name==="Produk Lainnya") && custom_name && custom_name.trim()) ? custom_name.trim() : p.name;
          const colorTallies = (p.sizes || []).reduce((acc, s) => {
            const c = (s.color || p.color || "").trim(); if (!c) return acc;
            acc[c] = (acc[c] || 0) + Number(s.quantity || 0); return acc;
          }, {});
          const topColor = Object.entries(colorTallies).sort((a, b) => b[1] - a[1])[0]?.[0] || p.color || "";
          // Iter 148/149/203 — Simpan `unit_price` per baris = harga efektif untuk baris otomatis,
          //   atau nilai manual jika price_manual===true. Legacy `_manual`/`_priceAutoBase` masih
          //   diterima bila field baru belum ada (kompatibilitas transisi).
          const autoBase = Number(p.auto_price_base ?? _priceAutoBase ?? 0);
          const autoRate = Number(p.auto_price_rate ?? _priceExtraRate ?? 0);
          const hasBase = autoBase > 0;
          const productBase = Number(p.unit_price || 0);
          const rowEff = (s) => {
            const isManual = s.price_manual === true || s._manual === true;
            if (isManual && Number(s.unit_price || 0) > 0) return Number(s.unit_price);
            const rp = (s.embroidery_points !== null && s.embroidery_points !== undefined) ? Number(s.embroidery_points) : Number(form.embroidery_points || 0);
            const extra = hasBase ? Math.max((Number.isFinite(rp) ? rp : 0) - 1, 0) * autoRate : 0;
            const base = hasBase ? autoBase : productBase;
            const slv = hasBase ? sleeveAddFor(finalName, p.material, s.variant, p.pricing_key) : 0;
            const upc = sizeUpcharge(finalName, s.size);
            return base + extra + slv + upc;
          };
          return {
            ...rest,
            name: finalName,
            color: topColor,
            production_route: p.production_route || "",
            quantity: p.sizes.reduce((a,s)=>a+Number(s.quantity||0),0),
            unit_price: Number(p.unit_price),
            discount: Number(p.discount||0),
            setting_fee: Number(p.setting_fee||0),
            auto_price_base: hasBase ? autoBase : null,
            auto_price_rate: hasBase ? autoRate : null,
            sizes: p.sizes.map(s=>{
              const {_priceAuto:_, _manual:__, ...srest} = s;
              const pts = (s.embroidery_points === null || s.embroidery_points === undefined) ? null : Number(s.embroidery_points);
              const priceManual = s.price_manual === true || s._manual === true;
              return {
                ...srest,
                size: String(s.size||"").trim(),
                color: String(s.color || p.color || "").trim(),
                variant: String(s.variant || (p.sleeve && p.sleeve !== "Tidak Berlaku" ? p.sleeve : "") || "").trim(),
                quantity: Number(s.quantity),
                unit_price: rowEff(s),
                embroidery_points: pts,
                price_manual: !!priceManual,
                price_auto_ref: priceManual && Number(s.price_auto_ref) > 0 ? Number(s.price_auto_ref) : null,
              };
            }),
          };
        }),
      };
      const { data } = await axios.post(`${API}/orders`, payload, { withCredentials:true });
      if (designFile) { const fd = new FormData(); fd.append("file", designFile); await axios.post(`${API}/upload/${data.order_number}/design`, fd, { withCredentials:true }); }
      const linkedGroup = await attachToSourceGroup(data.order_number, groupLink);
      const linkMsg = linkedGroup ? ` Terhubung ke Grup Nota bersama ${groupLink.source.order_number} (${linkedGroup.members.length} nota).` : "";
      await notify.success({
        title: status==="Draft" ? "Draft berhasil disimpan" : "Nota berhasil disimpan",
        message: (status==="Draft" ? "Draft tersimpan. Anda tetap bisa mengedit atau menyelesaikan pesanan nanti." : "Pesanan sudah masuk ke sistem TAMFARIS.") + linkMsg,
        primaryLabel: "Selesai",
      });
      onSaved(data);
      clearAutoSave(); // Iter 211 — hapus draft localStorage setelah save server sukses
    } catch (err) { notify.error({ title:"Gagal menyimpan nota", message: err.response?.data?.detail || "Nota belum dapat disimpan. Periksa koneksi atau hubungi admin sistem." }); }
    finally { setSaving(false); }
  };
  return <section className="form-page">
    <div className="page-head form-title">
      <button data-testid="close-order-form-button" className="icon-btn" onClick={onClose}><ChevronLeft/></button>
      <div><p className="eyebrow">Nota baru · {fmtDateID(form.order_date)} · {form.order_time} WIB</p><h2>Pesanan pelanggan</h2></div>
    </div>
    {/* Iter 211 — Restore banner untuk draft otomatis */}
    {restoreInfo && <div className="autosave-restore" data-testid="autosave-restore-banner" role="alert">
      <div className="autosave-restore-body">
        <span className="autosave-restore-icon" aria-hidden="true"><Clock size={18}/></span>
        <div>
          <strong>Draft otomatis tersedia</strong>
          <p>Ada draft dari {new Date(restoreInfo.at).toLocaleString("id-ID", {dateStyle:"medium", timeStyle:"short"})} — apakah Anda ingin melanjutkan?</p>
        </div>
      </div>
      <div className="autosave-restore-actions">
        <button type="button" className="soft-btn" data-testid="autosave-restore-discard" onClick={discardRestore}>Buang</button>
        <button type="button" className="primary" data-testid="autosave-restore-apply" onClick={applyRestore}>Pulihkan Draft</button>
      </div>
    </div>}
    {/* Iter 212 — Banner Salin Nota Lama: reminder tinjau harga & deadline */}
    {duplicatedFrom && <div className="duplicate-banner" data-testid="duplicate-nota-banner" role="alert">
      <div className="duplicate-banner-body">
        <span className="duplicate-banner-icon" aria-hidden="true"><Copy size={18}/></span>
        <div>
          <strong>Nota diduplikat dari {duplicatedFrom}</strong>
          <p>Deadline, pembayaran, & status produksi sudah direset. Harga otomatis akan dihitung ulang dengan tarif terbaru — mohon tinjau kembali sebelum simpan.</p>
          {(() => {
            // Iter 584 — beri tahu admin bila harga khusus (Manual) nota lama ikut tersalin.
            const rows = form.products.flatMap(p => (p.sizes || []).filter(s => (s.price_manual === true || s._manual === true) && Number(s.unit_price || 0) > 0)
              .map(s => `${p.name}${s.size && s.size !== "N/A" ? ` ${s.size}` : ""}${s.variant ? ` (${s.variant})` : ""}: Rp${Number(s.unit_price).toLocaleString("id-ID")}`));
            return rows.length > 0 && <p className="duplicate-manual-note" data-testid="duplicate-manual-price-note">
              <strong>Harga Manual dari {duplicatedFrom} ikut disalin ({rows.length} baris):</strong> {rows.slice(0, 6).join(" · ")}{rows.length > 6 ? ` · +${rows.length - 6} lainnya` : ""}. Periksa kembali atau tekan "Gunakan otomatis" pada baris yang perlu harga terbaru.</p>;
          })()}
        </div>
      </div>
    </div>}
    {/* Iter 214 — Ringkasan perubahan harga otomatis vs snapshot nota lama */}
    {duplicatedFrom && priceDeltas && (priceDeltas.up + priceDeltas.down) > 0 && <div className={`price-delta-banner ${priceDeltas.totalDeltaAmount >= 0 ? "up" : "down"}`} data-testid="price-delta-banner" role="alert">
      <div className="price-delta-icon" aria-hidden="true">{priceDeltas.totalDeltaAmount >= 0 ? <TrendingUp size={18}/> : <TrendingDown size={18}/>}</div>
      <div className="price-delta-body">
        <strong>Harga otomatis berubah dari nota lama</strong>
        <p>
          {priceDeltas.up > 0 && <span className="delta-up" data-testid="price-delta-up">{priceDeltas.up} baris naik</span>}
          {priceDeltas.up > 0 && priceDeltas.down > 0 && " · "}
          {priceDeltas.down > 0 && <span className="delta-down" data-testid="price-delta-down">{priceDeltas.down} baris turun</span>}
          {" · Selisih total "}
          <strong data-testid="price-delta-amount">{priceDeltas.totalDeltaAmount >= 0 ? "+" : "−"}Rp{Math.abs(priceDeltas.totalDeltaAmount).toLocaleString("id-ID")}</strong>
          {" dibanding "}{duplicatedFrom}
        </p>
      </div>
    </div>}
    <div className="form-chips" data-testid="form-chips">
      <div className="form-chip"><span>Nomor Nota</span><strong>Otomatis</strong></div>
      <div className="form-chip"><span>Dibuat oleh</span><strong>{form.admin || user.name}</strong></div>
    </div>
    <div className="form-flow" data-testid="form-flow">
      <span className="flow-pill flow-pemesan"><span className="flow-num">1</span> Pelanggan</span>
      <ChevronRight className="flow-arrow" size={14} aria-hidden="true"/>
      <span className="flow-pill flow-produk"><span className="flow-num">2</span> Produk</span>
      {form.order_type === "Custom" && <>
        <ChevronRight className="flow-arrow" size={14} aria-hidden="true"/>
        <span className="flow-pill flow-detail"><span className="flow-num">3</span> Detail</span>
      </>}
      <ChevronRight className="flow-arrow" size={14} aria-hidden="true"/>
      <span className="flow-pill flow-pembayaran"><span className="flow-num">{form.order_type === "Custom" ? "4" : "3"}</span> Pembayaran</span>
    </div>
    <div className="form-grid">
      <div className="section" data-section="pemesan">
        <h3 className="section-h"><UserIcon size={16} className="section-icon" aria-hidden="true"/><span>Informasi pesanan</span></h3>
        {/* Iter 221n — Hint eksplisit: input manual diperbolehkan; autocomplete hanya mempercepat, tidak wajib. */}
        <p className="muted small" data-testid="customer-manual-hint" style={{marginTop:-4, marginBottom:10}}>
          <strong>Tips:</strong> Ketik nama/nomor untuk mencari pelanggan lama, atau isi manual untuk pelanggan baru.
        </p>
        <div className="fields">
          <Field label="Nama pelanggan" required><CustomerAutocomplete testId="customer-name-input" field="name" value={form.customer_name} onChange={(v)=>set("customer_name",v)} onPick={applyCustomerSuggestion}/></Field>
          <Field label="Nomor WhatsApp" required><CustomerAutocomplete testId="whatsapp-input" field="whatsapp" value={form.whatsapp} onChange={(v)=>{ set("whatsapp",v.replace(/[^0-9+]/g,"")); setWaMatchDismissed(false); }} onPick={applyCustomerSuggestion} inputProps={{type:"tel", inputMode:"numeric"}}/></Field>
          <Field label="Instansi / perusahaan"><input data-testid="company-input" value={form.company} onChange={e=>set("company",e.target.value)}/></Field>
          {/* Iter 221n — Banner warning "Nomor WA sudah terdaftar" (soft-block, tidak menghentikan simpan). */}
          {waMatchHint && !waMatchDismissed && (
            <div
              data-testid="wa-duplicate-banner"
              style={{gridColumn:"1 / -1", padding:"10px 12px", background:"#fff4d9", border:"1px solid #e6c46b", borderRadius:8, fontSize:13, color:"#7a5100", display:"flex", flexDirection:"column", gap:8}}
            >
              <div>
                <strong>Nomor ini sudah terdaftar</strong> atas nama <strong>{waMatchHint.name}</strong>
                {waMatchHint.company ? <> · {waMatchHint.company}</> : null}
                {waMatchHint.count > 1 ? <> · {waMatchHint.count} pesanan sebelumnya</> : null}.
              </div>
              <div style={{display:"flex", gap:8, flexWrap:"wrap"}}>
                <button
                  type="button"
                  data-testid="wa-use-existing-btn"
                  className="soft-btn"
                  onClick={() => { applyCustomerSuggestion(waMatchHint); setWaMatchHint(null); }}
                  style={{background:"#7a5100", color:"#fff", borderColor:"#7a5100"}}
                >Gunakan pelanggan yang sudah ada</button>
                <button
                  type="button"
                  data-testid="wa-keep-manual-btn"
                  className="soft-btn"
                  onClick={() => { setWaMatchDismissed(true); setWaMatchHint(null); }}
                >Tetap simpan sebagai data baru</button>
              </div>
            </div>
          )}
          <Field label={<><Calendar size={13} className="field-icon" aria-hidden="true"/>Deadline Customer</>} required>
            <DatePickerID testId="deadline-input" value={form.deadline} onChange={v=>set("deadline",v)} placeholder="Pilih deadline" minDateISO={form.order_date}/>
          </Field>
          <ProductionDeadlineField customer={form.deadline} orderDate={form.order_date} value={form.production_deadline}
            manual={!!form.production_deadline_manual} sewing={(form.products||[]).some(p => p.production_route === SEW_ROUTE)}
            onChange={(v, m) => setForm(old => ({ ...old, production_deadline: v, production_deadline_manual: m }))}/>
          <Field label="Jenis pesanan"><select data-testid="order-type-select" value={form.order_type} onChange={e=>{
            const newType = e.target.value;
            // Iter 339 — Saat jenis pesanan jadi Polosan, hapus biaya setting dari seluruh produk
            //   (checkbox + input disembunyikan). Backend juga memaksa 0 untuk Polos.
            if (newType === "Polos") {
              setForm(old => ({
                ...old,
                order_type: newType,
                setting_fee: 0,
                products: (old.products || []).map(p => ({ ...p, setting_fee: 0 })),
              }));
            } else {
              setForm(old => ({ ...old, order_type: newType,
                products: (old.products || []).map(p => p.production_route === "Non-Produksi" ? { ...p, production_route: "" } : p) }));
            }
          }}><option value="Polos">Polosan</option><option value="Custom">Custom</option></select></Field>
          {/* Iter 204 — Aplikasi khusus pesanan offline. Dropdown "Sumber pesanan" dihilangkan
              dari UI; nilai `form.source` tetap "Offline" (default state) supaya backend menerima
              field yang sama & laporan lama tetap kompatibel. */}
          <input type="hidden" data-testid="source-hidden" value={form.source || "Offline"} readOnly/>
          {/* Iter 65 — Admin name kept in state (auto-filled from logged-in user); rendered as chip above. Backend tetap terima form.admin. */}
          <input type="hidden" data-testid="admin-name-input" value={form.admin} onChange={e=>set("admin",e.target.value)}/>
          <input type="hidden" data-testid="order-number-input" readOnly value="Dibuat otomatis saat disimpan"/>
          <input type="hidden" data-testid="order-date-input" readOnly value={form.order_date}/>
        </div>
      </div>
      {/* Iter 391 — Penanda Repeat Order (opsional) untuk nota offline. */}
      <div className="section" data-section="repeat-order" data-testid="repeat-order-section">
        <RepeatOrderFields
          active={!!form.is_repeat_order}
          repeatRef={form.repeat_ref || ""}
          onChange={({ is_repeat_order, repeat_ref }) => setForm(f => ({ ...f, is_repeat_order, repeat_ref }))}
          context="offline"
          idPrefix="new-order-repeat"/>
      </div>
      <div className="section" data-section="nota-group" data-testid="new-order-nota-group-section">
        <NotaGroupSourcePicker value={groupLink} onChange={setGroupLink} customerName={form.customer_name} whatsapp={form.whatsapp}/>
      </div>
      <div className="section" data-section="produk">
        <div className="section-title"><h3 className="section-h"><Package size={16} className="section-icon" aria-hidden="true"/><span>Detail produk</span></h3><button type="button" data-testid="add-product-button" className="soft-btn add-product-btn" onClick={()=>set("products",[...form.products,productTemplate()])}><Plus size={16}/>Tambah produk</button></div>
        {/* Iter 149 — Input global "Jumlah titik bordir" DIHAPUS dari UI. Titik bordir kini
            per variasi produk (di dalam kartu variasi masing-masing). State
            `form.embroidery_points` dipertahankan hanya sebagai fallback saat menampilkan
            nota lama yang menyimpan titik di level order. */}
        {form.products.map((p,i)=><ProductCard key={p._id || i} item={p} index={i} canRemove={form.products.length > 1} productNames={productNames} pricingKeyByProductName={pricingKeyByProductName} categoryByProductName={categoryByProductName} materialNames={materialNames} colorNames={colorNames} stockColorsByMaterial={colorsByMaterial} customColorsByMaterial={customColorsByMaterial} sizeNames={sizeNames} routeChoice={routeChoiceForProducts} orderType={form.order_type} customType={form.custom_type} embroideryPoints={form.embroidery_points} oldPricesForProduct={oldPricesMap ? Object.fromEntries(Object.entries(oldPricesMap).filter(([k])=>k.startsWith(`${i}__`)).map(([k,v])=>[k.split("__")[1], v])) : null} onChange={value=>set("products",form.products.map(old=>old._id===p._id?value:old))} onRemove={()=>{ const snapshot = { ...p }; setForm(old => ({ ...old, products: old.products.filter(x => x._id !== p._id) })); undoReverse({ title:`Produk "${(p.name && p.name.trim()) || "Tanpa nama"}" dihapus dari nota`, message:"Klik Batalkan dalam 5 detik untuk mengembalikan.", onUndo:()=>{ setForm(old => { if (old.products.some(x => x._id === snapshot._id)) return old; const idx = Math.min(i, old.products.length); return { ...old, products: [...old.products.slice(0, idx), snapshot, ...old.products.slice(idx)] }; }); }, undoneTitle:`Produk "${(p.name && p.name.trim()) || "Tanpa nama"}" dikembalikan` }); }}/>)}
      </div>
      {form.order_type==="Custom" && (() => {
        const { hasBordir, hasSablon, hasJahit, sablonTypes } = customProcesses;
        if (!hasBordir && !hasSablon && !hasJahit) return null; // Belum ada proses dipilih → sembunyikan detail
        const parts = [];
        if (hasJahit) parts.push("Jahit");
        if (hasBordir) parts.push("Bordir");
        if (hasSablon) parts.push(sablonTypes.length ? `Sablon (${sablonTypes.join(" & ")})` : "Sablon");
        const header = "Detail " + parts.join(" + ");
        return <div className="section" data-section="detail" data-testid="custom-detail-section">
          <h3 className="section-h" data-testid="custom-detail-header"><Sliders size={16} className="section-icon" aria-hidden="true"/><span>{header}</span></h3>
          {hasSablon && sablonTypes.length > 0 && (
            <p className="muted small" data-testid="custom-sablon-type-info" style={{margin:"0 0 8px"}}>
              Jenis Sablon: <strong>{sablonTypes.join(" & ")}</strong>
            </p>
          )}
          <div className="fields">
            <Field label="Posisi desain"><input data-testid="design-position-input" value={form.design_position} onChange={e=>set("design_position",e.target.value)}/></Field>
            <Field label="Ukuran desain"><input data-testid="design-size-input" value={form.design_size} onChange={e=>set("design_size",e.target.value)}/></Field>
            <Field label={<><ImageIcon size={13} className="field-icon" aria-hidden="true"/>Nama file desain</>}><input data-testid="design-filename-input" value={designFile?.name||"Belum dipilih"} readOnly/></Field>
            <Field label={<><Upload size={13} className="field-icon" aria-hidden="true"/>Upload desain</>}><input data-testid="design-file-input" type="file" accept="image/*,.pdf" capture="environment" onChange={e=>{setDesignFile(e.target.files?.[0]||null);set("design_filename",e.target.files?.[0]?.name||"")}}/></Field>
            <Field label="Status desain"><select data-testid="design-status-select" value={form.design_status} onChange={e=>set("design_status",e.target.value)}><option>Belum Dibuat</option><option>Menunggu Persetujuan</option><option>Revisi</option><option>Disetujui</option></select></Field>
            <Field label="Biaya tambahan"><input data-testid="additional-fee-input" type="number" inputMode="numeric" value={form.additional_fee} onChange={e=>set("additional_fee",stripZero(e.target.value))}/></Field>
          </div>
          <Field label="Catatan desain"><textarea data-testid="design-note-input" value={form.design_note} onChange={e=>set("design_note",e.target.value)}/></Field>
        </div>;
      })()}
      <div className="section" data-section="pembayaran">
        <h3 className="section-h"><Wallet size={16} className="section-icon" aria-hidden="true"/><span>Pembayaran</span></h3>
        <p className="muted small">Pelunasan berikutnya selalu menjadi transaksi baru.</p>
        <PaymentRows rows={payments} setRows={setPayments}/>
      </div>
      <aside className="summary">
        <p className="eyebrow">RINGKASAN NOTA</p>
        <div className="sum-line"><span>Total produk</span><strong>{money(total)}</strong></div>
        {/* Iter 344 — Pisahkan rincian biaya & diskon/ongkir. Sembunyikan baris yang tidak berlaku.
            Angka diambil dari variabel sama dgn `grand` (tanpa menghitung ulang). */}
        {setting > 0 && (
          <div className="sum-line" data-testid="sum-setting-bordir"><span>Biaya Setting Bordir</span><strong>{money(setting)}</strong></div>
        )}
        {Number(form.additional_fee||0) > 0 && (
          <div className="sum-line" data-testid="sum-additional-fee"><span>Biaya Tambahan</span><strong>{money(Number(form.additional_fee||0))}</strong></div>
        )}
        {Number(form.invoice_discount||0) > 0 && (
          <div className="sum-line" data-testid="sum-invoice-discount"><span>Diskon nota</span><strong>-{money(Number(form.invoice_discount||0))}</strong></div>
        )}
        {Number(form.shipping||0) > 0 && (
          <div className="sum-line" data-testid="sum-shipping"><span>Ongkir</span><strong>+{money(Number(form.shipping||0))}</strong></div>
        )}
        <div className="sum-line"><span>PPN 11% <button data-testid="ppn-toggle" className={`check-toggle ${form.ppn ? "is-on" : ""}`} aria-pressed={form.ppn ? "true" : "false"} onClick={()=>set("ppn",!form.ppn)}>{form.ppn?"Ya":"Tidak"}</button></span><strong data-testid="sum-ppn-value">{form.ppn ? money(tax) : "Tidak dikenakan"}</strong></div>
        <div className="sum-line grand"><span>Grand total</span><strong data-testid="grand-total">{money(grand)}</strong></div>
        <div className="sum-line"><span>Total sudah dibayar</span><strong>{money(paid)}</strong></div>
        <div className="sum-line grand"><span>Sisa pembayaran</span><strong data-testid="remaining-total">{money(Math.max(0,grand-paid))}</strong></div>
      </aside>
    </div>
    <div className="save-dock">
      {autoSavedAt && <span className="autosave-indicator" data-testid="autosave-indicator" title={`Tersimpan lokal ${autoSavedAt.toLocaleTimeString("id-ID")}`}>
        <CheckCircle2 size={13} aria-hidden="true"/>
        Tersimpan otomatis · {autoSavedAt.toLocaleTimeString("id-ID", {hour:"2-digit", minute:"2-digit"})}
      </span>}
      <button data-testid="preview-nota-button" type="button" className="soft-btn big preview-nota-btn" disabled={saving} onClick={()=>{
        // Validasi ringan: minimal nama/WA/deadline & 1 produk terisi. Bila tidak lengkap,
        // biarkan user tetap buka pratinjau (data terlihat kosong) — modal punya CTA "Kembali edit".
        if (!form.customer_name.trim() && !form.whatsapp.trim() && form.products.every(p=>!p.name)) {
          notify.warning({ title:"Form masih kosong", message:"Isi minimal nama pelanggan atau nomor WhatsApp untuk melihat pratinjau." });
          return;
        }
        setShowPreview(true);
      }}><Eye size={16} aria-hidden="true"/>Pratinjau Nota</button>
      <button data-testid="save-draft-button" className="secondary big" disabled={saving} onClick={()=>save("Draft")}>Simpan Draft</button>
      <button data-testid="save-note-button" className="primary big" disabled={saving} onClick={()=>save("Menunggu Pembayaran")}>{saving?"Menyimpan…":"Simpan Nota"}</button>
    </div>
    {showPreview && <PreviewNotaSheet
      form={form}
      payments={payments}
      total={total}
      setting={setting}
      tax={tax}
      grand={grand}
      paid={paid}
      user={user}
      saving={saving}
      onClose={()=>setShowPreview(false)}
      onSaveDraft={()=>{ setShowPreview(false); save("Draft"); }}
      onSaveNota={()=>{ setShowPreview(false); save("Menunggu Pembayaran"); }}
    />}
  </section>;
}

// Iter 210 — Pratinjau Nota Sebelum Simpan
// Modal melayang yang menampilkan ringkasan nota lengkap agar Aurel/Admin Toko bisa
// cross-check sebelum menekan Simpan. Data dibaca dari state form + turunan (total, tax,
// grand, paid). Tidak melakukan save sendiri; delegate ke `onSaveDraft` / `onSaveNota`.
function PreviewNotaSheet({ form, payments, total, setting, tax, grand, paid, user, saving, onClose, onSaveDraft, onSaveNota }) {
  useEffect(() => {
    const onEsc = e => { if (e.key === "Escape" && !saving) onClose(); };
    document.addEventListener("keydown", onEsc);
    document.body.style.overflow = "hidden";
    return () => { document.removeEventListener("keydown", onEsc); document.body.style.overflow = ""; };
  }, [onClose, saving]);

  const money = n => "Rp " + Number(n||0).toLocaleString("id-ID");
  const pcs = form.products.reduce((sum,p)=>sum+(p.sizes||[]).reduce((a,s)=>a+Number(s.quantity||0),0),0);
  const remaining = Math.max(0, grand - paid);
  const rowEff = (p, s) => computeRowEffective(p, s, form.embroidery_points);

  return <div className="modal-backdrop preview-nota-backdrop" data-testid="preview-nota-modal" onClick={e=>{ if (e.target === e.currentTarget && !saving) onClose(); }}>
    <div className="tam-modal preview-nota-sheet" role="dialog" aria-modal="true" aria-labelledby="preview-nota-title">
      <header className="preview-nota-head">
        <div>
          <p className="eyebrow" style={{margin:0}}>Nota baru · {fmtDateID(form.order_date)} · {form.order_time} WIB</p>
          <h2 id="preview-nota-title">Pratinjau Nota</h2>
          <p className="muted small" style={{margin:"4px 0 0"}}>Periksa detail sebelum menyimpan. Klik Kembali ubah untuk memperbaiki.</p>
        </div>
        <button type="button" className="icon-btn preview-nota-close" data-testid="preview-nota-close" aria-label="Tutup pratinjau" onClick={()=>!saving && onClose()}><X size={20}/></button>
      </header>

      <div className="preview-nota-body">
        {/* Pemesan */}
        <section className="preview-nota-card" data-section="pemesan">
          <h3 className="preview-nota-h"><UserIcon size={15} aria-hidden="true"/>Pelanggan</h3>
          <dl className="preview-nota-grid">
            <div><dt>Nama pelanggan</dt><dd data-testid="preview-customer-name">{form.customer_name || <span className="preview-empty">Belum diisi</span>}</dd></div>
            <div><dt>Nomor WhatsApp</dt><dd data-testid="preview-whatsapp">{form.whatsapp || <span className="preview-empty">Belum diisi</span>}</dd></div>
            {form.company && <div><dt>Instansi</dt><dd>{form.company}</dd></div>}
            <div><dt>Deadline Customer</dt><dd data-testid="preview-deadline">{form.deadline || <span className="preview-empty">Belum dipilih</span>}</dd></div>
            <div><dt>Deadline Produksi</dt><dd data-testid="preview-production-deadline">{form.production_deadline || <span className="preview-empty">Belum dipilih</span>}</dd></div>
            <div><dt>Jenis pesanan</dt><dd>{form.order_type === "Polos" ? "Polosan" : form.order_type}{form.custom_type ? ` · ${form.custom_type}` : ""}</dd></div>
            <div><dt>Dibuat oleh</dt><dd>{form.admin || user.name}</dd></div>
          </dl>
        </section>

        {/* Produk */}
        <section className="preview-nota-card" data-section="produk">
          <h3 className="preview-nota-h"><Package size={15} aria-hidden="true"/>Produk ({form.products.length}) · Total {pcs} pcs</h3>
          <div className="preview-nota-products" data-testid="preview-products-list">
            {form.products.map((p, pi) => {
              const isLainnya = p.name === "Lainnya" || p.name === "Produk Lainnya";
              const productName = (isLainnya && p.custom_name) ? p.custom_name : (p.name || "—");
              const rows = (p.sizes || []).filter(s => Number(s.quantity||0) > 0 && s.size);
              const subtotal = rows.reduce((a,s)=>a + Number(s.quantity||0) * rowEff(p,s), 0);
              const dtfBadge = p.dtf_size ? ` · DTF ${p.dtf_size}` : "";
              return <div key={pi} className="preview-nota-product" data-testid={`preview-product-${pi}`}>
                <div className="preview-nota-product-head">
                  <div>
                    <span className="preview-nota-product-num">PRODUK {String(pi+1).padStart(2,"0")}</span>
                    <strong className="preview-nota-product-name">{productName}</strong>
                    {(p.name === "Jasa Bordir" || p.name === "Jasa Sablon") && (
                      <span
                        data-testid={`preview-product-cm-badge-${pi}`}
                        style={{marginLeft:8, padding:"2px 8px", background:"#fff4d9", color:"#7a5100", border:"1px solid #e6c46b", borderRadius:6, fontSize:11, fontWeight:600}}
                      >Bahan Pelanggan</span>
                    )}
                  </div>
                  <span className="preview-nota-route">{p.production_route || "Tanpa jalur"}{dtfBadge}</span>
                </div>
                {rows.length === 0 && <p className="preview-empty" style={{padding:"8px 0"}}>Belum ada baris ukuran terisi.</p>}
                {rows.length > 0 && <table className="preview-nota-rows"><thead>
                  <tr><th>Warna</th><th>Lengan</th><th>Ukuran</th><th>Qty</th><th>Harga/pcs</th><th>Subtotal</th></tr>
                </thead><tbody>
                  {rows.map((s, si) => {
                    const eff = rowEff(p, s);
                    const isManual = s.price_manual === true || s._manual === true;
                    return <tr key={si} data-testid={`preview-row-${pi}-${si}`}>
                      <td>{s.color || p.color || <span className="preview-empty">—</span>}</td>
                      <td>{s.variant || <span className="preview-empty">—</span>}</td>
                      <td>{s.size}</td>
                      <td className="preview-num">{s.quantity}</td>
                      <td className="preview-num">{money(eff)}{isManual && <span className="preview-manual-tag" title="Harga manual">M</span>}</td>
                      <td className="preview-num"><strong>{money(Number(s.quantity||0) * eff)}</strong></td>
                    </tr>;
                  })}
                </tbody></table>}
                <div className="preview-nota-product-sub">
                  <span>Subtotal produk</span>
                  <strong data-testid={`preview-product-subtotal-${pi}`}>{money(Math.max(0, subtotal - Number(p.discount||0)))}</strong>
                </div>
                {Number(p.discount||0) > 0 && <div className="preview-nota-product-disc"><span>Diskon produk</span><span>−{money(Number(p.discount||0))}</span></div>}
                {Number(p.setting_fee||0) > 0 && <div className="preview-nota-product-disc"><span>Biaya setting</span><span>+{money(Number(p.setting_fee||0))}</span></div>}
              </div>;
            })}
          </div>
        </section>

        {/* Pembayaran awal */}
        {payments.filter(p=>Number(p.amount||0)>0).length > 0 && <section className="preview-nota-card" data-section="pembayaran">
          <h3 className="preview-nota-h"><Wallet size={15} aria-hidden="true"/>Pembayaran awal</h3>
          <ul className="preview-nota-payments" data-testid="preview-payments-list">
            {payments.filter(p=>Number(p.amount||0)>0).map((p, pi) => (
              <li key={pi} data-testid={`preview-payment-${pi}`}>
                <span>{p.method || "Tunai"}{p.reference ? ` · ${p.reference}` : ""}</span>
                <strong>{money(p.amount)}</strong>
              </li>
            ))}
          </ul>
        </section>}

        {/* Ringkasan angka */}
        <section className="preview-nota-summary" data-testid="preview-summary">
          <div className="preview-sum-row"><span>Total produk</span><strong>{money(total)}</strong></div>
          <div className="preview-sum-row"><span>Biaya setting + tambahan</span><strong>{money(setting + Number(form.additional_fee||0))}</strong></div>
          <div className="preview-sum-row"><span>Diskon nota + ongkir</span><strong>{money(-Number(form.invoice_discount||0) + Number(form.shipping||0))}</strong></div>
          <div className="preview-sum-row"><span>PPN 11% <span className={`preview-ppn-chip ${form.ppn?"on":"off"}`}>{form.ppn?"Ya":"Tidak"}</span></span><strong>{money(tax)}</strong></div>
          <div className="preview-sum-row grand"><span>Grand total</span><strong data-testid="preview-grand-total">{money(grand)}</strong></div>
          <div className="preview-sum-row"><span>Total sudah dibayar</span><strong>{money(paid)}</strong></div>
          <div className="preview-sum-row grand-remain"><span>Sisa pembayaran</span><strong data-testid="preview-remaining">{money(remaining)}</strong></div>
        </section>
      </div>

      <footer className="preview-nota-actions">
        <button type="button" className="secondary" data-testid="preview-back-edit" disabled={saving} onClick={()=>onClose()}><ChevronLeft size={16} aria-hidden="true"/>Kembali ubah</button>
        <div style={{flex:1}}/>
        <button type="button" className="soft-btn" data-testid="preview-save-draft" disabled={saving} onClick={()=>onSaveDraft()}>Simpan Draft</button>
        <button type="button" className="primary" data-testid="preview-save-note" disabled={saving} onClick={()=>onSaveNota()}>{saving ? "Menyimpan…" : "Simpan Nota"}</button>
      </footer>
    </div>
  </div>;
}



function EditModal({ order, onClose, onSaved }) {
  const inProduction = (order.products || []).some(p => p.production_updated_at);
  const [form, setForm] = useState({
    customer_name: order.customer_name || "",
    whatsapp: order.whatsapp || "",
    company: order.company || "",
    deadline: order.deadline || "",
    order_type: order.order_type || "Polos",
    // Iter 204 — Preserve sumber apa adanya (nota lama tidak boleh ditimpa menjadi "Offline").
    source: order.source ?? "",
    production_note: order.production_note || "",
    design_note: order.design_note || "",
    design_status: order.design_status || "Belum Dibuat",
    order_status: order.order_status || "Menunggu Pembayaran",
    // Iter 391 — Penanda Repeat Order (eksplisit, boleh diubah di sini).
    is_repeat_order: !!order.is_repeat_order,
    repeat_ref: order.repeat_ref || "",
  });
  const [reason, setReason] = useState("");
  const [saving, setSaving] = useState(false);
  // Nota lama tanpa Deadline Produksi: tampil tanggal lama & dianggap manual (tidak ditulis kecuali diubah).
  const [pd, setPd] = useState({ value: order.production_deadline || order.deadline || "",
    manual: order.production_deadline ? !!order.production_deadline_manual : true, touched: false });
  const save = async () => {
    if (saving) return;
    if (!form.customer_name.trim() || !form.whatsapp.trim()) { notify.warning({ title:"Data belum lengkap", message:"Nama dan nomor WhatsApp wajib diisi." }); return; }
    if (pd.value && form.deadline && pd.value > form.deadline) { notify.warning({ title:"Deadline Produksi tidak valid", message:"Deadline Produksi tidak boleh melewati Deadline Customer." }); return; }
    if (form.deadline && order.order_date && form.deadline < order.order_date) { notify.warning({ title:"Deadline tidak valid", message:"Deadline tidak boleh lebih awal dari tanggal pesanan." }); return; }
    if (inProduction && reason.trim().length < 3) { notify.warning({ title:"Alasan perubahan wajib diisi", message:"Nota sudah masuk produksi. Alasan perubahan wajib minimal 3 karakter." }); return; }
    setSaving(true);
    try {
      // Iter 204 — Jangan kirim `source` di payload edit; backend `update_order` hanya
      // mengubah field yang dikirim, jadi source pada nota lama TIDAK tertimpa.
      const { source: _srcOmit, ...formBase } = form;
      const formNoSource = pd.touched ? { ...formBase, production_deadline: pd.value, production_deadline_manual: pd.manual } : formBase;
      const payload = inProduction ? { ...formNoSource, edit_reason: reason.trim() } : formNoSource;
      await axios.patch(`${API}/orders/${order.order_number}`, payload, { withCredentials:true });
      await notify.success({ title:"Perubahan tersimpan", message:"Data nota berhasil diperbarui.", primaryLabel:"Selesai" });
      onSaved();
    } catch (e) { notify.error({ title:"Gagal menyimpan perubahan", message: e.response?.data?.detail || "Silakan coba lagi." }); }
    finally { setSaving(false); }
  };
  return <div className="modal-backdrop" onClick={onClose}>
    <div className="modal" onClick={e=>e.stopPropagation()} data-testid="edit-modal">
      <div className="modal-head">
        <h3>Edit Nota {order.order_number}</h3>
        <button className="icon-btn" onClick={onClose}><X/></button>
      </div>
      <p className="muted small">Riwayat pembayaran dan total nota tidak dapat diubah dari sini.</p>
      <div className="fields">
        <Field label="Nama pelanggan" required><input data-testid="edit-customer-name" value={form.customer_name} onChange={e=>setForm({...form,customer_name:e.target.value})}/></Field>
        <Field label="WhatsApp" required><input data-testid="edit-whatsapp" value={form.whatsapp} onChange={e=>setForm({...form,whatsapp:e.target.value.replace(/[^0-9+]/g,"")})}/></Field>
        <Field label="Instansi"><input data-testid="edit-company" value={form.company} onChange={e=>setForm({...form,company:e.target.value})}/></Field>
        <Field label="Deadline Customer">
          <DatePickerID testId="edit-deadline" value={form.deadline} onChange={v=>setForm({...form,deadline:v})} placeholder="Pilih deadline" minDateISO={order.order_date}/>
        </Field>
        <ProductionDeadlineField tid="edit-production-deadline" customer={form.deadline} orderDate={order.order_date} value={pd.value} manual={pd.manual}
          sewing={(order.products||[]).some(p => p.production_route === SEW_ROUTE)} exclude={order.order_number}
          onChange={(v, m) => setPd({ value: v, manual: m, touched: true })}/>
        {/* Iter 204 — Sumber disembunyikan dari UI Edit; nilai `form.source` tetap dijaga
            apa adanya dari nota tersimpan supaya laporan historis tidak berubah. */}
        <input type="hidden" data-testid="edit-source" value={form.source || ""} readOnly/>
        <Field label="Status pesanan">
          <select data-testid="edit-order-status" value={form.order_status} onChange={e=>setForm({...form,order_status:e.target.value})}>
            <option>Draft</option><option>Menunggu Pembayaran</option><option>Menunggu Desain</option><option>Menunggu Bahan</option><option>Diproses</option><option>Selesai</option><option>Diambil</option><option>Dikirim</option>
          </select>
        </Field>
      </div>
      <Field label="Catatan produksi"><textarea data-testid="edit-production-note" value={form.production_note} onChange={e=>setForm({...form,production_note:e.target.value})}/></Field>
      <div style={{marginTop:12}}>
        <RepeatOrderFields
          active={!!form.is_repeat_order}
          repeatRef={form.repeat_ref || ""}
          onChange={({ is_repeat_order, repeat_ref }) => setForm(f => ({ ...f, is_repeat_order, repeat_ref }))}
          context="offline"
          idPrefix="edit-order-repeat"/>
      </div>
      {inProduction && <Field label="Alasan perubahan (wajib, Nota sudah masuk produksi)" required>
        <textarea data-testid="edit-reason-input" value={reason} onChange={e=>setReason(e.target.value)} placeholder="Contoh: koreksi ukuran atas permintaan pelanggan pada 15 Feb 2026" rows={2}/>
      </Field>}
      <div className="modal-foot">
        <button className="secondary" onClick={onClose}>Batal</button>
        <button data-testid="edit-save-button" className="primary" onClick={save} disabled={saving}>{saving?"Menyimpan…":"Simpan Perubahan"}</button>
      </div>
    </div>
  </div>;
}

function PrintNota({ order, onClose }) {
  // Iter 115 — Preview modal = iframe PDF A5 backend (preview = output cetak).
  // Semua rendering HTML A4 lama dihapus supaya konsisten dgn hasil cetak PDF.
  const [printBusy, setPrintBusy] = useState(false);
  const [printHint, setPrintHint] = useState("");
  const [blobUrl, setBlobUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const [loadErr, setLoadErr] = useState("");

  useEffect(() => {
    const prev = document.title;
    document.title = `Nota-${order.order_number}`;
    return () => { document.title = prev; };
  }, [order.order_number]);

  const pdfUrl = `${API}/orders/${encodeURIComponent(order.order_number)}/nota.pdf`;

  useEffect(() => {
    // Fetch PDF as blob (bypass "Content-Disposition: attachment" utk iframe preview).
    let cancelled = false;
    let currentUrl = null;
    setLoading(true);
    setLoadErr("");
    (async () => {
      try {
        const res = await fetch(pdfUrl, { credentials: "include", cache: "no-store" });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const blob = await res.blob();
        currentUrl = URL.createObjectURL(blob);
        if (cancelled) { URL.revokeObjectURL(currentUrl); return; }
        setBlobUrl(currentUrl);
        setLoading(false);
      } catch (e) {
        if (!cancelled) {
          setLoadErr(String(e?.message||e) === "HTTP 403"
            ? "Anda tidak berwenang menampilkan PDF Nota (butuh role Owner/Admin/Admin Toko)."
            : "Gagal memuat preview PDF. Coba tombol Unduh PDF."
          );
          setLoading(false);
        }
      }
    })();
    return () => {
      cancelled = true;
      if (currentUrl) { try { URL.revokeObjectURL(currentUrl); } catch {} }
    };
  }, [pdfUrl]);

  const handlePrint = async () => {
    setPrintHint("");
    setPrintBusy(true);
    try {
      const r = await printPdfFromUrl(pdfUrl);
      if (r?.mode === "mobile-tab") setPrintHint("PDF dibuka di tab baru — gunakan menu Print browser (A5).");
      else if (r?.mode === "desktop-tab") setPrintHint("PDF dibuka di tab baru — gunakan Ctrl/⌘+P untuk cetak (A5).");
      else if (r?.mode === "blocked") setPrintHint("Popup diblokir — gunakan tombol Unduh PDF.");
    } catch (e) {
      setPrintHint("Gagal menyiapkan PDF cetak. Coba tombol Unduh PDF.");
    } finally {
      setPrintBusy(false);
    }
  };

  return <div className="print-shell print-iframe-shell">
    <div className="print-toolbar no-print">
      <button data-testid="print-close-button" className="soft-btn" onClick={onClose}><ChevronLeft size={16}/>Kembali</button>
      <div className="print-tools">
        <span className="muted small hide-mobile">Preview = hasil cetak (PDF A5 landscape).</span>
        {printHint && <span className="muted small" data-testid="print-hint">{printHint}</span>}
        <button
          data-testid="print-download-pdf"
          type="button"
          className="soft-btn"
          onClick={async () => {
            // Iter 146 — Reuse blob preview bila sudah termuat; fallback ke fetch baru
            // dengan cookie sesi + validasi Content-Type sebelum menyimpan.
            const fname = `Nota-${order.order_number}.pdf`;
            if (blobUrl) {
              const a = document.createElement("a");
              a.href = blobUrl; a.download = fname; a.rel = "noopener";
              document.body.appendChild(a); a.click();
              setTimeout(() => { try { a.remove(); } catch {} }, 400);
              return;
            }
            await downloadPdfFromUrl(pdfUrl, fname);
          }}
        ><Printer size={16}/>Unduh PDF</button>
        <button data-testid="print-do-print" className="primary" disabled={printBusy || loading || !!loadErr} onClick={handlePrint}><Printer size={16}/>{printBusy ? "Menyiapkan…" : "Cetak"}</button>
      </div>
    </div>
    <div className="print-iframe-wrap" data-testid="print-nota-page">
      {loading && <div className="print-iframe-status" data-testid="print-loading"><span className="muted">Memuat pratinjau PDF…</span></div>}
      {loadErr && <div className="print-iframe-status print-iframe-error" data-testid="print-error"><span>{loadErr}</span></div>}
      {!loading && !loadErr && blobUrl && (
        <iframe
          key={blobUrl}
          data-testid="print-iframe"
          title={`Nota ${order.order_number}`}
          src={`${blobUrl}#toolbar=0&navpanes=0&view=FitH`}
          className="print-iframe"
        />
      )}
    </div>
  </div>;
}

function SPKPage({ order, product, index, totalPages, isCancelled, productionStatus }) {
  const qty = product ? (product.quantity ?? (product.sizes||[]).reduce((a,s)=>a+Number(s.quantity||0),0)) : 0;
  const sizes = product?.sizes || [];
  const isCustomOrder = order.order_type === "Custom";
  const designImage = order.design_file && /^data:image\//.test(order.design_file) ? order.design_file : null;
  return <article className={`spk-page ${isCancelled?"spk-cancelled":""}`} data-testid={`spk-page-${index}`}>
    {isCancelled && <div className="spk-watermark" data-testid={`spk-watermark-${index}`}>DIBATALKAN</div>}
    <header className="spk-header">
      <div className="spk-brand">
        <div className="spk-mark" aria-label="Logo TAMFARIS"><img src="/logo-tamfaris.jpg" alt="Logo TAMFARIS" draggable="false"/></div>
        <div>
          <p className="print-eyebrow">TAMFARIS</p>
          <h1>SURAT PERINTAH KERJA</h1>
        </div>
      </div>
      <div className="spk-qr">
        <QRCodeSVG value={order.order_number || ""} size={54} bgColor="#ffffff" fgColor="#0f172a" level="M"/>
        <p className="spk-qr-caption">{order.order_number}</p>
      </div>
    </header>
    <div className="spk-meta-grid">
      <div><span>Nomor Nota</span><strong data-testid={`spk-order-number-${index}`}>{order.order_number}</strong></div>
      <div><span>Tanggal pesanan</span><strong>{fmtDate(order.order_date)}</strong></div>
      <div><span>Deadline produksi</span><strong data-testid={`spk-deadline-${index}`}>{fmtDate(order.production_deadline || order.deadline)}</strong></div>
      <div><span>Admin pencatat</span><strong>{order.admin || "—"}</strong></div>
      <div><span>Status produksi</span><strong className="spk-badge" data-testid={`spk-prod-status-${index}`}>{productionStatus}</strong></div>
      <div><span>Halaman</span><strong data-testid={`spk-page-num-${index}`}>Produk {index+1} dari {totalPages}</strong></div>
    </div>
    {order.is_repeat_order && <div className="spk-repeat-row" data-testid={`spk-repeat-${index}`}
      style={{margin:"6px 0", padding:"6px 10px", background:"linear-gradient(90deg,#D4AF37,#E8C656)", color:"#0f172a", borderRadius:6, fontSize:12, fontWeight:800, letterSpacing:".04em", display:"inline-flex", alignItems:"center", gap:8}}>
      ⟳ REPEAT ORDER
      {order.repeat_ref && <span style={{fontWeight:600, letterSpacing:".01em"}}>· Repeat dari Nota: <b>{order.repeat_ref}</b></span>}
    </div>}
    <div className="spk-barcode-row" data-testid={`spk-barcode-${index}`}>
      <Barcode value={order.order_number || " "} format="CODE128" height={34} width={1.4} fontSize={10} margin={0} background="#ffffff" lineColor="#0f172a" displayValue={true}/>
    </div>
    <section className="spk-section" data-section="pemesan">
      <h2 className="spk-section-h"><UserIcon size={14} aria-hidden="true"/><span>Informasi Pesanan</span></h2>
      <div className="spk-facts">
        <div><span>Nama pelanggan</span><strong>{order.customer_name || "—"}</strong></div>
        <div><span>Instansi</span><strong>{order.company || "—"}</strong></div>
        <div><span>Jenis pesanan</span><strong>{order.order_type === "Polos" ? "Polosan" : (order.order_type || "—")}</strong></div>
        <div><span>Sumber pesanan</span><strong>{order.source || "—"}</strong></div>
      </div>
    </section>
    {product && <section className="spk-section" data-section="produk">
      <h2 className="spk-section-h"><Package size={14} aria-hidden="true"/><span>Detail Produk</span></h2>
      <div className="spk-product-name" data-testid={`spk-product-name-${index}`}>{product.name || "—"}</div>
      <div className="spk-facts spk-facts-3">
        <div><span>Bahan</span><strong data-testid={`spk-material-${index}`}>{product.material||"—"}</strong></div>
        <div><span>Warna</span><strong data-testid={`spk-color-${index}`}>{product.color||"—"}</strong></div>
        {/* Iter 145 — Field "Lengan" global sudah dihapus dari form. Untuk nota lama yang masih
            menyimpan sleeve valid (Pendek/Panjang), tetap ditampilkan; jika "Tidak Berlaku"
            atau kosong, kolom Lengan diganti ringkasan varian per baris ukuran. */}
        {(product.sleeve && product.sleeve !== "Tidak Berlaku")
          ? <div><span>Lengan</span><strong data-testid={`spk-sleeve-${index}`}>{product.sleeve}</strong></div>
          : (() => {
              const variantCounts = (product.sizes || []).reduce((acc, s) => {
                const v = (s.variant || "").trim();
                if (!v) return acc;
                acc[v] = (acc[v] || 0) + Number(s.quantity || 0);
                return acc;
              }, {});
              const parts = Object.entries(variantCounts).map(([v, q]) => `${v} ${q}`);
              return <div><span>Varian</span><strong data-testid={`spk-sleeve-${index}`}>{parts.length ? parts.join(" · ") : "—"}</strong></div>;
            })()
        }
      </div>
      {/* Iter 276 — Model Kerah Jersey (bila diisi) tampil di SPK. */}
      {product.collar_model && <div className="spk-facts">
        <div><span>Model Kerah</span><strong data-testid={`spk-collar-${index}`}>
          {product.collar_model === "Lainnya" && product.collar_note ? `${product.collar_model} — ${product.collar_note}` : product.collar_model}
        </strong></div>
      </div>}
      {/* Iter 278 — Proses (Sublim / Bordir / Sablon / dst) bila process_mode terisi. */}
      {product.process_mode && <div className="spk-facts">
        <div><span>Proses</span><strong data-testid={`spk-process-${index}`}>{product.process_mode}</strong></div>
      </div>}
      <div className="spk-sizes-box">
        <p className="spk-label">Rincian ukuran</p>
        <div className="spk-sizes-list" data-testid={`spk-sizes-${index}`}>
          {sizes.length ? sizes.map((s,n)=>{
            // Iter 147 — SPK label = Warna · Size (Lengan). Fallback ke product-level.
            const c = (s.color || product.color || "").trim();
            const v = (s.variant || (product.sleeve && product.sleeve !== "Tidak Berlaku" ? product.sleeve : "") || "").trim();
            const label = `${c ? c + " · " : ""}${s.size}${v ? ` (${v})` : ""}`;
            return <div className="spk-size-item" key={n}>
              <span className="spk-size-label">{label}</span>
              <span className="spk-size-qty">{s.quantity} pcs</span>
            </div>;
          }) : <em>—</em>}
        </div>
        <div className="spk-total-row">
          <strong>Total jumlah</strong>
          <strong className="spk-total-num" data-testid={`spk-total-qty-${index}`}>{qty} pcs</strong>
        </div>
      </div>
      {product.note && <div className="spk-note-block">
        <p className="spk-label">Keterangan produk</p>
        <p>{product.note}</p>
      </div>}
    </section>}
    {isCustomOrder && <section className="spk-section" data-section="detail">
      <h2 className="spk-section-h"><Sliders size={14} aria-hidden="true"/><span>Detail Custom</span></h2>
      <div className="spk-facts spk-facts-2">
        <div><span>Jenis custom</span><strong data-testid={`spk-custom-type-${index}`}>{order.custom_type||"—"}</strong></div>
        <div><span>Posisi desain</span><strong>{order.design_position||"—"}</strong></div>
        <div><span>Ukuran desain</span><strong>{order.design_size||"—"}</strong></div>
        <div><span>Jumlah titik bordir</span><strong data-testid={`spk-embroidery-${index}`}>{order.embroidery_points ?? "—"}</strong></div>
        <div><span>Nama file desain</span><strong>{order.design_filename||"—"}</strong></div>
        <div><span>Status desain</span><strong>{order.design_status||"—"}</strong></div>
      </div>
      {order.design_note && <p className="spk-mini-note">Catatan desain: {order.design_note}</p>}
      <div className="spk-design-block">
        <p className="spk-label">Pratinjau desain</p>
        {designImage
          ? <img src={designImage} alt="Desain" className="spk-design-img"/>
          : <p className="spk-empty" data-testid={`spk-design-empty-${index}`}>Belum ada file desain</p>}
      </div>
    </section>}
    <section className="spk-section" data-section="produk">
      <h2 className="spk-section-h"><CheckCircle2 size={14} aria-hidden="true"/><span>Checklist Produksi</span></h2>
      <div className="spk-check-grid">
        {["Desain diperiksa","Bahan disiapkan","Potong","Bordir / DTF / Sablon","Jahit","Finishing / QC","Packing"].map(item=>
          <label className="spk-check-item" key={item}>
            <span className="spk-check-box"></span>
            <span>{item}</span>
          </label>
        )}
      </div>
    </section>
    <section className="spk-section spk-notes-area" data-section="detail">
      <h2 className="spk-section-h"><Pencil size={14} aria-hidden="true"/><span>Catatan Produksi</span></h2>
      <div className="spk-note-lines"><span></span><span></span><span></span></div>
    </section>
    <footer className="spk-footer">
      <div className="spk-sign-block">
        <p className="spk-label">Dikerjakan oleh</p>
        <div className="spk-sign-underline"></div>
      </div>
      <div className="spk-sign-block">
        <p className="spk-label">Tanggal mulai</p>
        <div className="spk-sign-underline"></div>
      </div>
      <div className="spk-sign-block">
        <p className="spk-label">Tanggal selesai</p>
        <div className="spk-sign-underline"></div>
      </div>
      <div className="spk-sign-block">
        <p className="spk-label">Pemeriksa / QC</p>
        <div className="spk-sign-underline"></div>
      </div>
      <div className="spk-sign-block">
        <p className="spk-label">Tanda tangan</p>
        <div className="spk-sign-underline"></div>
      </div>
    </footer>
  </article>;
}

function PrintSPK({ order, onClose }) {
  const [printBusy, setPrintBusy] = useState(false);
  const [printHint, setPrintHint] = useState("");
  useEffect(() => {
    const prev = document.title;
    document.title = `SPK-${order.order_number}`;
    return () => { document.title = prev; };
  }, [order.order_number]);
  const isCancelled = order.order_status === "Dibatalkan";
  const products = order.products || [];
  const totalPages = Math.max(1, products.length);
  const productionStatus = order.production_status && order.production_status !== "Antri" ? order.production_status : (order.order_status || "—");
  const pdfUrl = `${API}/orders/${encodeURIComponent(order.order_number)}/spk.pdf`;
  const handlePrint = async () => {
    if (printBusy) return;
    setPrintBusy(true); setPrintHint("");
    try {
      const r = await printPdfFromUrl(pdfUrl);
      if (r.mode === "mobile-tab") setPrintHint("Dokumen dibuka di tab baru. Tekan ikon Bagikan / Cetak lalu pilih Cetak.");
      else if (r.mode === "desktop-tab") setPrintHint("Dialog cetak diblokir; dokumen dibuka di tab baru — silakan cetak dari sana.");
    } catch (e) {
      setPrintHint("Gagal menyiapkan cetak. Coba tombol Unduh PDF.");
    } finally {
      setPrintBusy(false);
    }
  };
  return <div className="print-shell spk-shell">
    <div className="print-toolbar no-print">
      <button data-testid="spk-close-button" className="soft-btn" onClick={onClose}><ChevronLeft size={16}/>Kembali</button>
      <div className="print-tools">
        <span className="muted small hide-mobile">Cetak & Unduh memakai dokumen A5 portrait yang sama.</span>
        {printHint && <span className="muted small" data-testid="spk-print-hint">{printHint}</span>}
        <button
          data-testid="spk-download-pdf"
          type="button"
          className="soft-btn"
          onClick={() => downloadPdfFromUrl(pdfUrl, `SPK-${order.order_number}.pdf`)}
        ><Printer size={16}/>Unduh PDF A5</button>
        <button data-testid="spk-do-print" className="primary" disabled={printBusy} onClick={handlePrint}><Printer size={16}/>{printBusy ? "Menyiapkan…" : "Cetak"}</button>
      </div>
    </div>
    {products.length > 0
      ? products.map((p,i)=><SPKPage key={i} order={order} product={p} index={i} totalPages={totalPages} isCancelled={isCancelled} productionStatus={productionStatus}/>)
      : <SPKPage order={order} product={null} index={0} totalPages={1} isCancelled={isCancelled} productionStatus={productionStatus}/>
    }
  </div>;
}



function TimelineSection({ orderNumber }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [filter, setFilter] = useState("all");
  const load = async () => {
    setLoading(true);
    try { const r = await axios.get(`${API}/orders/${orderNumber}/audit`, { withCredentials:true }); setItems(r.data || []); }
    catch(e) { setItems([]); }
    finally { setLoading(false); }
  };
  useEffect(()=>{ if (open) load(); /* eslint-disable-next-line */ }, [open, orderNumber]);
  const badge = (action) => {
    if (/Diambil/i.test(action)) return "paid";
    if (/[Bb]ayar|[Pp]ayment/.test(action)) return "paid";
    if (/[Bb]atal/.test(action)) return "cancel";
    return "pending";
  };
  const categorize = (action) => {
    if (/[Bb]ayar|[Pp]ayment|[Tt]ransaksi/.test(action)) return "payment";
    if (/tahap|jalur|[Pp]roduksi|[Tt]erima pekerjaan|pengerjaan/i.test(action)) return "production";
    if (/Diambil|[Pp]ickup/i.test(action)) return "pickup";
    return "other";
  };
  const CATS = [
    {key:"all", label:"Semua"},
    {key:"payment", label:"Pembayaran"},
    {key:"production", label:"Produksi"},
    {key:"pickup", label:"Pengambilan"},
    {key:"other", label:"Lainnya"},
  ];
  const filtered = filter === "all" ? items : items.filter(it => categorize(it.action) === filter);
  return <section className="section" data-testid="section-timeline">
    <button type="button" className="options-toggle" data-testid="timeline-toggle" onClick={()=>setOpen(v=>!v)} aria-expanded={open}>
      {open ? <ChevronUp size={15}/> : <ChevronDown size={15}/>}{open ? "Tutup" : "Buka"} Timeline Nota
    </button>
    {open && <>
      <div className="pickup-filter-tabs" data-testid="timeline-filter-tabs" style={{marginTop:12}}>
        {CATS.map(c => <button key={c.key} type="button" data-testid={`timeline-filter-${c.key}`} className={`mode-tab ${filter===c.key?"active":""}`} onClick={()=>setFilter(c.key)}>{c.label}</button>)}
      </div>
      <div className="timeline" data-testid="timeline-list" style={{marginTop:14}}>
        {loading && <p className="muted small">Memuat riwayat…</p>}
        {!loading && filtered.length===0 && <p className="muted small" data-testid="timeline-empty">Tidak ada riwayat pada filter ini.</p>}
        {filtered.map((it, i) => <div key={it.id||i} className="timeline-item" data-testid={`timeline-item-${i}`}>
          <div className="timeline-dot"/>
          <div className="timeline-body">
            <div className="timeline-head"><span className={`status ${badge(it.action)}`}>{it.action}</span><span className="muted small">{it.at ? new Date(it.at).toLocaleString("id-ID") : "—"} · {it.user||"—"}</span></div>
            {it.after && <details className="timeline-details"><summary className="muted small">Detail</summary><pre>{JSON.stringify(it.after, null, 2)}</pre></details>}
          </div>
        </div>)}
      </div>
    </>}
  </section>;
}

function PickupSection({ user, order, onRefresh, onOrderUpdated }) {
  const [busy, setBusy] = useState(false);
  const [note, setNote] = useState("");
  const [override, setOverride] = useState(false);
  const [reason, setReason] = useState("");
  const [err, setErr] = useState("");
  const isAdmin = user && ["owner","admin"].includes(String(user.role||"").toLowerCase());
  const isOperatorReadonly = String(user?.role||"").toLowerCase() === "operator";
  const products = order.products || [];
  // Iter 223 — pakai helper `isProductProductionDone` (Polosan auto-complete).
  const allDone = products.length > 0 && products.every(isProductProductionDone);
  const isLunas = order.payment_status === "Lunas";
  const alreadyPicked = order.pickup_status === "Diambil";
  const cancelled = order.order_status === "Dibatalkan";
  const submit = async () => {
    setErr("");
    if (override && !reason.trim()) { setErr("Alasan override wajib diisi"); return; }
    setBusy(true);
    try {
      // Iter 227 — Backend mengembalikan order yang sudah di-enrich → apply LANGSUNG
      //   ke state global supaya Antrian/Dashboard/Piutang sinkron tanpa wait GET ulang.
      const r = await axios.post(`${API}/orders/${order.order_number}/pickup`, { note, override, reason }, { withCredentials:true });
      setNote(""); setReason(""); setOverride(false);
      if (r?.data && typeof onOrderUpdated === "function") onOrderUpdated(r.data);
      await onRefresh();
    } catch(e) { setErr(e.response?.data?.detail || "Gagal menandai Diambil"); }
    finally { setBusy(false); }
  };
  return <section className="section" data-testid="section-pickup">
    <h3>Status Pengambilan Barang</h3>
    <div className="detail-facts">
      <div><span>Status</span><strong data-testid="pickup-status-label"><span className={`status ${alreadyPicked?"paid":"pending"}`}>{order.pickup_status || "Belum Diambil"}</span></strong></div>
      {alreadyPicked && <>
        <div><span>Diambil pada</span><strong data-testid="pickup-picked-at">{order.picked_up_at ? new Date(order.picked_up_at).toLocaleString("id-ID") : "—"}</strong></div>
        <div><span>Petugas serah</span><strong data-testid="pickup-picked-by">{order.picked_up_by || "—"}</strong></div>
        {order.pickup_note && <div><span>Catatan</span><strong>{order.pickup_note}</strong></div>}
        {order.pickup_override_reason && <div><span>Override</span><strong>{order.pickup_override_reason}</strong></div>}
        {order.picked_up_auto && <div><span>Mode</span><strong data-testid="pickup-auto-label" style={{color:"#15803d"}}>Otomatis · {order.picked_up_auto_reason || "Polosan Siap Stok · Lunas"}</strong></div>}
      </>}
    </div>
    {!alreadyPicked && !cancelled && order.order_status !== "Dikirim" && !isOperatorReadonly && <div style={{marginTop:12,display:"flex",flexDirection:"column",gap:10}}>
      {/* Iter 338 — Hint khusus nota all-Polosan Siap Stok: begitu lunas → otomatis Diambil tanpa tombol. */}
      {products.length > 0 && products.every(p => (p.production_route || "") === "Polosan Siap Stok") && !isLunas && (
        <p className="muted small" data-testid="pickup-hint-siap-stok" style={{background:"#fef3c7", color:"#92400e", padding:"8px 10px", borderRadius:8, border:"1px solid #fde68a"}}>
          Barang siap · Pembayaran belum lunas · Belum Diambil. Setelah pelunasan dicatat, nota akan otomatis Selesai + Diambil (tanpa perlu finalisasi Shella atau tombol pengambilan).
        </p>
      )}
      {!allDone && <p className="muted small" data-testid="pickup-warning-notdone">Belum semua produk selesai. {isAdmin ? "Anda dapat override sebagai Admin." : "Tunggu sampai semua produk Selesai."}</p>}
      {!isLunas && <p className="muted small" data-testid="pickup-warning-unpaid">Pembayaran belum lunas — sisa tagihan <b>{money(Number(order.remaining||0))}</b>. {isAdmin ? "Anda dapat override sebagai Admin." : "Selesaikan pelunasan dulu (gunakan tombol Lunasi di bawah)."}</p>}
      <input data-testid="pickup-note-input" value={note} onChange={e=>setNote(e.target.value)} placeholder="Catatan opsional (nama pengambil, dsb.)"/>
      {isAdmin && (!allDone || !isLunas) && <label style={{display:"flex",gap:8,alignItems:"center",fontSize:13}}>
        <input type="checkbox" data-testid="pickup-override-checkbox" checked={override} onChange={e=>setOverride(e.target.checked)}/>
        Override sebagai Admin (alasan wajib)
      </label>}
      {override && <input data-testid="pickup-override-reason" value={reason} onChange={e=>setReason(e.target.value)} placeholder="Alasan override wajib"/>}
      {err && <div className="alert" data-testid="pickup-error">{err}</div>}
      <button type="button" data-testid="pickup-mark-btn" className="primary" disabled={busy || (!allDone && !override) || (!isLunas && !override)} onClick={submit}>
        Tandai Diambil
      </button>
    </div>}
  </section>;
}



function Detail({ user, order, onBack, onRefresh, onOrderUpdated, onOrderRemoved, onPrintNota, onPrintSPK, onDuplicate }) {
  const [showWA, setShowWA] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [payForm, setPayForm] = useState({ amount:"", method:"Cash", reference:"", note:"", proof:null });
  const [saving, setSaving] = useState(false);
  const isCancelled = order.order_status === "Dibatalkan";
  const isDraft = order.order_status === "Draft";
  const isLunas = order.payment_status === "Lunas";
  const isAdminToko = String(user?.role||"").toLowerCase() === "admin_toko";
  // Iter 124 — Operator biasa (Gudang, dst) buka Detail dari Pemantauan = READ-ONLY.
  const isOperatorReadonly = String(user?.role||"").toLowerCase() === "operator";
  // Iter 249 — Operator produksi (backend sudah strip finansial → grand_total undefined).
  //   Untuk role ini: sembunyikan Ringkasan Nota / Pembayaran / Riwayat Pembayaran & rename judul.
  const isProductionOperator = isOperatorReadonly && typeof order.grand_total === "undefined";
  const canPay = !isCancelled && !isLunas && !isOperatorReadonly;
  const displayStatus = isCancelled ? "Dibatalkan" : isDraft ? "Draft" : "Aktif";
  const statusChipClass = isCancelled ? "cancel" : isDraft ? "draft" : "active";

  const payments = [...(order.payments || [])].sort((a,b) => String(a.paid_at||"").localeCompare(String(b.paid_at||"")));
  const totalPaid = Number(order.paid || 0);
  const remaining = Number(order.remaining ?? Math.max(0, Number(order.grand_total||0) - totalPaid));
  const sumFromHistory = payments.reduce((sum,p) => sum + Number(p.amount||0), 0);
  const hasLegacyGap = payments.length === 0 && totalPaid > 0;

  const copyWA = async () => {
    try { await navigator.clipboard.writeText(order.whatsapp || ""); notify.success({ title:"Nomor WhatsApp disalin", message:"Silakan tempel di aplikasi WhatsApp untuk menghubungi pelanggan.", primaryLabel:"Selesai" }); }
    catch { notify.info({ title:"Nomor WhatsApp", message: order.whatsapp || "-" }); }
  };

  const pay = async () => {
    if (saving) return;
    const n = Number(payForm.amount);
    if (!n || n <= 0) { notify.warning({ title:"Nominal tidak valid", message:"Nominal pembayaran harus lebih dari nol." }); return; }
    if (n > remaining) { notify.warning({ title:"Nominal melebihi sisa tagihan", message:`Sisa tagihan saat ini ${money(remaining)}. Sesuaikan nominal.` }); return; }
    const isFull = n >= remaining;
    const ok = await notify.confirm({
      title: isFull ? "Konfirmasi pelunasan?" : "Konfirmasi pembayaran DP?",
      message: `Nominal ${money(n)} akan dicatat sebagai ${isFull ? "pelunasan" : "DP"} untuk Nota ${order.order_number}. Pastikan metode dan bukti pembayaran sudah benar.`,
      primaryLabel: isFull ? "Ya, Lunasi" : "Ya, Catat DP",
      secondaryLabel: "Cek Kembali",
    });
    if (!ok) return;
    setSaving(true);
    try {
      let proofUrl = "";
      if (payForm.proof) {
        const fd = new FormData(); fd.append("file", payForm.proof);
        const r = await axios.post(`${API}/upload-file`, fd, { withCredentials:true });
        proofUrl = r.data.url;
      }
      const r2 = await axios.post(`${API}/orders/${order.order_number}/payments`, {
        amount: n, method: payForm.method, reference: payForm.reference, note: payForm.note, proof: proofUrl,
      }, { withCredentials:true });
      setPayForm({ amount:"", method:"Cash", reference:"", note:"", proof:null });
      // Iter 227 — Sinkronisasi instan dari respons payment.
      if (r2?.data && typeof onOrderUpdated === "function") onOrderUpdated(r2.data);
      await notify.success({ title: isFull ? "Nota lunas" : "Pembayaran tercatat", message: isFull ? "Terima kasih! Pembayaran sudah lunas dan dicatat." : "Pembayaran DP berhasil dicatat.", primaryLabel:"Selesai" });
      onRefresh();
    } catch (e) { notify.error({ title:"Pembayaran gagal", message: e.response?.data?.detail || "Silakan periksa kembali atau ulangi." }); }
    finally { setSaving(false); }
  };

  const [cancelModal, setCancelModal] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
  const [cancelConfirmDP, setCancelConfirmDP] = useState(false);
  const [cancelSaving, setCancelSaving] = useState(false);
  // Iter 229 — SELESAI DARURAT (Owner only) — untuk nota lama yang secara fisik sudah selesai
  //   tapi status produksi per divisi tidak lengkap. Menandai order_status=Selesai + flag
  //   completion_override=true. TIDAK memalsukan progres per produk.
  const [completeOverrideModal, setCompleteOverrideModal] = useState(false);
  const [completeOverrideReason, setCompleteOverrideReason] = useState("Rekonsiliasi data lama");
  const [completeOverrideSaving, setCompleteOverrideSaving] = useState(false);
  const openCompleteOverride = () => {
    setCompleteOverrideReason("Rekonsiliasi data lama");
    setCompleteOverrideModal(true);
  };
  const submitCompleteOverride = async () => {
    const reason = completeOverrideReason.trim();
    if (!reason) { notify.warning({ title:"Alasan wajib", message:"Isi alasan Selesai Darurat." }); return; }
    setCompleteOverrideSaving(true);
    try {
      const r = await axios.post(`${API}/orders/${order.order_number}/complete-override`,
        { reason }, { withCredentials:true });
      if (r?.data && typeof onOrderUpdated === "function") onOrderUpdated(r.data);
      setCompleteOverrideModal(false);
      await notify.success({ title:"Nota ditandai Selesai (Darurat)", message:"Status produksi per divisi tetap apa adanya. Audit tercatat.", primaryLabel:"Selesai" });
    } catch (e) {
      notify.error({ title:"Gagal Selesai Darurat", message: e.response?.data?.detail || "Silakan coba lagi." });
    } finally {
      setCompleteOverrideSaving(false);
    }
  };
  const cancel = async () => {
    // Reset dan buka modal
    setCancelReason(""); setCancelConfirmDP(false); setCancelModal(true);
  };
  const submitCancel = async () => {
    if (cancelReason.trim().length < 3) { notify.warning({ title:"Alasan pembatalan wajib diisi", message:"Alasan pembatalan minimal 3 karakter." }); return; }
    // Iter 251 — deteksi pembayaran robust: `paid` selalu ada di list & detail;
    //   `payments` array hanya di detail. Legacy /api/orders list tidak sertakan `payments`
    //   sehingga check lama gagal → user stuck di error backend "Konfirmasi wajib".
    const hasPay = (Number(order.paid) || 0) > 0 || (order.payments||[]).some(p => !p.voided);
    if (hasPay && !cancelConfirmDP) { notify.warning({ title:"Konfirmasi tambahan diperlukan", message:"Nota ini sudah memiliki pembayaran. Centang konfirmasi tambahan untuk melanjutkan." }); return; }
    setCancelSaving(true);
    try {
      const r = await axios.post(`${API}/orders/${order.order_number}/cancel`,
        { reason: cancelReason.trim(), confirm_has_payment: cancelConfirmDP },
        { withCredentials:true });
      setCancelModal(false);
      // Iter 227 — respons cancel sekarang sertakan `.order` (enriched); apply ke state.
      if (r?.data?.order && typeof onOrderUpdated === "function") onOrderUpdated(r.data.order);
      if (r.data?.needs_owner_review) {
        await notify.warning({ title:"Menunggu peninjauan Owner", message:"Pembatalan dicatat, namun karena Nota SUDAH LUNAS transaksi ini akan ditinjau Owner sebelum diselesaikan." });
      } else {
        await notify.success({ title:"Nota dibatalkan", message:"Status nota berhasil diubah menjadi Dibatalkan. Audit tercatat.", primaryLabel:"Selesai" });
      }
      onRefresh();
    } catch (e) { notify.error({ title:"Pembatalan gagal", message: e.response?.data?.detail || "Silakan coba lagi." }); }
    finally { setCancelSaving(false); }
  };
  // Iter 45 — Hapus Permanen (Owner-only). Guard di FE untuk UX, guard utama di BE.
  const [deletingPerm, setDeletingPerm] = useState(false);
  const roleLower = String(user?.role||"").toLowerCase();
  const isOwner = roleLower === "owner";
  const hasAnyPayment = (order.payments || []).length > 0;
  const hasProdHistory = (order.products || []).some(p => (p.production_pic_history || []).length > 0);
  const hasParallelDone = (order.products || []).some(p => {
    const ps = p.parallel_status || {};
    return Object.keys(ps).some(k => k.endsWith("_done") && ps[k]);
  });
  const canHardDelete = isOwner && !hasAnyPayment && !hasProdHistory && !hasParallelDone;
  const hardDelete = async () => {
    if (!canHardDelete) return;
    const reason = await notify.prompt({
      title: `Hapus permanen Nota ${order.order_number}?`,
      message: "Tindakan ini TIDAK BISA di-undo. Nota akan hilang dari sistem. Gunakan hanya untuk Draft / Test / salah input.",
      placeholder: "Alasan (opsional, dicatat di audit log)",
      multiline: true,
      primaryLabel: "Lanjutkan",
      secondaryLabel: "Batal",
    });
    if (reason === null || reason === undefined) return;
    const ok = await notify.confirm({
      title: "Konfirmasi terakhir",
      message: `Benar-benar HAPUS PERMANEN Nota ${order.order_number}? Tindakan ini tidak bisa dibatalkan.`,
      primaryLabel: "Ya, Hapus Permanen",
      secondaryLabel: "Batal",
      danger: true,
    });
    if (!ok) return;
    setDeletingPerm(true);
    try {
      await axios.delete(`${API}/orders/${order.order_number}`, {
        withCredentials: true,
        data: { confirm: true, reason: (reason||"").trim() },
      });
      // Iter 227 — Sinkronisasi instan: hapus dari state global.
      if (typeof onOrderRemoved === "function") onOrderRemoved(order.order_number);
      await notify.success({ title:"Nota terhapus permanen", message:`Nota ${order.order_number} telah dihapus. Audit log tercatat.`, primaryLabel:"Selesai" });
      onBack();
      onRefresh();
    } catch (e) {
      notify.error({ title:"Gagal menghapus Nota", message: e.response?.data?.detail || "Silakan coba lagi." });
    } finally {
      setDeletingPerm(false);
    }
  };

  const voidPayment = async (p) => {
    const reason = await notify.prompt({
      title: `Void transaksi ${p.transaction_number}?`,
      message: "Alasan koreksi wajib diisi (minimal 3 karakter). Transaksi akan ditandai VOID dan tetap tercatat di audit.",
      placeholder: "Alasan void",
      multiline: true,
      required: true,
      minLength: 3,
      primaryLabel: "Ya, Void Transaksi",
      secondaryLabel: "Batal",
      danger: true,
    });
    if (reason === null || reason === undefined) return;
    try {
      const r = await axios.post(`${API}/orders/${order.order_number}/payments/${encodeURIComponent(p.transaction_number)}/void`,
        { reason: reason.trim() }, { withCredentials:true });
      // Iter 227 — Sinkronisasi instan (void → `.order` enriched).
      if (r?.data?.order && typeof onOrderUpdated === "function") onOrderUpdated(r.data.order);
      await notify.success({ title:"Transaksi di-void", message:"Transaksi berhasil dibatalkan (void). Audit tercatat.", primaryLabel:"Selesai" });
      onRefresh();
    } catch (e) { notify.error({ title:"Gagal void pembayaran", message: e.response?.data?.detail || "Silakan coba lagi." }); }
  };

  const ppnValue = order.ppn ? (Number(order.total_product||0)+Number(order.setting_fee||0)+Number(order.additional_fee||0)-Number(order.invoice_discount||0)+Number(order.shipping||0))*0.11 : 0;

  return <main className="detail-page">
    <div className="detail-topbar">
      <button data-testid="detail-back-button" className="icon-btn" onClick={onBack}><ChevronLeft/></button>
      <div className="detail-title-block">
        <p className="eyebrow">{isProductionOperator ? "DETAIL PRODUKSI" : "DETAIL NOTA"}</p>
        <h2 data-testid="detail-order-number" className="detail-order-number">{order.order_number}</h2>
        <span data-testid="detail-status" className={`status-chip status-${statusChipClass}`}>{displayStatus}</span>
        {order.completion_override && <span data-testid="detail-override-badge" className="status-chip status-warn" title={`Selesai Darurat oleh ${order.completion_override_by||"-"} · ${order.completion_override_reason||""}`}>Selesai Darurat</span>}
        {order.is_repeat_order && <RepeatOrderBadge active repeatRef={order.repeat_ref} context="offline" testid="detail-repeat-badge"/>}
      </div>
    </div>

    <div className="detail-actions-bar">
      {!isOperatorReadonly && <button data-testid="detail-edit-button" className="soft-btn" disabled={isCancelled || (isAdminToko && order.pickup_status === "Diambil")} onClick={()=>setShowEdit(true)}><Pencil size={15}/>Ubah</button>}
      {/* Iter 212 — Salin ke Nota Baru (repeat order) */}
      {!isOperatorReadonly && onDuplicate && <button data-testid="detail-duplicate-button" className="soft-btn" onClick={async ()=>{
        const ok = await notify.confirm({
          title: "Salin ke Nota Baru?",
          message: `Rincian produk dari ${order.order_number} akan disalin ke Nota Baru. Deadline, pembayaran, dan status produksi akan direset. Harga otomatis akan dihitung ulang dengan tarif berlaku.`,
          primaryLabel: "Ya, Salin",
          secondaryLabel: "Batal",
        });
        if (ok) onDuplicate(order);
      }}><Copy size={15}/>Salin ke Nota Baru</button>}
      {!isOperatorReadonly && <button data-testid="detail-cancel-button" className="soft-btn warn" disabled={isCancelled} onClick={cancel}><Ban size={15}/>Batalkan</button>}
      {/* Iter 229 — Tombol SELESAI DARURAT: hanya Owner. Boleh utk migrated Draft (rekonsiliasi
          nota lama). Untuk Draft asli / Dibatalkan / Selesai TIDAK muncul. */}
      {canShowCompleteOverride(order, String(user?.role||"").toLowerCase() === "owner") && <button data-testid="detail-complete-override-button" className="soft-btn warn" onClick={openCompleteOverride} title="Untuk nota lama yg fisik sudah selesai tapi status produksi tidak lengkap"><CheckCircle2 size={15}/>Selesai Darurat</button>}
      {!isOperatorReadonly && canHardDelete && <button data-testid="detail-hard-delete-button" className="soft-btn danger" disabled={deletingPerm} onClick={hardDelete} title="Hapus permanen (Owner only, untuk Draft/Test/salah input tanpa pembayaran & produksi)"><Trash2 size={15}/>{deletingPerm?"Menghapus…":"Hapus Permanen"}</button>}
      {String(user?.role||"").toLowerCase() === "owner" && String(order.source||"").toLowerCase() !== "shopee" && <OwnerManualMenu orderNumber={order.order_number} onDone={onRefresh}/>}
      <button data-testid="print-invoice-button" className="soft-btn" onClick={onPrintNota}><Printer size={15}/>Nota</button>
      {!isOperatorReadonly && <button data-testid="print-spk-button" className="soft-btn" onClick={onPrintSPK}><Printer size={15}/>SPK</button>}
      {isOperatorReadonly && <span className="chip chip-muted" data-testid="detail-readonly-badge">Mode baca-saja</span>}
    </div>
    {!isProductionOperator && <PickupSection user={user} order={order} onRefresh={onRefresh} onOrderUpdated={onOrderUpdated}/>}
    {String(order.source || "").toLowerCase() !== "shopee" && <NotaGroupPanel orderNumber={order.order_number}/>}
    <BordirTasksPanel order={order}/>
    <TimelineSection orderNumber={order.order_number}/>

    <div className="detail-grid">
      <section className="section" data-section="pemesan" data-testid="section-customer">
        <h3 className="section-h"><UserIcon size={16} className="section-icon" aria-hidden="true"/><span>Informasi Pelanggan</span></h3>
        <div className="detail-facts">
          <div><span>Nama pelanggan</span><strong data-testid="detail-customer-name">{dashVal(order.customer_name)}</strong></div>
          <div><span>Instansi</span><strong>{dashVal(order.company)}</strong></div>
          <div className="wa-cell">
            <span>WhatsApp</span>
            <strong className="wa-line">
              <span data-testid="detail-whatsapp">{showWA ? (order.whatsapp || "—") : maskWA(order.whatsapp)}</span>
              <button data-testid="reveal-wa-button" className="tiny-btn" onClick={()=>setShowWA(!showWA)}><Eye size={13}/>{showWA?"Tutup":"Lihat"}</button>
              <button data-testid="copy-wa-button" className="tiny-btn" onClick={copyWA}><Copy size={13}/>Salin</button>
            </strong>
          </div>
          <div><span>Admin</span><strong>{dashVal(order.admin)}</strong></div>
          <div><span>Tanggal pesanan</span><strong>{dashVal(order.order_date)}</strong></div>
          <div><span>Deadline</span><strong>{dashVal(order.deadline)}</strong></div>
          <div><span>Jenis pesanan</span><strong>{order.order_type === "Polos" ? "Polosan" : dashVal(order.order_type)}</strong></div>
          <div><span>Sumber</span><strong>{dashVal(order.source)}</strong></div>
        </div>
      </section>

      <section className="section" data-section="ringkasan" data-testid="section-summary" style={{display: isProductionOperator ? "none" : undefined}}>
        <h3 className="section-h"><ReceiptText size={16} className="section-icon" aria-hidden="true"/><span>Ringkasan Nota</span></h3>
        <div className="sum-lines">
          <div className="sum-row"><span>Total produk</span><strong>{money(order.total_product)}</strong></div>
          <div className="sum-row"><span>Biaya setting</span><strong>{money(order.setting_fee)}</strong></div>
          <div className="sum-row"><span>Biaya tambahan</span><strong>{money(order.additional_fee)}</strong></div>
          <div className="sum-row"><span>Diskon nota</span><strong>{money(order.invoice_discount)}</strong></div>
          <div className="sum-row"><span>Ongkos kirim</span><strong>{money(order.shipping)}</strong></div>
          <div className="sum-row"><span>PPN {order.ppn?"11%":"—"}</span><strong>{order.ppn?money(ppnValue):"—"}</strong></div>
          <div className="sum-row grand-row"><span>Grand total</span><strong data-testid="detail-grand-total">{money(order.grand_total)}</strong></div>
          <div className="sum-row"><span>Total sudah dibayar</span><strong data-testid="detail-total-paid">{money(totalPaid)}</strong></div>
          <div className="sum-row grand-row"><span>Sisa pembayaran</span><strong data-testid="detail-remaining">{money(remaining)}</strong></div>
          <div className="sum-row"><span>Status pembayaran</span><strong className={`status-chip ${isLunas?"status-paid":"status-pending"}`} data-testid="detail-payment-status">{order.payment_status}</strong></div>
        </div>
      </section>

      <section className="section detail-products-section" data-section="produk" data-testid="section-products">
        <h3 className="section-h"><Package size={16} className="section-icon" aria-hidden="true"/><span>Detail Produk ({(order.products||[]).length})</span></h3>
        {(order.products||[]).map((p,i)=>{
          const qty = p.quantity ?? (p.sizes||[]).reduce((a,s)=>a+Number(s.quantity||0),0);
          // Iter 131 — Subtotal mengikuti harga efektif per ukuran (fallback ke unit_price),
          // konsisten dengan `create_order`/`update_order` di backend.
          const sizesList = p.sizes || [];
          const sizesGross = sizesList.length
            ? sizesList.reduce((a,s)=>{
                const q = Number(s.quantity||0);
                const price = Number(s.unit_price||0) > 0 ? Number(s.unit_price) : Number(p.unit_price||0);
                return a + q*price;
              }, 0)
            : qty * Number(p.unit_price||0);
          const subtotal = Math.max(0, sizesGross - Number(p.discount||0)) + Number(p.setting_fee||0);
          return <div className="detail-product-card" data-testid={`detail-product-${i}`} key={i}>
            <div className="dp-head">
              <span className="card-kicker">PRODUK {String(i+1).padStart(2,"0")}</span>
              <strong className="dp-name" data-testid={`detail-product-name-${i}`}>{p.name || "—"}</strong>
            </div>
            <div className="dp-grid">
              <div><span>Bahan</span><strong>{dashVal(p.material)}</strong></div>
              <div><span>Warna</span><strong>{dashVal(p.color)}</strong></div>
              {(p.sleeve && p.sleeve !== "Tidak Berlaku")
                ? <div><span>Lengan</span><strong>{p.sleeve}</strong></div>
                : (() => {
                    const variantCounts = (p.sizes || []).reduce((acc, s) => {
                      const v = (s.variant || "").trim();
                      if (!v) return acc;
                      acc[v] = (acc[v] || 0) + Number(s.quantity || 0);
                      return acc;
                    }, {});
                    const parts = Object.entries(variantCounts).map(([v, q]) => `${v} ${q}`);
                    return <div><span>Varian</span><strong>{parts.length ? parts.join(" · ") : "—"}</strong></div>;
                  })()
              }
              <div><span>Total jumlah</span><strong>{qty} pcs</strong></div>
              {p.dtf_size && <div><span>Ukuran DTF</span><strong data-testid={`detail-dtf-size-${i}`}>{p.dtf_size}</strong></div>}
              {!isProductionOperator && (() => {
                // Iter 584 — tampilkan harga akhir per ukuran (sumber harga sebenarnya); fallback nota lama.
                const rp = [...new Set((p.sizes || []).map(s => Number(s.unit_price || 0)).filter(v => v > 0))];
                return <div><span>Harga/pcs</span><strong data-testid={`detail-product-price-${i}`}>{rp.length ? rp.map(v => money(v)).join(" · ") : money(p.unit_price)}</strong></div>;
              })()}
              {!isProductionOperator && <div><span>Diskon produk</span><strong>{money(p.discount)}</strong></div>}
              <div><span>Jalur produksi</span><strong data-testid={`detail-product-route-${i}`}>{dashVal(p.production_route)}</strong></div>
              {p.process_mode && <div data-testid={`detail-product-process-${i}`}><span>Proses</span><strong>{p.process_mode}</strong></div>}
              <div><span>Tahap saat ini</span><strong data-testid={`detail-product-stage-${i}`}>{dashVal(p.production_stage)}{p.production_stage && p.production_stage!=="Perlu Diperiksa" ? ` · PIC ${STAGE_TEAM_LABEL[p.production_stage]||"-"}` : ""}</strong></div>
              {/* Iter 276 — Model kerah Jersey (bila diisi). Tampil di Detail Nota + SPK (via PrintSPK). */}
              {p.collar_model && <div data-testid={`detail-collar-${i}`}><span>Model Kerah</span><strong>
                {p.collar_model === "Lainnya" && p.collar_note ? `${p.collar_model} — ${p.collar_note}` : p.collar_model}
              </strong></div>}
            </div>
            <div className="dp-sizes">
              <span>Rincian ukuran</span>
              <div className="size-chips">
                {(p.sizes||[]).length ? p.sizes.map((s,n)=>{
                  // Iter 147 — Chip: Warna · Ukuran (Lengan). Fallback ke product-level warna/lengan.
                  const c = (s.color || p.color || "").trim();
                  const v = (s.variant || (p.sleeve && p.sleeve !== "Tidak Berlaku" ? p.sleeve : "") || "").trim();
                  const lbl = `${c ? c + " · " : ""}${s.size}${v ? ` (${v})` : ""}`;
                  return <span key={n} className="size-chip">{lbl}: {s.quantity} pcs</span>;
                }) : <em>—</em>}
              </div>
            </div>
            <div className="dp-subtotal" style={{display: isProductionOperator ? "none" : undefined}}><span>Subtotal produk</span><strong>{money(subtotal)}</strong></div>
            <div className="dp-note"><span>Keterangan produk</span><p>{p.note || "—"}</p></div>
            {(p.id || p._id) && <ProductFilesPanel orderNumber={order.order_number} productId={p.id || p._id}/>}
          </div>;
        })}
      </section>

      {order.order_type === "Custom" && <section className="section" data-section="detail" data-testid="section-custom">
        <h3 className="section-h"><Sliders size={16} className="section-icon" aria-hidden="true"/><span>Detail Custom</span></h3>
        <div className="detail-facts">
          <div><span>Jenis custom</span><strong>{dashVal(order.custom_type)}</strong></div>
          <div><span>Posisi desain</span><strong>{dashVal(order.design_position)}</strong></div>
          <div><span>Ukuran desain</span><strong>{dashVal(order.design_size)}</strong></div>
          <div><span>Titik bordir</span><strong>{dashVal(order.embroidery_points)}</strong></div>
          <div><span>Status desain</span><strong>{dashVal(order.design_status)}</strong></div>
          <div><span>Nama file</span><strong>{dashVal(order.design_filename)}</strong></div>
        </div>
        <div className="dp-note"><span>Catatan desain</span><p>{order.design_note || "—"}</p></div>
        {order.design_file ? <div className="dp-note"><span>File desain</span><a href={order.design_file} target="_blank" rel="noreferrer" className="link-btn">Buka file</a></div> : <div className="dp-note"><span>File desain</span><p>—</p></div>}
      </section>}

      <section className="section" data-section="pembayaran" data-testid="section-payments" style={{display: isProductionOperator ? "none" : undefined}}>
        <h3 className="section-h"><Wallet size={16} className="section-icon" aria-hidden="true"/><span>Riwayat Pembayaran ({payments.length})</span></h3>
        {hasLegacyGap && <div className="info-banner legacy-banner" data-testid="legacy-banner">Data historis: total tercatat {money(totalPaid)}, rincian transaksi tidak tersedia.</div>}
        {payments.length === 0 && !hasLegacyGap
          ? <p className="muted">Belum ada transaksi pembayaran.</p>
          : payments.length > 0 && <div className="payment-history">
              {payments.map((p,i)=>
                <div className={`payment-row ${p.voided?"is-voided":""}`} data-testid={`payment-history-${i}`} key={i}>
                  <div className="pr-head">
                    <strong data-testid={`payment-txn-${i}`}>{p.transaction_number || `TRX-${order.order_number}-${String(i+1).padStart(2,"0")}`}{p.voided && <span className="void-badge" data-testid={`payment-voided-${i}`}> · VOID</span>}</strong>
                    <span>{fmtDT(p.paid_at)}</span>
                  </div>
                  <div className="pr-body">
                    <div><span>Nominal</span><strong>{money(p.amount)}</strong></div>
                    <div><span>Metode</span><strong>{dashVal(p.method)}</strong></div>
                    <div><span>Referensi</span><strong>{dashVal(p.reference)}</strong></div>
                    <div><span>Pencatat</span><strong>{dashVal(p.recorded_by)}</strong></div>
                  </div>
                  {p.note && <div className="pr-note">{p.note}</div>}
                  {p.proof && <a href={p.proof} target="_blank" rel="noreferrer" className="link-btn">Lihat bukti pembayaran</a>}
                  {p.voided && p.void_reason && <div className="pr-note void-note" data-testid={`payment-void-reason-${i}`}><b>Alasan void:</b> {p.void_reason} · oleh {p.voided_by} · {fmtDT(p.voided_at)}</div>}
                  {!p.voided && !isCancelled && <button type="button" className="soft-btn small-btn danger" data-testid={`payment-void-btn-${i}`} onClick={()=>voidPayment(p)}><Ban size={13}/>Koreksi / Void</button>}
                </div>
              )}
            </div>
        }

        {canPay && <div className="pay-box">
          <h3>Catat Pelunasan Baru</h3>
          <p className="muted small">Setiap pembayaran disimpan sebagai transaksi baru dan tidak dapat diubah.</p>
          <div className="pay-quick-actions" data-testid="pay-quick-actions" style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:10}}>
            <button
              type="button"
              className="soft-btn small-btn"
              data-testid="pay-quick-dp"
              onClick={()=>setPayForm(f=>({...f, amount:""}))}
            >+ Tambah DP</button>
            <button
              type="button"
              className="primary small-btn"
              data-testid="pay-quick-lunasi"
              onClick={()=>setPayForm(f=>({...f, amount:String(Math.round(remaining))}))}
              disabled={remaining <= 0}
              title={remaining>0?`Isi otomatis sebesar sisa tagihan (${money(remaining)})`:"Sisa tagihan Rp 0"}
            >Lunasi ({money(remaining)})</button>
          </div>
          <div className="fields">
            <Field label="Nominal" required>
              <input data-testid="detail-payment-amount" type="number" inputMode="numeric" min="1" value={payForm.amount} onChange={e=>setPayForm({...payForm,amount:stripZero(e.target.value)})}/>
            </Field>
            <Field label="Metode pembayaran">
              <select data-testid="detail-payment-method" value={payForm.method} onChange={e=>setPayForm({...payForm,method:e.target.value})}>
                {PAYMENT_METHODS.map(m=><option key={m}>{m}</option>)}
              </select>
            </Field>
            <Field label="Nomor referensi">
              <input data-testid="detail-payment-reference" value={payForm.reference} onChange={e=>setPayForm({...payForm,reference:e.target.value})}/>
            </Field>
            <Field label="Bukti pembayaran">
              <input data-testid="detail-payment-proof" type="file" accept="image/*" capture="environment" onChange={e=>setPayForm({...payForm,proof:e.target.files?.[0]||null})}/>
            </Field>
          </div>
          <Field label="Catatan">
            <textarea data-testid="detail-payment-note" value={payForm.note} onChange={e=>setPayForm({...payForm,note:e.target.value})}/>
          </Field>
          <button data-testid="detail-payment-submit" className="primary full" onClick={pay} disabled={saving}>{saving?"Menyimpan…":"Simpan Pembayaran"}</button>
        </div>}

        {isLunas && <div className="info-banner lunas-banner" data-testid="lunas-banner">Nota sudah LUNAS. Pembayaran tambahan tidak diperbolehkan.</div>}
        {isCancelled && <div className="info-banner cancel-banner" data-testid="cancel-banner">Nota DIBATALKAN. Pembayaran tidak dapat dicatat, riwayat tetap tersimpan.</div>}
      </section>

      {order.production_note && <section className="section" data-testid="section-production-note">
        <h3>Catatan Produksi</h3>
        <p>{order.production_note}</p>
      </section>}

      <AuditPanel orderNumber={order.order_number} refreshKey={order.updated_at || order.paid}/>
    </div>

    {showEdit && <EditModal order={order} onClose={()=>setShowEdit(false)} onSaved={()=>{setShowEdit(false);onRefresh();}}/>}
    {cancelModal && (() => {
      // Iter 251 — Fix bug: /api/orders list endpoint tidak sertakan `payments` array,
      //   hanya `paid` (int). Deteksi via `paid > 0` supaya checkbox konfirmasi muncul
      //   walaupun order object dari list view. Payment history tetap disimpan di backend.
      const _hasPay = (Number(order.paid) || 0) > 0 || (order.payments||[]).some(p=>!p.voided);
      const _canSubmit = cancelReason.trim().length >= 3 && (!_hasPay || cancelConfirmDP);
      return <div className="modal-backdrop" data-testid="cancel-modal">
      <div className="modal-panel">
        <h3>Batalkan Nota {order.order_number}</h3>
        <p className="muted small">Nota tetap tersimpan sebagai riwayat. Pembayaran yang sudah masuk tidak dihapus.</p>
        {_hasPay && <div className="warn-box" data-testid="cancel-has-payment-warn">
          <b>⚠️ Nota ini sudah memiliki pembayaran.</b>
          <p className="muted small" style={{marginTop:6}}>Pembatalan tidak menghapus transaksi. Bila Nota sudah <b>LUNAS</b>, pembatalan akan ditandai <b>menunggu peninjauan Owner</b>.</p>
        </div>}
        <label className="modal-field">Alasan pembatalan (wajib)
          <textarea data-testid="cancel-reason-input" rows={3} value={cancelReason} onChange={e=>setCancelReason(e.target.value)} placeholder="Contoh: Pelanggan minta batal karena…"/>
        </label>
        {_hasPay && <label className="modal-check">
          <input data-testid="cancel-confirm-payment-check" type="checkbox" checked={cancelConfirmDP} onChange={e=>setCancelConfirmDP(e.target.checked)}/>
          <span>Saya memahami nota ini sudah memiliki pembayaran dan riwayat pembayaran tetap disimpan.</span>
        </label>}
        <div className="modal-actions">
          <button type="button" data-testid="cancel-modal-back" className="soft-btn" onClick={()=>setCancelModal(false)} disabled={cancelSaving}>Batal</button>
          <button type="button" data-testid="cancel-modal-submit" className="primary warn" onClick={submitCancel} disabled={cancelSaving || !_canSubmit}>{cancelSaving?"Memproses…":"Batalkan Nota"}</button>
        </div>
      </div>
    </div>;
    })()}
    {/* Iter 229 — Modal SELESAI DARURAT (Owner only) */}
    {completeOverrideModal && <div className="modal-backdrop" role="dialog" aria-modal="true" data-testid="complete-override-modal">
      <div className="modal-card">
        <h3 className="modal-title">Selesai Darurat</h3>
        <p className="modal-lead">Barang ini sudah benar-benar selesai secara fisik?</p>
        <p className="modal-sub">Nota <b>{order.order_number}</b> akan ditandai <b>Selesai</b>. Histori produksi per divisi <b>tidak</b> dipalsukan — tetap tampil apa adanya. Tindakan tercatat di Timeline Audit.</p>
        <label className="modal-field">
          <span>Alasan (wajib)</span>
          <textarea
            data-testid="complete-override-reason"
            value={completeOverrideReason}
            onChange={e=>setCompleteOverrideReason(e.target.value)}
            rows={3}
            placeholder="Contoh: Rekonsiliasi data lama"
            disabled={completeOverrideSaving}
          />
        </label>
        <div className="modal-actions">
          <button type="button" data-testid="complete-override-back" className="soft-btn" onClick={()=>setCompleteOverrideModal(false)} disabled={completeOverrideSaving}>Batal</button>
          <button type="button" data-testid="complete-override-submit" className="primary" onClick={submitCompleteOverride} disabled={completeOverrideSaving || !completeOverrideReason.trim()}>{completeOverrideSaving?"Memproses…":"Ya, Tandai Selesai"}</button>
        </div>
      </div>
    </div>}
  </main>;

function AuditPanel({ orderNumber, refreshKey }) {
  const [open, setOpen] = useState(false);
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (!open) return;
    setLoading(true);
    axios.get(`${API}/orders/${orderNumber}/audit`, { withCredentials: true })
      .then(r => setEntries(r.data || []))
      .catch(() => setEntries([]))
      .finally(() => setLoading(false));
  }, [open, orderNumber, refreshKey]);
  return <section className="section" data-testid="section-audit">
    <button type="button" className="audit-toggle" data-testid="audit-toggle" onClick={()=>setOpen(v=>!v)} aria-expanded={open}>
      {open ? <ChevronUp size={16}/> : <ChevronDown size={16}/>}
      <span>Riwayat Perubahan{entries.length > 0 ? ` (${entries.length})` : ""}</span>
    </button>
    {open && <div className="audit-list" data-testid="audit-list">
      {loading ? <p className="muted small">Memuat…</p>
        : entries.length === 0 ? <p className="muted small">Belum ada riwayat perubahan tercatat.</p>
        : entries.map((a, i)=>
          <div className="audit-row" key={i} data-testid={`audit-row-${i}`}>
            <div className="audit-head">
              <strong data-testid={`audit-action-${i}`}>{a.action}</strong>
              <span>{fmtDT(a.at)}</span>
            </div>
            <div className="audit-meta">
              <span>oleh <strong>{a.user || "—"}</strong></span>
            </div>
          </div>
        )}
    </div>}
  </section>;
}

}

function SettingsMenu({ user, onOpenMaster, onOpenOperators, onOpenReports, onOpenCashClosing, onChangePassword, onOpenRecovery, onLogout }) {
  const [open, setOpen] = useState(false);
  const isAdmin = user && ["owner","admin"].includes(String(user.role||"").toLowerCase());
  useEffect(() => {
    if (!open) return;
    const close = (e) => { if (!e.target.closest(".settings-wrap")) setOpen(false); };
    const esc = (e) => { if (e.key === "Escape") setOpen(false); };
    document.addEventListener("mousedown", close);
    document.addEventListener("keydown", esc);
    return () => { document.removeEventListener("mousedown", close); document.removeEventListener("keydown", esc); };
  }, [open]);
  return <div className="settings-wrap">
    <button type="button" data-testid="settings-button" className="icon-btn settings-btn" aria-label="Pengaturan" aria-expanded={open} onClick={()=>setOpen(v=>!v)}><Settings size={18}/></button>
    {open && <div className="settings-menu" data-testid="settings-menu" role="menu">
      {isAdmin && <button type="button" data-testid="menu-master-products" role="menuitem" onClick={()=>{setOpen(false); onOpenMaster();}}>
        <Package size={15}/>Master Produk
      </button>}
      {isAdmin && <button type="button" data-testid="menu-master-operators" role="menuitem" onClick={()=>{setOpen(false); onOpenOperators();}}>
        <Users size={15}/>Master Operator
      </button>}
      {isAdmin && <button type="button" data-testid="menu-reports" role="menuitem" onClick={()=>{setOpen(false); onOpenReports();}}>
        <LayoutDashboard size={15}/>Laporan Omzet
      </button>}
      {isAdmin && onOpenCashClosing && <button type="button" data-testid="menu-cash-closing" role="menuitem" onClick={()=>{setOpen(false); onOpenCashClosing();}}>
        <WalletCards size={15}/>Tutup Kas Harian
      </button>}
      {isAdmin && onChangePassword && <button type="button" data-testid="menu-change-password" role="menuitem" onClick={()=>{setOpen(false); onChangePassword();}}>
        <Lock size={15}/>Ubah Password
      </button>}
      {isAdmin && onOpenRecovery && <button type="button" data-testid="menu-akun-owner" role="menuitem" onClick={()=>{setOpen(false); onOpenRecovery();}}>
        <Mail size={15}/>Akun Owner
      </button>}
      <button type="button" data-testid="menu-logout" role="menuitem" onClick={()=>{setOpen(false); onLogout();}}>
        <LogOut size={15}/>Keluar
      </button>
    </div>}
  </div>;
}


function MasterOperator({ user, onBack, initialFilter }) {
  // Iter 370 — Owner-only guard untuk fitur Edit Nama.
  const isOwner = String(user?.role || "").toLowerCase() === "owner";
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ name:"", team:"Mockup", pin:"", active:true, whatsapp:"", is_admin_toko:false, is_shopee_designer:false, is_acc_only:false });
  const [resetFor, setResetFor] = useState(null);
  const [resetPin, setResetPin] = useState("");
  // Iter 370 — Edit Nama Operator (Owner-only). Membuka modal kecil dgn field
  //   Nama saja. Tidak membuat operator baru, tidak menyentuh PIN/tim/role/
  //   is_admin_toko/is_shopee_designer/is_acc_only/whatsapp/active/histori.
  const [renameFor, setRenameFor] = useState(null);
  const [renameName, setRenameName] = useState("");
  const [renameBusy, setRenameBusy] = useState(false);
  const saveRenameNow = async () => {
    if (!renameFor) return;
    const nm = (renameName || "").trim();
    if (!nm) { notify.warning({ title: "Nama tidak boleh kosong", message: "Masukkan nama operator." }); return; }
    if (nm === renameFor.name) { setRenameFor(null); return; }
    setRenameBusy(true);
    try {
      await axios.patch(`${API}/master/operators/${renameFor.id}`, { name: nm }, { withCredentials: true });
      const prev = renameFor.name;
      setRenameFor(null); setRenameName("");
      await load();
      notify.success({ title: "Nama diperbarui", message: `“${prev}” → “${nm}”` });
    } catch (e) {
      notify.error({ title: "Gagal mengubah nama", message: e.response?.data?.detail || "Silakan coba lagi." });
    } finally {
      setRenameBusy(false);
    }
  };
  const [editWA, setEditWA] = useState({});
  // Iter 50 — filter status: "active" (default, sembunyikan nonaktif), "inactive", "all"
  const [statusFilter, setStatusFilter] = useState(initialFilter || "active");
  // Muat daftar: hanya respons TERBARU yang dipakai (cegah tabrakan), retry terbatas utk gangguan
  //   sementara, daftar lama dipertahankan saat gagal, error tampil inline (bukan modal).
  const [loadState, setLoadState] = useState({ status: "loading", error: null });
  const loadSeq = useRef(0);
  const load = async () => {
    const id = ++loadSeq.current;
    setLoadState(s => ({ ...s, status: "loading" }));
    try {
      const r = await getWithRetry(`${API}/master/operators`);
      if (id !== loadSeq.current) return;
      setItems(Array.isArray(r.data) ? r.data : []);
      setLoadState({ status: "ok", error: null });
    } catch (e) {
      if (id !== loadSeq.current) return;
      setLoadState({ status: "error", error: describeLoadError(e) });
    }
  };
  useEffect(()=>{ load(); }, []);
  const TEAMS = ["Mockup","Toko","Gudang","Bordir","Operator Bordir","Sablon/DTF","Mesin Press","Jersey/Sublim","Selesai","Shopee","Tokopedia","Shopee + Tokopedia"];
  const [creating, setCreating] = useState(false);
  const create = async () => {
    if (creating) return;
    if (!form.name.trim()) { notify.warning({ title:"Data belum lengkap", message:"Nama operator wajib diisi." }); return; }
    if (!/^\d{6}$/.test(form.pin)) { notify.warning({ title:"PIN tidak valid", message:"PIN wajib 6 digit angka." }); return; }
    setCreating(true);
    try {
      await axios.post(`${API}/master/operators`, form, { withCredentials:true });
      setForm({ name:"", team:"Mockup", pin:"", active:true, whatsapp:"", is_admin_toko:false, is_shopee_designer:false, is_acc_only:false });
      load();
      await notify.success({ title:"Operator ditambahkan", message:"Operator baru berhasil dibuat dan siap PIN-login.", primaryLabel:"Selesai" });
    }
    catch(e){ notify.error({ title:"Gagal membuat operator", message: describeLoadError(e).text + " Cek daftar sebelum mencoba lagi agar tidak dobel." }); load(); }
    finally { setCreating(false); }
  };
  const toggleActive = async (op) => {
    // Iter 46 — Wajib konfirmasi sebelum menonaktifkan / mengaktifkan kembali.
    const title = op.active ? "Nonaktifkan operator?" : "Aktifkan kembali operator?";
    const message = op.active
      ? `${op.name} (tim ${op.team}) tidak akan bisa PIN-login dan tidak muncul di pilihan pekerjaan baru. Seluruh riwayat pekerjaan, upah, dan laporan lama TETAP TERSIMPAN.`
      : `${op.name} (tim ${op.team}) dapat kembali PIN-login dan menerima pekerjaan baru.`;
    const ok = await notify.confirm({
      title, message,
      primaryLabel: op.active ? "Ya, Nonaktifkan" : "Ya, Aktifkan Kembali",
      secondaryLabel: "Batal",
      danger: op.active,
    });
    if (!ok) return;
    const wasActive = op.active;
    try {
      await axios.patch(`${API}/master/operators/${op.id}`,{ active: !wasActive }, { withCredentials:true });
      await load();
      // Iter 53 — Undo bar 5 detik (reverse).
      undoReverse({
        title: wasActive ? `${op.name} dinonaktifkan` : `${op.name} diaktifkan kembali`,
        message: "Salah klik? Klik Batalkan dalam 5 detik untuk mengembalikan.",
        onUndo: async () => {
          await axios.patch(`${API}/master/operators/${op.id}`,{ active: wasActive }, { withCredentials:true });
          await load();
        },
        undoneTitle: wasActive ? `${op.name} diaktifkan kembali` : `${op.name} dinonaktifkan`,
      });
    } catch(e){ notify.error({ title:"Gagal mengubah status", message: e.response?.data?.detail || "Silakan coba lagi." }); }
  };
  const toggleAdminToko = async (op) => {
    if (op.is_admin_toko) {
      const ok = await notify.confirm({
        title: "Cabut hak Admin Toko?",
        message: `Setelah dicabut, ${op.name} hanya bisa login sebagai operator biasa dan tidak dapat lagi membuat/edit Nota.`,
        primaryLabel: "Ya, Cabut Hak",
        secondaryLabel: "Batal",
        danger: true,
      });
      if (!ok) return;
    }
    try {
      await axios.patch(`${API}/master/operators/${op.id}`,{ is_admin_toko: !op.is_admin_toko }, { withCredentials:true });
      await load();
    } catch(e){ notify.error({ title:"Gagal mengubah hak Admin Toko", message: e.response?.data?.detail || "Silakan coba lagi." }); }
  };
  const changeTeam = async (op, team) => { try { await axios.patch(`${API}/master/operators/${op.id}`,{ team }, { withCredentials:true }); await load(); } catch(e){ notify.error({ title:"Gagal mengubah tim operator", message: e.response?.data?.detail || "Silakan coba lagi." }); } };
  // Iter 287c — toggle izin tambahan Designer Shopee (untuk operator tim non-Shopee).
  // Operator tim Shopee tidak perlu toggle: akses otomatis via team.
  const toggleShopeeDesigner = async (op) => {
    if (MP_DESIGNER_TEAMS[op.team]) { notify.info({ title:"Otomatis", message:`Operator tim ${op.team} sudah menjadi Desainer ${op.team}.` }); return; }
    const willEnable = !op.is_shopee_designer;
    const ok = await notify.confirm({
      title: willEnable ? "Beri akses Mockup Shopee?" : "Cabut akses Mockup Shopee?",
      message: willEnable
        ? `${op.name} (tim ${op.team}) akan mendapat akses tambahan Mockup Shopee. Akses tim asal tetap dipertahankan.`
        : `${op.name} tidak lagi dapat mengakses Mockup Shopee. Pekerjaan Shopee yang sedang ditanganinya tidak terhapus.`,
      confirmLabel: willEnable ? "Ya, beri akses" : "Ya, cabut",
    });
    if (!ok) return;
    try {
      await axios.patch(`${API}/master/operators/${op.id}`,{ is_shopee_designer: willEnable }, { withCredentials:true });
      await load();
    } catch(e){ notify.error({ title:"Gagal mengubah akses Shopee", message: e.response?.data?.detail || "Silakan coba lagi." }); }
  };
  // Iter 304 — Toggle akses ACC-only (Adit). Hanya relevan untuk operator tim Gudang.
  const toggleAccOnly = async (op) => {
    if (op.team !== "Gudang") { notify.info({ title:"Hanya tim Gudang", message:"Akses ACC-only hanya tersedia untuk operator tim Gudang." }); return; }
    const willEnable = !op.is_acc_only;
    const ok = await notify.confirm({
      title: willEnable ? "Beri akses ACC-only (Adit)?" : "Cabut akses ACC-only?",
      message: willEnable
        ? `${op.name} hanya akan melihat antrean Menunggu ACC & tombol ACC Barang Siap. Tidak dapat akses Stok, Mutasi, Opname, Mockup Print, atau menerima pekerjaan tahap. Berlaku di backend sekaligus tampilan.`
        : `${op.name} akan kembali ke akses penuh tim Gudang (Mockup Print, Penyiapan Barang, Stok, Mutasi, Opname).`,
      confirmLabel: willEnable ? "Ya, batasi ke ACC saja" : "Ya, buka akses penuh",
    });
    if (!ok) return;
    try {
      await axios.patch(`${API}/master/operators/${op.id}`,{ is_acc_only: willEnable }, { withCredentials:true });
      await load();
    } catch(e){ notify.error({ title:"Gagal mengubah akses ACC-only", message: e.response?.data?.detail || "Silakan coba lagi." }); }
  };
  const [deleteModalOp, setDeleteModalOp] = useState(null);
  const [deleteModalBusy, setDeleteModalBusy] = useState(false);
  const [deleteModalError, setDeleteModalError] = useState("");
  const openHardDelete = (op) => {
    if (op.active) { notify.warning({ title:"Nonaktifkan dulu", message:"Nonaktifkan operator ini terlebih dahulu sebelum menghapus permanen." }); return; }
    setDeleteModalError("");
    setDeleteModalOp(op);
  };
  const closeHardDelete = () => { if (deleteModalBusy) return; setDeleteModalOp(null); setDeleteModalError(""); };
  const confirmHardDelete = async () => {
    const op = deleteModalOp; if (!op) return;
    setDeleteModalError("");
    // Iter 53 — Deferred pattern: tunda DELETE 5 detik. Kartu operator tetap muncul selama
    // jendela undo agar Owner dapat membatalkan jika salah klik. Setelah 5 detik: eksekusi DELETE.
    setDeleteModalOp(null);
    undoDeferred({
      title: `${op.name} akan dihapus permanen`,
      message: "Klik Batalkan dalam 5 detik untuk mengurungkan penghapusan.",
      onCommit: async () => {
        await axios.delete(`${API}/master/operators/${op.id}`, {
          withCredentials: true,
          data: { confirm: true, reason: "hard delete via master operator UI" },
        });
        await load();
      },
      committedTitle: `${op.name} telah dihapus permanen`,
      cancelledTitle: `Penghapusan ${op.name} dibatalkan`,
    });
  };
  const saveWA = async (op) => {
    const v = editWA[op.id];
    if (v === undefined) return;
    try {
      await axios.patch(`${API}/master/operators/${op.id}`,{ whatsapp: v }, { withCredentials:true });
      setEditWA(prev=>{ const {[op.id]:_, ...rest}=prev; return rest; });
      await load();
    }
    catch(e){ notify.error({ title:"Gagal simpan WhatsApp", message: e.response?.data?.detail || "Silakan coba lagi." }); }
  };
  const resetPinNow = async () => {
    if (!/^\d{6}$/.test(resetPin)) { notify.warning({ title:"PIN tidak valid", message:"PIN wajib 6 digit angka." }); return; }
    try {
      await axios.post(`${API}/master/operators/${resetFor.id}/reset-pin`, { pin: resetPin }, { withCredentials:true });
      const name = resetFor?.name || "operator";
      setResetFor(null); setResetPin("");
      await notify.success({ title:"PIN berhasil direset", message:`PIN ${name} sudah diperbarui. Sampaikan PIN baru langsung kepada operator.`, primaryLabel:"Selesai" });
    }
    catch(e){ notify.error({ title:"Gagal reset PIN", message: e.response?.data?.detail || "Silakan coba lagi." }); }
  };
  return <div className="shell">
    <header className="topbar">
      <div className="brand"><b aria-label="Logo TAMFARIS"><img src="/logo-tamfaris.jpg" alt="Logo TAMFARIS" draggable="false"/></b><span><strong>TAMFARIS</strong></span></div>
      <div className="user-pill"><span>{user.name}</span><small>{user.role}</small></div>
    </header>
    <main className="content">
      <div className="welcome">
        <div><p className="eyebrow">Pengaturan</p><h1>Master Operator</h1><p className="muted">Kelola akun operator PIN untuk setiap tim.</p></div>
        <button type="button" className="soft-btn" data-testid="operator-master-back" onClick={onBack}>← Kembali</button>
      </div>
      <BordirShiftSettings/>
      <div className="section">
        <h3>Tambah operator baru</h3>
        <div className="op-form-grid">
          <Field label="Nama"><input data-testid="op-form-name" value={form.name} onChange={e=>setForm({...form,name:e.target.value})} placeholder="Nama operator"/></Field>
          <Field label="Tim"><select data-testid="op-form-team" value={form.team} onChange={e=>setForm({...form,team:e.target.value})}>{TEAMS.map(t=><option key={t} value={t}>{t}</option>)}</select></Field>
          <Field label="Nomor WhatsApp"><input data-testid="op-form-whatsapp" value={form.whatsapp} onChange={e=>setForm({...form,whatsapp:e.target.value.replace(/[^\d+]/g,"")})} placeholder="08xx atau +62xx" inputMode="tel"/></Field>
          <Field label="PIN (6 digit)"><input data-testid="op-form-pin" inputMode="numeric" maxLength={6} value={form.pin} onChange={e=>setForm({...form,pin:e.target.value.replace(/\D/g,"").slice(0,6)})}/></Field>
          {form.team === "Toko" && <Field label="Jenis akses">
            <label style={{display:"flex",gap:8,alignItems:"center",fontSize:13,cursor:"pointer"}}>
              <input type="checkbox" data-testid="op-form-admin-toko" checked={form.is_admin_toko} onChange={e=>setForm({...form,is_admin_toko:e.target.checked})} style={{width:16,height:16}}/>
              <span>Admin Toko (dapat buat & ubah Nota)</span>
            </label>
          </Field>}
          {/* Iter 287c — Akses Mockup Shopee: checkbox izin tambahan agar operator tim lain
              (misal Mockup/Bordir) dapat juga menjadi Designer Shopee TANPA menghilangkan akses
              tim asal. Untuk operator tim "Shopee" (khusus designer Shopee), akses otomatis
              didapat lewat team, checkbox ini bersifat penanda saja. */}
          {form.team !== "Toko" && <Field label="Akses Mockup Shopee">
            <label style={{display:"flex",gap:8,alignItems:"center",fontSize:13,cursor: MP_DESIGNER_TEAMS[form.team] ? "not-allowed" : "pointer"}}>
              <input type="checkbox" data-testid="op-form-shopee-designer"
                checked={MP_DESIGNER_TEAMS[form.team] ? true : form.is_shopee_designer}
                disabled={!!MP_DESIGNER_TEAMS[form.team]}
                onChange={e=>setForm({...form,is_shopee_designer:e.target.checked})}
                style={{width:16,height:16}}/>
              <span>
                {MP_DESIGNER_TEAMS[form.team]
                  ? `Desainer ${form.team} (otomatis karena tim = ${form.team})`
                  : "Designer Shopee (izin tambahan — tetap punya akses tim asal)"}
              </span>
            </label>
          </Field>}
          {/* Iter 304 — Akses ACC-only (Adit): hanya aktif untuk tim Gudang. Jika aktif,
              operator hanya boleh melihat Menunggu ACC & melakukan ACC Barang Siap.
              Tidak boleh akses Stok, Mutasi, Opname, Mockup Print, atau menerima pekerjaan. */}
          {form.team === "Gudang" && <Field label="Akses Khusus">
            <label style={{display:"flex",gap:8,alignItems:"center",fontSize:13,cursor:"pointer"}}>
              <input type="checkbox" data-testid="op-form-acc-only"
                checked={!!form.is_acc_only}
                onChange={e=>setForm({...form,is_acc_only:e.target.checked})}
                style={{width:16,height:16}}/>
              <span>ACC Barang saja (Adit) — tidak dapat akses Stok, Mutasi, Opname, Mockup Print, atau menerima pekerjaan</span>
            </label>
          </Field>}
          <button type="button" data-testid="op-form-submit" className="primary op-form-submit" onClick={create} disabled={creating}>{creating ? "Menyimpan…" : "Simpan"}</button>
        </div>
        <p className="muted small">PIN disimpan dalam bentuk hash dan hanya dapat direset. Nomor WhatsApp otomatis dinormalisasi ke +62.</p>
      </div>
      <div className="section">
        <div className="section-head-row op-filter-row">
          <h3>Daftar operator ({items.length} total · {items.filter(o=>o.active).length} aktif · {items.filter(o=>!o.active).length} nonaktif)</h3>
          <div className="op-filter-chips" role="tablist" aria-label="Filter status operator">
            <button type="button" role="tab" aria-selected={statusFilter==="active"} className={`op-filter-chip ${statusFilter==="active"?"active":""}`} data-testid="op-filter-active" onClick={()=>setStatusFilter("active")}>Aktif</button>
            <button type="button" role="tab" aria-selected={statusFilter==="inactive"} className={`op-filter-chip ${statusFilter==="inactive"?"active":""}`} data-testid="op-filter-inactive" onClick={()=>setStatusFilter("inactive")}>Nonaktif</button>
            <button type="button" role="tab" aria-selected={statusFilter==="all"} className={`op-filter-chip ${statusFilter==="all"?"active":""}`} data-testid="op-filter-all" onClick={()=>setStatusFilter("all")}>Semua</button>
          </div>
        </div>
        {loadState.status === "error" && <div className="warn-box small" role="alert" data-testid="op-load-error" style={{display:"flex",gap:8,alignItems:"center",flexWrap:"wrap",marginBottom:10}}>
          <span><b>{items.length ? "Daftar belum diperbarui." : "Gagal memuat operator."}</b> {loadState.error?.text}{items.length ? " Menampilkan data terakhir." : ""}</span>
          {loadState.error?.kind !== "auth" && loadState.error?.kind !== "forbidden" &&
            <button type="button" className="soft-btn small-btn" onClick={load} data-testid="op-load-retry">Coba Lagi</button>}
        </div>}
        {loadState.status === "loading" && items.length === 0 && <div className="muted small" data-testid="op-loading">Memuat daftar operator…</div>}
        <div className="op-card-grid" data-testid="op-card-grid">
          {(() => {
            if (items.length === 0 && loadState.status !== "ok") return null;
            const filtered = items.filter(o => statusFilter==="all" ? true : statusFilter==="active" ? !!o.active : !o.active);
            if (filtered.length === 0) {
              return <div className="empty" data-testid="op-empty">{statusFilter==="active"?"Belum ada operator aktif.":statusFilter==="inactive"?"Tidak ada operator nonaktif.":"Belum ada operator."}</div>;
            }
            const teamKey = (t) => String(t||"").toLowerCase().replaceAll(" ","-").replaceAll("/","-");
            const initials = (name) => String(name||"?").split(/\s+/).filter(Boolean).slice(0,2).map(w=>w[0].toUpperCase()).join("") || "?";
            return filtered.map(op => {
              const waEditing = editWA[op.id] !== undefined;
              const waVal = waEditing ? editWA[op.id] : (op.whatsapp||"");
              return <article key={op.id} className={`op-card ${op.active?"":"op-card-inactive"}`} data-team={teamKey(op.team)} data-testid={`op-row-${op.id}`}>
                <header className="op-card-head">
                  <div className="op-avatar" data-team={teamKey(op.team)} aria-hidden="true">{initials(op.name)}</div>
                  <div className="op-card-title">
                    <b>{op.name}</b>
                    <div className="op-card-meta">
                      <span className="op-team-badge" data-team={teamKey(op.team)}>{op.team}</span>
                      <span className={`status ${op.active?"paid":"cancel"}`}>{op.active?"Aktif":"Nonaktif"}</span>
                      {op.team === "Toko" && op.is_admin_toko && <span className="op-admin-badge">Admin Toko</span>}
                      {(MP_DESIGNER_TEAMS[op.team] || op.is_shopee_designer) && <span className="op-admin-badge" style={{background:"#ede9fe", color:"#6d28d9"}} data-testid={`op-badge-shopee-${op.id}`}>{op.team === "Shopee" ? "Designer Shopee" : MP_DESIGNER_TEAMS[op.team] ? `Desainer ${op.team}` : "Shopee +"}</span>}
                      {op.team === "Gudang" && op.is_acc_only && <span className="op-admin-badge" style={{background:"#fef3c7", color:"#92400e"}} data-testid={`op-badge-acc-only-${op.id}`}>ACC Only</span>}
                    </div>
                    {op.lockout_until && <small style={{color:"#dc2626",display:"block",marginTop:4}}>Terkunci sampai {new Date(op.lockout_until).toLocaleTimeString("id-ID")}</small>}
                  </div>
                </header>
                <div className="op-card-body">
                  {/* Iter 337 — Fix iOS Safari mobile: pisahkan <label> dari <select> (htmlFor/id),
                      tambah value eksplisit di option, agar native picker terbuka saat ditap. */}
                  <div className="op-field-label">
                    <label htmlFor={`op-team-select-${op.id}`}>Tim</label>
                    <select id={`op-team-select-${op.id}`} data-testid={`op-team-select-${op.id}`} value={op.team} onChange={e=>changeTeam(op, e.target.value)}>
                      {TEAMS.map(t=><option key={t} value={t}>{t}</option>)}
                    </select>
                  </div>
                  <label className="op-field-label">WhatsApp
                    <div style={{display:"flex",gap:6,alignItems:"center"}}>
                      <input data-testid={`op-wa-input-${op.id}`} value={waVal} onChange={e=>setEditWA(prev=>({...prev,[op.id]:e.target.value.replace(/[^\d+]/g,"")}))} placeholder="+62..." inputMode="tel" style={{flex:1,minWidth:0}}/>
                      {waEditing && <button type="button" className="soft-btn small-btn" data-testid={`op-wa-save-${op.id}`} onClick={()=>saveWA(op)}>Simpan</button>}
                    </div>
                  </label>
                </div>
                <footer className="op-card-actions">
                  {/* Iter 370 — Owner-only: Edit Nama operator (membuka modal). */}
                  {isOwner && <button type="button" className="soft-btn small-btn" data-testid={`op-rename-${op.id}`} onClick={()=>{setRenameFor(op); setRenameName(op.name || "");}} title="Ubah nama operator"><Pencil size={13} aria-hidden="true"/> Ubah Nama</button>}
                  <button type="button" className={`soft-btn small-btn ${op.active?"warn":"success"}`} data-testid={`op-toggle-active-${op.id}`} onClick={()=>toggleActive(op)}>{op.active?"Nonaktifkan":"Aktifkan Kembali"}</button>
                  {!op.active && <button type="button" className="soft-btn small-btn danger" data-testid={`op-hard-delete-${op.id}`} onClick={()=>openHardDelete(op)} title="Hapus permanen (hanya bila tanpa riwayat pekerjaan)">Hapus Permanen</button>}
                  {op.team === "Toko" && <button type="button" className="soft-btn small-btn" data-testid={`op-toggle-admin-toko-${op.id}`} onClick={()=>toggleAdminToko(op)}>{op.is_admin_toko?"Jadikan Operator Toko":"Jadikan Admin Toko"}</button>}
                  {!MP_DESIGNER_TEAMS[op.team] && op.team !== "Toko" && <button type="button" className="soft-btn small-btn" data-testid={`op-toggle-shopee-${op.id}`} onClick={()=>toggleShopeeDesigner(op)}>{op.is_shopee_designer ? "Cabut Akses Shopee" : "Beri Akses Shopee"}</button>}
                  {op.team === "Gudang" && <button type="button" className="soft-btn small-btn" data-testid={`op-toggle-acc-only-${op.id}`} onClick={()=>toggleAccOnly(op)}>{op.is_acc_only ? "Buka Akses Penuh Gudang" : "Jadikan ACC-Only"}</button>}
                  <button type="button" className="soft-btn small-btn" data-testid={`op-reset-pin-${op.id}`} onClick={()=>{setResetFor(op);setResetPin("");}}>Reset PIN</button>
                </footer>
              </article>;
            });
          })()}
        </div>
      </div>
      {resetFor && <div className="modal-overlay" onClick={()=>setResetFor(null)}>
        <div className="modal" onClick={e=>e.stopPropagation()}>
          <h3>Reset PIN — {resetFor.name}</h3>
          <Field label="PIN baru (6 digit)"><input data-testid="op-reset-pin-input" inputMode="numeric" maxLength={6} value={resetPin} onChange={e=>setResetPin(e.target.value.replace(/\D/g,"").slice(0,6))} autoFocus/></Field>
          <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
            <button type="button" className="soft-btn" onClick={()=>setResetFor(null)}>Batal</button>
            <button type="button" className="primary" data-testid="op-reset-pin-submit" onClick={resetPinNow}>Simpan PIN</button>
          </div>
        </div>
      </div>}
      {/* Iter 370 — Modal Edit Nama Operator (Owner-only). Hanya mengubah field `name`
          via PATCH /master/operators/{id}; tidak menyentuh PIN/tim/role/relasi lain. */}
      {renameFor && <div className="modal-overlay" data-testid="op-rename-modal" onClick={()=>!renameBusy && setRenameFor(null)}>
        <div className="modal" onClick={e=>e.stopPropagation()}>
          <h3>Ubah Nama Operator</h3>
          <p className="muted small" style={{margin:"4px 0 10px"}}>
            Mengubah nama saja. ID, PIN, tim, akses, status, dan histori pekerjaan tidak berubah.
          </p>
          <Field label="Nama Operator">
            <input
              data-testid="op-rename-input"
              value={renameName}
              onChange={e=>setRenameName(e.target.value)}
              onKeyDown={e=>{ if (e.key === "Enter") { e.preventDefault(); saveRenameNow(); } }}
              maxLength={64}
              autoFocus
            />
          </Field>
          <div style={{display:"flex",gap:8,justifyContent:"flex-end",marginTop:8}}>
            <button type="button" className="soft-btn" data-testid="op-rename-cancel" onClick={()=>setRenameFor(null)} disabled={renameBusy}>Batal</button>
            <button type="button" className="primary" data-testid="op-rename-submit" onClick={saveRenameNow} disabled={renameBusy || !renameName.trim()}>{renameBusy ? "Menyimpan…" : "Simpan"}</button>
          </div>
        </div>
      </div>}
      {deleteModalOp && <div className="modal-overlay" data-testid="op-hard-delete-modal" onClick={closeHardDelete}>
        <div className="modal op-hard-delete-modal" onClick={e=>e.stopPropagation()}>
          <h3>Hapus operator ini secara permanen?</h3>
          <p className="muted small" style={{margin:"6px 0 12px"}}>
            <strong>{deleteModalOp.name}</strong> (tim {deleteModalOp.team}) akan dihapus dari sistem. Tindakan ini tidak dapat di-undo.
          </p>
          {deleteModalError && <div className="op-hard-delete-err" data-testid="op-hard-delete-error" role="alert">{deleteModalError}</div>}
          <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
            <button type="button" className="soft-btn" data-testid="op-hard-delete-cancel" onClick={closeHardDelete} disabled={deleteModalBusy}>Batal</button>
            <button type="button" className="primary danger" data-testid="op-hard-delete-confirm" onClick={confirmHardDelete} disabled={deleteModalBusy}>{deleteModalBusy?"Menghapus…":"Ya, Hapus Permanen"}</button>
          </div>
        </div>
      </div>}
    </main>
  </div>;
}


function MasterEditModal({ kind, item, onClose, onSaved, allMaterials, allProducts }) {
  const [name, setName] = useState(item?.name || "");
  // Iter 276 — Kategori hanya berlaku untuk kind='products'. Default "" = umum.
  const [category, setCategory] = useState(item?.category || "");
  const [saving, setSaving] = useState(false);
  const isColors = kind === "colors";
  // Iter 530 — Scope untuk Master Warna. Checkbox independen (boleh pilih keduanya).
  //   Default: tidak dicentang → Umum. Jika dicentang → minimal 1 pilihan wajib.
  const initialMat = Array.isArray(item?.scope_materials) && item.scope_materials.length > 0 ? item.scope_materials : [];
  const initialPrd = Array.isArray(item?.scope_products) && item.scope_products.length > 0 ? item.scope_products : [];
  const [scopeMatOn, setScopeMatOn] = useState(initialMat.length > 0);
  const [scopePrdOn, setScopePrdOn] = useState(initialPrd.length > 0);
  const [scopeMaterials, setScopeMaterials] = useState(initialMat);
  const [scopeProducts, setScopeProducts] = useState(initialPrd);
  const toggleMatValue = (nm) => {
    setScopeMaterials(prev => prev.includes(nm) ? prev.filter(x => x !== nm) : [...prev, nm]);
  };
  const togglePrdValue = (nm) => {
    setScopeProducts(prev => prev.includes(nm) ? prev.filter(x => x !== nm) : [...prev, nm]);
  };
  const kindLabel = kind === "materials" ? "bahan" : kind === "colors" ? "warna" : kind === "sizes" ? "ukuran" : "produk";
  const isProducts = kind === "products";
  const save = async () => {
    if (saving) return;
    if (!name.trim()) { notify.warning({ title:"Data belum lengkap", message:`Nama ${kindLabel} wajib diisi.` }); return; }
    // Iter 530 — Validasi scope sebelum submit (sinkron dengan backend).
    if (isColors && scopeMatOn && scopeMaterials.length === 0) {
      notify.warning({ title:"Scope bahan kosong", message:"Pilih minimal satu bahan atau hilangkan centang 'Bahan tertentu'." }); return;
    }
    if (isColors && scopePrdOn && scopeProducts.length === 0) {
      notify.warning({ title:"Scope produk kosong", message:"Pilih minimal satu produk atau hilangkan centang 'Produk tertentu'." }); return;
    }
    setSaving(true);
    try {
      const payload = { name: name.trim() };
      if (isProducts) payload.category = (category || "").trim();
      if (isColors) {
        // Kirim array hanya jika centang aktif + ada isi. Jika edit & centang mati, kirim []
        // supaya backend unset. Jika create & centang mati, jangan kirim field (default Umum).
        if (scopeMatOn) payload.scope_materials = scopeMaterials;
        else if (item) payload.scope_materials = [];
        if (scopePrdOn) payload.scope_products = scopeProducts;
        else if (item) payload.scope_products = [];
      }
      if (item) await axios.patch(`${API}/master/${kind}/${item.id}`, payload, { withCredentials: true });
      else await axios.post(`${API}/master/${kind}`, payload, { withCredentials: true });
      window.dispatchEvent(new Event("master-updated"));
      onSaved();
    } catch (e) { notify.error({ title:"Gagal menyimpan", message: e.response?.data?.detail || "Silakan coba lagi." }); }
    finally { setSaving(false); }
  };
  return <div className="modal-backdrop" onClick={onClose}>
    <div className="modal" onClick={e=>e.stopPropagation()} data-testid="master-modal">
      <div className="modal-head">
        <h3>{item ? `Ubah ${kindLabel}` : `Tambah ${kindLabel}`}</h3>
        <button type="button" className="icon-btn" onClick={onClose}><X/></button>
      </div>
      <p className="muted small">Nama tersimpan sebagai snapshot pada Nota — perubahan tidak mengubah Nota lama.</p>
      <Field label={`Nama ${kindLabel}`} required>
        <input data-testid="master-name-input" autoFocus value={name} onChange={e=>setName(e.target.value)} placeholder={`Contoh: ${kind==="materials"?"Cotton Combed 30s":kind==="colors"?"Biru Dongker":kind==="sizes"?"XXL atau 2XL (huruf besar-kecil dibedakan)":"Polo Cotton Bamboo"}`}/>
      </Field>
      {isProducts && <Field label="Kategori (opsional)">
        <select data-testid="master-category-select" value={category} onChange={e=>setCategory(e.target.value)}>
          <option value="">Umum</option>
          <option value="Jersey">Jersey (alur Mockup → Sublim → Selesai)</option>
        </select>
      </Field>}
      {isColors && (
        <div className="master-scope" data-testid="master-scope-wrap" style={{marginTop:10}}>
          <p className="muted small" style={{marginBottom:6}}>Berlaku untuk (opsional)</p>
          <p className="muted small" style={{fontSize:11,marginTop:0,marginBottom:10,color:"#64748b"}}>
            Biarkan tidak tercentang untuk warna <strong>Umum</strong> (muncul di semua produk/bahan). Centang untuk membatasi scope. Boleh keduanya.
          </p>
          <label className="master-scope-row" style={{display:"flex",alignItems:"center",gap:8,fontSize:13,fontWeight:600,cursor:"pointer"}}>
            <input type="checkbox" data-testid="master-scope-materials-toggle" checked={scopeMatOn} onChange={e=>setScopeMatOn(e.target.checked)}/>
            Bahan tertentu
          </label>
          {scopeMatOn && (
            <div className="master-scope-chips" data-testid="master-scope-materials-chips" style={{display:"flex",flexWrap:"wrap",gap:6,margin:"8px 0 14px",padding:"8px",border:"1px dashed #cbd5e1",borderRadius:8,maxHeight:150,overflowY:"auto"}}>
              {(allMaterials || []).map(m => {
                const nm = m.name || m;
                const sel = scopeMaterials.includes(nm);
                return <button
                  type="button"
                  key={nm}
                  data-testid={`master-scope-material-chip-${nm}`}
                  onClick={()=>toggleMatValue(nm)}
                  style={{
                    padding:"4px 10px",borderRadius:999,fontSize:12,cursor:"pointer",
                    border:sel?"1px solid #0f766e":"1px solid #cbd5e1",
                    background:sel?"#ccfbf1":"#fff",color:sel?"#115e59":"#334155",
                    fontWeight:sel?700:500,touchAction:"manipulation",WebkitAppearance:"none",
                  }}
                >{sel && "✓ "}{nm}</button>;
              })}
              {(!allMaterials || allMaterials.length === 0) && <span className="muted small">Belum ada master bahan.</span>}
            </div>
          )}
          <label className="master-scope-row" style={{display:"flex",alignItems:"center",gap:8,fontSize:13,fontWeight:600,cursor:"pointer"}}>
            <input type="checkbox" data-testid="master-scope-products-toggle" checked={scopePrdOn} onChange={e=>setScopePrdOn(e.target.checked)}/>
            Produk tertentu
          </label>
          {scopePrdOn && (
            <div className="master-scope-chips" data-testid="master-scope-products-chips" style={{display:"flex",flexWrap:"wrap",gap:6,margin:"8px 0 6px",padding:"8px",border:"1px dashed #cbd5e1",borderRadius:8,maxHeight:150,overflowY:"auto"}}>
              {(allProducts || []).map(p => {
                const nm = p.name || p;
                const sel = scopeProducts.includes(nm);
                return <button
                  type="button"
                  key={nm}
                  data-testid={`master-scope-product-chip-${nm}`}
                  onClick={()=>togglePrdValue(nm)}
                  style={{
                    padding:"4px 10px",borderRadius:999,fontSize:12,cursor:"pointer",
                    border:sel?"1px solid #1e3a8a":"1px solid #cbd5e1",
                    background:sel?"#dbeafe":"#fff",color:sel?"#1e3a8a":"#334155",
                    fontWeight:sel?700:500,touchAction:"manipulation",WebkitAppearance:"none",
                  }}
                >{sel && "✓ "}{nm}</button>;
              })}
              {(!allProducts || allProducts.length === 0) && <span className="muted small">Belum ada master produk.</span>}
            </div>
          )}
        </div>
      )}
      <div className="modal-foot">
        <button type="button" className="secondary" onClick={onClose}>Batal</button>
        <button type="button" data-testid="master-save-button" className="primary" onClick={save} disabled={saving}>{saving?"Menyimpan…":"Simpan"}</button>
      </div>
    </div>
  </div>;
}

// ========================================================================
// Iter 532 Tahap 2 — StockColorsPanel: Master Warna Berbasis Stok
// ------------------------------------------------------------------------
// Sumber data: GET /api/stock/colors/groups (returns {kain, polosan}).
// Operasi: tambah (POST /colors/add), rename (POST /colors/rename), toggle
// aktif (POST /colors/toggle-active). Semua guard sudah di-backend:
//   - Rename: preserve variant_id/SKU, append nama lama ke color_aliases.
//   - Nonaktifkan: ditolak bila ADA SATU varian dengan current_qty > 0.
// Accordion per group bahan (kain) / produk+material (polosan). Pencarian.
// ========================================================================
function StockColorsPanel({ isAdminToko }) {
  const [data, setData] = useState({ kain: [], polosan: [] });
  const [status, setStatus] = useState("loading"); // loading | ok | error
  const [errorMsg, setErrorMsg] = useState("");
  const [search, setSearch] = useState("");
  const [openKeys, setOpenKeys] = useState(() => new Set());
  const [busyKey, setBusyKey] = useState(""); // "cat::group::color" / "add::..."
  const [addFor, setAddFor] = useState(null); // {category, fabric_name|product_name+material, label}
  const [renameFor, setRenameFor] = useState(null); // {category, group, color, label}
  const reqRef = useRef(0);

  const load = useCallback(async () => {
    const myId = ++reqRef.current;
    setStatus("loading"); setErrorMsg("");
    try {
      const r = await axios.get(`${API}/stock/colors/groups`, { withCredentials: true });
      if (reqRef.current !== myId) return;
      const payload = r.data || {};
      setData({
        kain: Array.isArray(payload.kain) ? payload.kain : [],
        polosan: Array.isArray(payload.polosan) ? payload.polosan : [],
      });
      setStatus("ok");
    } catch (e) {
      if (reqRef.current !== myId) return;
      const detail = e.response?.data?.detail || "Gagal memuat warna stok.";
      setErrorMsg(detail);
      setStatus("error");
    }
  }, []);
  useEffect(() => { load(); }, [load]);

  const toggleOpen = (key) => {
    setOpenKeys(prev => {
      const next = new Set(prev);
      if (next.has(key)) next.delete(key); else next.add(key);
      return next;
    });
  };

  const matchSearch = useCallback((label) => {
    const s = search.trim().toLowerCase();
    if (!s) return true;
    return (label || "").toLowerCase().includes(s);
  }, [search]);

  const kainFiltered = useMemo(() => (data.kain || []).filter(g => matchSearch(g.fabric_name)), [data.kain, matchSearch]);
  const poloFiltered = useMemo(() => (data.polosan || []).filter(g => matchSearch(`${g.product_name} ${g.material || ""}`)), [data.polosan, matchSearch]);

  const totalKainColors = useMemo(() => (data.kain || []).reduce((n, g) => n + (g.colors?.length || 0), 0), [data.kain]);
  const totalPoloColors = useMemo(() => (data.polosan || []).reduce((n, g) => n + (g.colors?.length || 0), 0), [data.polosan]);

  async function handleRename(group, cat, c) {
    if (isAdminToko) return;
    const label = cat === "kain" ? `bahan ${group.fabric_name}` : `${group.product_name} · ${group.material || "-"}`;
    // Buka modal preview — bukan prompt. User harus melihat dampak (jml varian, saldo, SKU)
    // sebelum konfirmasi. Rename atomik di backend; alias append menjaga history & PR Linking.
    setRenameFor({ category: cat, group, color: c, label });
  }

  async function handleToggle(group, cat, c) {
    if (isAdminToko) return;
    const willActivate = !c.all_active;
    const key = `toggle::${cat}::${group.fabric_name || `${group.product_name}::${group.material}`}::${c.color}`;
    const groupLabel = cat === "kain" ? group.fabric_name : `${group.product_name} · ${group.material || "-"}`;
    if (!willActivate && c.has_qty) {
      notify.warning({
        title: "Tidak dapat dinonaktifkan",
        message: `Warna "${c.color}" di ${groupLabel} masih punya saldo (${c.total_qty} ${c.unit || ""}). Habiskan dulu — stok fisik tidak boleh dipaksa nol.`,
      });
      return;
    }
    const confirmed = await notify.confirm({
      title: willActivate ? "Aktifkan warna?" : "Nonaktifkan warna?",
      message: `${willActivate ? "Aktifkan" : "Nonaktifkan"} warna "${c.color}" di ${groupLabel} (${c.variant_count} varian)?`,
      primaryLabel: willActivate ? "Ya, aktifkan" : "Ya, nonaktifkan",
    });
    if (!confirmed) return;
    setBusyKey(key);
    try {
      await axios.post(`${API}/stock/colors/toggle-active`, {
        category: cat,
        fabric_name: cat === "kain" ? group.fabric_name : undefined,
        product_name: cat === "polosan" ? group.product_name : undefined,
        material: cat === "polosan" ? group.material : undefined,
        color: c.color,
        active: willActivate,
      }, { withCredentials: true });
      await notify.success({ title: willActivate ? "Warna diaktifkan" : "Warna dinonaktifkan", message: `"${c.color}" di ${groupLabel} sudah ${willActivate ? "aktif" : "nonaktif"}.`, primaryLabel: "Selesai" });
      window.dispatchEvent(new Event("master-updated"));
      await load();
    } catch (e) {
      notify.error({ title: "Gagal mengubah status warna", message: e.response?.data?.detail || "Silakan coba lagi." });
    } finally { setBusyKey(""); }
  }

  const renderGroup = (group, cat) => {
    const groupKey = cat === "kain"
      ? `KAIN::${group.fabric_name}`
      : `POLO::${group.product_name}::${group.material || ""}`;
    const label = cat === "kain" ? group.fabric_name : `${group.product_name}${group.material ? ` · ${group.material}` : ""}`;
    const open = openKeys.has(groupKey);
    const variantCount = (group.colors || []).reduce((n, c) => n + (c.variant_count || 0), 0);
    // Iter 532 Tahap 2 FIX (iPhone Safari) — Header dibuat <div role=button> (bukan <button>) agar
    // tombol "Tambah warna" bisa jadi <button> asli tanpa nested-button (invalid HTML yang bikin
    // iOS Safari kadang gagal propagasi tap). Target tap 44px + touchAction:manipulation.
    return (
      <div key={groupKey} className="stock-color-group" data-testid={`stock-color-group-${groupKey}`}
           style={{ border: "1px solid #e2e8f0", borderRadius: 10, marginBottom: 8, background: "#ffffff" }}>
        <div
          role="button"
          tabIndex={0}
          data-testid={`stock-color-group-header-${groupKey}`}
          onClick={() => toggleOpen(groupKey)}
          onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); toggleOpen(groupKey); } }}
          style={{
            display: "flex", alignItems: "center", gap: 10, width: "100%", padding: "10px 14px",
            background: open ? "#f1f5f9" : "transparent", cursor: "pointer", textAlign: "left",
            borderRadius: 10, minHeight: 44,
            touchAction: "manipulation", WebkitTapHighlightColor: "rgba(37,99,235,.15)",
            userSelect: "none",
          }}
        >
          <ChevronRight size={16} style={{ transform: open ? "rotate(90deg)" : "none", transition: "transform 150ms", flexShrink: 0 }} aria-hidden="true" />
          <strong style={{ fontSize: 14, color: "#0f172a" }}>{label}</strong>
          <span className="muted small" style={{ marginLeft: 6 }}>
            {(group.colors || []).length} warna · {variantCount} varian
          </span>
          {!isAdminToko && (
            <button
              type="button"
              data-testid={`stock-color-group-add-${groupKey}`}
              onClick={(e) => { e.stopPropagation(); setAddFor({ category: cat, group, label }); }}
              className="tiny-btn"
              style={{
                marginLeft: "auto", display: "inline-flex", alignItems: "center", gap: 4,
                padding: "8px 12px", cursor: "pointer", minHeight: 36,
                touchAction: "manipulation", WebkitTapHighlightColor: "rgba(37,99,235,.2)",
              }}
              title={`Tambah warna di ${label}`}
            >
              <Plus size={12} /> Tambah warna
            </button>
          )}
        </div>
        {open && (
          <div data-testid={`stock-color-group-body-${groupKey}`} style={{ padding: "6px 14px 12px" }}>
            {(group.colors || []).length === 0 ? (
              <p className="muted small" style={{ margin: "6px 0" }}>Belum ada warna.</p>
            ) : group.colors.map(c => {
              const colorKey = `${groupKey}::${c.color}`;
              const toggleBusy = busyKey === `toggle::${cat}::${group.fabric_name || `${group.product_name}::${group.material}`}::${c.color}`;
              // Rename kini ditangani oleh StockColorRenameModal (bukan prompt singkat). Modal
              // mengontrol state saving-nya sendiri → row cukup disable saat toggle sedang jalan.
              const anyBusy = toggleBusy;
              // iPhone Safari tap safety: touchAction + tap-highlight + min 44px.
              const touchStyle = { touchAction: "manipulation", WebkitTapHighlightColor: "rgba(37,99,235,.2)", minHeight: 36, padding: "8px 12px" };
              return (
                <div key={colorKey} data-testid={`stock-color-row-${colorKey}`}
                     className={`master-row ${c.all_active ? "" : "inactive"}`}
                     style={{ marginTop: 6 }}>
                  <div className="master-info" style={{ flexWrap: "wrap" }}>
                    <span className="master-kind-icon" aria-hidden="true"><Palette size={16} strokeWidth={1.75} /></span>
                    <strong data-testid={`stock-color-name-${colorKey}`}>{c.color}</strong>
                    <span className={`status-chip ${c.all_active ? "status-active" : "status-draft"}`} data-testid={`stock-color-status-${colorKey}`}>
                      {c.all_active ? "AKTIF" : "NONAKTIF"}
                    </span>
                    <span className="muted small" data-testid={`stock-color-qty-${colorKey}`}>
                      {c.variant_count} varian · {c.total_qty} {c.unit || ""}
                    </span>
                    {(c.aliases || []).length > 0 && (
                      <span
                        data-testid={`stock-color-aliases-${colorKey}`}
                        title={`Alias (nama lama): ${c.aliases.join(", ")}`}
                        style={{
                          fontSize: 11, fontWeight: 600, padding: "2px 8px", borderRadius: 999,
                          background: "#fef9c3", color: "#854d0e", border: "1px solid #fde68a",
                        }}
                      >
                        alias: {c.aliases.slice(0, 2).join(", ")}{c.aliases.length > 2 ? ` +${c.aliases.length - 2}` : ""}
                      </span>
                    )}
                  </div>
                  <div className="master-actions">
                    {isAdminToko ? (
                      <span className="muted small">Kelola oleh Owner/Admin</span>
                    ) : (
                      <>
                        <button
                          type="button"
                          className="tiny-btn"
                          data-testid={`stock-color-rename-${colorKey}`}
                          disabled={anyBusy}
                          onClick={() => handleRename(group, cat, c)}
                          style={touchStyle}
                        >
                          <Pencil size={12} /> Ubah Nama
                        </button>
                        <button
                          type="button"
                          className="tiny-btn"
                          data-testid={`stock-color-toggle-${colorKey}`}
                          disabled={anyBusy || (c.all_active && c.has_qty)}
                          title={c.all_active && c.has_qty ? "Masih ada saldo — tidak dapat dinonaktifkan" : ""}
                          onClick={() => handleToggle(group, cat, c)}
                          style={touchStyle}
                        >
                          {toggleBusy ? "…" : (c.all_active ? "Nonaktifkan" : "Aktifkan")}
                        </button>
                      </>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  };

  return (
    <section className="stock-colors-panel" data-testid="stock-colors-panel"
             style={{ marginBottom: 20, padding: "14px 14px 10px", background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 10 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap", marginBottom: 10 }}>
        <strong style={{ fontSize: 14, color: "#0f172a" }}>Warna dari Stok</strong>
        <span className="muted small" data-testid="stock-colors-summary">
          {status === "loading" ? "memuat…" : status === "error" ? "gagal memuat" :
            `${(data.kain || []).length} bahan kain · ${totalKainColors} warna · ${(data.polosan || []).length} grup polosan · ${totalPoloColors} warna`}
        </span>
        <button
          type="button"
          className="icon-btn"
          data-testid="stock-colors-refresh"
          onClick={load}
          disabled={status === "loading"}
          aria-label="Muat ulang warna stok"
          style={{ marginLeft: "auto" }}
          title="Muat ulang"
        >
          <RefreshCw size={14} className={status === "loading" ? "spin" : ""} />
        </button>
      </div>
      <div style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 10 }}>
        <Search size={14} aria-hidden="true" style={{ color: "#64748b" }} />
        <input
          type="search"
          data-testid="stock-colors-search"
          placeholder="Cari bahan atau produk…"
          value={search}
          onChange={e => setSearch(e.target.value)}
          style={{ flex: 1, padding: "6px 10px", borderRadius: 6, border: "1px solid #cbd5e1", fontSize: 13 }}
        />
      </div>
      {status === "loading" && (
        <div className="master-state master-state-loading" data-testid="stock-colors-loading" role="status" aria-live="polite">
          <Loader2 size={18} className="spin" aria-hidden="true" />
          <span>Memuat warna stok…</span>
        </div>
      )}
      {status === "error" && (
        <div className="master-state master-state-error" data-testid="stock-colors-error" role="alert">
          <div className="master-state-icon" aria-hidden="true"><AlertTriangle size={20} /></div>
          <div className="master-state-body">
            <strong>Gagal memuat warna stok</strong>
            <p className="muted small">{errorMsg}</p>
            <div className="master-state-actions">
              <button type="button" className="primary" data-testid="stock-colors-retry" onClick={load}>
                <RefreshCw size={14} /> Coba Lagi
              </button>
            </div>
          </div>
        </div>
      )}
      {status === "ok" && (
        <>
          <div style={{ marginBottom: 10 }}>
            <p className="eyebrow" style={{ margin: "4px 0 6px" }}>Kain (per bahan)</p>
            {kainFiltered.length === 0 ? (
              <p className="muted small" data-testid="stock-colors-kain-empty">
                {search ? "Tidak ada bahan kain yang cocok dengan pencarian." : "Belum ada varian kain."}
              </p>
            ) : kainFiltered.map(g => renderGroup(g, "kain"))}
          </div>
          <div>
            <p className="eyebrow" style={{ margin: "4px 0 6px" }}>Polosan (per produk · bahan)</p>
            {poloFiltered.length === 0 ? (
              <p className="muted small" data-testid="stock-colors-polo-empty">
                {search ? "Tidak ada produk polosan yang cocok dengan pencarian." : "Belum ada varian polosan."}
              </p>
            ) : poloFiltered.map(g => renderGroup(g, "polosan"))}
          </div>
        </>
      )}
      {addFor && (
        <StockColorAddModal
          category={addFor.category}
          group={addFor.group}
          label={addFor.label}
          onClose={() => setAddFor(null)}
          onSaved={() => { setAddFor(null); load(); window.dispatchEvent(new Event("master-updated")); }}
        />
      )}
      {renameFor && (
        <StockColorRenameModal
          category={renameFor.category}
          group={renameFor.group}
          colorRow={renameFor.color}
          label={renameFor.label}
          onClose={() => setRenameFor(null)}
          onSaved={() => { setRenameFor(null); load(); window.dispatchEvent(new Event("master-updated")); }}
        />
      )}
    </section>
  );
}

// Iter 532 Tahap 2 (FIX iPhone Safari) — Modal "Ubah nama warna" single-step.
// Tampilkan: nama lama, input nama baru, produk/bahan, jumlah varian terdampak, tombol Batal + Simpan.
// Validasi duplikat (termasuk alias warna lain di group) client-side. Backend atomik (preserve ID+SKU+qty+alias).
// Rename TIDAK dibatasi oleh saldo (hanya nonaktif yang dibatasi).
function StockColorRenameModal({ category, group, colorRow, label, onClose, onSaved }) {
  const [newName, setNewName] = useState(colorRow.color || "");
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState("");
  const trimmed = newName.trim();
  const normalized = trimmed.toUpperCase().replace(/\s+/g, " ").trim();
  const normOld = (colorRow.color || "").toUpperCase().replace(/\s+/g, " ").trim();

  // Daftar nama/alias dari warna LAIN di group yang sama (untuk cek duplikat client-side).
  // Nama baru TIDAK boleh match warna lain atau alias warna lain. Boleh identik dengan alias
  // existing warna INI sendiri (nanti akan di-dedup oleh backend).
  const otherNormNames = useMemo(() => {
    const s = new Set();
    for (const other of (group.colors || [])) {
      if (other.color === colorRow.color) continue;
      s.add((other.color || "").toUpperCase().replace(/\s+/g, " ").trim());
      for (const a of (other.aliases || [])) {
        s.add((a || "").toUpperCase().replace(/\s+/g, " ").trim());
      }
    }
    return s;
  }, [group, colorRow]);

  const empty = !trimmed;
  const unchanged = !!normalized && normalized === normOld;
  const duplicate = !!normalized && otherNormNames.has(normalized);
  const canSave = !empty && !unchanged && !duplicate && !saving;

  const variantCount = colorRow.variant_count || 0;
  const totalQty = colorRow.total_qty || 0;
  const existingAliases = colorRow.aliases || [];

  async function submit() {
    if (!canSave) return;
    setSaving(true); setErr("");
    let ok = false;
    try {
      await axios.post(`${API}/stock/colors/rename`, {
        category,
        fabric_name: category === "kain" ? group.fabric_name : undefined,
        product_name: category === "polosan" ? group.product_name : undefined,
        // Iter 532 bugfix — kirim material='' (bukan undefined) utk polosan agar backend bisa
        // match group di DB yang legitim menyimpan material='' (contoh: Kaos Combed 24s).
        material: category === "polosan" ? (group.material || "") : undefined,
        old_color: colorRow.color,
        new_color: trimmed,
      }, { withCredentials: true, timeout: 20000 });
      ok = true;
    } catch (e) {
      // Iter 532 bugfix — error handling defensive. detail bisa string (HTTPException), list
      // (Pydantic validation), atau undefined (network/timeout). Convert ke string yang friendly.
      let detail = e.response?.data?.detail;
      if (Array.isArray(detail)) detail = detail.map(d => d?.msg || JSON.stringify(d)).join("; ");
      else if (typeof detail === "object" && detail !== null) detail = JSON.stringify(detail);
      const isNetwork = !e.response;
      const isTimeout = e.code === "ECONNABORTED";
      const friendly = isTimeout
        ? "Permintaan terlalu lama (timeout). Backend mungkin masih memproses — tutup modal, muat ulang daftar, lalu periksa apakah warna sudah berubah sebelum coba lagi."
        : isNetwork
          ? "Gagal terhubung ke server. Periksa koneksi internet lalu coba lagi."
          : (detail || `Gagal mengubah nama warna (HTTP ${e.response?.status || "?"}). Silakan coba lagi.`);
      setErr(friendly);
    } finally {
      // Reset saving di SEMUA jalur (sukses/gagal/timeout) agar tombol tidak macet "Menyimpan…".
      setSaving(false);
    }
    if (ok) {
      // Tutup modal + refresh daftar DULU (jangan menunggu user klik "Selesai" di notify.success,
      // itulah penyebab modal terkesan macet). Lalu kirim notifikasi success (non-blocking).
      onSaved();
      notify.success({
        title: "Nama warna diperbarui",
        message: `"${colorRow.color}" → "${trimmed}" di ${label}. ${variantCount} varian ter-rename atomik. Nama lama tersimpan sebagai alias — PR & Barang Masuk Rido lama tetap bisa dicocokkan.`,
        primaryLabel: "Selesai",
      }).catch(() => {});
    }
  }

  const touchBtn = { touchAction: "manipulation", WebkitTapHighlightColor: "rgba(37,99,235,.2)", minHeight: 44 };

  return (
    <div className="modal-backdrop" data-testid="stock-color-rename-modal"
         onClick={(e) => { if (e.target === e.currentTarget && !saving) onClose(); }}>
      <div className="modal" style={{ maxWidth: 480 }}>
        <div className="modal-head">
          <h3>Ubah nama warna</h3>
          <button type="button" className="icon-btn" onClick={onClose} aria-label="Tutup" disabled={saving} style={touchBtn}><X size={16} /></button>
        </div>
        <div className="modal-body">
          <div data-testid="stock-color-rename-context"
               style={{ padding: "10px 12px", background: "#f1f5f9", borderRadius: 8, marginBottom: 12, fontSize: 13, lineHeight: 1.7 }}>
            <div><span className="muted small">Produk/bahan:</span> <strong>{label}</strong></div>
            <div><span className="muted small">Nama warna lama:</span> <strong data-testid="stock-color-rename-oldname" style={{ color: "#b91c1c" }}>{colorRow.color}</strong></div>
            <div>
              <span className="muted small">Varian terdampak:</span>{" "}
              <strong data-testid="stock-color-rename-variantcount">{variantCount}</strong> varian
              {totalQty > 0 && <> · saldo <strong>{totalQty} {colorRow.unit || ""}</strong></>}
            </div>
            {existingAliases.length > 0 && (
              <div>
                <span className="muted small">Alias yang sudah ada:</span>{" "}
                <span data-testid="stock-color-rename-aliases-current" style={{ fontSize: 12 }}>{existingAliases.join(", ")}</span>
              </div>
            )}
          </div>
          <label className="field">
            <span>Nama warna baru</span>
            <input
              type="text"
              autoFocus
              data-testid="stock-color-rename-input"
              value={newName}
              onChange={e => setNewName(e.target.value)}
              placeholder="Masukkan nama baru"
              style={{ minHeight: 44, touchAction: "manipulation" }}
            />
          </label>
          {duplicate && (
            <p className="muted small" data-testid="stock-color-rename-duplicate" style={{ color: "#b91c1c", marginTop: 6 }}>
              Nama ini sudah dipakai (atau alias) oleh warna lain di {label}. Pilih nama lain.
            </p>
          )}
          {unchanged && (
            <p className="muted small" data-testid="stock-color-rename-unchanged" style={{ color: "#64748b", marginTop: 6 }}>
              Nama baru sama dengan nama saat ini.
            </p>
          )}
          <div style={{ marginTop: 10, padding: "8px 10px", background: "#dbeafe", border: "1px solid #93c5fd", borderRadius: 6, fontSize: 12, color: "#1e3a8a", lineHeight: 1.6 }}>
            <strong>Setelah disimpan:</strong> Semua {variantCount} varian di <strong>{label}</strong> akan di-rename atomik.
            ID varian, SKU, saldo, dan status aktif <strong>tidak berubah</strong>. Nama lama otomatis dicatat sebagai alias
            agar Permintaan Produksi &amp; Barang Masuk Rido yang sudah ada tetap bisa dicocokkan.
          </div>
          {err && <p className="muted small" data-testid="stock-color-rename-error" style={{ color: "#b91c1c", marginTop: 8 }}>{err}</p>}
        </div>
        <div className="modal-foot">
          <button
            type="button"
            className="secondary"
            data-testid="stock-color-rename-cancel"
            onClick={onClose}
            disabled={saving}
            style={touchBtn}
          >Batal</button>
          <button
            type="button"
            className="primary"
            data-testid="stock-color-rename-apply"
            onClick={submit}
            disabled={!canSave}
            style={touchBtn}
          >
            {saving ? "Menyimpan…" : "Simpan Perubahan"}
          </button>
        </div>
      </div>
    </div>
  );
}

// Iter 532 Tahap 2 — Modal "Tambah warna" ke sebuah group kain/polosan.
function StockColorAddModal({ category, group, label, onClose, onSaved }) {
  const [name, setName] = useState("");
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState("");
  const trimmed = name.trim();
  const existingNames = useMemo(() => {
    const names = new Set();
    for (const c of (group.colors || [])) {
      if (c.color) names.add(c.color.toUpperCase().replace(/\s+/g, " ").trim());
      for (const a of (c.aliases || [])) names.add((a || "").toUpperCase().replace(/\s+/g, " ").trim());
    }
    return names;
  }, [group]);
  const normalized = trimmed.toUpperCase().replace(/\s+/g, " ").trim();
  const duplicate = normalized && existingNames.has(normalized);
  const canSave = !!trimmed && !duplicate && !saving;

  async function submit() {
    if (!canSave) return;
    setSaving(true); setErr("");
    try {
      await axios.post(`${API}/stock/colors/add`, {
        category,
        fabric_name: category === "kain" ? group.fabric_name : undefined,
        product_name: category === "polosan" ? group.product_name : undefined,
        material: category === "polosan" ? group.material : undefined,
        new_color: trimmed,
      }, { withCredentials: true });
      await notify.success({ title: "Warna ditambahkan", message: `"${trimmed}" ditambahkan ke ${label} (saldo awal 0).`, primaryLabel: "Selesai" });
      onSaved();
    } catch (e) {
      setErr(e.response?.data?.detail || "Gagal menambah warna.");
      setSaving(false);
    }
  }

  return (
    <div className="modal-backdrop" data-testid="stock-color-add-modal" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="modal" style={{ maxWidth: 460 }}>
        <div className="modal-head">
          <h3>Tambah warna di {label}</h3>
          <button type="button" className="icon-btn" onClick={onClose} aria-label="Tutup"><X size={16} /></button>
        </div>
        <div className="modal-body">
          <p className="muted small" style={{ marginBottom: 8 }}>
            Nama warna wajib unik di dalam group ini (termasuk alias). Varian baru akan dibuat untuk setiap kombinasi dimensi
            {category === "kain" ? " (brand + unit)" : " (sleeve + size)"} dengan saldo awal <strong>0</strong>.
          </p>
          <label className="field">
            <span>Nama warna</span>
            <input
              type="text"
              autoFocus
              data-testid="stock-color-add-input"
              value={name}
              onChange={e => setName(e.target.value)}
              placeholder="Contoh: Charcoal Melange"
            />
          </label>
          {duplicate && (
            <p className="muted small" data-testid="stock-color-add-duplicate" style={{ color: "#b91c1c", marginTop: 6 }}>
              Nama ini sudah ada (atau pernah dipakai sebagai alias) di group {label}.
            </p>
          )}
          {err && <p className="muted small" data-testid="stock-color-add-error" style={{ color: "#b91c1c", marginTop: 6 }}>{err}</p>}
        </div>
        <div className="modal-foot">
          <button type="button" className="secondary" onClick={onClose} disabled={saving}>Batal</button>
          <button type="button" className="primary" data-testid="stock-color-add-save" onClick={submit} disabled={!canSave}>
            {saving ? "Menambahkan…" : "Tambahkan"}
          </button>
        </div>
      </div>
    </div>
  );
}

function MasterProducts({ onBack, initialKind, isAdminToko, isOwnerUser }) {
  const [kind, setKind] = useState(isAdminToko ? "products" : (initialKind || "products"));
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const [showAdd, setShowAdd] = useState(false);
  const [busy, setBusy] = useState(false);
  // Iter 529 — Pisahkan status Loading / Berhasil / Kosong / Error.
  //   `status` = "loading" | "ok" | "error". `errorInfo` = {status, msg} saat error.
  //   "Belum ada data" HANYA ketika status === "ok" && items.length === 0 (API sukses tapi array kosong).
  //   Catatan: race-condition dilindungi via reqIdRef — bila user ganti tab cepat, response
  //   fetch yang terlambat untuk kind lama TIDAK boleh menimpa items dari kind terbaru.
  const [status, setStatus] = useState("loading");
  const [errorInfo, setErrorInfo] = useState(null);
  const reqIdRef = useRef(0);
  // Iter 530 — Filter scope (hanya aktif saat kind='colors'). Reset saat ganti kind.
  const [scopeFilter, setScopeFilter] = useState({ mode: "all", value: "" });
  // Iter 530 — Load master_materials & master_products untuk chip picker di modal + filter.
  const [allMaterialsList, setAllMaterialsList] = useState([]);
  const [allProductsList, setAllProductsList] = useState([]);
  useEffect(() => {
    axios.get(`${API}/master/materials?active_only=true`, { withCredentials: true })
      .then(r => setAllMaterialsList(Array.isArray(r.data) ? r.data : []))
      .catch(() => {});
    axios.get(`${API}/master/products?active_only=true`, { withCredentials: true })
      .then(r => setAllProductsList(Array.isArray(r.data) ? r.data : []))
      .catch(() => {});
  }, []);
  // Iter 530 — Preview warna dari stok sesuai scope filter (reuse Iter 528 endpoint).
  const [stockPreview, setStockPreview] = useState([]);
  const [stockPreviewLoading, setStockPreviewLoading] = useState(false);
  useEffect(() => {
    if (kind !== "colors" || scopeFilter.mode !== "material" || !scopeFilter.value) {
      setStockPreview([]); return;
    }
    let ignore = false;
    setStockPreviewLoading(true);
    axios.get(`${API}/master/colors/by-material`, { params: { material: scopeFilter.value }, withCredentials: true })
      .then(r => { if (!ignore) setStockPreview(Array.isArray(r.data) ? r.data : []); })
      .catch(() => { if (!ignore) setStockPreview([]); })
      .finally(() => { if (!ignore) setStockPreviewLoading(false); });
    return () => { ignore = true; };
  }, [kind, scopeFilter.mode, scopeFilter.value]);
  const load = useCallback(async (k, filterOpts) => {
    const myId = ++reqIdRef.current;
    setStatus("loading");
    setErrorInfo(null);
    try {
      const params = {};
      if (k === "colors" && filterOpts && filterOpts.mode === "material" && filterOpts.value) {
        params.for_material = filterOpts.value;
      } else if (k === "colors" && filterOpts && filterOpts.mode === "product" && filterOpts.value) {
        params.for_product = filterOpts.value;
      }
      const r = await axios.get(`${API}/master/${k}`, { params, withCredentials: true });
      if (reqIdRef.current !== myId) return;  // race: user sudah pindah tab, abaikan.
      setItems(Array.isArray(r.data) ? r.data : []);
      setStatus("ok");
    } catch (e) {
      if (reqIdRef.current !== myId) return;  // race: abaikan error dari fetch kadaluarsa.
      const httpStatus = e.response?.status;
      const detail = e.response?.data?.detail;
      const isNetwork = !e.response;  // CORS / offline / timeout
      let friendly;
      if (httpStatus === 401) friendly = "Sesi login Anda sudah berakhir. Silakan login ulang untuk melanjutkan.";
      else if (httpStatus === 403) friendly = "Tidak berwenang mengakses data ini.";
      else if (isNetwork) friendly = "Gagal terhubung ke server. Cek koneksi internet lalu klik \u201CCoba Lagi\u201D.";
      else friendly = detail || `Terjadi kesalahan (HTTP ${httpStatus || "?"}). Klik \u201CCoba Lagi\u201D.`;
      setErrorInfo({ httpStatus, detail: detail || null, isNetwork, friendly });
      setStatus("error");
      // Tetap tampilkan toast agar Owner cepat sadar — pesan utama di-UI yang menetap.
      notify.error({ title: "Gagal memuat data", message: friendly });
    }
  }, []);
  useEffect(() => { setScopeFilter({ mode: "all", value: "" }); }, [kind]);
  useEffect(() => { load(kind, scopeFilter); }, [kind, scopeFilter, load]);
  const refresh = useCallback(() => { load(kind, scopeFilter); }, [kind, scopeFilter, load]);
  const move = async (id, dir) => {
    if (busy || status !== "ok") return;
    const idx = items.findIndex(x => x.id === id);
    const partner = items[idx + dir];
    if (!partner) return;
    setBusy(true);
    try {
      await axios.patch(`${API}/master/${kind}/${id}`, { order_index: partner.order_index }, { withCredentials: true });
      await axios.patch(`${API}/master/${kind}/${partner.id}`, { order_index: items[idx].order_index }, { withCredentials: true });
      window.dispatchEvent(new Event("master-updated"));
      await load(kind, scopeFilter);
    } catch (e) { notify.error({ title:"Gagal mengubah urutan", message: e.response?.data?.detail || "Silakan coba lagi." }); }
    finally { setBusy(false); }
  };
  const toggleActive = async (row) => {
    if (busy || status !== "ok") return;
    setBusy(true);
    try {
      await axios.patch(`${API}/master/${kind}/${row.id}`, { is_active: !row.is_active }, { withCredentials: true });
      window.dispatchEvent(new Event("master-updated"));
      await load(kind, scopeFilter);
    } catch (e) { notify.error({ title:"Gagal mengubah status", message: e.response?.data?.detail || "Silakan coba lagi." }); }
    finally { setBusy(false); }
  };
  const removeProduct = async (row) => {
    if (busy || status !== "ok") return;
    setBusy(true);
    try {
      const u = (await axios.get(`${API}/master/products/${row.id}/usage`, { withCredentials: true })).data;
      if (!u.can_delete) {
        const parts = [u.usage.nota && `${u.usage.nota} nota`, u.usage.stok && `${u.usage.stok} varian stok`, u.usage.warna && `${u.usage.warna} warna`].filter(Boolean);
        notify.warning({ title: "Tidak dapat dihapus", message: u.locked ? `"${row.name}" adalah produk baku sistem. Cukup Nonaktifkan.`
          : `"${row.name}" sudah dipakai (${parts.join(", ")}) — dihapus akan merusak riwayat. Cukup Nonaktifkan.` });
        return;
      }
      const ok = await notify.confirm({ title: "Hapus produk ini?", message: `"${row.name}" akan dihapus permanen dari Master Produk. Produk ini belum pernah dipakai di nota maupun stok.`, primaryLabel: "Ya, Hapus", secondaryLabel: "Batal", danger: true });
      if (!ok) return;
      await axios.delete(`${API}/master/products/${row.id}`, { withCredentials: true });
      window.dispatchEvent(new Event("master-updated"));
      await load(kind, scopeFilter);
    } catch (e) { notify.error({ title:"Gagal menghapus", message: e.response?.data?.detail || "Silakan coba lagi." }); }
    finally { setBusy(false); }
  };
  const kindLabel = kind === "materials" ? "Bahan" : kind === "colors" ? "Warna" : kind === "sizes" ? "Ukuran" : "Produk";
  return <div className="section master-section">
    <div className="master-topbar">
      <button type="button" data-testid="master-back-button" className="icon-btn" onClick={onBack} aria-label="Kembali"><ChevronLeft size={18}/></button>
      <p className="eyebrow">HALAMAN</p>
      <span className="master-crumb">Master Data</span>
      <button
        type="button"
        data-testid="master-refresh-button"
        className="icon-btn"
        onClick={refresh}
        disabled={status === "loading"}
        aria-label="Muat ulang"
        title="Muat ulang data master"
        style={{ marginLeft: "auto" }}
      >
        <RefreshCw size={16} className={status === "loading" ? "spin" : ""}/>
      </button>
    </div>
    <div className="master-tabs">
      {[{id:"products",label:"Produk"},{id:"materials",label:"Bahan"},{id:"colors",label:"Warna"},{id:"sizes",label:"Ukuran"}]
        .filter(t=>!isAdminToko || t.id==="products")
        .map(t=>
          <button type="button" key={t.id} data-testid={`master-tab-${t.id}`} className={`master-tab ${kind===t.id?"active":""}`} onClick={()=>setKind(t.id)}>{t.label}</button>
        )}
    </div>
    <div className="section-title">
      <h3>Master {kindLabel}</h3>
      <button type="button" data-testid="master-add-button" className="soft-btn add-product-btn" onClick={()=>setShowAdd(true)}><Plus size={16}/>Tambah {kindLabel.toLowerCase()}</button>
    </div>
    <p className="muted small">Kelola daftar {kindLabel.toLowerCase()} pada dropdown Form Nota. Item yang pernah dipakai tidak dapat dihapus permanen — cukup nonaktifkan.{kind === "products" && isOwnerUser ? " Produk yang belum pernah dipakai dapat dihapus Owner." : ""}</p>
    {kind === "colors" && (
      <div
        className="master-note-banner"
        data-testid="master-colors-info-banner"
        style={{
          background: "#eff6ff",
          border: "1px solid #bfdbfe",
          borderLeft: "3px solid #2563eb",
          padding: "10px 14px",
          borderRadius: 8,
          margin: "6px 0 12px",
          fontSize: 12,
          color: "#1e3a8a",
          lineHeight: 1.6,
        }}
      >
        <strong>Daftar warna generik</strong> untuk Form Nota (pekerjaan custom / non-stok).
        Warna detail per bahan — misalnya 37 varian <em>Cotton Combed 24S Knitto</em>, warna
        American Drill, Nagata Drill, CVC, dll — dikelola di <strong>Master Stok Kain</strong>
        dan otomatis muncul di dropdown Form Nota ketika operator memilih bahan terkait.
        Tidak perlu diduplikasi di sini.
      </div>
    )}
    {/* Iter 532 Tahap 2 — Master Warna Berbasis Stok (bagian utama). */}
    {kind === "colors" && !isAdminToko && (
      <StockColorsPanel isAdminToko={isAdminToko} />
    )}
    {kind === "colors" && !isAdminToko && (
      <div className="master-divider-note" data-testid="master-colors-divider" style={{
        margin: "6px 0 10px", padding: "6px 10px", background: "#fef3c7", borderLeft: "3px solid #d97706",
        borderRadius: 6, fontSize: 12, color: "#78350f",
      }}>
        <strong>Di bawah ini:</strong> Master Warna Umum/Custom (untuk pekerjaan non-stok di Form Nota).
      </div>
    )}
    {/* Iter 530 — Filter scope untuk Master Warna. Hanya tampil saat kind='colors'. */}
    {kind === "colors" && (
      <div className="master-scope-filter" data-testid="master-scope-filter" style={{
        display:"flex",flexWrap:"wrap",gap:10,alignItems:"center",
        padding:"10px 12px",background:"#f8fafc",border:"1px solid #e2e8f0",
        borderRadius:8,marginBottom:12
      }}>
        <span className="muted small" style={{fontWeight:600}}>Lihat warna untuk:</span>
        <label style={{display:"inline-flex",alignItems:"center",gap:4,fontSize:13,cursor:"pointer"}}>
          <input
            type="radio"
            name="master-color-scope"
            data-testid="master-scope-filter-all"
            checked={scopeFilter.mode === "all"}
            onChange={() => setScopeFilter({ mode: "all", value: "" })}
          /> Semua
        </label>
        <label style={{display:"inline-flex",alignItems:"center",gap:4,fontSize:13,cursor:"pointer"}}>
          <input
            type="radio"
            name="master-color-scope"
            data-testid="master-scope-filter-material"
            checked={scopeFilter.mode === "material"}
            onChange={() => setScopeFilter({ mode: "material", value: scopeFilter.value || (allMaterialsList[0]?.name || "") })}
          /> Bahan tertentu
        </label>
        <label style={{display:"inline-flex",alignItems:"center",gap:4,fontSize:13,cursor:"pointer"}}>
          <input
            type="radio"
            name="master-color-scope"
            data-testid="master-scope-filter-product"
            checked={scopeFilter.mode === "product"}
            onChange={() => setScopeFilter({ mode: "product", value: scopeFilter.value || (allProductsList[0]?.name || "") })}
          /> Produk tertentu
        </label>
        {scopeFilter.mode === "material" && (
          <select
            data-testid="master-scope-filter-material-select"
            value={scopeFilter.value}
            onChange={e => setScopeFilter({ mode: "material", value: e.target.value })}
            style={{padding:"6px 10px",borderRadius:6,border:"1px solid #cbd5e1",fontSize:13,maxWidth:220}}
          >
            <option value="">— pilih bahan —</option>
            {allMaterialsList.map(m => <option key={m.name} value={m.name}>{m.name}</option>)}
          </select>
        )}
        {scopeFilter.mode === "product" && (
          <select
            data-testid="master-scope-filter-product-select"
            value={scopeFilter.value}
            onChange={e => setScopeFilter({ mode: "product", value: e.target.value })}
            style={{padding:"6px 10px",borderRadius:6,border:"1px solid #cbd5e1",fontSize:13,maxWidth:220}}
          >
            <option value="">— pilih produk —</option>
            {allProductsList.map(p => <option key={p.name} value={p.name}>{p.name}</option>)}
          </select>
        )}
      </div>
    )}
    {/* Iter 530 — Preview warna dari stok (read-only) saat filter mode=material + value ada. */}
    {kind === "colors" && scopeFilter.mode === "material" && scopeFilter.value && (
      <div className="master-stock-preview" data-testid="master-stock-preview" style={{
        marginBottom:12,padding:"12px 14px",background:"#fffbeb",border:"1px solid #fde68a",
        borderLeft:"3px solid #d97706",borderRadius:8
      }}>
        <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:6}}>
          <strong style={{fontSize:13,color:"#78350f"}}>★ Dari Stok · {scopeFilter.value}</strong>
          <span className="muted small" data-testid="master-stock-preview-count">
            {stockPreviewLoading ? "memuat…" : `${stockPreview.length} warna (read-only)`}
          </span>
        </div>
        <p className="muted small" style={{fontSize:11,marginBottom:8,color:"#78350f"}}>
          Warna di bawah ini berasal dari <strong>Master Stok Kain</strong> dan tidak dapat diedit di sini. Kelola langsung di modul Stok.
        </p>
        {stockPreview.length > 0 ? (
          <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
            {stockPreview.map(c => (
              <span
                key={c.name}
                data-testid={`master-stock-preview-chip-${c.name}`}
                style={{padding:"3px 10px",borderRadius:999,fontSize:12,background:"#fef3c7",color:"#78350f",border:"1px solid #fde68a"}}
              >{c.name}</span>
            ))}
          </div>
        ) : (
          !stockPreviewLoading && <p className="muted small" style={{fontSize:12}}>Tidak ada warna di stok untuk bahan ini.</p>
        )}
      </div>
    )}
    <div className="master-list" data-kind={kind}>
      {status === "loading" ? (
        <div className="master-state master-state-loading" data-testid="master-state-loading" role="status" aria-live="polite">
          <Loader2 size={18} className="spin" aria-hidden="true"/>
          <span>Memuat data {kindLabel.toLowerCase()}…</span>
        </div>
      ) : status === "error" ? (
        <div className="master-state master-state-error" data-testid="master-state-error" role="alert">
          <div className="master-state-icon" aria-hidden="true"><AlertTriangle size={20}/></div>
          <div className="master-state-body">
            <strong data-testid="master-error-title">
              {errorInfo?.httpStatus === 401 ? "Sesi login berakhir" : "Gagal memuat data"}
            </strong>
            <p className="muted small" data-testid="master-error-message">
              {errorInfo?.friendly}
              {errorInfo?.httpStatus != null && (
                <span className="muted small" style={{ marginLeft: 6 }}>· HTTP {errorInfo.httpStatus}</span>
              )}
            </p>
            <div className="master-state-actions">
              <button
                type="button"
                data-testid="master-error-retry"
                className="primary"
                onClick={refresh}
                disabled={status === "loading"}
              >
                <RefreshCw size={14}/> Coba Lagi
              </button>
              {errorInfo?.httpStatus === 401 && (
                <button
                  type="button"
                  data-testid="master-error-relogin"
                  className="secondary"
                  onClick={() => { window.location.assign("/"); }}
                >
                  <LogOut size={14}/> Login Ulang
                </button>
              )}
            </div>
          </div>
        </div>
      ) : items.length === 0 ? (
        <div className="empty" data-testid="master-state-empty">
          Belum ada data. Klik "Tambah" untuk memulai.
        </div>
      ) : items.map((row, i)=>{
          const KindIcon = kind === "materials" ? Layers : kind === "colors" ? Palette : kind === "sizes" ? Ruler : Package;
          // Iter 530 — Badge scope untuk kind='colors'. Umum = tanpa scope, atau tampilkan daftar.
          const scopeMats = Array.isArray(row.scope_materials) ? row.scope_materials : [];
          const scopePrds = Array.isArray(row.scope_products) ? row.scope_products : [];
          const isUmum = kind === "colors" && scopeMats.length === 0 && scopePrds.length === 0;
          return <div className={`master-row ${row.is_active?"":"inactive"}`} data-kind={kind} key={row.id} data-testid={`master-row-${row.id}`}>
            <div className="master-info">
              <span className="master-kind-icon" aria-hidden="true"><KindIcon size={18} strokeWidth={1.75}/></span>
              <span className="master-order">#{String(i+1).padStart(2,"0")}</span>
              <strong data-testid={`master-name-${row.id}`}>{row.name}</strong>
              <span className={`status-chip ${row.is_active?"status-active":"status-draft"}`} data-testid={`master-status-${row.id}`}>{row.is_active?"AKTIF":"NONAKTIF"}</span>
              {kind === "colors" && (
                <span
                  className="master-scope-badge"
                  data-testid={`master-scope-badge-${row.id}`}
                  data-scope={isUmum ? "umum" : "scoped"}
                  title={isUmum ? "Berlaku untuk semua produk/bahan" : `Bahan: ${scopeMats.join(", ")||"—"} · Produk: ${scopePrds.join(", ")||"—"}`}
                  style={{
                    fontSize:11,fontWeight:600,padding:"2px 8px",borderRadius:999,
                    background:isUmum?"#f1f5f9":"#ecfeff",
                    color:isUmum?"#475569":"#0369a1",
                    border:isUmum?"1px solid #cbd5e1":"1px solid #67e8f9",
                    marginLeft:4,
                  }}
                >
                  {isUmum
                    ? "Umum"
                    : [
                        scopeMats.length > 0 ? `Bahan: ${scopeMats.slice(0,2).join(", ")}${scopeMats.length>2?` +${scopeMats.length-2}`:""}` : null,
                        scopePrds.length > 0 ? `Produk: ${scopePrds.slice(0,2).join(", ")}${scopePrds.length>2?` +${scopePrds.length-2}`:""}` : null,
                      ].filter(Boolean).join(" · ")}
                </span>
              )}
            </div>
            <div className="master-actions">
              {isAdminToko ? (
                <span className="muted small" data-testid={`master-readonly-${row.id}`}>Kelola oleh Owner/Admin</span>
              ) : (<>
                <button type="button" className="tiny-btn" disabled={i===0||busy} data-testid={`master-up-${row.id}`} onClick={()=>move(row.id,-1)} aria-label="Naik"><ArrowUp size={13}/></button>
                <button type="button" className="tiny-btn" disabled={i===items.length-1||busy} data-testid={`master-down-${row.id}`} onClick={()=>move(row.id,1)} aria-label="Turun"><ArrowDown size={13}/></button>
                <button type="button" className="tiny-btn" data-testid={`master-edit-${row.id}`} onClick={()=>setEditing(row)}><Pencil size={13}/>Ubah</button>
                <button type="button" className="tiny-btn" data-testid={`master-toggle-${row.id}`} disabled={busy} onClick={()=>toggleActive(row)}>{row.is_active?"Nonaktifkan":"Aktifkan"}</button>
                {kind === "products" && isOwnerUser && <button type="button" className="tiny-btn master-del-btn" data-testid={`master-delete-${row.id}`} disabled={busy} onClick={()=>removeProduct(row)}><Trash2 size={13}/>Hapus</button>}
              </>)}
            </div>
          </div>;
        })}
    </div>
    {showAdd && <MasterEditModal kind={kind} allMaterials={allMaterialsList} allProducts={allProductsList} onClose={()=>setShowAdd(false)} onSaved={()=>{setShowAdd(false);load(kind, scopeFilter);}}/>}
    {editing && <MasterEditModal kind={kind} item={editing} allMaterials={allMaterialsList} allProducts={allProductsList} onClose={()=>setEditing(null)} onSaved={()=>{setEditing(null);load(kind, scopeFilter);}}/>}
  </div>;
}


// ==== ProductionQueue + TeamProductCard + StageCorrectModal dipindah ke ./production_queue ====


function ReportsPage({ user, onBack }) {
  const [period, setPeriod] = useState("daily");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [data, setData] = useState({items:[], total:{orders:0,gross:0,paid:0,outstanding:0,pieces:0}});
  const [trend, setTrend] = useState({items:[]});
  const [busy, setBusy] = useState(false);
  const load = async () => {
    setBusy(true);
    try {
      const q = new URLSearchParams({period, from_:from, to}).toString();
      const r = await axios.get(`${API}/reports/omzet?${q}`, { withCredentials:true });
      setData(r.data);
      // 30-day trend (daily, terlepas dari filter periode)
      const today = new Date(); const past = new Date(today); past.getTime(); past.setDate(today.getDate()-29);
      const fmt = d => d.toISOString().slice(0,10);
      const tq = new URLSearchParams({period:"daily", from_:fmt(past), to:fmt(today)}).toString();
      const t = await axios.get(`${API}/reports/omzet?${tq}`, { withCredentials:true });
      // fill missing dates dengan 0 agar chart mulus
      const map = {}; for (const it of (t.data.items||[])) map[it.period] = it.gross;
      const days = []; for (let i=0;i<30;i++) { const d = new Date(past); d.setDate(past.getDate()+i); const k = fmt(d); days.push({period:k, gross:map[k]||0}); }
      setTrend({items:days});
    } catch(e) { notify.error({ title:"Gagal memuat laporan", message: e.response?.data?.detail || "Silakan coba lagi." }); }
    finally { setBusy(false); }
  };
  useEffect(()=>{ load(); /* eslint-disable-next-line */ }, [period]);
  const exportXLSX = () => {
    const q = new URLSearchParams({period, from_:from, to}).toString();
    window.open(`${API}/reports/omzet.xlsx?${q}`, "_self");
  };
  const money = n => "Rp "+Number(n||0).toLocaleString("id-ID");
  return <div className="shell">
    <header className="topbar">
      <div className="brand"><b aria-label="Logo TAMFARIS"><img src="/logo-tamfaris.jpg" alt="Logo TAMFARIS" draggable="false"/></b><span><strong>TAMFARIS</strong></span></div>
      <div className="user-pill"><span>{user.name}</span><small>{user.role}</small></div>
    </header>
    <main className="content">
      <div className="welcome">
        <div><p className="eyebrow">Pengaturan</p><h1>Laporan Omzet</h1><p className="muted">Ringkasan omzet berdasarkan tanggal pesanan. Nota Dibatalkan tidak dihitung.</p></div>
        <button type="button" className="soft-btn" data-testid="reports-back" onClick={onBack}>← Kembali</button>
      </div>
      <div className="section">
        <div className="toolbar" style={{gap:8,flexWrap:"wrap"}}>
          <select data-testid="reports-period" value={period} onChange={e=>setPeriod(e.target.value)}>
            <option value="daily">Harian</option><option value="weekly">Mingguan</option><option value="monthly">Bulanan</option>
          </select>
          <input type="date" data-testid="reports-from" value={from} onChange={e=>setFrom(e.target.value)}/>
          <input type="date" data-testid="reports-to" value={to} onChange={e=>setTo(e.target.value)}/>
          <button type="button" className="primary" data-testid="reports-apply" disabled={busy} onClick={load}>Terapkan</button>
          <button type="button" className="soft-btn" data-testid="reports-export-xlsx" disabled={busy || data.items.length===0} onClick={exportXLSX}>Ekspor Excel</button>
        </div>
      </div>
      <div className="metrics" data-testid="reports-summary">
        <div className="metric"><span>Jumlah Nota</span><strong>{data.total.orders}</strong></div>
        <div className="metric accent"><span>Omzet Kotor</span><strong data-testid="reports-total-gross">{money(data.total.gross)}</strong></div>
        <div className="metric"><span>Terbayar</span><strong>{money(data.total.paid)}</strong></div>
        <div className="metric"><span>Piutang</span><strong>{money(data.total.outstanding)}</strong></div>
        <div className="metric"><span>Total Pcs</span><strong>{data.total.pieces}</strong></div>
      </div>
      <TrendChart data={trend.items}/>
      <div className="section">
        <h3>Detail per periode</h3>
        <div className="table-wrap"><table><thead><tr><th>Periode</th><th>Nota</th><th>Omzet</th><th>Terbayar</th><th>Piutang</th><th>Pcs</th></tr></thead>
          <tbody>
            {data.items.map((x,i)=><tr key={i} data-testid={`reports-row-${i}`}><td><b>{x.period}</b></td><td>{x.orders}</td><td>{money(x.gross)}</td><td>{money(x.paid)}</td><td>{money(x.outstanding)}</td><td>{x.pieces}</td></tr>)}
            {data.items.length===0 && !busy && <tr><td colSpan={6}><div className="empty">Tidak ada data pada rentang ini.</div></td></tr>}
          </tbody></table></div>
      </div>
    </main>
  </div>;
}

function TrendChart({ data }) {
  const W = 800, H = 200, PAD = 30;
  const max = Math.max(1, ...data.map(d => d.gross || 0));
  const stepX = data.length > 1 ? (W - PAD*2) / (data.length - 1) : 0;
  const points = data.map((d, i) => {
    const x = PAD + i * stepX;
    const y = H - PAD - (d.gross / max) * (H - PAD*2);
    return `${x.toFixed(1)},${y.toFixed(1)}`;
  }).join(" ");
  const total = data.reduce((s, d) => s + (d.gross||0), 0);
  return <div className="section" data-testid="reports-trend-chart">
    <div className="section-title"><h3>Grafik Omzet 30 Hari Terakhir</h3><span className="muted small">Total: Rp {total.toLocaleString("id-ID")}</span></div>
    <div style={{overflowX:"auto"}}>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:"100%",height:"200px",background:"#fff",border:"1px solid var(--line)"}}>
        <line x1={PAD} y1={H-PAD} x2={W-PAD} y2={H-PAD} stroke="#e5e7eb"/>
        <line x1={PAD} y1={PAD} x2={PAD} y2={H-PAD} stroke="#e5e7eb"/>
        {data.length > 1 && <polyline fill="none" stroke="#c8a047" strokeWidth="2" points={points}/>}
        {data.map((d, i) => { const x = PAD + i*stepX; const y = H - PAD - (d.gross/max)*(H - PAD*2); return <circle key={i} cx={x} cy={y} r="3" fill="#15161a"><title>{d.period}: Rp {(d.gross||0).toLocaleString("id-ID")}</title></circle>; })}
        {data.length > 0 && <>
          <text x={PAD} y={H-8} fontSize="10" fill="#6b7280">{data[0]?.period}</text>
          <text x={W-PAD} y={H-8} fontSize="10" fill="#6b7280" textAnchor="end">{data[data.length-1]?.period}</text>
        </>}
      </svg>
    </div>
  </div>;
}


// ===== Dashboard Admin =====
function AttentionCard({ cat, count, active, onClick }) {
  const icons = { active:<ReceiptText size={18}/>, overdue:<AlertTriangle size={18}/>, near:<Clock size={18}/>, wip:<Factory size={18}/>, ready:<PackageOpen size={18}/>, unpaid:<Wallet size={18}/> };
  return <button type="button" data-testid={`att-card-${cat}`} className={`att-card ${CAT_CLASS[cat]} ${active?"is-active":""}`} onClick={onClick} aria-pressed={active}>
    <span className="att-icon" aria-hidden="true">{icons[cat]}</span>
    <span className="att-label">{CAT_LABEL[cat]}</span>
    <strong className="att-count" data-testid={`att-count-${cat}`}>{count}</strong>
  </button>;
}

function AttentionOrderRow({ order, cats, onOpen }) {
  const products = order.products || [];
  // Iter 223 — Polosan auto-done saat hitung "X dari Y selesai".
  const doneCount = products.filter(isProductProductionDone).length;
  const activeStages = products
    .map(p => ({ name:p.name, stage:p.production_stage||"—", pic:p.production_pic || (p.production_stage ? (STAGE_TEAM_LABEL[p.production_stage]||"-") : "-") }))
    .filter(x => x.stage !== "Selesai" && !POLOSAN_ROUTES.has(products.find(p => p.name===x.name)?.production_route));
  const uniqStages = Array.from(new Set(activeStages.map(x => `${x.stage}·${x.pic}`)));
  const [expand, setExpand] = useState(false);
  const remaining = Number(order.remaining ?? Math.max(0, Number(order.grand_total||0) - Number(order.paid||0)));
  const productSummary = products.map(p => `${p.name} (${Number(p.quantity)||p.sizes?.reduce((a,s)=>a+Number(s.quantity||0),0)||0})`).join(" • ") || "—";
  const multiTeam = uniqStages.length > 1;
  return <div className="att-row" data-testid={`att-row-${order.order_number}`}>
    <div className="att-row-head">
      <div className="att-row-titlewrap">
        <strong className="att-row-title">{order.customer_name || "—"}</strong>
        <span className="att-row-no">{order.order_number}</span>
      </div>
      <div className="att-row-badges" data-testid={`att-row-badges-${order.order_number}`}>
        {Array.from(cats).map(c => <span key={c} className={`att-badge ${CAT_CLASS[c]}`}>{CAT_LABEL[c]}</span>)}
        {dateAnomaly(order) && <span className="att-badge att-badge-anomaly" title="Periksa tanggal nota" data-testid={`att-row-date-anomaly-${order.order_number}`}>⚠ {dateAnomaly(order)}</span>}
      </div>
    </div>
    <div className="att-row-meta">
      <div><span>Produk</span><strong>{productSummary}</strong></div>
      <div><span>Deadline</span><strong data-testid={`att-row-deadline-${order.order_number}`}>{order.deadline || "—"}</strong></div>
      <div><span>Progres</span><strong data-testid={`att-row-progress-${order.order_number}`}>{doneCount} dari {products.length} produk selesai</strong></div>
      <div><span>Tahap aktif</span><strong data-testid={`att-row-stage-${order.order_number}`}>
        {activeStages.length === 0 ? "Semua selesai" : (multiTeam ? <button type="button" className="att-linkbtn" onClick={()=>setExpand(v=>!v)} data-testid={`att-row-expand-${order.order_number}`}>Beberapa tim ({uniqStages.length}) {expand?<ChevronUp size={13}/>:<ChevronDown size={13}/>}</button> : `${activeStages[0].stage} · PIC ${activeStages[0].pic}`)}
      </strong></div>
      <div><span>Pembayaran</span><strong data-testid={`att-row-payment-${order.order_number}`}>{order.payment_status || "—"}{remaining>0 ? ` · Sisa ${money(remaining)}` : ""}</strong></div>
      <div><span>Pengambilan</span><strong>{order.pickup_status || "Belum Diambil"}</strong></div>
    </div>
    {multiTeam && expand && <div className="att-multiteam" data-testid={`att-row-multiteam-${order.order_number}`}>
      {activeStages.map((s, i) => <div key={i} className="att-multiteam-row"><b>{s.name}</b><span>{s.stage}</span><span className="muted small">PIC {s.pic}</span></div>)}
    </div>}
    <div className="att-row-actions">
      {order.whatsapp && <a
        href={`https://wa.me/${(order.whatsapp||"").replace(/[^0-9]/g,"")}`}
        target="_blank" rel="noreferrer"
        className="soft-btn small-btn"
        data-testid={`att-row-wa-${order.order_number}`}
        onClick={e=>e.stopPropagation()}
      ><Phone size={14}/>Hubungi</a>}
      <button type="button" className="soft-btn small-btn" data-testid={`att-row-open-${order.order_number}`} onClick={()=>onOpen(order)}><Eye size={15}/>Lihat Detail</button>
    </div>
  </div>;
}

// Iter 585 — Ringkasan pemantauan Admin Toko (jumlah nota unik dari SELURUH pesanan, bukan hasil filter).
const OM_TILES = [
  { k: "overdue", label: "Terlambat", hint: "Lewat deadline, belum selesai", tone: "red", Icon: AlertTriangle },
  { k: "today", label: "Deadline Hari Ini", hint: "Aktif, deadline hari ini", tone: "amber", Icon: Clock },
  { k: "unpaid", label: "Belum Lunas", hint: "Masih ada sisa tagihan", tone: "amber", Icon: Wallet },
  { k: "pending", label: "Selesai Belum Diambil", hint: "Produksi selesai, menunggu diambil", tone: "green", Icon: PackageOpen },
];
function OrdersMonitorSummary({ counts, pickupFilter, attentionFilter, onPick, onClear, scopeNote }) {
  const active = OM_TILES.find(t => t.k === pickupFilter);
  return (
    <div className="om-summary" data-testid="orders-monitor-summary">
      <div className="om-tiles">
        {OM_TILES.map(({ k, label, hint, tone, Icon }) => (
          <button key={k} type="button" className={`om-tile om-${tone} ${pickupFilter === k ? "is-active" : ""} ${(counts[k] || 0) === 0 ? "is-zero" : ""}`}
            aria-pressed={pickupFilter === k} onClick={() => onPick(k)} data-testid={`orders-summary-${k}`}>
            <span className="om-tile-top"><Icon size={15} aria-hidden="true"/>{label}</span>
            <b className="om-count" data-testid={`orders-summary-${k}-count`}>{counts[k] || 0}</b>
            <span className="om-hint">{hint}</span>
          </button>
        ))}
      </div>
      <div className="om-scope muted small">
        <span data-testid="orders-summary-scope">{scopeNote}</span>
        {(active || attentionFilter) && <>
          {" "}<span className="om-active-chip" data-testid="orders-summary-active">Filter aktif: {active ? active.label : "Dari Dashboard"}</span>
          <button type="button" className="om-clear" onClick={onClear} data-testid="orders-summary-clear"><X size={13} aria-hidden="true"/> Hapus Filter</button>
        </>}
      </div>
    </div>
  );
}

function OrdersSection({ query, onQuery, attentionFilter, onClearAttention, pickupFilter, onPickupFilter, orderDateFilter, onClearOrderDateFilter, rows, baseRows, onOpen, onDuplicate, subtab: subtabProp, onSubtabChange, isAdminToko = false, user, operator, onOrderUpdated }) {
  // Draft input yang dikirim ke query saat user submit (Enter / klik Cari).
  const [draft, setDraft] = useState(query || "");
  // Iter 214 — State pelanggan sering (≥ 3 nota) + filter chip.
  const [frequentSet, setFrequentSet] = useState(new Set());
  const [filterFrequent, setFilterFrequent] = useState(false);
  const [exportingExcel, setExportingExcel] = useState(false);
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await axios.get(`${API}/customers/list`, { withCredentials: true });
        if (cancelled) return;
        const set = new Set();
        (r.data || []).forEach(c => {
          if (Number(c.count || 0) >= 3) {
            // Key: nama|wa untuk match kartu order
            set.add(`${c.name || ""}|${c.whatsapp || ""}`);
          }
        });
        setFrequentSet(set);
      } catch (e) { /* fallback: kosong; chip tidak tampil */ }
    })();
    return () => { cancelled = true; };
  }, []);
  const exportCustomersExcel = async () => {
    if (exportingExcel) return;
    setExportingExcel(true);
    try {
      const r = await axios.get(`${API}/customers/export.xlsx`, { responseType: "blob", withCredentials: true });
      const url = window.URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `pelanggan-tamfaris-${new Date().toISOString().slice(0,10)}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => window.URL.revokeObjectURL(url), 400);
      notify.success({ title: "Ekspor selesai", message: "File Excel berisi daftar pelanggan sudah diunduh." });
    } catch (e) {
      notify.error({ title: "Gagal ekspor", message: e.response?.status === 403 ? "Hanya Owner atau Admin Toko yang dapat mengekspor." : "Silakan coba lagi." });
    } finally { setExportingExcel(false); }
  };
  // Sub-tab: daftar Pesanan vs Riwayat perubahan (read-only). Bisa dikontrol dari parent.
  const [subtabInternal, setSubtabInternal] = useState("orders");
  const subtab = subtabProp !== undefined ? subtabProp : subtabInternal;
  const setSubtab = (v) => { if (onSubtabChange) onSubtabChange(v); else setSubtabInternal(v); };
  // Filter dropdown lokal (client-side, di atas rows yg sudah difilter parent).
  const [fPayment, setFPayment] = useState("");
  const [fOrder, setFOrder] = useState("");
  const [fStage, setFStage] = useState("");
  // Iter 101 — Dropdown urutan (Deadline default / Sisa Tagihan / Baru Dibuat).
  // Sort ini menimpa sort dari parent (yg selalu memakai "deadline") saat user memilih lain.
  const [sortMode, setSortMode] = useState("deadline");
  // Iter 585 — Mode pemantauan (Admin Toko): default hanya pesanan aktif; selesai-diambil/dikirim/batal via "Tampilkan Semua".
  const [activeOnly, setActiveOnly] = useState(true);
  const todayISO = new Intl.DateTimeFormat("en-CA", { timeZone:"Asia/Jakarta" }).format(new Date());
  const STAGES = ["Perlu Diperiksa","Mockup","Toko","Gudang","Bordir","Sablon/DTF","Mesin Press","Jersey/Sublim","Selesai"];
  const ORDER_STATUSES = ["Draft","Menunggu Desain","Diproses","Selesai","Diambil","Dikirim","Dibatalkan"];
  const PAY_STATUSES = ["Belum Bayar","DP","Lunas"];
  // Sinkronisasi bila query berubah dari luar (mis. filter dashboard) & saat mount
  useEffect(() => { setDraft(query || ""); }, [query]);
  const submit = (e) => { if (e) e.preventDefault(); onQuery(draft.trim()); };
  const clear = () => { setDraft(""); onQuery(""); };
  const searchActive = !!(query||"").trim();
  const hideInactive = isAdminToko && activeOnly && pickupFilter === "all" && !attentionFilter && !searchActive
    && !(orderDateFilter && orderDateFilter.from);
  const hiddenInactive = hideInactive ? rows.filter(isInactiveOrder).length : 0;
  const displayRows = rows.filter(o => {
    if (hideInactive && isInactiveOrder(o)) return false;
    if (fPayment && String(o.payment_status||"") !== fPayment) return false;
    if (fOrder && String(o.order_status||"") !== fOrder) return false;
    if (fStage) {
      const ps = (o.products||[]).some(p => String(p.production_stage||"") === fStage);
      if (!ps) return false;
    }
    // Iter 214 — Filter Pelanggan Sering (≥ 3 nota)
    if (filterFrequent && !frequentSet.has(`${o.customer_name || ""}|${o.whatsapp || ""}`)) return false;
    return true;
  }).sort((a,b) => {
    // Iter 101 — Sort lokal berdasarkan sortMode: deadline (default) / sisa / created.
    // Semua mode tetap prioritaskan: (1) belum diambil di atas, (2) non-batal di atas.
    const aPicked = a.pickup_status === "Diambil" ? 1 : 0;
    const bPicked = b.pickup_status === "Diambil" ? 1 : 0;
    if (aPicked !== bPicked) return aPicked - bPicked;
    const aCancel = a.order_status === "Dibatalkan" ? 1 : 0;
    const bCancel = b.order_status === "Dibatalkan" ? 1 : 0;
    if (aCancel !== bCancel) return aCancel - bCancel;
    if (sortMode === "sisa") {
      // Sisa tagihan terbesar di atas (0 di bawah).
      return (Number(b.remaining||0) - Number(a.remaining||0)) || (String(a.deadline||"9999-99-99").localeCompare(String(b.deadline||"9999-99-99")));
    }
    if (sortMode === "created") {
      // Baru dibuat di atas — order_date descending (dengan order_time sebagai tie-breaker).
      const aKey = `${a.order_date||""}T${a.order_time||"00:00"}`;
      const bKey = `${b.order_date||""}T${b.order_time||"00:00"}`;
      return bKey.localeCompare(aKey);
    }
    // Default deadline: (1) Terlambat paling atas, (2) hari ini, (3) deadline asc.
    const aOverdue = isOrderLate(a, todayISO) ? 0 : 1;
    const bOverdue = isOrderLate(b, todayISO) ? 0 : 1;
    if (aOverdue !== bOverdue) return aOverdue - bOverdue;
    const aToday = (a.deadline === todayISO && a.pickup_status !== "Diambil") ? 0 : 1;
    const bToday = (b.deadline === todayISO && b.pickup_status !== "Diambil") ? 0 : 1;
    if (aToday !== bToday) return aToday - bToday;
    return String(a.deadline || "9999-99-99").localeCompare(String(b.deadline || "9999-99-99"));
  });
  const filtersActive = !!(fPayment || fOrder || fStage || filterFrequent);
  const clearFilters = () => { setFPayment(""); setFOrder(""); setFStage(""); setFilterFrequent(false); };
  // Iter 255 — Counter chip DIHITUNG DARI `baseRows` (dataset scope baseline: test-order guard
  //   + orderDateFilter). Tidak dipengaruhi pickupFilter/attentionFilter/fPayment/fOrder/fStage
  //   supaya angka Semua/Terlambat/Belum Lunas/Selesai—Belum Diambil/Sudah Diambil tetap stabil.
  //   Fallback ke `rows` untuk cabang pemakaian lama yang belum kirim baseRows (safety net).
  const _countSource = Array.isArray(baseRows) ? baseRows : rows;
  const counts = useMemo(() => {
    const all = _countSource.length;
    let unpaid = 0, pending = 0, picked = 0, overdue = 0, today = 0;
    const _today = new Intl.DateTimeFormat("en-CA", { timeZone:"Asia/Jakarta" }).format(new Date());
    _countSource.forEach(o => {
      // Iter 224d — Include Draft supaya konsisten dgn backend `counts.unpaid` (dashboard)
      //   dan `/api/receivables`. Nota migrasi legacy dgn `remaining>0` di-set order_status=Draft
      //   oleh Import Nota Lama; mereka tetap piutang riil sampai direklasifikasi Owner.
      if ((o.remaining || 0) > 0 && o.order_status !== "Dibatalkan") unpaid++;
      // Iter 501 — "Selesai — Belum Diambil" (nota unik):
      //   produksi semua produk sudah final + belum diambil + bukan Dibatalkan/Dikirim.
      //   Status existing jadi source-of-truth; tidak membuat state baru.
      const allDone = (o.products||[]).length>0 && (o.products||[]).every(isProductProductionDone);
      if (allDone
          && o.pickup_status !== "Diambil"
          && o.order_status !== "Dibatalkan"
          && o.order_status !== "Dikirim") pending++;
      if (o.pickup_status === "Diambil") picked++;
      // Iter 250 — Terlambat via single source-of-truth `isOrderLate`.
      if (isOrderLate(o, _today)) overdue++;
      if (isDeadlineTodayActive(o, _today)) today++;
    });
    return { all, unpaid, pending, picked, overdue, today };
  }, [_countSource]);
  return <div className={`section ${isAdminToko ? "at-orders-v2" : ""}`}>
    <div className="pickup-filter-tabs orders-subtab-wrap" data-testid="orders-subtab-tabs" style={{marginBottom:12}}>
      <button type="button" data-testid="orders-subtab-orders" className={`mode-tab ${subtab==="orders"?"active":""}`} onClick={()=>setSubtab("orders")}>{isAdminToko ? "Pesanan" : "Daftar Pesanan"}</button>
      <button type="button" data-testid="orders-subtab-history" className={`mode-tab ${subtab==="history"?"active":""}`} onClick={()=>setSubtab("history")}>Riwayat {isAdminToko ? "" : "Perubahan"}</button>
    </div>
    {subtab === "history" ? <HistoryPanel/> : <>
    {isAdminToko && <OrdersMonitorSummary counts={counts} pickupFilter={pickupFilter} attentionFilter={attentionFilter}
      onPick={(k) => { if (attentionFilter && onClearAttention) onClearAttention(); onPickupFilter(pickupFilter === k ? "all" : k); }}
      onClear={() => { if (attentionFilter && onClearAttention) onClearAttention(); onPickupFilter("all"); }}
      scopeNote={(query || "").trim() ? `Angka ringkasan mengikuti hasil pencarian "${(query || "").trim()}" (nota unik).`
        : orderDateFilter && orderDateFilter.from ? "Angka ringkasan mengikuti rentang tanggal yang dipilih (nota unik)."
        : "Angka ringkasan dihitung dari seluruh pesanan (nota unik)."}/>}
    <form className="toolbar order-toolbar" onSubmit={submit} role="search" data-testid="orders-search-form">
      <div className="search order-search">
        <Search size={18}/>
        <input
          data-testid="order-search-input"
          value={draft}
          onChange={e=>{
            const val = e.target.value;
            setDraft(val);
            // Iter 240 — Kalau user menghapus seluruh teks pencarian sampai kosong,
            //   langsung keluar dari mode search (query="") tanpa perlu klik Cari lagi.
            //   Filter lain (fPayment/fOrder/fStage/urutan/attentionFilter/pickupFilter)
            //   tetap terjaga karena tidak disentuh di sini.
            if (val === "" && (query || "") !== "") onQuery("");
          }}
          placeholder={isAdminToko ? "Cari nama, nomor nota, atau WhatsApp" : "Cari nomor Nota, nama pelanggan, WhatsApp"}
          aria-label="Pencarian pesanan"
          enterKeyHint="search"
          type="search"
        />
        {searchActive && <button
          type="button" className="search-clear-btn"
          data-testid="order-search-clear"
          onClick={clear} aria-label="Hapus pencarian"
        ><X size={14}/></button>}
      </div>
      <button
        type="submit"
        className="primary order-search-btn"
        data-testid="order-search-submit"
        disabled={!draft.trim() && !searchActive}
      >Cari</button>
      {/* Iter 356 — Untuk Admin Toko, filter sekunder (status pembayaran/pesanan/tahap/
          urutan + chips Selesai-Belum Diambil/Sudah Diambil) dipindah ke popover
          "Filter" via <details>. data-testid tiap field dipertahankan supaya legacy
          tests tetap valid. Iter 357 — Filter + Lainnya dibungkus dalam satu baris
          toolbar (.at-tools-row) agar sejajar, tidak memakan baris masing-masing. */}
      {isAdminToko ? (
        <div className="at-tools-row" data-testid="at-tools-row">
        <details className="at-filter-pop" data-testid="at-filter-pop" onClick={e=>e.stopPropagation()}>
          <summary className="at-filter-trigger" data-testid="at-filter-trigger" aria-label="Filter lanjutan">
            <Sliders size={14} aria-hidden="true"/>
            <span>Filter</span>
            {filtersActive && <span className="at-filter-dot" aria-hidden="true"/>}
          </summary>
          <div className="at-filter-panel" role="group" aria-label="Panel filter">
            <div className="at-filter-grp">
              <label className="at-filter-grp-lbl">Status pengambilan</label>
              <div className="at-filter-chip-row">
                {/* Iter 501 — Chip "Selesai — Belum Diambil" dipindah ke row quick
                    filter utama supaya langsung terlihat; dihilangkan dari popover
                    agar testid tidak duplikat. "Sudah Diambil" tetap di popover
                    untuk Admin Toko. */}
                <button type="button" data-testid="pickup-filter-sudah-diambil"
                  className={`at-filter-chip ${pickupFilter==="picked"?"active":""}`}
                  onClick={()=>onPickupFilter("picked")}>Sudah Diambil ({counts.picked})</button>
              </div>
            </div>
            <div className="at-filter-grp">
              <label className="at-filter-grp-lbl" htmlFor="at-f-pay">Status Pembayaran</label>
              <select id="at-f-pay" data-testid="filter-payment-status" value={fPayment} onChange={e=>setFPayment(e.target.value)}>
                <option value="">Semua</option>
                {PAY_STATUSES.map(v=><option key={v} value={v}>{v}</option>)}
              </select>
            </div>
            <div className="at-filter-grp">
              <label className="at-filter-grp-lbl" htmlFor="at-f-ord">Status Pesanan</label>
              <select id="at-f-ord" data-testid="filter-order-status" value={fOrder} onChange={e=>setFOrder(e.target.value)}>
                <option value="">Semua</option>
                {ORDER_STATUSES.map(v=><option key={v} value={v}>{v}</option>)}
              </select>
            </div>
            <div className="at-filter-grp">
              <label className="at-filter-grp-lbl" htmlFor="at-f-stage">Tahap Produksi</label>
              <select id="at-f-stage" data-testid="filter-production-stage" value={fStage} onChange={e=>setFStage(e.target.value)}>
                <option value="">Semua</option>
                {STAGES.map(v=><option key={v} value={v}>{v}</option>)}
              </select>
            </div>
            <div className="at-filter-grp">
              <label className="at-filter-grp-lbl" htmlFor="at-f-sort">Urutkan</label>
              <select id="at-f-sort" data-testid="order-sort-mode" value={sortMode} onChange={e=>setSortMode(e.target.value)}>
                <option value="deadline">Deadline terdekat</option>
                <option value="sisa">Sisa tagihan terbesar</option>
                <option value="created">Baru dibuat</option>
              </select>
            </div>
            {filtersActive && <button type="button" data-testid="filter-clear" className="at-filter-clear" onClick={clearFilters}>Hapus semua filter</button>}
          </div>
        </details>
        {/* Iter 357 — Menu "Lainnya" (Ekspor Pelanggan) dipindah ke dalam baris toolbar
            agar sejajar dengan Filter. Non-Admin Toko tetap memakai tombol Ekspor
            lama di .orders-customer-tools. */}
        <details className="at-more-menu at-more-menu-toolbar" data-testid="at-more-menu" onClick={e=>e.stopPropagation()}>
          <summary className="at-more-trigger" aria-label="Menu lainnya">
            <MoreHorizontal size={16} aria-hidden="true"/>
            <span>Lainnya</span>
          </summary>
          <div className="at-more-list" role="menu">
            <button
              type="button"
              role="menuitem"
              data-testid="export-customers-xlsx"
              className="at-more-item"
              disabled={exportingExcel}
              onClick={exportCustomersExcel}
            ><FileDown size={14} aria-hidden="true"/>{exportingExcel ? "Menyiapkan…" : "Ekspor Pelanggan (Excel)"}</button>
          </div>
        </details>
        </div>
      ) : (
        <div className="order-filter-row" data-testid="order-filter-row" style={{display:"flex",gap:8,flexWrap:"wrap",alignItems:"center",width:"100%"}}>
          <select data-testid="filter-payment-status" value={fPayment} onChange={e=>setFPayment(e.target.value)} aria-label="Filter status pembayaran">
            <option value="">Status Pembayaran</option>
            {PAY_STATUSES.map(v=><option key={v} value={v}>{v}</option>)}
          </select>
          <select data-testid="filter-order-status" value={fOrder} onChange={e=>setFOrder(e.target.value)} aria-label="Filter status pesanan">
            <option value="">Status Pesanan</option>
            {ORDER_STATUSES.map(v=><option key={v} value={v}>{v}</option>)}
          </select>
          <select data-testid="filter-production-stage" value={fStage} onChange={e=>setFStage(e.target.value)} aria-label="Filter tahap produksi">
            <option value="">Tahap Produksi</option>
            {STAGES.map(v=><option key={v} value={v}>{v}</option>)}
          </select>
          {/* Iter 101 — Dropdown urutan card */}
          <select data-testid="order-sort-mode" value={sortMode} onChange={e=>setSortMode(e.target.value)} aria-label="Urutkan pesanan">
            <option value="deadline">Urut: Deadline</option>
            <option value="sisa">Urut: Sisa Tagihan</option>
            <option value="created">Urut: Baru Dibuat</option>
          </select>
          {filtersActive && <button type="button" data-testid="filter-clear" className="text-btn" onClick={clearFilters}>Hapus Filter</button>}
        </div>
      )}
      {/* Iter 356 — Chip ringkasan filter aktif (di luar panel popover) agar Admin Toko
          tetap sadar daftar sedang difilter dan bisa cepat menghapus. */}
      {isAdminToko && filtersActive && <div className="at-filter-active-row" data-testid="at-filter-active-row">
        {fPayment && <span className="at-filter-active-pill">Pembayaran: <b>{fPayment}</b>
          <button type="button" onClick={()=>setFPayment("")} aria-label="Hapus filter pembayaran"><X size={12}/></button></span>}
        {fOrder && <span className="at-filter-active-pill">Pesanan: <b>{fOrder}</b>
          <button type="button" onClick={()=>setFOrder("")} aria-label="Hapus filter pesanan"><X size={12}/></button></span>}
        {fStage && <span className="at-filter-active-pill">Tahap: <b>{fStage}</b>
          <button type="button" onClick={()=>setFStage("")} aria-label="Hapus filter tahap"><X size={12}/></button></span>}
        {filterFrequent && <span className="at-filter-active-pill">Pelanggan Sering
          <button type="button" onClick={()=>setFilterFrequent(false)} aria-label="Hapus filter pelanggan sering"><X size={12}/></button></span>}
      </div>}
      {attentionFilter && <div className="att-filter-pill" data-testid="orders-attention-pill">
        <span>Filter: <b>{CAT_LABEL[attentionFilter]}</b></span>
        <button type="button" data-testid="orders-attention-clear" className="text-btn" onClick={onClearAttention}>Hapus filter</button>
      </div>}
      {orderDateFilter && orderDateFilter.from && <div className="att-filter-pill" data-testid="orders-date-pill">
        <span>Periode: <b>{fmtDateID(orderDateFilter.from)} – {fmtDateID(orderDateFilter.to)}</b></span>
        <button type="button" data-testid="orders-date-clear" className="text-btn" onClick={onClearOrderDateFilter}>Hapus filter</button>
      </div>}
      <div className="pickup-filter-tabs" data-testid="pickup-filter-tabs">
        {/* Iter 507 — "Semua" HANYA aktif kalau benar-benar tidak ada filter
            lain yang berjalan. Saat attentionFilter aktif (mis. KPI "Deadline
            Hari Ini" dari Dashboard), highlight utama ada di pill "Filter: ..."
            di atas, bukan di chip Semua. Ini mencegah user bingung ada 2 chip
            terlihat "aktif" bersamaan. */}
        <button type="button" data-testid="pickup-filter-all"
          className={`mode-tab ${pickupFilter==="all" && !attentionFilter ? "active" : ""}`}
          onClick={()=>{ onPickupFilter("all"); if (attentionFilter) onClearAttention && onClearAttention(); }}>
          Semua ({counts.all})
        </button>
        {/* Iter 103 — Quick filter Terlambat untuk fokus overdue */}
        {counts.overdue > 0 && <button type="button" data-testid="pickup-filter-overdue" className={`mode-tab mode-tab-overdue ${pickupFilter==="overdue"?"active":""}`} onClick={()=>onPickupFilter("overdue")}>Terlambat ({counts.overdue})</button>}
        <button type="button" data-testid="pickup-filter-unpaid" className={`mode-tab ${pickupFilter==="unpaid"?"active":""}`} onClick={()=>onPickupFilter("unpaid")}>Belum Lunas ({counts.unpaid})</button>
        {/* Iter 501 — Chip "Selesai — Belum Diambil" juga tersedia sebagai quick
            filter untuk Admin Toko (sebelumnya hanya di popover). Chip "Sudah
            Diambil" tetap di popover untuk Admin Toko (tidak termasuk permintaan). */}
        <button type="button" data-testid="pickup-filter-selesai-belum-diambil" className={`mode-tab ${pickupFilter==="pending"?"active":""}`} onClick={()=>onPickupFilter("pending")}>Selesai — Belum Diambil ({counts.pending})</button>
        {!isAdminToko && <button type="button" data-testid="pickup-filter-sudah-diambil" className={`mode-tab ${pickupFilter==="picked"?"active":""}`} onClick={()=>onPickupFilter("picked")}>Sudah Diambil ({counts.picked})</button>}
      </div>
    </form>
    {/* Iter 214 — Chip Pelanggan Sering (≥ 3 nota) + tombol Ekspor Excel */}
    <div className="orders-customer-tools" data-testid="orders-customer-tools">
      {frequentSet.size > 0 && <button
        type="button"
        data-testid="filter-frequent-toggle"
        className={`frequent-chip ${filterFrequent ? "active" : ""}`}
        aria-pressed={filterFrequent}
        onClick={() => setFilterFrequent(v => !v)}
        title="Pelanggan dengan ≥ 3 nota — filter untuk broadcast atau tindak lanjut"
      ><Star size={13} aria-hidden="true"/>Pelanggan Sering ({frequentSet.size})</button>}
      {/* Iter 356/357 — Admin Toko: Ekspor Pelanggan sekarang berada di menu "Lainnya"
          dalam toolbar (sejajar dengan Filter). Baris customer-tools di sini hanya
          menampilkan chip Pelanggan Sering supaya tidak padat. Non-Admin Toko tetap
          memakai tombol Ekspor Pelanggan di sini (akses legacy terjaga). */}
      {!isAdminToko && <button
        type="button"
        data-testid="export-customers-xlsx"
        className="soft-btn export-customers-btn"
        disabled={exportingExcel}
        onClick={exportCustomersExcel}
        title="Unduh daftar pelanggan (Excel .xlsx) — Owner & Admin Toko"
      ><FileDown size={14} aria-hidden="true"/>{exportingExcel ? "Menyiapkan…" : "Ekspor Pelanggan"}</button>}
    </div>
    {searchActive && <div className="search-status muted small" data-testid="order-search-status">Menampilkan hasil pencarian: <b>{query}</b> · {displayRows.length} pesanan</div>}
    {!searchActive && filtersActive && <div className="search-status muted small" data-testid="order-filter-status">Filter aktif · {displayRows.length} pesanan</div>}
    {isAdminToko && hideInactive && hiddenInactive > 0 && <div className="search-status muted small om-hidden-note" data-testid="orders-active-only-note">
      Menampilkan {displayRows.length} pesanan aktif · {hiddenInactive} nota tuntas (diambil/dikirim & lunas) atau batal disembunyikan.{" "}
      <button type="button" className="text-btn" data-testid="orders-show-all" onClick={() => setActiveOnly(false)}>Tampilkan Semua Pesanan</button></div>}
    {isAdminToko && !activeOnly && pickupFilter === "all" && !attentionFilter && !searchActive && <div className="search-status muted small om-hidden-note" data-testid="orders-all-note">
      Menampilkan semua pesanan termasuk yang sudah diambil/dikirim/batal.{" "}
      <button type="button" className="text-btn" data-testid="orders-show-active" onClick={() => setActiveOnly(true)}>Kembali ke Pesanan Aktif</button></div>}
    {/* Iter 69/234 — Quick chip filter payment (Semua/Lunas/DP/Belum Lunas).
        Counter dihitung dari basis `rows` (yg sudah difilter primer oleh parent:
        attentionFilter/pickupFilter/orderDateFilter) + semua filter sekunder LAIN
        (fOrder, fStage, filterFrequent) — kecuali fPayment itu sendiri, supaya
        angka pada tiap chip = jumlah kartu yang akan tampil kalau chip itu diklik.
        Strict match "Belum Bayar" (bukan else) supaya konsisten dgn filter di
        displayRows (line di atas). */}
    {(() => {
      const baseForPayChips = rows.filter(o => {
        if (fOrder && String(o.order_status||"") !== fOrder) return false;
        if (fStage) {
          const ps = (o.products||[]).some(p => String(p.production_stage||"") === fStage);
          if (!ps) return false;
        }
        if (filterFrequent && !frequentSet.has(`${o.customer_name || ""}|${o.whatsapp || ""}`)) return false;
        return true;
      });
      const cnt = { all: baseForPayChips.length, paid: 0, dp: 0, unpaid: 0 };
      baseForPayChips.forEach(r => {
        const s = String(r.payment_status||"");
        if (s === "Lunas") cnt.paid++;
        else if (s === "DP") cnt.dp++;
        else if (s === "Belum Bayar") cnt.unpaid++;
      });
      const chips = [
        { key: "", label: "Semua", count: cnt.all, tone: "" },
        { key: "Lunas", label: "Lunas", count: cnt.paid, tone: "paid" },
        { key: "DP", label: "DP", count: cnt.dp, tone: "dp" },
        { key: "Belum Bayar", label: "Belum Bayar", count: cnt.unpaid, tone: "unpaid" },
      ];
      return <div className="pay-chip-row" data-testid="pay-chip-row" role="tablist">
        {chips.map(c => <button
          type="button"
          key={c.key || "all"}
          role="tab"
          data-testid={`pay-chip-${c.key ? c.key.toLowerCase().replace(" ","-") : "all"}`}
          className={`pay-chip ${fPayment===c.key?"active":""} tone-${c.tone||"neutral"}`}
          onClick={()=>setFPayment(c.key)}
          aria-pressed={fPayment===c.key}
        >{c.label} <span className="pay-chip-count">{c.count}</span></button>)}
      </div>;
    })()}
    {/* Iter 68 — Semua role (Owner/Admin) pakai card view; OrderTable legacy dipertahankan untuk backward compat. */}
    <OrdersCardList rows={displayRows} onOpen={onOpen} onDuplicate={onDuplicate} frequentSet={frequentSet} query={query} user={user} operator={operator} onOrderUpdated={onOrderUpdated} isAdminToko={isAdminToko}/>
    </>}
  </div>;
}

function ReceiptsByMethodSection({ from, to, receipts }) {
  const items = receipts || [];
  // Iter 368 — Sembunyikan section bila tidak ada penerimaan pada periode aktif,
  //   agar dashboard tidak menampilkan box besar kosong "Belum ada penerimaan …".
  if (items.length === 0) return null;
  const total = items.reduce((s,i) => ({ count: s.count + i.count, amount: s.amount + i.total }), { count: 0, amount: 0 });
  // Iter 401 — Rombak dari table HTML klasik menjadi list card responsive.
  // Alasan: table rawan overflow horizontal di mobile, hardcoded cream TOTAL
  // row tidak kompatibel dark mode. List pakai `.receipts-list` + modifier
  // row/total yang theme-aware (light & dark). Logic kalkulasi TIDAK diubah.
  return <div className="section att-section" data-testid="receipts-section">
    <div className="section-title">
      <h3>Penerimaan per Rekening/Metode</h3>
      <span className="muted small">Dihitung dari <b>tanggal transaksi pembayaran</b> (paid_at). QRIS terpisah, tidak digandakan.</span>
    </div>
    <ul className="receipts-list" data-testid="receipts-table" aria-label="Penerimaan per rekening/metode">
      <li className="receipts-row receipts-row--head" aria-hidden="true">
        <span className="receipts-col-method">Rekening / Metode</span>
        <span className="receipts-col-count">Trx</span>
        <span className="receipts-col-amount">Total (Rp)</span>
      </li>
      {items.map((it, i) => <li key={it.method} className="receipts-row" data-testid={`receipts-row-${i}`}>
        <span className="receipts-col-method" data-testid={`receipts-method-${i}`}>
          <b>{it.method}</b>
        </span>
        <span className="receipts-col-count"><span className="receipts-col-label">Trx</span>{it.count}</span>
        <span className="receipts-col-amount">
          <span className="receipts-col-label">Total</span>
          <span className="receipts-amount-value">{money(it.total)}</span>
        </span>
      </li>)}
      <li className="receipts-row receipts-row--total" data-testid="receipts-total-row">
        <span className="receipts-col-method"><b>TOTAL</b></span>
        <span className="receipts-col-count" data-testid="receipts-total-count">
          <span className="receipts-col-label">Trx</span>{total.count}
        </span>
        <span className="receipts-col-amount" data-testid="receipts-total-amount">
          <span className="receipts-col-label">Total</span>
          <span className="receipts-amount-value">{money(total.amount)}</span>
        </span>
      </li>
    </ul>
  </div>;
}

function PeriodBar({ period, from, to, onChange }) {
  const todayISO = new Intl.DateTimeFormat("en-CA", { timeZone:"Asia/Jakarta" }).format(new Date());
  const monthISO = todayISO.slice(0,8) + "01";
  const dow = new Date(todayISO+"T00:00:00").getDay();
  const monday = (() => { const d=new Date(todayISO+"T00:00:00"); d.setDate(d.getDate() - ((dow+6)%7)); return d.toISOString().slice(0,10); })();
  return <div className="period-bar" data-testid="period-bar">
    <button type="button" data-testid="period-today" className={`mode-tab ${period==="today"?"active":""}`} onClick={()=>onChange({period:"today",from:todayISO,to:todayISO})}>Hari Ini</button>
    <button type="button" data-testid="period-week" className={`mode-tab ${period==="week"?"active":""}`} onClick={()=>onChange({period:"week",from:monday,to:todayISO})}>Minggu Ini</button>
    <button type="button" data-testid="period-month" className={`mode-tab ${period==="month"?"active":""}`} onClick={()=>onChange({period:"month",from:monthISO,to:todayISO})}>Bulan Ini</button>
    <button type="button" data-testid="period-custom" className={`mode-tab ${period==="custom"?"active":""}`} onClick={()=>onChange({period:"custom",from:from||monthISO,to:to||todayISO})}>Rentang</button>
    {period==="custom" && <>
      <label className="receipts-range">Dari <input type="date" data-testid="period-from" value={from} onChange={e=>onChange({period:"custom",from:e.target.value,to})}/></label>
      <label className="receipts-range">Sampai <input type="date" data-testid="period-to" value={to} onChange={e=>onChange({period:"custom",from,to:e.target.value})}/></label>
    </>}
  </div>;
}

function KpiTile({ label, value, sub, secondary, testid, tone, onClick }) {
  const clickable = typeof onClick === "function";
  const Comp = clickable ? "button" : "div";
  return <Comp type={clickable?"button":undefined} className={`kpi-tile ${tone||""} ${clickable?"kpi-clickable":""}`} data-testid={testid} onClick={onClick}>
    <span className="kpi-label">{label}</span>
    <strong className="kpi-value" data-testid={`${testid}-value`}>{value}</strong>
    {sub && <span className="kpi-sub">{sub}</span>}
    {secondary && <span className="kpi-secondary" data-testid={`${testid}-secondary`}>{secondary}</span>}
  </Comp>;
}

function currentStageLabel(order) {
  const products = order.products || [];
  if (products.length === 0) return "Menunggu Detail";
  // Iter 223 — Polosan auto-treated production-complete.
  const allDone = products.every(isProductProductionDone);
  const picked = order.pickup_status === "Diambil";
  if (allDone) return picked ? "Sudah Diambil" : "Siap Diambil";
  const inProgress = products.find(p => !isProductProductionDone(p));
  if (inProgress) {
    let stage = String(inProgress.production_stage || "").trim();
    // Map stage generik ke nama yang lebih spesifik.
    const STAGE_MAP = {
      "Perlu Diperiksa": "Menunggu Rute Produksi",
      "Gudang": "Menunggu Gudang",
      "Toko": "Menunggu Toko",
    };
    stage = STAGE_MAP[stage] || stage;
    return stage;
  }
  return "Menunggu Antrean";
}
// Sama persis dgn backend _is_test_order: pola kuat langsung uji; kata "test" di tengah nama
//   (mis. "Rina Tester") hanya uji bila nomor WA = nomor fixture pengujian.
const TEST_FIXTURE_PHONES = new Set(["081234567890", "6281234567890", "08123456789", "000000000000"]);
const isTestOrderClient = (o) => {
  if (o?.is_test === true) return true;
  const on = String(o?.order_number||"").toLowerCase();
  if (on.includes("test") || on.includes("dummy")) return true;
  const cn = String(o?.customer_name||"").trim().toLowerCase();
  if (!cn) return false;
  if (["dummy","debug","tmf-test"].some(k => cn.includes(k))) return true;
  if (cn.startsWith("test_") || cn === "test" || cn.includes("uji_")) return true;
  if (/^uji\d+/.test(cn) || /^iter\d+_/.test(cn) || /^test_iter\d+_/.test(cn)) return true;
  if (cn.includes("test")) return TEST_FIXTURE_PHONES.has(String(o?.whatsapp||"").replace(/\D/g, ""));
  return false;
};

// Tanda tanggal tidak wajar (hanya penanda; tidak mengubah status/terlambat).
const dateAnomaly = (o) => {
  const od = o?.order_date || "", dl = o?.deadline || "";
  if (od && dl && dl < od) return "Deadline sebelum tanggal pesanan";
  const created = String(o?.created_at || "").slice(0, 10);
  if (!o?.is_migrated && od && created && od < created) {
    const days = (Date.parse(created) - Date.parse(od)) / 864e5;
    if (days > 14) return `Tanggal pesanan ${Math.round(days)} hari sebelum nota dibuat`;
  }
  return "";
};

function AdminTokoDashboard({ orders, onNewOrder, onOpen, onGoToOrders, onGoToReceivable, onGoToOrdersByPeriod, onSearch, onGoToProduction }) {
  const todayISO = new Intl.DateTimeFormat("en-CA", { timeZone:"Asia/Jakarta" }).format(new Date());
  const [range, setRange] = useState({ period:"today", from: todayISO, to: todayISO });
  const [kpi, setKpi] = useState(null);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const [txModalOpen, setTxModalOpen] = useState(false);
  const [searchDraft, setSearchDraft] = useState("");
  const submitSearch = (e) => { if(e) e.preventDefault(); const q = searchDraft.trim(); if (!q) return; onSearch && onSearch(q); };
  const loadKpi = async () => {
    setLoading(true); setErr("");
    try {
      const r = await axios.get(`${API}/dashboard/admin-toko?period=${range.period}&from_=${range.from}&to=${range.to}`, { withCredentials: true });
      setKpi(r.data);
    } catch (e) { setErr(e.response?.data?.detail || "Gagal memuat KPI"); }
    finally { setLoading(false); }
  };
  useEffect(() => { loadKpi(); /* eslint-disable-next-line */ }, [range.period, range.from, range.to]);
  // Iter 221k2 — Include Draft & Selesai supaya "unpaid"/"ready" ikut dihitung.
  const opsOrders = orders.filter(o =>
    o.order_status !== "Dibatalkan" && o.order_status !== "Diambil" &&
    o.order_status !== "Dikirim" && !isTestOrderClient(o)
  );
  // Iter 503 — `enriched`/`attentionRows` lama (unpaid+ready mix) dihapus;
  //   logic prioritas dipindah ke komponen `PrioritasPesanan` tanpa pembayaran.
  const netOmzet = kpi ? (Number(kpi.omzet?.gross) || 0) : 0;
  const cancelledOmzet = kpi ? (Number(kpi.omzet?.cancelled) || 0) : 0;
  const cancelledCount = kpi ? (Number(kpi.omzet?.cancelled_count) || 0) : 0;
  return <>
    {err && <div className="att-error" data-testid="kpi-error">{err}</div>}
    {/* Iter 226 — Period picker Admin Toko: quick chips + tanggal/bulan/tahun (TANPA rentang custom). */}
    <div className="at-period-wrap" data-testid="at-period-wrap">
      {/* Iter 464 — Hilangkan label aktif besar di kanan panel (redundan dgn
          chip aktif). Hanya sisakan eyebrow "Periode" di kiri agar chip tidak
          berebut tempat dengan teks label. */}
      <div className="at-period-label"><span>Periode</span></div>
      <PeriodPicker
        value={range}
        allowRange={false}
        testidPrefix="at-period"
        onChange={({period:np, from:nf, to:nt})=>{
          setRange({ period: np, from: nf || range.from, to: (nt || (np==="range" ? range.to : (nf || range.from))) });
        }}
      />
    </div>
    {loading && !kpi && <div className="empty" data-testid="kpi-loading">Memuat KPI…</div>}
    {kpi && <>
      <div className="at-hero-grid" data-testid="at-hero-grid">
        <div className="at-hero-card" data-testid="kpi-omzet" onClick={()=>onGoToOrdersByPeriod && onGoToOrdersByPeriod(range)} role="button" tabIndex={0}>
          <div className="at-hero-icon green"><ShoppingCart size={22}/></div>
          <div className="at-hero-label">Omzet</div>
          <div className="at-hero-value" data-testid="kpi-omzet-value">{moneyShort(netOmzet)}</div>
          <div className="at-hero-sub">{kpi.omzet.orders} Nota valid{cancelledCount > 0 ? ` · Dibatalkan ${cancelledCount}` : ""}</div>
        </div>
        <div className="at-hero-card" data-testid="kpi-uang-masuk" onClick={()=>setTxModalOpen(true)} role="button" tabIndex={0}>
          <div className="at-hero-icon blue"><WalletCards size={22}/></div>
          <div className="at-hero-label">Uang Masuk</div>
          <div className="at-hero-value" data-testid="kpi-uang-masuk-value">{moneyShort(kpi.uang_masuk.amount)}</div>
          <div className="at-hero-sub">{kpi.uang_masuk.tx_count} transaksi</div>
        </div>
      </div>
      <div className="at-tile-grid at-tile-grid-4" data-testid="at-tile-grid">
        {/* Iter 503 — Perlu Perhatian: 4 indikator operasional yang semuanya
            berdasarkan source-of-truth existing (`counts.overdue/near/ready/unpaid`
            dari `/dashboard/admin-toko`). KPI "Nota Aktif" & "Sedang Diproses"
            dihapus dari dashboard (keduanya overlap; akses tetap lewat halaman
            Pesanan). "Piutang Aktif" naik ke grid supaya 1 baris penuh — row
            terpisah di bawah dihapus (dedup). */}
        <button type="button" className="at-tile overdue" data-testid="kpi-overdue" onClick={()=>onGoToOrders("overdue")}>
          <div className="at-tile-icon"><Clock size={18}/></div>
          <div className="at-tile-label">Terlambat</div>
          <div className="at-tile-value">{kpi.counts.overdue}</div>
        </button>
        <button type="button" className="at-tile near" data-testid="kpi-near" onClick={()=>onGoToOrders("near")}>
          <div className="at-tile-icon"><AlertCircle size={18}/></div>
          <div className="at-tile-label">Deadline Hari Ini</div>
          <div className="at-tile-value">{kpi.counts.near}</div>
        </button>
        <button type="button" className="at-tile ready" data-testid="kpi-ready" onClick={()=>onGoToOrders("ready")}>
          <div className="at-tile-icon"><Package size={18}/></div>
          <div className="at-tile-label">Selesai Belum Diambil</div>
          <div className="at-tile-value">{kpi.counts.ready ?? 0}</div>
        </button>
        <button type="button" className="at-tile piutang" data-testid="kpi-piutang"
          onClick={()=>onGoToReceivable && onGoToReceivable()}>
          <div className="at-tile-icon"><WalletCards size={18}/></div>
          <div className="at-tile-label">Piutang Aktif</div>
          <div className="at-tile-value" data-testid="kpi-piutang-value">
            {kpi.piutang && kpi.piutang.total ? moneyShort(kpi.piutang.total) : "Rp 0"}
          </div>
          <div className="at-tile-sub">{kpi.piutang?.orders || 0} Nota</div>
        </button>
      </div>
    </>}
    <button type="button" className="at-cta-nota" data-testid="new-order-button" onClick={onNewOrder}>
      <Plus/> Nota Baru
    </button>
    {/* Iter 503 — "Prioritas Pesanan" (sebelumnya "Produksi Hari Ini"):
        1 nota = 1 kartu, maks 5. Prioritas: Terlambat → Deadline hari ini →
        Perlu Diperiksa (bermasalah). Pembayaran TIDAK dicampur sebagai penentu.
        Reuse `attentionCats` + `orders` prop; tidak membuat endpoint baru. */}
    <PrioritasPesanan orders={opsOrders} todayISO={todayISO}
      onOpen={onOpen} onGoToProduction={()=>onGoToProduction && onGoToProduction()}/>
    {kpi && <ReceiptsByMethodSection from={range.from} to={range.to} receipts={kpi.receipts_by_method}/>}
    {txModalOpen && <TransactionsModal period={range.period} from={range.from} to={range.to} onClose={()=>setTxModalOpen(false)}/>}
  </>;
}

// Iter 503 — Section "Prioritas Pesanan" di Dashboard Admin Toko.
//   1 nota = 1 kartu. Maks 5. Urutan: Terlambat (0) → Deadline Hari Ini (1) →
//   Perlu Diperiksa (2). Payment status TIDAK dipakai sebagai penentu agar
//   sinkron dengan permintaan user "jangan mencampurkan status pembayaran
//   sebagai penentu keterlambatan produksi".
//   Reuse: `attentionCats`, `isOrderLate`, `isProductProductionDone`.
function PrioritasPesanan({ orders, todayISO, onOpen, onGoToProduction }) {
  const rows = (orders || []).map(o => {
    const cats = attentionCats(o, todayISO);
    const isToday = (o.deadline || "") === todayISO;
    const hasPerluCheck = (o.products || []).some(p => (p.production_stage || "") === "Perlu Diperiksa");
    const allDone = (o.products || []).length > 0 && (o.products || []).every(isProductProductionDone);
    // Score lebih kecil = prioritas lebih tinggi. 99 = tidak ditampilkan.
    let score = 99;
    let badge = null; // {text, cls}
    if (cats.has("overdue")) {
      score = 0;
      const daysLate = Math.max(1, Math.round((new Date(todayISO) - new Date(o.deadline || todayISO)) / 86400000));
      badge = { text: `Terlambat ${daysLate} hari`, cls: "pp-badge-late" };
    } else if (isToday && !allDone && o.order_status !== "Dibatalkan"
               && o.order_status !== "Diambil" && o.order_status !== "Dikirim"
               && o.pickup_status !== "Diambil") {
      score = 1;
      badge = { text: "Deadline Hari Ini", cls: "pp-badge-today" };
    } else if (hasPerluCheck) {
      score = 2;
      badge = { text: "Perlu Diperiksa", cls: "pp-badge-warn" };
    }
    return { o, score, badge };
  }).filter(r => r.score < 99)
    .sort((a, b) => {
      if (a.score !== b.score) return a.score - b.score;
      return (a.o.deadline || "9999-12-31").localeCompare(b.o.deadline || "9999-12-31");
    })
    .slice(0, 5);

  // Ringkas tahap sekarang (reuse logic yang paling dekat dengan ProductionToday).
  const stageOf = (o) => {
    const active = (o.products || [])
      .map(p => p.production_stage || "")
      .filter(s => s && s !== "Selesai" && s !== "Perlu Diperiksa");
    const uniq = Array.from(new Set(active));
    if (uniq.length === 0) {
      if ((o.products || []).some(p => (p.production_stage || "") === "Perlu Diperiksa")) return "Perlu Diperiksa";
      return "Produksi selesai";
    }
    if (uniq.length === 1) return uniq[0];
    return uniq.join(" · ");
  };
  const prodSummary = (o) => {
    const prods = o.products || [];
    if (prods.length === 0) return "Belum ada produk";
    const totalQty = prods.reduce((s, p) => s + (Number(p.quantity) || (p.sizes || []).reduce((a, b) => a + Number(b.quantity || 0), 0)), 0);
    const head = prods.slice(0, 2).map(p => (p.custom_name || p.name || "Produk")).join(", ");
    const more = prods.length > 2 ? ` +${prods.length - 2} lagi` : "";
    return `${head}${more}${totalQty > 0 ? ` · ${totalQty} pcs` : ""}`;
  };

  return <section className="at-prioritas" data-testid="at-prioritas">
    <div className="at-prioritas-head">
      <div className="at-prioritas-title">
        <AlertTriangle size={16} aria-hidden="true"/>
        <strong>Prioritas Pesanan</strong>
      </div>
      <button type="button" className="at-prioritas-more text-btn small-btn"
        onClick={onGoToProduction} data-testid="at-prioritas-see-all">
        Lihat Semua <ChevronRight size={13}/>
      </button>
    </div>
    {rows.length === 0 ? (
      <div className="at-prioritas-empty" data-testid="at-prioritas-empty">
        Tidak ada pesanan prioritas saat ini.
      </div>
    ) : (
      <ul className="at-prioritas-list" data-testid="at-prioritas-list">
        {rows.map(({ o, badge }) => (
          <li key={o.order_number} className="at-prioritas-item"
            data-testid={`at-prioritas-item-${o.order_number}`}>
            <button type="button" className="at-prioritas-card"
              onClick={() => onOpen && onOpen(o)}
              aria-label={`Buka ${o.order_number}`}>
              <div className="at-prioritas-top">
                <div className="at-prioritas-cust">
                  <strong>{o.customer_name || "—"}</strong>
                  <span className="at-prioritas-nota">{o.order_number}</span>
                </div>
                {badge && (
                  <span className={`at-prioritas-badge ${badge.cls}`}
                    data-testid={`at-prioritas-badge-${o.order_number}`}>
                    {badge.text}
                  </span>
                )}
              </div>
              <div className="at-prioritas-mid">{prodSummary(o)}</div>
              <div className="at-prioritas-bot">
                <span className="at-prioritas-stage">
                  <Factory size={12} aria-hidden="true"/> {stageOf(o)}
                </span>
                <span className="at-prioritas-dl">
                  <Calendar size={12} aria-hidden="true"/>
                  {o.deadline ? new Date(o.deadline).toLocaleDateString("id-ID", { day: "numeric", month: "short" }) : "—"}
                </span>
              </div>
            </button>
          </li>
        ))}
      </ul>
    )}
  </section>;
}

function TransactionsModal({ period, from, to, onClose }) {
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    axios.get(`${API}/dashboard/admin-toko/transactions?period=${period}&from_=${from}&to=${to}`, { withCredentials: true })
      .then(r => setData(r.data)).catch(e => setErr(e.response?.data?.detail || "Gagal memuat transaksi"));
  }, [period, from, to]);
  return <div className="modal-backdrop" data-testid="transactions-modal" onClick={onClose}>
    <div className="modal-panel wide" onClick={e=>e.stopPropagation()}>
      <div className="modal-head" style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
        <h3 style={{margin:0}}>Transaksi Pembayaran</h3>
        <button type="button" className="icon-btn" onClick={onClose} data-testid="transactions-modal-close" aria-label="Tutup"><X size={16}/></button>
      </div>
      <p className="muted small" style={{marginTop:0}}>{fmtDateID(from)} → {fmtDateID(to)}</p>
      {err && <div className="att-error">{err}</div>}
      {!data && !err && <div className="empty">Memuat…</div>}
      {data && data.items.length === 0 && <div className="empty" data-testid="transactions-empty">Tidak ada transaksi pada periode ini.</div>}
      {data && data.items.length > 0 && <>
        <div className="tx-summary" data-testid="transactions-summary">
          <span>{data.count} transaksi</span> · <strong>{money(data.total)}</strong>
        </div>
        <div className="table-wrap tx-wrap"><table data-testid="transactions-table">
          <thead><tr><th>Tanggal</th><th>Nota</th><th>Pelanggan</th><th>Metode</th><th style={{textAlign:"right"}}>Nominal</th></tr></thead>
          <tbody>
            {data.items.map((t,i) => <tr key={(t.transaction_number||"")+i} data-testid={`transactions-row-${i}`}>
              <td><small>{fmtDateTimeID(t.paid_at)}</small></td>
              <td><small className="muted">{t.order_number}</small></td>
              <td>{t.customer_name}</td>
              <td>{t.method || "—"}</td>
              <td style={{textAlign:"right",fontFamily:"'Space Mono', monospace"}}>{money(t.amount)}</td>
            </tr>)}
          </tbody>
        </table></div>
      </>}
    </div>
  </div>;
}

function AdminTokoNotif({ orders, open, onToggle, onClose, onOpenOrder, onGoToOrders }) {
  // Hitung overdue + hampir deadline dari orders yg tidak dibatalkan/diambil/draft.
  const todayISO = new Intl.DateTimeFormat("en-CA", { timeZone:"Asia/Jakarta" }).format(new Date());
  const active = (orders||[]).filter(o => !["Dibatalkan","Draft","Diambil","Dikirim"].includes(String(o.order_status||"")) && !isTestOrderClient(o));
  const enriched = active.map(o => {
    const cats = attentionCats(o, todayISO);
    return { o, cats, isOverdue: cats.has("overdue"), isNear: cats.has("near") };
  });
  const overdue = enriched.filter(x => x.isOverdue).sort((a,b)=>(a.o.deadline||"").localeCompare(b.o.deadline||""));
  const near = enriched.filter(x => !x.isOverdue && x.isNear).sort((a,b)=>(a.o.deadline||"").localeCompare(b.o.deadline||""));
  const total = overdue.length + near.length;
  const popRef = useRef(null);
  useEffect(() => {
    if (!open) return;
    const onDoc = (e) => { if (popRef.current && !popRef.current.contains(e.target)) onClose(); };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, [open, onClose]);
  return <div className="at-notif-wrap" ref={popRef}>
    <button
      type="button"
      className="at-notif-btn"
      data-testid="at-notif-btn"
      onClick={onToggle}
      aria-label={`Notifikasi (${total})`}
    >
      <Bell size={20}/>
      {total > 0 && <span className="at-notif-badge" data-testid="at-notif-badge">{total > 99 ? "99+" : total}</span>}
    </button>
    {open && <div className="at-notif-pop" data-testid="at-notif-pop" role="menu">
      <div className="at-notif-head">
        <b>Notifikasi</b>
        <span className="at-hero-sub">{total} pesanan perlu perhatian</span>
      </div>
      {total === 0 && <div className="empty" data-testid="at-notif-empty" style={{padding:"18px 12px"}}>Tidak ada pesanan yang butuh perhatian saat ini.</div>}
      {overdue.length > 0 && <div className="at-notif-group" data-testid="at-notif-group-overdue">
        <div className="at-notif-group-head">
          <span className="at-notif-dot overdue"/>
          <span>Terlambat · {overdue.length}</span>
          <button type="button" className="at-see-all" data-testid="at-notif-see-overdue" onClick={()=>onGoToOrders("overdue")}>Lihat semua<ChevronRight size={12}/></button>
        </div>
        <div className="at-notif-list">
          {overdue.slice(0,5).map(({o}) => <button type="button" key={o.order_number} className="at-notif-row" data-testid={`at-notif-row-${o.order_number}`} onClick={()=>onOpenOrder(o)}>
            <div className="at-notif-row-left">
              <b>{o.order_number}</b>
              <span className="at-hero-sub">{o.customer_name || "—"}</span>
            </div>
            <div className="at-notif-row-right">
              <span className="at-chip chip-cancel">Terlambat</span>
              <span className="at-hero-sub">{fmtDateID(o.deadline)}</span>
            </div>
          </button>)}
        </div>
      </div>}
      {near.length > 0 && <div className="at-notif-group" data-testid="at-notif-group-near">
        <div className="at-notif-group-head">
          <span className="at-notif-dot near"/>
          <span>Deadline Hari Ini · {near.length}</span>
          <button type="button" className="at-see-all" data-testid="at-notif-see-near" onClick={()=>onGoToOrders("near")}>Lihat semua<ChevronRight size={12}/></button>
        </div>
        <div className="at-notif-list">
          {near.slice(0,5).map(({o}) => <button type="button" key={o.order_number} className="at-notif-row" data-testid={`at-notif-row-${o.order_number}`} onClick={()=>onOpenOrder(o)}>
            <div className="at-notif-row-left">
              <b>{o.order_number}</b>
              <span className="at-hero-sub">{o.customer_name || "—"}</span>
            </div>
            <div className="at-notif-row-right">
              <span className="at-chip chip-dp">Deadline dekat</span>
              <span className="at-hero-sub">{fmtDateID(o.deadline)}</span>
            </div>
          </button>)}
        </div>
      </div>}
    </div>}
  </div>;
}

function ProductionToday({ orders, onOpen, onGoToProduction }) {
  const todayISO = new Intl.DateTimeFormat("en-CA", { timeZone:"Asia/Jakarta" }).format(new Date());
  const rows = [];
  (orders||[]).forEach(o => {
    if (isTestOrderClient(o)) return;
    if (["Dibatalkan","Draft","Diambil"].includes(String(o.order_status||""))) return;
    if ((o.deadline||"") !== todayISO) return;
    (o.products || []).forEach(p => {
      const stage = String(p.production_stage || "");
      if (stage === "Selesai") return;
      rows.push({ order: o, product: p, stage });
    });
  });
  // Iter 368 — Section disembunyikan sepenuhnya bila kosong, agar dashboard tidak
  //   menampilkan box besar "tidak ada produk ...". Jika data tersedia, render seperti biasa.
  if (rows.length === 0) return null;
  // Iter 400 — Badge utama = DIVISI (bukan nama orang) agar user langsung tahu
  // pesanan ada di bagian mana. Nama PIC tetap bisa ditampilkan sebagai teks
  // sekunder kecil "Oleh {pic}". Tidak mengubah logic produksi.
  const divisionOf = (stage) => STAGE_DIVISION_LABEL[stage] || STAGE_TEAM_LABEL[stage] || stage || "—";
  const picOf = (product, stage) => String(product.production_pic || "").trim() || STAGE_TEAM_LABEL[stage] || "";
  return <>
    <div className="at-section-head">
      <h3>Produksi Hari Ini</h3>
      <button type="button" className="at-see-all" data-testid="at-see-all-production" onClick={onGoToProduction}>Lihat Semua<ChevronRight size={14}/></button>
    </div>
    <div className="at-prod-list" data-testid="at-prod-list">
      {rows.slice(0,8).map(({order, product, stage}, i) => {
        const pic = picOf(product, stage);
        return <button
          type="button"
          key={order.order_number + "|" + (product.id || product._id || i)}
          className="at-prod-row"
          data-testid={`at-prod-row-${i}`}
          onClick={()=>onOpen(order)}
        >
          <div className="at-prod-info">
            <div className="at-prod-name" data-testid={`at-prod-name-${i}`}>{product.name || "—"} <span className="at-hero-sub">×{product.quantity || 1}</span></div>
            <div className="at-hero-sub">{order.order_number} · {order.customer_name}</div>
          </div>
          <div className="at-prod-meta">
            <span className={`at-chip ${stage==='Selesai'?'chip-lunas':stage==='Toko'?'chip-siap':'chip-proses'}`}
              data-testid={`at-prod-chip-${i}`}>{divisionOf(stage)}</span>
            {pic && <span className="at-prod-pic" data-testid={`at-prod-pic-${i}`}>Oleh {pic}</span>}
          </div>
          <ChevronRight className="at-chev" size={18}/>
        </button>;
      })}
    </div>
  </>;
}


function AdminTokoRecentRow({ order, onOpen }) {
  const products = order.products || [];
  const pcs = products.reduce((s,p)=>s + Number(p.quantity||1), 0);
  const primaryName = (products[0]?.name) || "—";
  const amount = Number(order.grand_total || 0);
  const paymentStatus = String(order.payment_status || "");
  const orderStatus = String(order.order_status || "");
  const chipCls = paymentStatus === "Lunas" ? "chip-lunas"
    : paymentStatus === "DP" ? "chip-dp"
    : orderStatus === "Diambil" ? "chip-diambil"
    : orderStatus === "Selesai" ? "chip-siap"
    : orderStatus === "Diproses" ? "chip-proses"
    : orderStatus === "Dibatalkan" ? "chip-cancel"
    : "chip-belum";
  const chipLabel = paymentStatus === "Lunas" ? "Lunas"
    : orderStatus === "Diambil" ? "Diambil"
    : orderStatus === "Selesai" ? "Siap Diambil"
    : orderStatus === "Diproses" ? "Diproses"
    : orderStatus === "Dibatalkan" ? "Batal"
    : paymentStatus === "DP" ? "DP"
    : "Belum Lunas";
  const timeStr = order.updated_at ? new Date(order.updated_at).toLocaleTimeString("id-ID", { hour: "2-digit", minute: "2-digit", timeZone: "Asia/Jakarta" }) : "";
  return <div className="at-recent-row" data-testid={`at-recent-${order.order_number}`} onClick={()=>onOpen(order)} role="button" tabIndex={0}>
    <div className="at-recent-info">
      <div className="at-recent-no">
        <span>{order.order_number}</span>
        <span className={`at-chip ${chipCls}`} data-testid={`at-recent-chip-${order.order_number}`}>{chipLabel}</span>
      </div>
      <div className="at-recent-customer">{order.customer_name} · {pcs} pcs · {primaryName}</div>
    </div>
    <div>
      <div className="at-recent-amount">{"Rp " + Math.round(amount).toLocaleString("id-ID")}</div>
      {timeStr && <div className="at-recent-time">{timeStr}</div>}
    </div>
    <ChevronRight className="at-chev" size={18}/>
  </div>;
}


function CompactAttentionRow({ order, cats, isToday, onOpen }) {
  const stageLabel = currentStageLabel(order);
  const products = order.products || [];
  const remaining = Number(order.remaining ?? Math.max(0, Number(order.grand_total||0) - Number(order.paid||0)));
  const dueBadge = cats.has("overdue") ? "Produksi Terlambat" : isToday ? "Deadline Hari Ini" : cats.has("near") ? "Hampir Deadline" : cats.has("ready") ? "Siap Diambil" : (remaining > 0 ? "Menunggu Pembayaran" : "");
  const qtyStr = products.map(p => `${p.name} ×${p.quantity||1}`).join(" · ");
  const waDigits = (order.whatsapp||"").replace(/[^0-9]/g,"");
  const badgeClass = cats.has("overdue")?"cat-overdue":isToday?"cat-near":cats.has("near")?"cat-near":cats.has("ready")?"cat-ready":"cat-unpaid";
  return <div className="compact-att-row" data-testid={`att-row-${order.order_number}`} onClick={()=>onOpen(order)}>
    <div className="cr-head">
      <div>
        <b className="cr-name">{order.customer_name}</b>
        <span className="cr-no">{order.order_number}</span>
      </div>
      {dueBadge && <span className={`att-badge ${badgeClass}`} data-testid={`att-row-badge-${order.order_number}`}>{dueBadge}</span>}
    </div>
    <div className="cr-body">
      <span className="cr-line" title={qtyStr}>{qtyStr || "—"}</span>
      <span className="cr-line">Deadline: <b>{fmtDateID(order.deadline)}</b> · Tahap: <b data-testid={`att-row-stage-${order.order_number}`}>{stageLabel}</b></span>
    </div>
    <div className="cr-actions">
      {waDigits && <a href={`https://wa.me/${waDigits}`} target="_blank" rel="noreferrer" className="soft-btn small-btn" data-testid={`att-row-wa-${order.order_number}`} onClick={e=>e.stopPropagation()}><Phone size={13}/>Hubungi</a>}
      <button type="button" className="soft-btn small-btn" data-testid={`att-row-open-${order.order_number}`} onClick={e=>{e.stopPropagation();onOpen(order);}}><Eye size={13}/>Detail</button>
    </div>
  </div>;
}

function AdminDashboard({ orders, dash, loading, loadError, query, onQuery, onNewOrder, onOpen, onGoToOrders, onGoToReceivable, onGoToNeedsReview, controlCenter, isAdminToko=false }) {
  const todayISO = new Intl.DateTimeFormat("en-CA", { timeZone:"Asia/Jakarta" }).format(new Date());
  // Iter 221k2 — Untuk hitung counts kategori (termasuk unpaid mirror Piutang),
  //   hanya exclude Dibatalkan. attentionCats() sudah handle semantik final states.
  // Nota uji dipisahkan dari ringkasan & daftar tindak lanjut Owner (tetap ada di menu Pesanan).
  const { enriched, counts, testCount } = useMemo(() => {
    const ops = orders.filter(o => o.order_status !== "Dibatalkan");
    const real = ops.filter(o => !isTestOrderClient(o));
    const en = real.map(o => ({ o, cats: attentionCats(o, todayISO) }));
    const c = { active:0, overdue:0, near:0, wip:0, ready:0, unpaid:0 };
    en.forEach(({cats}) => cats.forEach(k => { if (k in c) c[k]++; }));
    return { enriched: en, counts: c, testCount: ops.length - real.length };
  }, [orders, todayISO]);
  // Search filter (dashboard-level; server-side sudah pre-filter melalui query prop)
  const q = (query||"").trim().toLowerCase();
  const searchable = enriched;
  // Priority sort: overdue > near > ready > unpaid (unique per Nota)
  const priorityScore = cats => cats.has("overdue")?0 : cats.has("near")?1 : cats.has("ready")?2 : cats.has("unpaid")?3 : 4;
  const attentionRows = useMemo(() => searchable
    .filter(({cats}) => ["overdue","near","ready","unpaid"].some(k => cats.has(k)))
    .sort((a,b) => {
      const sa=priorityScore(a.cats), sb=priorityScore(b.cats);
      if (sa !== sb) return sa - sb;
      const da = a.o.deadline || "9999-12-31", db = b.o.deadline || "9999-12-31";
      return da < db ? -1 : da > db ? 1 : 0;
    }), [searchable]); // eslint-disable-line react-hooks/exhaustive-deps
  const [visible, setVisible] = useState(5);
  useEffect(() => { setVisible(5); }, [query]);
  const shown = attentionRows.slice(0, visible);
  const CATS_LIST = isAdminToko
    ? ["active","near","overdue","wip","ready","unpaid"]
    : ["overdue","near","wip","ready","unpaid"];
  // Owner/Admin: Pusat Kendali menggantikan ringkasan & daftar panjang (fungsi lama tetap di menu terkait).
  if (!isAdminToko && controlCenter) return <>
    <div className="dash-toolbar" data-testid="dash-toolbar">
      <div className="dash-toolbar-actions">
        <button type="button" data-testid="dash-goto-orders" className="soft-btn" onClick={()=>onGoToOrders(null)}><ReceiptText size={16}/>Semua Pesanan</button>
        <button type="button" data-testid="new-order-button" className="primary" onClick={onNewOrder}><Plus size={16}/>Nota Baru</button>
      </div>
    </div>
    {controlCenter}
  </>;
  return <>
    <div className="dash-toolbar" data-testid="dash-toolbar">
      <div className="dash-toolbar-actions">
        <button type="button" data-testid="dash-goto-orders" className="soft-btn" onClick={()=>onGoToOrders(null)}><ReceiptText size={16}/>Semua Pesanan</button>
        <button type="button" data-testid="new-order-button" className="primary" onClick={onNewOrder}><Plus size={16}/>Nota Baru</button>
      </div>
    </div>
    {!isAdminToko && <div className="metric-grid compact" data-testid="dash-metric-grid">
      <Metric label="Omzet hari ini" value={moneyShort(dash.revenue||0)} tone="gold" icon={<Wallet size={18} strokeWidth={1.75}/>}/>
      <Metric label="Pesanan aktif" value={dash.orders ?? 0} tone="navy" icon={<ReceiptText size={18} strokeWidth={1.75}/>}/>
      <Metric label="Sedang diproses" value={dash.process ?? 0} tone="teal" icon={<Factory size={18} strokeWidth={1.75}/>}/>
      {/* Iter 221f — Total Piutang: sumber sama dgn /api/receivables (Draft ikut, Dibatalkan out). Clickable → menu Piutang. */}
      <div
        role={onGoToReceivable ? "button" : undefined}
        tabIndex={onGoToReceivable ? 0 : undefined}
        data-testid="dash-tile-piutang"
        onClick={onGoToReceivable}
        onKeyDown={(e)=>{ if(onGoToReceivable && (e.key==="Enter"||e.key===" ")){ e.preventDefault(); onGoToReceivable(); } }}
        style={{cursor: onGoToReceivable ? "pointer" : "default"}}
      >
        <Metric label="Total piutang" value={moneyShort(dash.receivable||0)} tone="burgundy" icon={<AlertTriangle size={18} strokeWidth={1.75}/>}/>
      </div>
      {/* Iter 221f — Kartu Perlu Review: hanya muncul kalau ada nota migrasi is_migrated && needs_review. Klik → Semua Pesanan dgn filter needs_review. */}
      {(dash.needs_review || 0) > 0 && <div
        role="button"
        tabIndex={0}
        data-testid="dash-tile-needs-review"
        onClick={onGoToNeedsReview}
        onKeyDown={(e)=>{ if(onGoToNeedsReview && (e.key==="Enter"||e.key===" ")){ e.preventDefault(); onGoToNeedsReview(); } }}
        style={{cursor:"pointer"}}
      >
        <Metric label="Perlu Review" value={dash.needs_review} tone="amber" icon={<AlertTriangle size={18} strokeWidth={1.75}/>}/>
      </div>}
    </div>}
    <div className="section att-section">
      <div className="section-title"><h3>Ringkasan Pesanan</h3><span className="muted small">Satu Nota bisa masuk lebih dari satu kategori</span></div>
      {loadError && <div className="att-error" data-testid="dash-load-error">Gagal memuat data. Coba refresh halaman.</div>}
      <div className={`att-cards-grid ${isAdminToko?"att-cards-toko":""}`} data-testid="att-cards-grid" role="group" aria-label="Kartu ringkasan pesanan">
        {CATS_LIST.map(c => <AttentionCard key={c} cat={c} count={counts[c]||0} onClick={()=>onGoToOrders(c)} active={false}/>)}
      </div>
    </div>
    {/* Untuk Admin Toko, dashboard baru ditangani oleh <AdminTokoDashboard/> — bagian ini fallback owner/admin. */}
    <div className="section att-section">
      <div className="section-title"><h3>Perlu Ditindaklanjuti</h3><span className="muted small">{attentionRows.length} pesanan · paling mendesak di atas</span></div>
      {loading && attentionRows.length===0 && !loadError && <div className="empty" data-testid="att-loading">Memuat pesanan…</div>}
      {!loading && !loadError && attentionRows.length===0 && <div className="empty" data-testid="att-empty">Tidak ada pesanan yang perlu perhatian saat ini.</div>}
      <div className="att-list" data-testid="att-list">
        {shown.map(({o,cats}) => <AttentionOrderRow key={o.order_number} order={o} cats={cats} onOpen={onOpen}/>)}
      </div>
      {(attentionRows.length > visible || visible > 5) && <div className="att-more">
        {attentionRows.length > visible && <button type="button" className="soft-btn" data-testid="att-load-more" onClick={()=>setVisible(v=>v+10)}>Lihat Selengkapnya ({attentionRows.length - visible} lagi)</button>}
        {visible > 5 && <button type="button" className="soft-btn" data-testid="att-show-less" onClick={()=>setVisible(5)}>Tampilkan lebih sedikit</button>}
      </div>}
      {testCount > 0 && <div className="muted small" data-testid="att-test-excluded" style={{marginTop:8}}>{testCount} nota uji (data simulasi/pengujian) tidak dihitung di Dashboard. Masih bisa dilihat di menu Pesanan.</div>}
    </div>
  </>;
}




// Iter 218 — Halaman Owner Claim (recovery dari HP).
// Dipakai bila Owner produksi kehilangan akses login. Alur:
//   1. Pemilik project set env var PROJECT_OWNER_CLAIM_SECRET di Emergent dashboard, redeploy.
//   2. Owner buka halaman ini di browser HP, paste secret + isi email tujuan.
//   3. Backend generate token 30 menit sekali pakai, kirim link ke email (kalau Resend hidup)
//      atau tampilkan link di halaman ini (fallback bila email gagal).
//   4. Owner klik link setup password → /setup-password?token=... → simpan password baru.
//   5. Endpoint jadi permanen 409 (one-shot lock). Pemilik project hapus secret & redeploy.
function OwnerClaimPage() {
  const [secret, setSecret] = useState("");
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [result, setResult] = useState(null);
  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setResult(null);
    if (!secret || secret.length < 16) { setErr("Secret minimal 16 karakter."); return; }
    if (!email || !email.includes("@")) { setErr("Email tujuan tidak valid."); return; }
    setBusy(true);
    try {
      const r = await axios.post(`${API}/auth/project-owner-claim`, {
        project_secret: secret,
        target_email: email.trim().toLowerCase(),
      });
      setResult(r.data || {});
      setSecret(""); // segera lupakan secret di memori setelah sukses
    } catch (ex) {
      const detail = ex.response?.data?.detail || ex.message || "Gagal.";
      setErr(String(detail));
    } finally { setBusy(false); }
  };
  if (result?.ok) {
    return <div className="setup-pw-wrap"><div className="setup-pw-card">
      <p className="eyebrow">TAMFARIS · Owner Claim Berhasil</p>
      <h1>Langkah terakhir</h1>
      <p className="muted small" style={{marginTop:6}}>{result.message}</p>
      {result.setup_url && (
        <>
          <p style={{marginTop:14, fontWeight:600}}>Buka tautan setup password di bawah dari HP yang sama. Token berlaku 30 menit &amp; hanya bisa dipakai sekali.</p>
          <a className="primary big" href={result.setup_url} data-testid="owner-claim-setup-link" style={{marginTop:8, wordBreak:"break-all", textAlign:"center", display:"block"}}>Buka Halaman Setup Password</a>
          <p className="muted small" style={{marginTop:10}}>Setelah password baru tersimpan &amp; login berhasil, minta pemilik project menghapus <code>PROJECT_OWNER_CLAIM_SECRET</code> di dashboard lalu redeploy.</p>
        </>
      )}
    </div></div>;
  }
  return <div className="setup-pw-wrap"><div className="setup-pw-card">
    <p className="eyebrow">TAMFARIS · Owner Recovery</p>
    <h1>Pemulihan Akun Owner</h1>
    <p className="muted small" style={{marginTop:6}}>Halaman ini hanya berfungsi bila pemilik project mengaktifkan <code>PROJECT_OWNER_CLAIM_SECRET</code> di environment produksi. Fitur ini <b>sekali pakai</b> — begitu berhasil, endpoint akan otomatis mati permanen.</p>
    <form onSubmit={submit} className="setup-pw-form">
      <label className="field-label"><span className="field-label-text">Project secret <b className="required">*</b></span>
        <input type="password" value={secret} onChange={e=>setSecret(e.target.value)} minLength={16} required autoComplete="off" data-testid="owner-claim-secret" placeholder="Tempel PROJECT_OWNER_CLAIM_SECRET"/>
      </label>
      <label className="field-label"><span className="field-label-text">Email Owner (baru) <b className="required">*</b></span>
        <input type="email" value={email} onChange={e=>setEmail(e.target.value)} required autoComplete="email" data-testid="owner-claim-email" placeholder="mis. taufikmldn@gmail.com"/>
      </label>
      {err && <div className="alert warn" data-testid="owner-claim-err">{err}</div>}
      <button type="submit" className="primary big" disabled={busy} data-testid="owner-claim-submit">{busy ? "Memproses…" : "Kirim & Ambil Link Setup"}</button>
    </form>
  </div></div>;
}


// Iter 217 — Halaman set password baru untuk Owner setelah project-owner-claim.
// Token disampaikan lewat query param `?token=xxx`. Berlaku 30 menit, sekali pakai.
function SetupPasswordPage() {
  const params = new URLSearchParams(window.location.search);
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (pw.length < 6) { setErr("Password minimal 6 karakter."); return; }
    if (pw !== confirm) { setErr("Konfirmasi tidak cocok."); return; }
    setBusy(true);
    try {
      await axios.post(`${API}/auth/setup-password-via-token`, { token, new_password: pw, confirm_password: confirm });
      setDone(true);
    } catch (ex) {
      setErr(ex.response?.data?.detail || "Gagal menyimpan password.");
    } finally { setBusy(false); }
  };
  if (!token) {
    return <div className="setup-pw-wrap"><div className="setup-pw-card">
      <h1>Token tidak ditemukan</h1>
      <p>Tautan tidak lengkap. Silakan buka email dan klik tautan setup password yang lengkap.</p>
    </div></div>;
  }
  if (done) {
    return <div className="setup-pw-wrap"><div className="setup-pw-card">
      <h1>Password tersimpan</h1>
      <p>Password Owner Anda sudah diperbarui. Silakan login di halaman utama pakai password baru.</p>
      <a className="primary big" href="/" data-testid="setup-pw-go-login">Masuk ke Halaman Login</a>
    </div></div>;
  }
  return <div className="setup-pw-wrap"><div className="setup-pw-card">
    <p className="eyebrow">TAMFARIS · Setup Password Owner</p>
    <h1>Buat Password Baru</h1>
    <p className="muted small" style={{marginTop:6}}>Tautan ini sekali pakai & berlaku 30 menit sejak dikirim ke email Anda.</p>
    <form onSubmit={submit} className="setup-pw-form">
      <label className="field-label"><span className="field-label-text">Password baru <b className="required">*</b></span>
        <input type="password" value={pw} onChange={e=>setPw(e.target.value)} minLength={6} required autoComplete="new-password" data-testid="setup-pw-input"/>
      </label>
      <label className="field-label"><span className="field-label-text">Konfirmasi password <b className="required">*</b></span>
        <input type="password" value={confirm} onChange={e=>setConfirm(e.target.value)} minLength={6} required autoComplete="new-password" data-testid="setup-pw-confirm"/>
      </label>
      {err && <div className="alert warn" data-testid="setup-pw-err">{err}</div>}
      <button type="submit" className="primary big" disabled={busy} data-testid="setup-pw-submit">{busy ? "Menyimpan…" : "Simpan Password"}</button>
    </form>
  </div></div>;
}


function lazyNamed(loader, name) { return lazy(() => loader().then(m => ({ default: m[name] }))); }
const PageLoading = () => <div className="muted small" style={{padding:24}} data-testid="page-lazy-loading">Memuat halaman…</div>;
const ORDER_DATA_TABS = new Set(["dashboard", "orders", "receivable", "production"]);

function App() {
  // Iter 74/75 — Init theme (light/dark/auto) dari localStorage sedini mungkin agar tidak flash of light.
  useEffect(() => {
    try {
      const saved = localStorage.getItem("tamfaris-theme") || "auto";
      const prefersDark = window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches;
      const effectiveDark = saved === "dark" || (saved === "auto" && prefersDark);
      if (effectiveDark) document.documentElement.setAttribute("data-theme", "dark");
    } catch {}
  }, []);
  const [user,setUser]=useState(null),[operator,setOperator]=useState(null),[tab,setTab]=useState("dashboard"),[orders,setOrders]=useState([]),[receivables,setReceivables]=useState([]),[dash,setDash]=useState({}),[showForm,setShowForm]=useState(false),[detail,setDetail]=useState(null),[query,setQuery]=useState(""),[printOrder,setPrintOrder]=useState(null),[spkOrder,setSpkOrder]=useState(null),[showOperatorMaster,setShowOperatorMaster]=useState(false),[pickupFilter,setPickupFilter]=useState("all"),[showReports,setShowReports]=useState(false),[attentionFilter,setAttentionFilter]=useState(null),[loading,setLoading]=useState(false),[loadError,setLoadError]=useState(false),[orderDateFilter,setOrderDateFilter]=useState(null),[showCashClosing,setShowCashClosing]=useState(false),[sidebarOpen,setSidebarOpen]=useState(false),[masterKind,setMasterKind]=useState("products"),[ordersSubtab,setOrdersSubtab]=useState("orders"),[notifOpen,setNotifOpen]=useState(false),[showPerformance,setShowPerformance]=useState(false),[showChangePw,setShowChangePw]=useState(false),[showAkunOwner,setShowAkunOwner]=useState(false),[showWorkshopSettings,setShowWorkshopSettings]=useState(false),[showWarehouse,setShowWarehouse]=useState(false),[showShopee,setShowShopee]=useState(false),[showShopeeConnection,setShowShopeeConnection]=useState(false),[duplicateSource,setDuplicateSource]=useState(null),[showResetNota,setShowResetNota]=useState(false),[showImportNota,setShowImportNota]=useState(false),[showTokopedia,setShowTokopedia]=useState(false);
  const channel = useChannel();
  const isAdminTokoUser = !!operator?.is_admin_toko;
  const todayISO = new Intl.DateTimeFormat("en-CA", { timeZone:"Asia/Jakarta" }).format(new Date());
  // Iter 255 — Split filter chain: `baseOrders` = scope baseline (test order guard +
  //   orderDateFilter). Counter quick-filter Semua/Terlambat/Belum Lunas/Selesai—Belum Diambil/
  //   Sudah Diambil dihitung dari baseline ini agar TIDAK berubah saat user klik chip filter.
  //   `filteredOrders` = baseline + attentionFilter/pickupFilter → dipakai untuk daftar card.
  // Perf — filter+sort ratusan nota hanya dihitung ulang bila datanya/filternya berubah,
  //   bukan setiap render (buka menu, ketik, buka modal).
  const baseOrders = useMemo(() => orders.filter(o => {
    if (isAdminTokoUser && isTestOrderClient(o)) return false;
    if (orderDateFilter && orderDateFilter.from && orderDateFilter.to) {
      const od = o.order_date || "";
      if (od < orderDateFilter.from || od > orderDateFilter.to) return false;
      if (o.order_status === "Dibatalkan" || o.order_status === "Draft") return false;
    }
    return true;
  }), [orders, isAdminTokoUser, orderDateFilter]);
  const filteredOrders = useMemo(() => baseOrders.filter(o => {
    if (attentionFilter) {
      // Iter 221g — "needs-review" filter: nota migrasi butuh Owner action.
      //   Definisi konsisten dgn Dashboard tile: is_migrated && needs_review && !final_state.
      //   Nota final (Dibatalkan/Selesai/Diambil/Dikirim) otomatis keluar dari list.
      if (attentionFilter === "needs-review") {
        const FINAL_STATES = new Set(["Dibatalkan","Selesai","Diambil","Dikirim"]);
        return !!o.is_migrated
          && !!(o._migration_meta && o._migration_meta.needs_review)
          && !FINAL_STATES.has(o.order_status);
      }
      if (o.order_status === "Dibatalkan" || o.order_status === "Draft") return false;
      return attentionCats(o, todayISO).has(attentionFilter);
    }
    if (pickupFilter === "unpaid") {
      // Iter 224d — Include Draft (nota migrasi legacy) supaya konsisten dgn chip counter.
      return (o.remaining || 0) > 0 && o.order_status !== "Dibatalkan";
    }
    if (pickupFilter === "pending") {
      // Iter 501 — Konsisten dgn counter: exclude Dibatalkan + Dikirim.
      const allDone = (o.products||[]).length>0 && (o.products||[]).every(isProductProductionDone);
      return allDone
        && o.pickup_status !== "Diambil"
        && o.order_status !== "Dibatalkan"
        && o.order_status !== "Dikirim";
    }
    if (pickupFilter === "picked") return o.pickup_status === "Diambil";
    // Iter 585 — Ringkasan "Deadline Hari Ini" (nota aktif, deadline internal = hari ini).
    if (pickupFilter === "today") return isDeadlineTodayActive(o, todayISO);
    // Iter 250 — Quick filter "Terlambat" via single source-of-truth `isOrderLate`.
    if (pickupFilter === "overdue") {
      return isOrderLate(o, todayISO);
    }
    return true;
  }).sort((a,b) => {
    // Iter 100 — Sort by prioritas: (1) deadline hari ini + belum diambil, (2) terlambat/deadline lampau + belum selesai, (3) deadline asc, (4) diambil paling bawah.
    const aPicked = a.pickup_status === "Diambil" ? 1 : 0;
    const bPicked = b.pickup_status === "Diambil" ? 1 : 0;
    if (aPicked !== bPicked) return aPicked - bPicked; // belum diambil di atas
    const aCancel = a.order_status === "Dibatalkan" ? 1 : 0;
    const bCancel = b.order_status === "Dibatalkan" ? 1 : 0;
    if (aCancel !== bCancel) return aCancel - bCancel; // batal di bawah
    const aToday = (a.deadline === todayISO && a.pickup_status !== "Diambil") ? 0 : 1;
    const bToday = (b.deadline === todayISO && b.pickup_status !== "Diambil") ? 0 : 1;
    if (aToday !== bToday) return aToday - bToday; // hari ini di atas
    // Kemudian urut deadline ascending (kosong di bawah)
    const ad = a.deadline || "9999-99-99";
    const bd = b.deadline || "9999-99-99";
    return ad < bd ? -1 : ad > bd ? 1 : 0;
  }), [baseOrders, attentionFilter, pickupFilter, todayISO]);
  const loadErrorRef = useRef(null);
  // Iter 228 — Coalescing pending load. Kalau load() dipanggil saat request /api/orders
  //   sebelumnya masih in-flight, return promise yg sama supaya tidak ada race +
  //   dobel network. Simpan juga last-fetched-query supaya kalau debouncedQuery sama,
  //   dan mutation sudah apply state via applyOrderUpdate, kita bisa skip load ulang.
  const pendingLoadRef = useRef(null);
  const skipNextLoadRef = useRef(false);
  // Iter 224 — Fix #3: Debounce search query 350ms sebelum trigger fetch.
  // Sebelumnya tiap keystroke → fetch /api/orders + /api/dashboard (2 request full-scan).
  // Sekarang: state `query` tetap update instan (untuk input UI); state `debouncedQuery`
  // lag 350ms → dipakai untuk fetch URL & useEffect deps.
  const [debouncedQuery, setDebouncedQuery] = useState("");
  useEffect(() => {
    const t = setTimeout(() => setDebouncedQuery(query), 350);
    return () => clearTimeout(t);
  }, [query]);
  const load = async () => {
    // Iter 228 — Deduplicate concurrent load: kalau request sebelumnya masih jalan,
    //   share promise yg sama (semua caller ikut menunggu).
    if (pendingLoadRef.current) return pendingLoadRef.current;
    // Iter 228 — Skip load kalau caller mutation baru saja apply state via applyOrderUpdate
    //   dan tidak butuh fetch ulang (mis. onBack setelah pickup — state global sudah fresh).
    if (skipNextLoadRef.current) { skipNextLoadRef.current = false; return; }
    const p = (async () => {
      try {
        setLoading(true); setLoadError(false); loadErrorRef.current = null;
        const q = debouncedQuery || "";
        if (operator) {
          const o = await axios.get(`${API}/orders?q=${encodeURIComponent(q)}`, { withCredentials:true });
          setOrders(o.data);
          return;
        }
        const [o,d] = await Promise.all([axios.get(`${API}/orders?q=${encodeURIComponent(q)}`,{withCredentials:true}), axios.get(`${API}/dashboard`,{withCredentials:true})]);
        setOrders(o.data); setDash(d.data);
      } catch (e) {
        if (e.response?.status === 401) {
          // Sesi berakhir: operator diberi tahu lewat interceptor (antrean tidak dikosongkan diam-diam)
          if (!operator) { setOrders([]); setDash({}); }
        } else {
          setLoadError(true);
          loadErrorRef.current = e;
          console.warn("load error", e.response?.data || e.message);
        }
      } finally {
        setLoading(false);
        pendingLoadRef.current = null;
      }
    })();
    pendingLoadRef.current = p;
    return p;
  };
  useEffect(()=>{
    // Cek sesi admin dulu; jika tidak ada, cek sesi operator
    (async () => {
      try { const r = await axios.get(`${API}/auth/me`,{withCredentials:true}); setUser(r.data); return; } catch{}
      try { const r = await axios.get(`${API}/operators/me`,{withCredentials:true}); setOperator(r.data); setTab(r.data?.is_admin_toko ? "dashboard" : "production"); } catch{}
    })();
  }, []);
  // Trigger load pada state login + debounced query (bukan query mentah)
  useEffect(()=>{ if(user||operator){ load(); } /* eslint-disable-next-line */ }, [user,operator,debouncedQuery]);

  // Iter 221e — Fetch /api/receivables dedicated endpoint saat tab=receivable.
  // Sebelumnya Piutang derive dari `orders` state yg dilimit 500 (tidak scale ke 2790+ nota migrasi).
  // /api/receivables sudah filter server-side (remaining>0 && !Dibatalkan) + limit 5000.
  const loadReceivables = async () => {
    try {
      // Iter 225 Fix 1.b — Route Admin Toko operator ke endpoint yg menerima operator auth.
      //   `/api/receivables` guard `Depends(current_user)` = admin cookie only → operator dapat 401.
      //   `/api/receivables/admin-toko` guard `actor_from_request` menerima operator dgn is_admin_toko.
      //   Operator biasa (non-admin-toko) TETAP tidak bisa akses (403), tidak dilebarkan.
      const endpoint = operator?.is_admin_toko ? "/receivables/admin-toko" : "/receivables";
      const r = await axios.get(`${API}${endpoint}`, { withCredentials: true });
      setReceivables(Array.isArray(r.data) ? r.data : []);
    } catch (e) {
      if (e.response?.status !== 401) console.warn("receivables load err", e.response?.data || e.message);
      setReceivables([]);
    }
  };
  useEffect(()=>{ if((user||operator) && tab==="receivable"){ loadReceivables(); } /* eslint-disable-next-line */ }, [user,operator,tab]);

  // Iter 141 — Auto-refresh 30 detik untuk data utama (orders + dashboard).
  //   Berlaku pada tab: dashboard, orders, receivable, production (AdminToko).
  //   Manual refresh via tombol / Alt+R. Paused otomatis saat form/modal aktif.
  const autoMain = useAutoRefresh({
    enabled: !!(user || operator),
    // Iter 224 — Fix #7: 30s → 90s. Endpoint list/dashboard sudah cukup responsif via manual
    // refresh + tombol; auto-refresh terlalu sering (30s) memicu request penuh /api/orders +
    // /api/dashboard tiap 30 detik → 120 req/jam × 1.2 MB payload. 90s = 40 req/jam.
    intervalMs: 90000,
    onRefresh: async () => {
      // Perf — nota+dashboard (payload besar) hanya di-refresh pada tab yang memakainya.
      if (!ORDER_DATA_TABS.has(tab) || (tab === "dashboard" && !isAdminTokoUser)) return;
      await load();
      // Iter 221e — refresh /api/receivables juga saat user berada di tab Piutang
      if (tab === "receivable") { try { await loadReceivables(); } catch {} }
      // load() menelan error non-401 & set loadErrorRef; propagasi ke hook agar
      // RefreshIndicator menunjukkan 'Gagal · data lama ditampilkan'.
      if (loadErrorRef.current) { const e = loadErrorRef.current; loadErrorRef.current = null; throw e; }
    },
    deps: [tab, debouncedQuery],
  });
  useRefreshShortcut(autoMain.refresh);
  // Pusat Kendali → buka modul terkait dengan filter terpasang.
  const [navFilter, setNavFilter] = useState(null);
  const goTo = (t, f = {}) => {
    if (t === "orders") { setAttentionFilter(f.needs_review ? "needs-review" : null); setPickupFilter("all"); setOrderDateFilter(null); setTab("orders"); return; }
    if (t === "order-detail") { axios.get(`${API}/orders/${encodeURIComponent(f.order_number)}`, { withCredentials: true }).then(r => setDetail(r.data)).catch(() => toast.error(`Pesanan ${f.order_number} tidak ditemukan`)); return; }
    if (t === "shopee-connection") { setShowCashClosing(false); setShowPerformance(false); setShowOperatorMaster(false); setShowWarehouse(false); setShowShopee(false); setShowShopeeConnection(true); return; }
    if (t === "performance") { setShowCashClosing(false); setShowOperatorMaster(false); setShowWarehouse(false); setShowPerformance(true); return; }
    setNavFilter({ tab: t, ...f, n: Date.now() }); setTab(t); window.scrollTo(0, 0);
  };
  // Perf — kembali ke tab nota setelah lama di menu lain: muat ulang sekali bila data > 90 dtk.
  const lastOrdersLoadRef = useRef(0);
  const [ordersLoadedAt, setOrdersLoadedAt] = useState(null);
  useEffect(() => { lastOrdersLoadRef.current = Date.now(); if (orders.length) setOrdersLoadedAt(new Date()); }, [orders]);
  useEffect(() => {
    if ((user || operator) && ORDER_DATA_TABS.has(tab) && lastOrdersLoadRef.current && Date.now() - lastOrdersLoadRef.current > 90000) load();
    /* eslint-disable-next-line */
  }, [tab]);
  useDirtyGuard(showForm || !!detail || showCashClosing || showChangePw || showAkunOwner || showOperatorMaster || showReports || showWorkshopSettings);

  // Iter 141 — polling 60s Admin Toko digantikan oleh useAutoRefresh 30s global.
  //   Bagian notif/toast Nota Terlambat tetap dipertahankan di useEffect berikutnya.
  const prevAlertKeysRef = useRef(null);
  useEffect(() => {
    if (!operator?.is_admin_toko) return;
    const todayISO = new Intl.DateTimeFormat("en-CA",{timeZone:"Asia/Jakarta"}).format(new Date());
    const overdueKeys = new Set();
    (orders||[]).forEach(o => {
      if (isTestOrderClient(o)) return;
      if (["Dibatalkan","Draft","Diambil","Dikirim"].includes(String(o.order_status||""))) return;
      const cats = attentionCats(o, todayISO);
      if (cats.has("overdue")) overdueKeys.add(o.order_number);
    });
    if (prevAlertKeysRef.current === null) {
      // Baseline pertama, jangan bunyikan
      prevAlertKeysRef.current = overdueKeys;
      return;
    }
    const newOnes = [...overdueKeys].filter(k => !prevAlertKeysRef.current.has(k));
    if (newOnes.length > 0) {
      // Sound: Web Audio beep
      try {
        const AC = window.AudioContext || window.webkitAudioContext;
        if (AC) {
          const ctx = new AC();
          const osc = ctx.createOscillator();
          const gain = ctx.createGain();
          osc.frequency.value = 880; osc.type = "sine";
          gain.gain.setValueAtTime(0.001, ctx.currentTime);
          gain.gain.exponentialRampToValueAtTime(0.25, ctx.currentTime + 0.02);
          gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.6);
          osc.connect(gain).connect(ctx.destination);
          osc.start(); osc.stop(ctx.currentTime + 0.65);
          setTimeout(()=>{ try { ctx.close(); } catch{} }, 800);
        }
      } catch {}
      toast.error(`${newOnes.length} Nota Terlambat baru: ${newOnes.slice(0,3).join(", ")}${newOnes.length>3?"…":""}`, {
        duration: 8000,
        action: { label: "Lihat", onClick: () => { setAttentionFilter("overdue"); setTab("orders"); } },
      });
    }
    prevAlertKeysRef.current = overdueKeys;
    // eslint-disable-next-line
  }, [orders, operator]);
  // Idle auto-logout (60 menit) — reset tiap ada aktivitas user (klik, ketik, scroll, scan, pindah tab)
  // Berlaku untuk operator & admin/owner. Timer berbasis aktivitas, bukan umur session.
  useEffect(() => {
    if (!user && !operator) return;
    let timer = null;
    const IDLE_MS = (operator?.team === "Operator Bordir" ? 240 : 60) * 60 * 1000; // Operator Bordir 4 jam, lainnya 60 menit
    const trigger = () => {
      if (operator) {
        operatorLogout();
        notify.warning({ title:"Sesi berakhir, silakan masuk kembali", message:`Anda tidak aktif selama ${IDLE_MS / 60000} menit. Masuk kembali dengan PIN; pekerjaan Anda tetap tersimpan.` });
      } else if (user) {
        (async () => { try { await axios.post(`${API}/auth/logout`,{},{withCredentials:true}); } catch{} setUser(null); })();
        notify.warning({ title:"Sesi berakhir karena tidak aktif", message:"Anda telah tidak aktif selama 60 menit. Silakan login ulang." });
      }
    };
    const reset = () => { if (timer) clearTimeout(timer); timer = setTimeout(trigger, IDLE_MS); };
    const events = ["mousemove","keydown","touchstart","click","scroll","wheel","pointerdown","visibilitychange"];
    const onEvt = (e) => { if (e.type === "visibilitychange" && document.visibilityState !== "visible") return; reset(); };
    events.forEach(ev => window.addEventListener(ev, onEvt, { passive: true }));
    document.addEventListener("visibilitychange", onEvt);
    reset();
    return () => {
      events.forEach(ev => window.removeEventListener(ev, onEvt));
      document.removeEventListener("visibilitychange", onEvt);
      if (timer) clearTimeout(timer);
    };
    /* eslint-disable-next-line */
  }, [user, operator]);
  // Sesi operator berakhir di server (401) → keluar + pemberitahuan, satu kali; pekerjaan dimuat ulang setelah login PIN.
  useEffect(() => {
    if (!operator) return undefined;
    let fired = false;
    const id = axios.interceptors.response.use(r => r, (err) => {
      const det = String(err?.response?.data?.detail || "");
      if (!fired && err?.response?.status === 401 && /^Sesi (berakhir|operator)/.test(det)) {
        fired = true;
        setOperator(null); setChannel("shopee");
        notify.warning({ title:"Sesi berakhir, silakan masuk kembali", message:"Masuk kembali dengan PIN. Pekerjaan yang sedang dikerjakan tetap tersimpan dan akan tampil lagi." });
      }
      return Promise.reject(err);
    });
    return () => axios.interceptors.response.eject(id);
    /* eslint-disable-next-line */
  }, [operator]);
  // Sesi Owner/Admin habis di server (401) → ke halaman login + pemberitahuan, satu kali.
  useEffect(() => {
    if (!user || operator) return undefined;
    let fired = false;
    const id = axios.interceptors.response.use(r => r, (err) => {
      const det = String(err?.response?.data?.detail || "");
      if (!fired && err?.response?.status === 401 && /^(Silakan masuk|Sesi (tidak valid|kadaluarsa))/.test(det)) {
        fired = true;
        setUser(null);
        notify.warning({ title:"Sesi berakhir, silakan login ulang", message:"Data tidak berubah. Setelah login, halaman dapat dibuka kembali." });
      }
      return Promise.reject(err);
    });
    return () => axios.interceptors.response.eject(id);
    /* eslint-disable-next-line */
  }, [user, operator]);
  const operatorLogout = async () => { try { await axios.post(`${API}/operators/logout`,{},{withCredentials:true}); } catch{} setOperator(null); setOrders([]); setChannel("shopee"); };
  // Iter 50 — Hooks harus SEBELUM early returns (rules-of-hooks).
  const [showOperatorMasterInitial, setShowOperatorMasterInitial] = useState(null);
  const [inactiveOpsCount, setInactiveOpsCount] = useState(0);
  const identityRole = String(user?.role||"").toLowerCase();
  // Lab Uji AI: menu hanya muncul bila backend Preview mengaktifkannya (backend tetap memeriksa Owner).
  const [labEnabled, setLabEnabled] = useState(false);
  const [mpHoldView, setMpHoldView] = useState(false);
  useEffect(() => {
    if (identityRole !== "owner") { setLabEnabled(false); return; }
    axios.get(`${API}/ai-eval-lab/status`, { withCredentials: true }).then(() => setLabEnabled(true)).catch(() => setLabEnabled(false));
  }, [identityRole]);
  const isOwnerOrAdmin = identityRole === "owner" || identityRole === "admin";
  useEffect(() => {
    if (!isOwnerOrAdmin) { setInactiveOpsCount(0); return; }
    let alive = true;
    axios.get(`${API}/master/operators`, { withCredentials: true })
      .then(r => { if (alive) setInactiveOpsCount((r.data||[]).filter(o=>!o.active).length); })
      .catch(() => {});
    return () => { alive = false; };
  }, [isOwnerOrAdmin, showOperatorMaster]);
  useEffect(() => {
    const chs = MP_DESIGNER_TEAMS[operator?.team];
    if (chs && !chs.includes(channel)) setChannel(chs[0]);
  }, [operator?.team, channel]);
  const openMasterOpNonaktif = () => { setShowOperatorMasterInitial("inactive"); setShowOperatorMaster(true); };
  if (!user && !operator) return <Login onLogin={setUser} onOperator={op=>{setOperator(op);setTab(op?.is_admin_toko?"dashboard":"production");}}/>;
  if (printOrder) return <PrintNota order={printOrder} onClose={()=>setPrintOrder(null)}/>;
  if (spkOrder) return <PrintSPK order={spkOrder} onClose={()=>setSpkOrder(null)}/>;
  // Operator produksi (bukan Admin Toko): hanya tab Produksi, tidak boleh buka detail nota lain, tidak boleh buka form
  if (operator && !operator.is_admin_toko) {
    // Iter 287 — Designer Shopee (team="Shopee") langsung masuk ke modul Mockup Shopee,
    // tidak ke ProductionQueue. Tidak ada akses ke keuangan/pengaturan/nota offline.
    const mpChannels = MP_DESIGNER_TEAMS[operator.team];
    if (mpChannels) {
      const both = mpChannels.length > 1;
      return <div className="shell operator-shell">
        <header className="topbar">
          <div className="brand"><b aria-label="Logo TAMFARIS"><img src="/logo-tamfaris.jpg" alt="Logo TAMFARIS" draggable="false"/></b><span><strong>TAMFARIS</strong></span></div>
          <div className="user-pill">
            {both && <div className="mpb-tabs mpb-tabs-top" role="tablist" aria-label="Marketplace pekerjaan desain">
              <SourceTab channel="shopee" active={channel!=="tokopedia"} onClick={()=>setChannel("shopee")} testid="operator-mp-tab-shopee"/>
              <SourceTab channel="tokopedia" active={channel==="tokopedia"} onClick={()=>setChannel("tokopedia")} testid="operator-mp-tab-tokopedia"/>
            </div>}
            <button type="button" className={`soft-btn small-btn desk-only${mpHoldView ? " active" : ""}`} onClick={()=>setMpHoldView(v=>!v)}
              data-testid="operator-hold-manager-btn">{mpHoldView ? "Kembali ke Pekerjaan" : "HOLD / Pembatalan"}</button>
            <span data-testid="operator-header-name">{operator.name}</span><small data-testid="operator-header-team">{operator.team === "Shopee" ? "Shopee Designer" : `Desainer ${operator.team}`}</small>
            <MyMistakesButton/><QuickThemeToggle/>
            <button className="soft-btn small-btn desk-only" onClick={operatorLogout} style={{marginLeft:8}} data-testid="operator-lock-btn">Ganti / Kunci</button>
            <AccountMenu name={operator.name} role={operator.team === "Shopee" ? "Shopee Designer" : `Desainer ${operator.team}`} onLogout={operatorLogout}>
              <button type="button" role="menuitem" className="acct-menu-item" onClick={()=>setMpHoldView(v=>!v)} data-testid="account-menu-hold">
                {mpHoldView ? "Kembali ke Pekerjaan" : "HOLD / Pembatalan"}</button>
            </AccountMenu>
          </div>
        </header>
        <main className="content operator-content">
          {mpHoldView ? <HoldManagerPage me={operator}/>
            : mpChannels.includes(channel) && <>{channel === "tokopedia" && <TokopediaBanner/>}<ShopeeModule key={channel} embedded/></>}
        </main>
      </div>;
    }
    // Iter 287b — Operator tim produksi + flag is_shopee_designer: dapat AKSES KEDUANYA.
    // Toggle di header memilih mode; ProductionQueue vs ShopeeModule keduanya dapat diakses.
    // Tim asal (Mockup/Bordir/dll) mempertahankan akses Nota Offline sebelumnya.
    if (operator.is_shopee_designer) {
      const opIdentity2 = { name: operator?.name, role: "operator", team: operator?.team };
      const refreshOpDetail2 = async () => {
        if (!detail) return;
        try {
          const r = await axios.get(`${API}/orders/${detail.order_number}`, { withCredentials:true });
          setDetail(r.data);
          setOrders(prev => Array.isArray(prev) ? prev.map(o => o.order_number === r.data.order_number ? { ...o, ...r.data } : o) : prev);
        } catch {}
      };
      if (detail) return <Detail user={opIdentity2} order={detail} onBack={()=>{setDetail(null); skipNextLoadRef.current = true; load();}} onRefresh={refreshOpDetail2} onPrintNota={()=>setPrintOrder(detail)} onPrintSPK={()=>setSpkOrder(detail)} onDuplicate={(o)=>{ setDetail(null); setDuplicateSource(o); setShowForm(true); }}/>;
      return <div className="shell operator-shell">
        <header className="topbar">
          <div className="brand"><b aria-label="Logo TAMFARIS"><img src="/logo-tamfaris.jpg" alt="Logo TAMFARIS" draggable="false"/></b><span><strong>TAMFARIS</strong></span></div>
          <div className="user-pill" style={{gap:6}}>
            <div className="mpb-tabs mpb-tabs-top" role="tablist" aria-label="Sumber pekerjaan desain">
              <SourceTab channel="offline" active={tab!=="shopee"} onClick={()=>{ setChannel("shopee"); setTab("production"); }} testid="operator-mode-produksi"/>
              <SourceTab channel="shopee" active={tab==="shopee" && channel!=="tokopedia"} onClick={()=>{ setChannel("shopee"); setTab("shopee"); }} testid="operator-mode-shopee"/>
              <SourceTab channel="tokopedia" active={tab==="shopee" && channel==="tokopedia"} onClick={()=>{ setChannel("tokopedia"); setTab("shopee"); }} testid="operator-mode-tokopedia"/>
            </div>
            <span data-testid="operator-header-name">{operator.name}</span>
            <small data-testid="operator-header-team">{operator.team} · Shopee</small>
            <MyMistakesButton/><QuickThemeToggle/>
            <button className="soft-btn small-btn desk-only" onClick={operatorLogout} style={{marginLeft:8}} data-testid="operator-lock-btn">Ganti / Kunci</button>
            <AccountMenu name={operator.name} role={`${operator.team} · Shopee`} onLogout={operatorLogout}/>
          </div>
        </header>
        <main className="content operator-content">
          {tab === "shopee"
            ? <><TokopediaBanner/><ShopeeModule key={channel} embedded/></>
            : <ProductionQueue user={null} operator={operator} orders={orders} onOpen={setDetail} onChanged={load} onOperatorLogout={operatorLogout}/>}
        </main>
      </div>;
    }
    const opIdentity = { name: operator?.name, role: "operator", team: operator?.team };
    const refreshOpDetail = async () => {
      if (!detail) return;
      // Iter 228 — Skip full load() setelah mutation. Response GET single sudah di-apply
      //   ke state global lewat setOrders map — cukup untuk sinkronisasi Antrian.
      try {
        const r = await axios.get(`${API}/orders/${detail.order_number}`, { withCredentials:true });
        setDetail(r.data);
        setOrders(prev => Array.isArray(prev) ? prev.map(o => o.order_number === r.data.order_number ? { ...o, ...r.data } : o) : prev);
      } catch {}
    };
    if (detail) return <Detail user={opIdentity} order={detail} onBack={()=>{setDetail(null); skipNextLoadRef.current = true; load();}} onRefresh={refreshOpDetail} onPrintNota={()=>setPrintOrder(detail)} onPrintSPK={()=>setSpkOrder(detail)} onDuplicate={(o)=>{ setDetail(null); setDuplicateSource(o); setShowForm(true); }}/>;
    return <div className="shell operator-shell">
      <header className="topbar">
        <div className="brand"><b aria-label="Logo TAMFARIS"><img src="/logo-tamfaris.jpg" alt="Logo TAMFARIS" draggable="false"/></b><span><strong>TAMFARIS</strong></span></div>
        <div className="user-pill">
          <span data-testid="operator-header-name">{operator.name}</span><small data-testid="operator-header-team">{operator.team}</small>
          <MyMistakesButton/><QuickThemeToggle/>
          <AccountMenu name={operator.name} role={operator.team} onLogout={operatorLogout}/>
        </div>
      </header>
      <main className="content operator-content">
        <ProductionQueue user={null} operator={operator} orders={orders} onOpen={setDetail} onChanged={load} onOperatorLogout={operatorLogout}/>
      </main>
    </div>;
  }
  // Dari sini: user admin/owner ATAU Admin Toko (operator dengan is_admin_toko=true)
  const isAdminToko = !!operator?.is_admin_toko;
  const identity = user || { name: operator?.name, role: "admin_toko" };
  const identityLabel = user ? user.role : "Admin Toko";
  // Iter 227 — Sinkronisasi instan setelah mutation.
  //   Setiap mutation (pickup, payment, cancel, void, edit, stage change) mengembalikan
  //   dokumen order yang sudah di-enrich. Kita apply hasilnya ke state lokal LANGSUNG:
  //     - `orders[]` di-update by order_number → semua tampilan yang derive dari `orders`
  //       (Dashboard chip, Pesanan list, Antrian/Produksi tab, Piutang tab) langsung refresh
  //     - `detail` di-update kalau sedang membuka nota yang sama
  //   Menghilangkan race condition antara load() lama dan tab switch: user tidak perlu
  //   menunggu polling 90s atau round-trip GET /orders lagi.
  const applyOrderUpdate = (updated) => {
    if (!updated || !updated.order_number) return;
    setOrders(prev => Array.isArray(prev) ? prev.map(o => o.order_number === updated.order_number ? { ...o, ...updated } : o) : prev);
    setReceivables(prev => Array.isArray(prev) ? prev.map(o => o.order_number === updated.order_number ? { ...o, ...updated } : o) : prev);
    setDetail(prev => (prev && prev.order_number === updated.order_number) ? { ...prev, ...updated } : prev);
  };
  const removeOrderLocal = (orderNumber) => {
    setOrders(prev => Array.isArray(prev) ? prev.filter(o => o.order_number !== orderNumber) : prev);
    setReceivables(prev => Array.isArray(prev) ? prev.filter(o => o.order_number !== orderNumber) : prev);
  };
  const refreshDetail = async () => {
    if (!detail) return;
    // Iter 228 — Setelah mutation, mutation handler sudah panggil applyOrderUpdate() dari
    //   respons endpoint (pickup/pay/cancel/void) → state global sudah fresh. Kita cukup
    //   fetch single-order untuk sinkronisasi field derived (audit, history) tanpa full
    //   /api/orders load. Skip load() supaya tidak dobel ~1.6 MB per mutation.
    try {
      const r = await axios.get(`${API}/orders/${detail.order_number}`, { withCredentials:true });
      applyOrderUpdate(r.data);
    } catch {}
  };
  if (detail) return <Detail user={identity} order={detail} onBack={()=>{setDetail(null); skipNextLoadRef.current = true; load();}} onRefresh={refreshDetail} onOrderUpdated={applyOrderUpdate} onOrderRemoved={removeOrderLocal} onPrintNota={()=>setPrintOrder(detail)} onPrintSPK={()=>setSpkOrder(detail)} onDuplicate={(o)=>{ setDetail(null); setDuplicateSource(o); setShowForm(true); }}/>;
  if (showOperatorMaster) return <MasterOperator user={identity} initialFilter={showOperatorMasterInitial||"active"} onBack={()=>{setShowOperatorMaster(false);setShowOperatorMasterInitial(null);}}/>;
  if (showReports) return <ReportsPage user={identity} onBack={()=>setShowReports(false)}/>;
  if (showCashClosing) return <CashClosingPage user={identity} onBack={()=>setShowCashClosing(false)}/>;
  if (showWarehouse) return <WarehousePage user={identity} onBack={()=>setShowWarehouse(false)}/>;
  if (showShopee) return <ShopeeModule onBack={()=>setShowShopee(false)}/>;
  if (showTokopedia) return <TokopediaPage onBack={()=>setShowTokopedia(false)}/>;
  if (showShopeeConnection) return <><ShopeeConnectionStatus user={identity} onBack={()=>setShowShopeeConnection(false)}/>
    {String(identity?.role||"").toLowerCase() === "owner" && <TikTokConnectionCard/>}</>;
  if (showPerformance) return <PerformancePage
    user={identity}
    onBack={()=>setShowPerformance(false)}
    onOpenOrder={(o)=>{ setShowPerformance(false); setDetail(o); }}
    onNavigateFilter={isAdminToko ? ((opts)=>{
      // Iter 232 — Clickable KPI cards Performa (Admin Toko only). Navigate ke Pesanan
      //   dengan attentionFilter/orderDateFilter yang sesuai. Snapshot metrics tetap current;
      //   metric periodik bawa orderDateFilter dari periode aktif.
      setShowPerformance(false);
      setPickupFilter("all");
      setAttentionFilter(opts?.attentionFilter || null);
      setOrderDateFilter(opts?.orderDateFilter || null);
      setTab("orders");
    }) : null}
  />;
  if (showWorkshopSettings) return <WorkshopSettingsPage user={identity} onBack={()=>setShowWorkshopSettings(false)}/>;
  const nav = isAdminToko
    ? [{id:"dashboard",label:"Dashboard",icon:<LayoutDashboard/>},{id:"orders",label:"Pesanan",icon:<ReceiptText/>},{id:"receivable",label:"Piutang",icon:<WalletCards/>},{id:"production",label:"Produksi",icon:<Factory/>}]
    : [{id:"dashboard",label:"Ringkasan",icon:<LayoutDashboard/>},{id:"orders",label:"Pesanan",icon:<ReceiptText/>},{id:"receivable",label:"Piutang",icon:<WalletCards/>},{id:"production",label:"Produksi",icon:<Factory/>}];
  const logout = async () => {
    if (!window.confirm(LOGOUT_CONFIRM)) return;
    if (isAdminToko) { await operatorLogout(); return; }
    await axios.post(`${API}/auth/logout`,{},{withCredentials:true}); setUser(null);
  };
  return <div className={`shell${isAdminToko?" admin-toko":""}${!isAdminToko && user?" owner-shell":""}`}>
    {isAdminToko && <AdminTokoSidebar
      open={sidebarOpen}
      onClose={()=>setSidebarOpen(false)}
      operatorName={identity.name}
      menuBadges={(() => {
        // Iter 104 — Badge menu Pesanan = jumlah overdue + hari ini (belum diambil, aktif).
        const t = new Intl.DateTimeFormat("en-CA",{timeZone:"Asia/Jakarta"}).format(new Date());
        let n = 0;
        (orders||[]).forEach(o => {
          if (["Dibatalkan","Draft"].includes(o.order_status)) return;
          if (o.pickup_status === "Diambil") return;
          if (o.deadline && (o.deadline < t || o.deadline === t)) n++;
        });
        return { orders: n };
      })()}
      current={
        showCashClosing ? "cash-closing"
        : showPerformance ? "performance"
        : tab === "orders" && ordersSubtab === "history" ? "history"
        : tab === "master" ? `master-${masterKind}`
        : tab
      }
      onNavigate={(id)=>{
        setSidebarOpen(false);
        if (id === "cash-closing") { setShowPerformance(false); setShowCashClosing(true); return; }
        if (id === "performance") { setShowCashClosing(false); setShowPerformance(true); return; }
        setShowCashClosing(false); setShowPerformance(false);
        if (id === "history") { setTab("orders"); setOrdersSubtab("history"); return; }
        if (id === "orders") { setTab("orders"); setOrdersSubtab("orders"); return; }
        if (id === "master-products") { setMasterKind("products"); setTab("master"); return; }
        if (id === "master-materials") { setMasterKind("materials"); setTab("master"); return; }
        if (id === "master-colors") { setMasterKind("colors"); setTab("master"); return; }
        if (["dashboard","receivable","production","scan","stock","marketplace","hold-manager"].includes(id)) {
          if (query) setQuery("");
          if (orderDateFilter) setOrderDateFilter(null);
          setTab(id);
        }
      }}
      onLock={()=>{ setSidebarOpen(false); operatorLogout(); }}
      onLogout={()=>{ setSidebarOpen(false); logout(); }}
    />}
    {/* Iter 68 — Owner sidebar dapat "Kunci Aplikasi" untuk konsistensi visual dengan Admin Toko */}
    {!isAdminToko && user && <AdminTokoSidebar
      open={sidebarOpen}
      onClose={()=>setSidebarOpen(false)}
      operatorName={identity.name}
      roleLabel={identityLabel}
      menu={(() => {
        // Iter 220 — Item ownerOnly hanya muncul utk role owner.
        // Iter 549 — Pengecualian: `hold-manager` boleh dilihat oleh user/operator
        //   yang punya flag `is_hold_approver=True` (Rido approver), supaya mereka
        //   bisa memberi keputusan HOLD/BATAL meski bukan Owner. Admin / Gudang
        //   biasa TIDAK terbuka otomatis (butuh flag eksplisit).
        const isOwner = identityRole === "owner";
        // HOLD marketplace kini dikendalikan Tim Mockup (menu di tampilan desainer); Owner/Rido tidak memutuskan.
        const allow = (it) => it.id !== "hold-manager" && (!it.labOnly || (isOwner && labEnabled)) && !(it.ownerOnly && !isOwner);
        return (OWNER_MENU || []).map(section => ({
          ...section,
          items: (section.items || []).filter(allow)
            .map(it => it.children ? { ...it, children: it.children.filter(allow) } : it)
            .filter(it => !it.children || it.children.length > 0),
        })).filter(section => (section.items || []).length > 0);
      })()}
      menuBadges={(() => {
        // Iter 104 — Badge Pesanan Owner (sumber sama), dipisah: merah = lewat deadline, emas = deadline hari ini.
        const t = new Intl.DateTimeFormat("en-CA",{timeZone:"Asia/Jakarta"}).format(new Date());
        let late = 0, today = 0;
        (orders||[]).forEach(o => {
          if (["Dibatalkan","Draft"].includes(o.order_status)) return;
          if (o.pickup_status === "Diambil") return;
          if (o.deadline && o.deadline < t) late++;
          else if (o.deadline === t) today++;
        });
        const hint = [late && `${late} lewat deadline`, today && `${today} deadline hari ini`].filter(Boolean).join(" · ");
        return { orders: { hint, parts: [
          { tone: "red", count: late, title: `${late} nota belum diambil & lewat deadline` },
          { tone: "gold", count: today, title: `${today} nota belum diambil dengan deadline hari ini` },
        ] } };
      })()}
      compact
      current={
        showWorkshopSettings ? "workshop"
        : showAkunOwner ? "settings"
        : showOperatorMaster ? "master-operators"
        : showCashClosing ? "cash-closing"
        : showPerformance ? "performance"
        : showWarehouse ? "warehouse"
        : showShopee ? "shopee"
        : showTokopedia ? "tokopedia"
        : showShopeeConnection ? "shopee-connection"
        : tab === "orders" && ordersSubtab === "history" ? "history"
        : tab === "master" ? `master-${masterKind}`
        : tab
      }
      onNavigate={(id)=>{
        setSidebarOpen(false);
        setShowTokopedia(id === "tokopedia");
        if (id === "tokopedia") { setShowCashClosing(false); setShowPerformance(false); setShowOperatorMaster(false); setShowWarehouse(false); setShowShopee(false); setShowShopeeConnection(false); setShowAkunOwner(false); setShowWorkshopSettings(false); return; }
        if (id === "import-nota") { setShowImportNota(true); return; }
        if (id === "reset-nota") { setShowResetNota(true); return; }
        if (id === "change-password") { setShowChangePw(true); return; }
        if (id === "workshop") { setShowCashClosing(false); setShowPerformance(false); setShowOperatorMaster(false); setShowWarehouse(false); setShowAkunOwner(false); setShowWorkshopSettings(true); return; }
        setShowWorkshopSettings(false);
        if (id === "settings") { setShowCashClosing(false); setShowPerformance(false); setShowOperatorMaster(false); setShowWarehouse(false); setShowAkunOwner(true); return; }
        setShowAkunOwner(false);
        if (id === "cash-closing") { setShowPerformance(false); setShowOperatorMaster(false); setShowWarehouse(false); setShowCashClosing(true); return; }
        if (id === "performance") { setShowCashClosing(false); setShowOperatorMaster(false); setShowWarehouse(false); setShowPerformance(true); return; }
        if (id === "warehouse") { setShowCashClosing(false); setShowPerformance(false); setShowOperatorMaster(false); setShowShopee(false); setShowWarehouse(true); return; }
        if (id === "shopee") { setShowCashClosing(false); setShowPerformance(false); setShowOperatorMaster(false); setShowWarehouse(false); setShowShopeeConnection(false); setShowShopee(true); return; }
        if (id === "shopee-connection") { setShowCashClosing(false); setShowPerformance(false); setShowOperatorMaster(false); setShowWarehouse(false); setShowShopee(false); setShowShopeeConnection(true); return; }
        if (id === "master-operators") { setShowCashClosing(false); setShowPerformance(false); setShowWarehouse(false); setShowShopee(false); setShowShopeeConnection(false); setShowOperatorMasterInitial("active"); setShowOperatorMaster(true); return; }
        setShowCashClosing(false); setShowPerformance(false); setShowOperatorMaster(false); setShowWarehouse(false); setShowShopee(false); setShowShopeeConnection(false);
        if (id === "history") { setTab("orders"); setOrdersSubtab("history"); return; }
        if (id === "orders") { setTab("orders"); setOrdersSubtab("orders"); return; }
        if (id === "master-products") { setMasterKind("products"); setTab("master"); return; }
        if (id === "master-materials") { setMasterKind("materials"); setTab("master"); return; }
        if (id === "master-colors") { setMasterKind("colors"); setTab("master"); return; }
        if (["dashboard","receivable","production","scan","stock","marketplace","hold-manager","bordir-performance","mockup-monitor","shopee-monitor","offline-monitor","ai-eval-lab","ai-beta","order-no-check"].includes(id)) {
          if (query) setQuery("");
          if (orderDateFilter) setOrderDateFilter(null);
          setTab(id);
        }
      }}
      onLock={()=>{ setSidebarOpen(false); logout(); }}
      onLogout={()=>{ setSidebarOpen(false); logout(); }}
    />}
    <header className={`topbar${isAdminToko?" at-topbar":""}`}>
      {isAdminToko ? <>
        <div className="at-topbar-brand" data-testid="at-topbar-brand">
          <span className="at-brand-mark"><b>TAMFARIS</b></span>
        </div>
        <div className="at-topbar-right">
          {/* Iter 464 — Role chip + RefreshIndicator dipindahkan keluar topbar
              (role → hero welcome; refresh → baris meta kecil di dashboard)
              supaya topbar mobile tidak berdesakan. */}
          <AdminTokoNotif
            orders={orders}
            open={notifOpen}
            onToggle={()=>setNotifOpen(v=>!v)}
            onClose={()=>setNotifOpen(false)}
            onOpenOrder={(o)=>{ setNotifOpen(false); setDetail(o); }}
            onGoToOrders={(cat)=>{ setNotifOpen(false); setAttentionFilter(cat); setPickupFilter("all"); setOrderDateFilter(null); setTab("orders"); }}
          />
          <MyMistakesButton/><QuickThemeToggle/>
          <button
            type="button"
            className="hamburger-btn"
            data-testid="admin-hamburger-btn"
            onClick={()=>setSidebarOpen(true)}
            aria-label="Buka menu"
          ><MenuIcon size={22}/></button>
        </div>
      </> : <>
        <div className="brand"><b aria-label="Logo TAMFARIS"><img src="/logo-tamfaris.jpg" alt="Logo TAMFARIS" draggable="false"/></b><span><strong>TAMFARIS</strong></span></div>
        <div className="user-pill">
          <span>{identity.name}</span><small data-testid="header-role-label">{identityLabel}</small>
          <MyMistakesButton/><QuickThemeToggle/>
          <button
            type="button"
            className="hamburger-btn"
            data-testid="owner-hamburger-btn"
            onClick={()=>setSidebarOpen(true)}
            aria-label="Buka menu"
          ><MenuIcon size={20}/></button>
        </div>
      </>}
    </header>
    {/* Iter 67 — nav-tabs horizontal Owner dihilangkan, digantikan sidebar drawer di atas */}
    {/* Iter 67 — Owner & Admin Kantor sekarang pakai sidebar; nav-tabs horizontal dihapus. */}
    {showForm
      ? <OrderForm user={identity} initialFromOrder={duplicateSource} onClose={()=>{setShowForm(false); setDuplicateSource(null);}} onSaved={data=>{setShowForm(false); setDuplicateSource(null); setDetail(data); load();}}/>
      : <main className="content">
          {isAdminToko && tab === "dashboard" ? <div className="at-hero-welcome" data-testid="at-hero-welcome">
            <div className="at-hero-welcome-left">
              <span className="at-hero-hello">Selamat datang,</span>
              <h1 className="at-hero-name" data-testid="at-hero-name">{identity.name?.split(" ")[0] || "Admin"}</h1>
              <span className="at-hero-role" data-testid="header-role-label">Admin Toko</span>
            </div>
            <div className="at-hero-welcome-right">
              <span className="at-hero-day">{new Date().toLocaleDateString("id-ID",{weekday:"long",timeZone:"Asia/Jakarta"})}</span>
              <span className="at-hero-date">{new Date().toLocaleDateString("id-ID",{day:"numeric",month:"short",year:"numeric",timeZone:"Asia/Jakarta"})}</span>
              {/* Iter 464 — RefreshIndicator dipindah dari topbar ke sini sebagai
                  info kecil di sudut hero (konsisten dgn date), tidak lagi
                  menumpuk dengan ikon profile/menu. */}
              <RefreshIndicator
                testId="at-refresh"
                lastUpdated={autoMain.lastUpdated || ordersLoadedAt}
                isRefreshing={autoMain.isRefreshing}
                error={autoMain.error}
                onRefresh={autoMain.refresh}
                compact
              />
            </div>
          </div> : <div className={`welcome${isAdminToko?" welcome-admin-toko":""}`}>
            <div>
              <p className="eyebrow">{new Date().toLocaleDateString("id-ID",{weekday:"long",day:"numeric",month:"long",timeZone:"Asia/Jakarta"})}</p>
              <h1>{tab==="dashboard"?"Selamat datang kembali.":nav.find(x=>x.id===tab)?.label}</h1>
              {/* Iter 356 — Hapus paragraf "Mode Admin Toko…" dari tampilan Admin Toko.
                  Admin Toko sudah tahu konteksnya dari topbar + sidebar. */}
              {!isAdminToko && <p className="muted">{
                tab==="dashboard" ? "Ringkasan operasional TAMFARIS hari ini." :
                tab==="orders" ? "Kelola dan tindak lanjuti pesanan pelanggan." :
                tab==="receivable" ? "Pantau tagihan pelanggan yang belum lunas." :
                tab==="production" ? "Pantau antrean dan progres tiap tim produksi." :
                tab==="cash-closing" ? "Tutup kas harian dan rekap arus uang toko." :
                tab==="history" ? "Riwayat pembatalan, koreksi, dan perubahan penting." :
                tab==="master" ? "Kelola master produk, bahan, warna, ukuran, dan operator." :
                tab==="performance" ? "Analisis performa toko & tim produksi periode berjalan." :
                "Pantau alur pesanan TAMFARIS hari ini."
              }</p>}
            </div>
            <div className="welcome-actions">
              {/* Iter 356 — Admin Toko: topbar sudah ada RefreshIndicator kompak dgn
                  cakupan sama (autoMain) — hilangkan duplikasi di welcome area. */}
              {/* Owner Dashboard: Pusat Kendali punya cap waktunya sendiri → indikator data nota tidak ditampilkan di sini. */}
              {!isAdminToko && !(isOwnerOrAdmin && tab==="dashboard") && <RefreshIndicator
                testId="main-refresh"
                lastUpdated={autoMain.lastUpdated || ordersLoadedAt}
                isRefreshing={autoMain.isRefreshing}
                error={autoMain.error}
                onRefresh={autoMain.refresh}
              />}
              {isOwnerOrAdmin && inactiveOpsCount > 0 && tab==="dashboard" && <button
                type="button"
                className="rekap-nonaktif-chip is-quiet"
                data-testid="rekap-nonaktif-chip"
                onClick={openMasterOpNonaktif}
                title="Buka Master Operator, filter Nonaktif"
              >
                <UserX size={12}/>
                <span>{inactiveOpsCount} operator nonaktif · Master Operator</span>
              </button>}
              {tab !== "production" && tab !== "dashboard" && <button data-testid="new-order-button" className="primary big" onClick={()=>setShowForm(true)}><Plus/>Nota baru</button>}
            </div>
          </div>}
          <Suspense fallback={<PageLoading/>}>
          {tab==="dashboard" && (isAdminToko
            ? <AdminTokoDashboard
                orders={orders}
                onNewOrder={()=>setShowForm(true)}
                onOpen={setDetail}
                onGoToOrders={(cat)=>{ setAttentionFilter(cat); setPickupFilter("all"); setOrderDateFilter(null); setTab("orders"); }}
                onGoToReceivable={()=>{ setAttentionFilter(null); setOrderDateFilter(null); setTab("receivable"); }}
                onGoToOrdersByPeriod={(r)=>{ setAttentionFilter(null); setPickupFilter("all"); setOrderDateFilter({from:r.from,to:r.to,label:r.period}); setTab("orders"); }}
                onSearch={(q)=>{ setAttentionFilter(null); setOrderDateFilter(null); setPickupFilter("all"); setQuery(q); setTab("orders"); }}
                onGoToProduction={()=>{ setAttentionFilter(null); setOrderDateFilter(null); setTab("production"); }}
              />
            : <AdminDashboard
              orders={orders} dash={dash} loading={loading} loadError={loadError}
              query={query} onQuery={setQuery}
              isAdminToko={isAdminToko}
              onNewOrder={()=>setShowForm(true)}
              onOpen={setDetail}
              onGoToOrders={(cat)=>{ setAttentionFilter(cat); setPickupFilter("all"); setTab("orders"); }}
              onGoToReceivable={()=>{ setAttentionFilter(null); setOrderDateFilter(null); setPickupFilter("all"); setTab("receivable"); }}
              onGoToNeedsReview={()=>{ setAttentionFilter("needs-review"); setPickupFilter("all"); setOrderDateFilter(null); setTab("orders"); }}
              controlCenter={user && ["owner","admin"].includes(String(user.role||"").toLowerCase())
                ? <OwnerControlCenter go={goTo} onReceivable={()=>{ setAttentionFilter(null); setOrderDateFilter(null); setPickupFilter("all"); setTab("receivable"); }}/> : null}
            />)}
          {tab==="orders" && <OrdersSection
            query={query} onQuery={setQuery}
            attentionFilter={attentionFilter} onClearAttention={()=>setAttentionFilter(null)}
            pickupFilter={pickupFilter} onPickupFilter={(v)=>{setPickupFilter(v);setAttentionFilter(null);setOrderDateFilter(null);}}
            orderDateFilter={orderDateFilter} onClearOrderDateFilter={()=>setOrderDateFilter(null)}
            rows={filteredOrders} baseRows={baseOrders} onOpen={setDetail} onDuplicate={(o)=>{ setDuplicateSource(o); setShowForm(true); }}
            subtab={isAdminToko?ordersSubtab:undefined} onSubtabChange={isAdminToko?setOrdersSubtab:undefined}
            isAdminToko={isAdminToko}
            user={user} operator={operator} onOrderUpdated={applyOrderUpdate}
          />}
          {tab==="receivable" && <div className="section">
            <h3>Daftar piutang</h3>
            <p className="muted small">Umur piutang: hijau 0–7 hari · kuning 8–14 · oranye 15–30 · merah &gt;30. Urut default: paling perlu tindak lanjut.</p>
            <ReceivableTable rows={receivables.filter(x=>x.remaining>0 && x.order_status!=="Dibatalkan" && !isTestOrderClient(x))} onOpen={setDetail}/>
          </div>}
          {tab==="production" && (isAdminToko
            ? <ProductionQueueAdminToko orders={orders} operator={operator} onOpen={setDetail} onOperatorLogout={operatorLogout} onOpenMaster={()=>{setMasterKind("products");setTab("master");}}/>
            : <ProductionQueue user={user} operator={null} orders={orders} onOpen={setDetail} onChanged={load}/>)}
          {/* Iter 109 — Halaman Scan Nota */}
          {tab==="scan" && <ScanNotaPage onOpen={setDetail} onBack={()=>setTab("dashboard")}/>}
          {tab==="master" && <MasterProducts key={masterKind} initialKind={masterKind} isAdminToko={isAdminToko} isOwnerUser={identityRole === "owner"} onBack={()=>setTab(isAdminToko ? "production" : "dashboard")}/>}
          {tab==="stock" && <StockModule key={navFilter?.tab==="stock" ? navFilter.n : "st"} initialTab={navFilter?.tab==="stock" ? navFilter.stockTab : undefined} user={user} operator={operator} onOpenOrder={(no)=>{
            const o = (orders||[]).find(x => x.order_number === no);
            if (o) setDetail(o);
          }}/>}
          {tab==="marketplace" && <MarketplaceOrdersPage user={user}/>}
          {/* Iter 538 — Panel HOLD / Pembatalan Shopee (Owner / Rido approver). */}
          {tab==="hold-manager" && <HoldManagerPage me={user || operator} channelPicker={!!user} initialChannel={navFilter?.tab==="hold-manager" ? navFilter.channel : undefined} key={navFilter?.tab==="hold-manager" ? navFilter.n : "h"}/>}
          {/* Iter 636 — Owner/Admin: Dashboard Performa Bordir yang sama dengan Produksi › Bordir (bukan halaman baru). */}
          {tab==="bordir-performance" && user && ["owner","admin"].includes(String(user.role||"").toLowerCase()) && <div data-testid="owner-bordir-performance-page" style={{maxWidth:760, margin:"0 auto", padding:"8px 4px", minWidth:0}}>
            {navFilter?.tab==="bordir-performance" && navFilter.section==="desain"
              ? <DesainPerformaPanel key={navFilter.n} testIdPrefix="owner-desain-performa"/>
              : <OperatorBordirPerformance testIdPrefix="owner-opbordir-performa"/>}
          </div>}
          {tab==="ai-eval-lab" && identityRole==="owner" && labEnabled && <AiEvalLab/>}
          {tab==="ai-beta" && identityRole==="owner" && <AiBetaPanel/>}
          {tab==="order-no-check" && ["owner","admin"].includes(identityRole) && <OrderNoCheckPanel isOwner={identityRole==="owner"}/>}
          {tab==="mockup-monitor" && user && ["owner","admin","admin_kantor"].includes(String(user.role||"").toLowerCase()) && <Fragment key={navFilter?.tab==="mockup-monitor" ? navFilter.n : "m"}><ChannelScope ch={navFilter?.tab==="mockup-monitor" ? navFilter.channel : "shopee"}/><ShopeeMockupMonitor initialPicName={navFilter?.tab==="mockup-monitor" ? navFilter.pic : ""}/></Fragment>}
          {/* Pantau Pesanan Shopee Rido untuk Owner/Admin — komponen & endpoint sama, baca-saja. */}
          {tab==="shopee-monitor" && user && ["owner","admin"].includes(String(user.role||"").toLowerCase()) && <div data-testid="owner-shopee-monitor-page" style={{maxWidth:1100, margin:"0 auto", padding:"8px 4px", minWidth:0}}>
            <ChannelScope key={navFilter?.tab==="shopee-monitor" ? "c"+navFilter.n : "cs"} ch={navFilter?.tab==="shopee-monitor" ? navFilter.channel : "shopee"}/>
            <ProductionMonitoring key={navFilter?.tab==="shopee-monitor" ? navFilter.n : "s"} operator={null} onOpen={()=>{}} source="shopee" initial={navFilter?.tab==="shopee-monitor" ? navFilter : null}/>
          </div>}
          {tab==="offline-monitor" && user && ["owner","admin"].includes(String(user.role||"").toLowerCase()) && <div data-testid="owner-offline-monitor-page" style={{maxWidth:1100, margin:"0 auto", padding:"8px 4px", minWidth:0}}>
            <ProductionMonitoring key={navFilter?.tab==="offline-monitor" ? navFilter.n : "o"} operator={null} onOpen={setDetail} source="offline" initial={navFilter?.tab==="offline-monitor" ? navFilter : null}/>
          </div>}
          </Suspense>
          {showChangePw && <ChangePasswordModal onClose={()=>setShowChangePw(false)}/>}
          {showAkunOwner && <AkunOwnerModal user={identity} onClose={()=>setShowAkunOwner(false)}/>}
          {showResetNota && <ResetNotaModal onClose={()=>setShowResetNota(false)} onDone={()=>{ setShowResetNota(false); load(); }}/>}
          {showImportNota && <ImportNotaModal onClose={()=>setShowImportNota(false)} onDone={()=>{ setShowImportNota(false); load(); }}/>}
        </main>
    }
  </div>;
}

function ChangePasswordModal({ onClose }) {
  const [oldPw, setOldPw] = useState("");
  const [newPw, setNewPw] = useState("");
  const [confirmPw, setConfirmPw] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (!oldPw || !newPw) { setErr("Password lama & password baru wajib diisi."); return; }
    if (newPw.length < 6) { setErr("Password baru minimal 6 karakter."); return; }
    if (newPw !== confirmPw) { setErr("Konfirmasi password baru tidak cocok."); return; }
    setBusy(true);
    try {
      await axios.post(`${API}/auth/change-password`, {
        old_password: oldPw, new_password: newPw, confirm_password: confirmPw,
      }, { withCredentials: true });
      toast.success("Password berhasil diganti. Silakan gunakan password baru saat login berikutnya.");
      onClose();
    } catch (e) {
      setErr(e.response?.data?.detail || "Gagal mengganti password");
    } finally {
      setBusy(false);
    }
  };
  return <div className="modal-overlay" data-testid="change-password-modal" onClick={onClose}>
    <form className="modal" onClick={e=>e.stopPropagation()} onSubmit={submit}>
      <h3>Ubah Password</h3>
      <p className="muted small" style={{margin:"4px 0 12px"}}>Password lama akan diverifikasi. Password baru disimpan aman (hashed).</p>
      {err && <div className="op-hard-delete-err" data-testid="change-password-error" role="alert">{err}</div>}
      <Field label="Password Lama" required>
        <input type="password" data-testid="change-password-old" value={oldPw} onChange={e=>setOldPw(e.target.value)} autoFocus autoComplete="current-password"/>
      </Field>
      <Field label="Password Baru (min. 6 karakter)" required>
        <input type="password" data-testid="change-password-new" value={newPw} onChange={e=>setNewPw(e.target.value)} autoComplete="new-password"/>
      </Field>
      <Field label="Konfirmasi Password Baru" required>
        <input type="password" data-testid="change-password-confirm" value={confirmPw} onChange={e=>setConfirmPw(e.target.value)} autoComplete="new-password"/>
      </Field>
      <div style={{display:"flex",gap:8,justifyContent:"flex-end",marginTop:8}}>
        <button type="button" className="soft-btn" onClick={onClose} disabled={busy}>Batal</button>
        <button type="submit" className="primary" data-testid="change-password-submit" disabled={busy}>{busy?"Menyimpan…":"Simpan Password Baru"}</button>
      </div>
    </form>
  </div>;
}

function QuickThemeToggle({ compact }) {
  // Iter 78 — Quick toggle Sun/Moon di topbar. Toggle langsung tanpa buka Pengaturan.
  const [isDark, setIsDark] = useState(() => document.documentElement.getAttribute("data-theme") === "dark");
  const toggle = () => {
    const next = !isDark;
    setIsDark(next);
    if (next) document.documentElement.setAttribute("data-theme", "dark");
    else document.documentElement.removeAttribute("data-theme");
    try { localStorage.setItem("tamfaris-theme", next ? "dark" : "light"); } catch {}
  };
  useEffect(() => {
    // Sync jika theme diubah dari Pengaturan (via localStorage/data-theme)
    const obs = new MutationObserver(() => {
      setIsDark(document.documentElement.getAttribute("data-theme") === "dark");
    });
    obs.observe(document.documentElement, { attributes: true, attributeFilter: ["data-theme"] });
    return () => obs.disconnect();
  }, []);
  return <button
    type="button"
    className={`quick-theme-toggle ${compact?"compact":""}`}
    data-testid="quick-theme-toggle"
    onClick={toggle}
    aria-label={isDark ? "Pindah ke mode terang" : "Pindah ke mode gelap"}
    title={isDark ? "Mode Terang" : "Mode Gelap"}
  >
    {isDark ? <Sun size={18} strokeWidth={1.75}/> : <Moon size={18} strokeWidth={1.75}/>}
  </button>;
}

function ThemeToggle() {
  // Iter 74/75 — Dark mode preview (opt-in) + Auto mode ikut OS prefers-color-scheme.
  const [theme, setTheme] = useState(() => {
    try { return localStorage.getItem("tamfaris-theme") || "auto"; } catch { return "auto"; }
  });
  useEffect(() => {
    const root = document.documentElement;
    const applyEffective = () => {
      if (theme === "dark") { root.setAttribute("data-theme", "dark"); return; }
      if (theme === "light") { root.removeAttribute("data-theme"); return; }
      // auto → ikut OS
      const prefersDark = window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches;
      if (prefersDark) root.setAttribute("data-theme", "dark");
      else root.removeAttribute("data-theme");
    };
    applyEffective();
    try { localStorage.setItem("tamfaris-theme", theme); } catch {}
    // Listen ke OS change bila mode auto
    if (theme !== "auto") return;
    if (!window.matchMedia) return;
    const mql = window.matchMedia("(prefers-color-scheme: dark)");
    const listener = () => applyEffective();
    mql.addEventListener ? mql.addEventListener("change", listener) : mql.addListener(listener);
    return () => {
      mql.removeEventListener ? mql.removeEventListener("change", listener) : mql.removeListener(listener);
    };
  }, [theme]);
  return <div className="theme-toggle-wrap" data-testid="theme-toggle-wrap">
    <div className="theme-toggle-head">
      <div>
        <b>Tampilan</b>
        <p className="muted small" style={{margin:"2px 0 0"}}>Mode gelap membantu di malam hari. Otomatis ikut pengaturan HP/laptop Anda. <span className="theme-beta">PREVIEW</span></p>
      </div>
    </div>
    <div className="theme-toggle-btns" role="tablist" aria-label="Pilih tampilan">
      <button type="button" role="tab" data-testid="theme-toggle-light" className={`theme-btn ${theme==="light"?"active":""}`} onClick={()=>setTheme("light")} aria-pressed={theme==="light"}>
        <Sun size={14} strokeWidth={1.75}/>Terang
      </button>
      <button type="button" role="tab" data-testid="theme-toggle-auto" className={`theme-btn ${theme==="auto"?"active":""}`} onClick={()=>setTheme("auto")} aria-pressed={theme==="auto"}>
        <Sparkles size={14} strokeWidth={1.75}/>Otomatis
      </button>
      <button type="button" role="tab" data-testid="theme-toggle-dark" className={`theme-btn ${theme==="dark"?"active":""}`} onClick={()=>setTheme("dark")} aria-pressed={theme==="dark"}>
        <Moon size={14} strokeWidth={1.75}/>Gelap
      </button>
    </div>
  </div>;
}

function AkunOwnerModal({ user, onClose }) {
  // Iter 54 — Akun Owner (Email Recovery). Owner/Admin bisa set email, verifikasi OTP 6-digit,
  // dan menggunakan email tersebut untuk Lupa Password di halaman login.
  const [state, setState] = useState({ recovery_email:"", recovery_email_verified:false, pending_recovery_email:"", recovery_email_verified_at:null });
  const [loading, setLoading] = useState(true);
  const [step, setStep] = useState("view"); // view | input | verify | remove
  const [newEmail, setNewEmail] = useState("");
  const [currentPw, setCurrentPw] = useState("");
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const load = async () => {
    try { const r = await axios.get(`${API}/auth/recovery-email`, { withCredentials:true }); setState(r.data); }
    catch (e) { setErr(e.response?.data?.detail || "Gagal memuat status email recovery."); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);
  const sendCode = async (e) => {
    e && e.preventDefault(); setErr("");
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(newEmail)) { setErr("Format email tidak valid."); return; }
    if (!currentPw) { setErr("Password saat ini wajib diisi."); return; }
    setBusy(true);
    try {
      await axios.post(`${API}/auth/recovery-email/request`, { new_email: newEmail.trim().toLowerCase(), current_password: currentPw }, { withCredentials:true });
      setCurrentPw(""); setStep("verify"); await load();
      toast.success("Kode 6 digit dikirim. Cek inbox email tersebut (berlaku 10 menit).");
    } catch (e) { setErr(e.response?.data?.detail || "Gagal mengirim kode."); }
    finally { setBusy(false); }
  };
  const verify = async (e) => {
    e && e.preventDefault(); setErr("");
    if (!/^\d{6}$/.test(code)) { setErr("Kode wajib 6 digit angka."); return; }
    setBusy(true);
    try {
      await axios.post(`${API}/auth/recovery-email/verify`, { code }, { withCredentials:true });
      await notify.success({ title:"Email recovery terverifikasi", message:"Sekarang Anda bisa gunakan fitur Lupa Password.", primaryLabel:"Selesai" });
      setCode(""); setStep("view"); await load();
    } catch (e) { setErr(e.response?.data?.detail || "Verifikasi gagal."); }
    finally { setBusy(false); }
  };
  const remove = async () => {
    setErr("");
    if (!currentPw) { setErr("Password saat ini wajib diisi."); return; }
    setBusy(true);
    try {
      await axios.delete(`${API}/auth/recovery-email`, { withCredentials:true, data:{ current_password: currentPw } });
      await notify.success({ title:"Email recovery dihapus", message:"Fitur Lupa Password menjadi tidak aktif untuk akun ini.", primaryLabel:"Selesai" });
      setCurrentPw(""); setStep("view"); await load();
    } catch (e) { setErr(e.response?.data?.detail || "Gagal menghapus email recovery."); }
    finally { setBusy(false); }
  };
  const closeAndReset = () => { setErr(""); onClose(); };
  return <div className="modal-overlay" data-testid="akun-owner-modal" onClick={closeAndReset}>
    <div className="modal" onClick={e=>e.stopPropagation()} style={{maxWidth:460}}>
      <h3 style={{margin:"0 0 6px",display:"flex",alignItems:"center",gap:8}}><Mail size={18}/>Akun Owner</h3>
      <p className="muted small" style={{margin:"0 0 14px"}}>Email recovery dipakai untuk <strong>Lupa Password</strong> di halaman login. Kode 6 digit akan dikirim ke email ini.</p>
      {err && <div className="op-hard-delete-err" data-testid="akun-owner-error" role="alert">{err}</div>}
      <ThemeToggle/>
      {loading ? <p className="muted small">Memuat…</p> :
        step === "view" ? <div data-testid="akun-owner-view">
          <div style={{background:"#f8fafc",border:"1px solid #e5e7eb",padding:"12px 14px",borderRadius:8,marginBottom:12}}>
            <div style={{fontSize:12,color:"#64748b",marginBottom:4}}>Email Recovery</div>
            <div style={{fontWeight:600,color:"#0f172a",wordBreak:"break-all"}} data-testid="akun-owner-current-email">{state.recovery_email || "— belum di-set —"}</div>
            <div style={{marginTop:8,display:"flex",alignItems:"center",gap:6}}>
              {state.recovery_email_verified
                ? <span data-testid="akun-owner-status" style={{background:"#dcfce7",color:"#15803d",border:"1px solid #86efac",padding:"3px 10px",fontSize:11,fontWeight:700,borderRadius:20,display:"inline-flex",alignItems:"center",gap:4}}><ShieldCheck size={12}/>Terverifikasi</span>
                : state.recovery_email
                  ? <span data-testid="akun-owner-status" style={{background:"#fef3c7",color:"#92400e",border:"1px solid #fbbf24",padding:"3px 10px",fontSize:11,fontWeight:700,borderRadius:20}}>Belum Terverifikasi</span>
                  : <span data-testid="akun-owner-status" style={{background:"#f1f5f9",color:"#64748b",border:"1px solid #e2e8f0",padding:"3px 10px",fontSize:11,fontWeight:700,borderRadius:20}}>Belum di-set</span>}
              {state.pending_recovery_email && state.pending_recovery_email !== state.recovery_email && <span style={{fontSize:11,color:"#92400e"}}>&middot; menunggu verifikasi: {state.pending_recovery_email}</span>}
            </div>
          </div>
          <div style={{display:"flex",flexWrap:"wrap",gap:8,justifyContent:"flex-end"}}>
            <button type="button" className="soft-btn" onClick={closeAndReset} data-testid="akun-owner-close">Tutup</button>
            {state.recovery_email && <button type="button" className="soft-btn" onClick={()=>{ setStep("remove"); setCurrentPw(""); setErr(""); }} data-testid="akun-owner-remove-btn">Hapus Email</button>}
            {state.pending_recovery_email && !state.recovery_email_verified && <button type="button" className="soft-btn" onClick={()=>{ setStep("verify"); setCode(""); setErr(""); }} data-testid="akun-owner-continue-verify">Lanjutkan Verifikasi</button>}
            <button type="button" className="primary" data-testid="akun-owner-change-btn" onClick={()=>{ setNewEmail(state.recovery_email || ""); setCurrentPw(""); setErr(""); setStep("input"); }}>{state.recovery_email ? "Ganti Email" : "Set Email Recovery"}</button>
          </div>
        </div> :
        step === "input" ? <form onSubmit={sendCode} data-testid="akun-owner-input">
          <Field label="Email Recovery Baru" required>
            <input type="email" data-testid="akun-owner-new-email" value={newEmail} onChange={e=>setNewEmail(e.target.value)} placeholder="mis. owner@gmail.com" autoFocus autoComplete="email"/>
          </Field>
          <Field label="Password Anda Saat Ini" required>
            <input type="password" data-testid="akun-owner-current-pw" value={currentPw} onChange={e=>setCurrentPw(e.target.value)} autoComplete="current-password"/>
          </Field>
          <p className="muted small" style={{margin:"0 0 10px"}}>Kami akan kirim kode 6 digit ke email tersebut. Kode berlaku 10 menit &amp; hanya bisa dipakai sekali.</p>
          <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
            <button type="button" className="soft-btn" onClick={()=>{ setStep("view"); setErr(""); }} disabled={busy}>Kembali</button>
            <button type="submit" className="primary" data-testid="akun-owner-send-code" disabled={busy}>{busy?"Mengirim…":"Kirim Kode ke Email"}</button>
          </div>
        </form> :
        step === "verify" ? <form onSubmit={verify} data-testid="akun-owner-verify">
          <p className="muted small" style={{margin:"0 0 10px"}}>Masukkan kode 6 digit yang dikirim ke <strong>{state.pending_recovery_email || newEmail || "email Anda"}</strong>.</p>
          <Field label="Kode Verifikasi (6 digit)" required>
            <input type="text" inputMode="numeric" maxLength={6} data-testid="akun-owner-code" value={code} onChange={e=>setCode(e.target.value.replace(/\D/g,""))} autoFocus style={{fontSize:20,letterSpacing:6,fontWeight:700,textAlign:"center"}}/>
          </Field>
          <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
            <button type="button" className="soft-btn" onClick={()=>{ setStep("view"); setErr(""); }} disabled={busy}>Nanti Saja</button>
            <button type="submit" className="primary" data-testid="akun-owner-verify-submit" disabled={busy}>{busy?"Memverifikasi…":"Verifikasi Kode"}</button>
          </div>
        </form> :
        step === "remove" ? <div data-testid="akun-owner-remove">
          <p className="muted small" style={{margin:"0 0 10px"}}>Menghapus email recovery <strong>{state.recovery_email}</strong> akan menonaktifkan fitur Lupa Password untuk akun ini.</p>
          <Field label="Password Anda Saat Ini" required>
            <input type="password" data-testid="akun-owner-remove-pw" value={currentPw} onChange={e=>setCurrentPw(e.target.value)} autoComplete="current-password" autoFocus/>
          </Field>
          <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
            <button type="button" className="soft-btn" onClick={()=>{ setStep("view"); setErr(""); setCurrentPw(""); }} disabled={busy}>Batal</button>
            <button type="button" className="primary danger" data-testid="akun-owner-remove-submit" onClick={remove} disabled={busy}>{busy?"Menghapus…":"Ya, Hapus Email"}</button>
          </div>
        </div> : null
      }
    </div>
  </div>;
}

function Metric({label,value,accent,warn,icon,tone}) {
  // Iter 66 — Premium metric card: icon lembut + accent per tone (tanpa warna penuh).
  const key = label.toLowerCase().replaceAll(" ","-");
  return <div className={`metric ${accent?"accent":""} ${warn?"warn":""} ${tone?`tone-${tone}`:""}`} data-testid={`metric-${key}`} data-tone={tone||""}>
    {icon && <span className="metric-icon" aria-hidden="true">{icon}</span>}
    <span className="metric-label">{label}</span>
    <strong className="metric-value">{value}</strong>
  </div>;
}

function ReceivableTable({rows,onOpen}) {
  const [ageFilter, setAgeFilter] = useState("all"); // Iter 70 — chip filter aging
  const today = new Date();
  const allWithAging = rows.map(o => {
    const d = new Date(o.order_date || o.created_at || today);
    const ageDays = Math.max(0, Math.floor((today - d) / (1000*60*60*24)));
    let band = "age-fresh", bandLabel = "0–7 hari";
    if (ageDays > 30) { band = "age-critical"; bandLabel = ">30 hari"; }
    else if (ageDays > 14) { band = "age-orange"; bandLabel = "15–30 hari"; }
    else if (ageDays >= 7) { band = "age-warn"; bandLabel = "8–14 hari"; }
    return { o, ageDays, band, bandLabel };
  }).sort((a,b) => b.ageDays - a.ageDays);
  const cnt = { all: allWithAging.length, fresh: 0, warn: 0, orange: 0, critical: 0 };
  allWithAging.forEach(x => {
    if (x.band === "age-fresh") cnt.fresh++;
    else if (x.band === "age-warn") cnt.warn++;
    else if (x.band === "age-orange") cnt.orange++;
    else if (x.band === "age-critical") cnt.critical++;
  });
  const withAging = ageFilter === "all" ? allWithAging : allWithAging.filter(x => x.band === ageFilter);
  const total = withAging.reduce((s,{o})=>s+Number(o.remaining||0),0);
  const chips = [
    { key: "all", label: "Semua", count: cnt.all, tone: "" },
    { key: "age-fresh", label: "0–7 hari", count: cnt.fresh, tone: "fresh" },
    { key: "age-warn", label: "8–14 hari", count: cnt.warn, tone: "warn" },
    { key: "age-orange", label: "15–30 hari", count: cnt.orange, tone: "orange" },
    { key: "age-critical", label: ">30 hari", count: cnt.critical, tone: "critical" },
  ];
  if (allWithAging.length===0) return <div className="empty" data-testid="empty-receivables">Tidak ada piutang saat ini.</div>;
  return <>
    <div className="receivable-summary" data-testid="receivable-summary">
      <div><span>Total Piutang</span><strong data-testid="receivable-total">{money(total)}</strong></div>
      <div><span>Jumlah Nota</span><strong data-testid="receivable-count">{withAging.length}</strong></div>
    </div>
    <div className="age-chip-row" data-testid="age-chip-row" role="tablist">
      {chips.map(c => <button
        type="button" key={c.key} role="tab"
        data-testid={`age-chip-${c.key}`}
        className={`age-chip ${ageFilter===c.key?"active":""} tone-${c.tone||"neutral"}`}
        onClick={()=>setAgeFilter(c.key)}
        aria-pressed={ageFilter===c.key}
      >{c.label} <span className="age-chip-count">{c.count}</span></button>)}
    </div>
    {withAging.length === 0 && ageFilter !== "all" && <div className="empty" data-testid="empty-age-filter">Tidak ada piutang di kategori ini.</div>}
    <div className="receivable-cards" data-testid="receivable-cards">
      {withAging.map(({o,ageDays,band,bandLabel})=>{
        const waDigits = (o.whatsapp||"").replace(/[^0-9]/g,"");
        return <div key={o.order_number} className="rec-card" data-testid={`receivable-row-${o.order_number}`}>
          <div className="rec-head">
            <div>
              <b>{o.customer_name}</b>
              <span className="muted small">{o.order_number}</span>
            </div>
            <span className={`aging-pill ${band}`} data-testid={`receivable-aging-${o.order_number}`}>{bandLabel} · {ageDays}h</span>
          </div>
          <div className="rec-grid">
            <div><span>Total Nota</span><b>{money(o.grand_total)}</b></div>
            <div><span>Dibayar</span><b>{money(o.paid)}</b></div>
            <div><span>Sisa</span><b className="txt-warn">{money(o.remaining)}</b></div>
            <div><span>Deadline</span><b>{fmtDateID(o.deadline)}</b></div>
          </div>
          <div className="rec-actions">
            {waDigits && <a href={`https://wa.me/${waDigits}`} target="_blank" rel="noreferrer" className="soft-btn small-btn" data-testid={`receivable-wa-${o.order_number}`} onClick={e=>e.stopPropagation()}><Phone size={13}/>Hubungi</a>}
            <button type="button" className="soft-btn small-btn" data-testid={`receivable-open-${o.order_number}`} onClick={()=>onOpen(o)}><Eye size={13}/>Lihat Nota</button>
          </div>
        </div>;
      })}
    </div>
  </>;
}

function OrderTable({rows,onOpen,query}) {
  const isSearch = !!(query||"").trim();
  return <div className="table-wrap">
    {rows.length===0
      ? <div className="empty" data-testid={isSearch?"empty-search":"empty-orders"}>{isSearch ? "Pesanan tidak ditemukan." : "Belum ada pesanan."}</div>
      : <table><thead><tr><th>Nota</th><th>Pelanggan</th><th>Total</th><th>Status</th><th>Produksi</th><th>Pengambilan</th></tr></thead>
        <tbody>
          {rows.map(o=>{
            const products = o.products || [];
            // Iter 223 — Polosan auto-done.
            const doneCount = products.filter(isProductProductionDone).length;
            const prodTxt = products.length===0 ? "—" : (doneCount===products.length ? "Semua selesai" : `${doneCount}/${products.length} selesai`);
            const pickup = o.pickup_status || "Belum Diambil";
            const statusClass = o.order_status==="Dibatalkan" ? "cancel" : o.payment_status==="Lunas" ? "paid" : "pending";
            const statusText = o.order_status==="Dibatalkan" ? "Dibatalkan" : (o.payment_status || "—");
            return <tr data-testid={`order-row-${o.order_number}`} key={o.order_number} onClick={()=>onOpen(o)}>
              <td><b>{o.order_number}</b><small>{fmtDateID(o.deadline)}</small></td>
              <td>{o.customer_name}<small>{o.whatsapp}</small></td>
              <td>{money(o.grand_total)}</td>
              <td><span className={`status ${statusClass}`}>{statusText}</span></td>
              <td data-testid={`order-row-prod-${o.order_number}`}>{prodTxt}</td>
              <td data-testid={`order-row-pickup-${o.order_number}`}>{pickup}</td>
            </tr>;
          })}
        </tbody>
      </table>
    }
  </div>;
}

// Mobile-first Card list for Admin Toko (replaces horizontal-scroll table).
// Iter 224 Fix #5 + Iter 224c: Lazy render + infinite auto-load.
//   - Initial batch 100 card supaya render awal cepat.
//   - Sentinel div di bawah list dipantau IntersectionObserver → auto-append batch 100
//     berikutnya saat user scroll mendekati bawah. Tombol "Muat lebih banyak" tetap ada
//     sbg fallback (mis. browser tanpa IO support) & indikator progres.
//   - Motivasi: 2790+ nota di Live → render sekaligus freeze browser; sekaligus user
//     expect scroll seamless (bukan harus tap tombol).
const ORDERS_CARDS_PAGE = 100;
function OrdersCardList({rows,onOpen,onDuplicate,frequentSet,query,user,operator,onOrderUpdated,isAdminToko=false}) {
  // Iter 118 — State modal preview mockup (klik thumbnail → open full-size).
  const [mockupPreview, setMockupPreview] = useState(null); // {order_number, customer_name} atau null
  const [visibleCount, setVisibleCount] = useState(ORDERS_CARDS_PAGE);
  // Reset paging saat rows berubah (mis. filter/query berubah).
  useEffect(() => { setVisibleCount(ORDERS_CARDS_PAGE); }, [rows]);
  const sentinelRef = useRef(null);
  // Iter 230 — quickBusy: order_number sedang diproses quick pickup Polosan (harus di atas early return supaya
  //   Rules of Hooks: hook dipanggil di urutan yg sama tiap render).
  const [quickBusy, setQuickBusy] = useState(null);
  // Iter 239 — Quick action Owner: Selesai Darurat + Ambil langsung di card Pesanan.
  //   Reuse endpoint /orders/{n}/complete-override (Iter 229) + /orders/{n}/pickup + applyOrderUpdate (Iter 227).
  const [overrideOrder, setOverrideOrder] = useState(null);
  const [overrideReason, setOverrideReason] = useState("Rekonsiliasi data lama");
  const [overrideSaving, setOverrideSaving] = useState(false);
  const openOverride = (o) => { setOverrideOrder(o); setOverrideReason("Rekonsiliasi data lama"); };
  const closeOverride = () => { if (!overrideSaving) { setOverrideOrder(null); setOverrideReason("Rekonsiliasi data lama"); } };
  const submitOverride = async () => {
    if (!overrideOrder) return;
    const reason = overrideReason.trim();
    if (!reason) { notify.warning({ title:"Alasan wajib", message:"Isi alasan Selesai Darurat." }); return; }
    setOverrideSaving(true);
    try {
      const r = await axios.post(`${API}/orders/${overrideOrder.order_number}/complete-override`,
        { reason }, { withCredentials: true });
      if (r?.data && typeof onOrderUpdated === "function") onOrderUpdated(r.data);
      toast.success(`${overrideOrder.order_number} · Ditandai Selesai Darurat`);
      setOverrideOrder(null);
    } catch (e) {
      notify.error({ title:"Gagal Selesai Darurat", message: e.response?.data?.detail || "Silakan coba lagi." });
    } finally {
      setOverrideSaving(false);
    }
  };
  // Iter 224c — Auto-load next batch saat sentinel masuk viewport.
  useEffect(() => {
    if (typeof IntersectionObserver === "undefined") return;
    const el = sentinelRef.current;
    if (!el) return;
    if (visibleCount >= rows.length) return;
    const io = new IntersectionObserver((entries) => {
      if (entries.some(e => e.isIntersecting)) {
        setVisibleCount(v => Math.min(v + ORDERS_CARDS_PAGE, rows.length));
      }
    }, { rootMargin: "300px 0px" });
    io.observe(el);
    return () => io.disconnect();
  }, [visibleCount, rows.length]);
  const isSearch = !!(query||"").trim();
  if (rows.length === 0) {
    return <div className="empty" data-testid={isSearch?"empty-search":"empty-orders"}>{isSearch ? "Pesanan tidak ditemukan." : "Belum ada pesanan."}</div>;
  }
  const waHref = (num) => {
    const digits = String(num||"").replace(/\D/g,"");
    if (!digits) return null;
    const normalized = digits.startsWith("0") ? "62"+digits.slice(1) : digits;
    return `https://wa.me/${normalized}`;
  };
  // Iter 230 — Quick Action "Ambil" utk Polosan. Cek permission actor.
  //   Owner/Admin (session user) — allowed
  //   Admin Toko operator — allowed
  //   Plain operator — TIDAK ditampilkan
  const canQuickPickup = (user && ["owner","admin"].includes(String(user.role||"").toLowerCase()))
                      || (operator && operator.is_admin_toko);
  const isOwner = String(user?.role || "").toLowerCase() === "owner";
  const quickPickup = async (o, opts = {}) => {
    // Guard: harus Lunas — tidak bypass syarat pembayaran (spec Iter 239)
    if (o.payment_status !== "Lunas") {
      toast.warning("Nota belum lunas — tambah pembayaran dulu");
      return;
    }
    const isOwnerGeneric = !!opts.ownerGeneric;
    const isAdminTokoAmbil = !!opts.adminTokoAmbil;
    const ok = await notify.confirm({
      title: isAdminTokoAmbil
        ? "Pastikan barang sudah diserahkan"
        : (isOwnerGeneric ? "Tandai pesanan ini sudah diambil?" : "Tandai Diambil sekarang?"),
      message: isAdminTokoAmbil
        ? `Pastikan barang untuk nota ${o.order_number}${o.customer_name?` — ${o.customer_name}`:""} sudah diserahkan kepada pelanggan.`
        : (isOwnerGeneric
            ? `Nota ${o.order_number}${o.customer_name?` — ${o.customer_name}`:""} akan ditandai Diambil.`
            : `Barang Polosan untuk nota ${o.order_number} (${o.customer_name||"—"}) sudah diambil pelanggan?`),
      primaryLabel: isAdminTokoAmbil ? "Ya, sudah diserahkan" : (isOwnerGeneric ? "Ya, Diambil" : "Ya, Ambil"),
      secondaryLabel: "Batal",
    });
    if (!ok) return;
    setQuickBusy(o.order_number);
    try {
      // Iter 239 — Owner generic Ambil: kalau produk belum semua "done" tapi order_status
      //   sudah Selesai (via Selesai Darurat) → kirim override=true dgn reason otomatis
      //   supaya validasi backend lolos. Payment tetap wajib Lunas (dijaga di atas).
      const products = o.products || [];
      const allDone = products.length > 0 && products.every(isProductProductionDone);
      const needsOverride = isOwnerGeneric && !allDone;
      const r = await axios.post(`${API}/orders/${o.order_number}/pickup`,
        {
          note: "",
          override: needsOverride,
          reason: needsOverride ? "Ambil cepat Owner — nota rekonsiliasi/darurat" : "",
        },
        { withCredentials: true });
      if (r?.data && typeof onOrderUpdated === "function") onOrderUpdated(r.data);
      toast.success(`${o.order_number} · Ditandai Diambil`);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Gagal menandai Diambil");
    } finally {
      setQuickBusy(null);
    }
  };
  const shownRows = rows.slice(0, visibleCount);
  const hasMore = rows.length > visibleCount;
  return <div className="orders-card-list" data-testid="orders-card-list">
    {shownRows.map((o, idx) => {
      const products = o.products || [];
      // Iter 97 — Fix field mapping (dulu p.qty/p.product_name yg tidak ada di data → card kosong).
      const qtyOf = (p) => Number(p.quantity)||(Array.isArray(p.sizes)?p.sizes.reduce((a,s)=>a+Number(s.quantity||0),0):0);
      const nameOf = (p) => p.custom_name || p.name || "Produk (tanpa nama)";
      const totalQty = products.reduce((s,p)=>s+qtyOf(p),0);
      // Iter 223 — Polosan auto-done → mempengaruhi `canMarkPicked` di card Admin Toko.
      const doneCount = products.filter(isProductProductionDone).length;
      // Iter 243 — Badge Produksi di card = tahap/divisi produksi saat ini (bukan nama orang).
      //   Semua produksi selesai → "Produksi: Selesai". Ada tahap aktif → "Proses: {stage(s)}".
      //   Paralel → gabung " + ". "Perlu Diperiksa" TETAP ditampilkan apa adanya supaya status
      //   asli tidak hilang. Hanya kalau stage benar-benar kosong ("") baru fallback ke
      //   "Menunggu Proses". Angka 0/N tetap tersedia di Detail Nota.
      const _procStages = Array.from(new Set((products||[])
        .filter(p => !isProductProductionDone(p))
        .map(p => String(p.production_stage || "").trim())
        .filter(s => s)
      ));
      let prodTxt;
      if (products.length === 0) prodTxt = "—";
      else if (doneCount === products.length) prodTxt = "Produksi: Selesai";
      else if (_procStages.length === 0) prodTxt = "Menunggu Proses";
      else prodTxt = `Proses: ${_procStages.join(" + ")}`;
      const prodClass = products.length>0 && doneCount===products.length ? "prod-done" : "prod-wip";
      const pickup = o.pickup_status || "Belum Diambil";
      const pickupClass = pickup === "Diambil" ? "pickup-picked" : "pickup-pending";
      const cancelled = o.order_status === "Dibatalkan";
      const isLunas = o.payment_status === "Lunas";
      const allDone = products.length > 0 && doneCount === products.length;
      const canMarkPicked = isLunas && allDone && pickup !== "Diambil" && !cancelled;
      // Iter 230 — Detect Polosan: SEMUA produk pakai jalur Polosan (Siap Stok / Perlu Jahit)
      //   → tidak perlu buka Detail untuk pickup. Quick Action "Ambil" muncul di kartu.
      const isPolosanOrder = products.length > 0 && products.every(p => POLOSAN_ROUTES.has(p.production_route));
      const canQuickAmbil = canQuickPickup && isPolosanOrder && isLunas && pickup !== "Diambil" && !cancelled;
      // Iter 239 — Owner-only quick actions di card.
      //   Selesai Darurat: eligible sama dgn detail button (Iter 229).
      //   Owner Ambil generic: Lunas + belum diambil + (allDone atau order sudah Selesai
      //   via override). Non-Polosan supaya tidak dobel dgn canQuickAmbil.
      const canOwnerCompleteOverride = canShowCompleteOverride(o, isOwner);
      const canOwnerQuickAmbil = canShowOwnerAmbil(o, isOwner) && !canQuickAmbil;
      // Iter 505 — Admin Toko quick "Tandai Diambil" dengan syarat STRICT:
      //   - Lunas + allDone + order_status === "Selesai" (via finalisasi existing)
      //   - Belum Diambil/Dikirim/Dibatalkan
      //   - Bukan Polosan Siap Stok (sudah pakai canQuickAmbil)
      //   - Bukan Owner (Owner pakai canOwnerQuickAmbil yang lebih longgar untuk kasus Selesai Darurat)
      //   Backend `/orders/{n}/pickup` tetap validasi payment+allDone sendiri → aman.
      const canAdminTokoAmbil = !!operator?.is_admin_toko
                                && !isOwner
                                && isLunas && allDone
                                && o.order_status === "Selesai"
                                && pickup !== "Diambil"
                                && o.order_status !== "Dikirim"
                                && !cancelled
                                && !canQuickAmbil;
      // Tandai Diambil (buka Detail) sekarang dihide utk Owner kalau quick Ambil sudah tersedia,
      // supaya tidak ada dua tombol dgn semantik serupa.
      //   Iter 505 — Juga disembunyikan ketika canAdminTokoAmbil tersedia.
      const showTandaiDiambilBtn = canMarkPicked && !canQuickAmbil && !canOwnerQuickAmbil && !canAdminTokoAmbil;
      const payClass = cancelled ? "cancel" : (isLunas ? "paid" : "pending");
      const payText = cancelled ? "Dibatalkan" : (o.payment_status || "—");
      const remaining = Number(o.remaining || 0);
      const paid = Number(o.grand_total||0) - remaining;
      const productSummary = products.length === 0
        ? "Belum ada produk"
        : products.slice(0,2).map(p => { const q=qtyOf(p); return `${nameOf(p)}${q?` ×${q}`:""}`;}).join(", ") + (products.length>2 ? ` +${products.length-2} lagi` : "");
      // Iter 97 — Tahap aktif + PIC untuk info ringkas
      const activeStages = products
        .map(p => ({ stage: p.production_stage || "—", pic: p.production_pic || (p.production_stage ? "—" : "—") }))
        .filter(x => x.stage !== "Selesai" && x.stage !== "—");
      const uniqStageKeys = Array.from(new Set(activeStages.map(x=>`${x.stage}·${x.pic}`)));
      const stagePicText = activeStages.length === 0
        ? (allDone ? "Semua selesai" : "—")
        : (uniqStageKeys.length === 1 ? `${activeStages[0].stage}${activeStages[0].pic&&activeStages[0].pic!=="—"?` · Operator ${activeStages[0].pic}`:""}` : `Beberapa tahap (${uniqStageKeys.length})`);
      // Iter 356 — Label "Proses sekarang" & "Petugas" mengikuti DATA (bedakan
      //   menunggu vs sedang dikerjakan berdasarkan keberadaan PIC/claim). Dipakai
      //   di card Admin Toko. Grouping per stage dengan claimed flag.
      // Iter 372 — Tahap pasif (Selesai/Toko/Perlu Diperiksa) di-exclude dari daftar
      //   tahap aktif. Baris Petugas hanya tampil saat ada tahap aktif, dan tiap
      //   tahap dicocokkan dengan PIC sebenarnya (tidak ada "Lihat rincian").
      const AT_PASSIVE_STAGES = new Set(["Selesai", "Toko", "Perlu Diperiksa"]);
      const atStageGroups = (() => {
        const map = new Map();
        for (const p of products) {
          const s = p.production_stage || "";
          if (!s || AT_PASSIVE_STAGES.has(s)) continue;
          if (!map.has(s)) map.set(s, { pics: new Set(), claimed: false });
          const g = map.get(s);
          const pic = p.production_pic;
          if (pic && pic !== "—") { g.pics.add(pic); g.claimed = true; }
        }
        return Array.from(map.entries()).map(([stage, g]) => ({ stage, pics: Array.from(g.pics), claimed: g.claimed }));
      })();
      const atProcessLabel = (stage, hasPic) => {
        const inProgress = {
          "Mockup": "Mockup sedang dikerjakan",
          "Gudang": "Barang sedang disiapkan",
          "Bordir": "Sedang dibordir",
          "Sablon/DTF": "Sedang disablon",
          "Mesin Press": "Sedang di-press",
          "Jersey/Sublim": "Sedang disublim",
          "Toko": "Sedang disiapkan di Toko",
          "Perlu Diperiksa": "Perlu diperiksa",
        };
        const waiting = {
          "Mockup": "Menunggu pengerjaan mockup",
          "Gudang": "Menunggu barang disiapkan",
          "Bordir": "Menunggu antrean bordir",
          "Sablon/DTF": "Menunggu antrean sablon",
          "Mesin Press": "Menunggu antrean press",
          "Jersey/Sublim": "Menunggu antrean sublim",
          "Toko": "Menunggu di Toko",
          "Perlu Diperiksa": "Perlu diperiksa",
        };
        return hasPic ? (inProgress[stage] || `${stage} sedang dikerjakan`) : (waiting[stage] || `Menunggu antrean ${stage}`);
      };
      // Iter 372 — Teks Proses + daftar PIC per tahap aktif.
      //   - allDone / order_status terminal → "Produksi selesai" (atau label pasif).
      //   - atStageGroups=[] tapi produk ada di tahap pasif → ambil label pasif.
      //   - Satu tahap aktif → label sesuai tahap + claim.
      //   - Multi tahap aktif → gabung "Mockup (menunggu) · Bordir" dsb.
      const atHasToko = products.some(p => (p.production_stage || "") === "Toko");
      const atHasPerlu = products.some(p => (p.production_stage || "") === "Perlu Diperiksa");
      const atPassiveLabel = o.order_status === "Menunggu Finalisasi"
        ? "Di Shella (menunggu diterima)"
        : (atHasToko ? "Menunggu di Toko"
            : (atHasPerlu ? "Perlu diperiksa"
                : "Semua selesai"));
      // Iter 506 — Label paralel ramah-manusia untuk kartu Admin Toko.
      //   Backend `STAGE_PARALLEL_TRACKS`: {sablon, gudang} di Sablon Paralel,
      //   {bordir_design, gudang, sablon} di Persiapan Paralel. Untuk masing-
      //   masing track dibaca `parallel_status.{key}_done` / `_claimed_by`.
      //   Agregasi lintas produk (worst state wins: pending > wip > done).
      const PARALLEL_TRACKS = {
        "Sablon Paralel": [["sablon","Sablon"], ["gudang","Gudang"]],
        "Persiapan Paralel": [["bordir_design","Bordir"], ["gudang","Gudang"], ["sablon","Sablon"]],
      };
      const joinAnd = (arr) => {
        if (!arr || arr.length === 0) return "";
        if (arr.length === 1) return arr[0];
        if (arr.length === 2) return `${arr[0]} dan ${arr[1]}`;
        return `${arr.slice(0,-1).join(", ")}, dan ${arr[arr.length-1]}`;
      };
      const parallelLabelForStage = (stageName) => {
        const tracks = PARALLEL_TRACKS[stageName];
        if (!tracks) return "";
        // Agregasi state per track lintas produk pada nota ini.
        const stateByKey = {};
        tracks.forEach(([k]) => { stateByKey[k] = "done"; }); // optimistic start
        let anyProduct = false;
        for (const p of products) {
          if ((p.production_stage || "") !== stageName) continue;
          anyProduct = true;
          const ps = p.parallel_status || {};
          for (const [k] of tracks) {
            const done = !!ps[`${k}_done`];
            const claimed = !!ps[`${k}_claimed_by`];
            const cur = done ? "done" : (claimed ? "wip" : "pending");
            // worst state wins: pending > wip > done
            const prior = { "pending":2, "wip":1, "done":0 };
            if (prior[cur] > prior[stateByKey[k]]) stateByKey[k] = cur;
          }
        }
        if (!anyProduct) return "";
        const items = tracks.map(([k, label]) => ({ label, state: stateByKey[k] }));
        const pending = items.filter(x => x.state === "pending").map(x => x.label);
        const wip     = items.filter(x => x.state === "wip").map(x => x.label);
        const done    = items.filter(x => x.state === "done").map(x => x.label);
        if (pending.length === 0 && wip.length === 0 && done.length) return `${joinAnd(done)} selesai`;
        if (wip.length === 0 && done.length === 0 && pending.length)  return `Menunggu ${joinAnd(pending)}`;
        if (pending.length === 0 && done.length === 0 && wip.length)  return `${joinAnd(wip)} sedang diproses`;
        const parts = [];
        if (done.length)    parts.push(`${joinAnd(done)} selesai`);
        if (wip.length)     parts.push(`${joinAnd(wip)} dikerjakan`);
        if (pending.length) parts.push(`menunggu ${joinAnd(pending)}`);
        return parts.join(", ");
      };
      const atProcessText = allDone
        ? "Produksi selesai"
        : atStageGroups.length === 0
          ? atPassiveLabel
          : atStageGroups.length === 1
            ? (PARALLEL_TRACKS[atStageGroups[0].stage]
                ? (parallelLabelForStage(atStageGroups[0].stage) || atProcessLabel(atStageGroups[0].stage, atStageGroups[0].claimed))
                : atProcessLabel(atStageGroups[0].stage, atStageGroups[0].claimed))
            : atStageGroups.map(g => PARALLEL_TRACKS[g.stage]
                ? (parallelLabelForStage(g.stage) || `${g.stage}${g.claimed ? "" : " (menunggu)"}`)
                : `${g.stage}${g.claimed ? "" : " (menunggu)"}`
              ).join(" · ");
      // Iter 502 — "Proses pengerjaan" (jenis kerja) dari field existing per produk.
      //   Source-of-truth: `p.process_mode` dgn fallback derive dari `p.production_route`.
      //   Multi-produk → gabung badge UNIK (tanpa duplikasi). Label user-friendly.
      //   TIDAK mengubah workflow/routing/status.
      const atWorkTypesText = (() => {
        const seen = new Set();
        const out = [];
        for (const p of products) {
          const pr = String(p.production_route || "");
          const mode = String(p.process_mode || "").trim();
          // Polosan di-handle lewat route karena process_mode-nya kosong.
          let label = "";
          if (POLOSAN_ROUTES.has(pr)) label = "Polosan";
          else if (mode === "Bordir") label = "Bordir";
          else if (mode === "Sablon") label = "Sablon / DTF";
          else if (mode === "Bordir+Sablon") label = "Bordir + Sablon";
          else if (mode === "Jahit") label = "Jahit saja";
          else if (mode === "Jahit+Bordir") label = "Jahit + Bordir";
          else if (mode === "Jahit+Sablon") label = "Jahit + Sablon";
          else if (mode === "Sublim") label = "Jersey / Sublim";
          else {
            // Fallback derive dari route legacy (nota lama tanpa process_mode).
            if (pr === "Bordir") label = "Bordir";
            else if (pr.startsWith("Bordir + Sablon")) label = "Bordir + Sablon";
            else if (pr.startsWith("Sablon (") || pr === "Sablon/DTF" || pr === "Sablon/DTF + Press") label = "Sablon / DTF";
            else if (pr === "Jersey/Sublim") label = "Jersey / Sublim";
          }
          if (label && !seen.has(label)) { seen.add(label); out.push(label); }
        }
        return out.join(" · ");
      })();
      // Iter 372 — picPerStage: cocokkan nama PIC dengan tahap masing-masing.
      //   "Belum ditugaskan" HANYA bila pics kosong di tahap aktif tsb. Baris
      //   Petugas disembunyikan saat tidak ada tahap aktif.
      const atPicPerStage = atStageGroups.map(g => ({
        stage: g.stage,
        label: g.pics.length ? g.pics.join(", ") : "Belum ditugaskan",
      }));
      const atHasActiveStages = atStageGroups.length > 0;
      const atPicText = atPicPerStage.length === 1
        ? atPicPerStage[0].label
        : atPicPerStage.map(x => `${x.stage}: ${x.label}`).join(" · ");
      const wa = waHref(o.whatsapp);
      // Iter 99 — Pin merah "Deadline Hari Ini": kondisi longgar — pin muncul selama nota aktif,
      // belum diambil, belum dibatalkan. Termasuk produk yang sudah selesai (justru prioritas pickup hari ini!).
      const isDeadlineToday = !!(o.deadline && o.deadline === localDate() && !cancelled && pickup !== "Diambil");
      // Iter 250 — Chip oranye "Terlambat" via single source-of-truth `isOrderLate`.
      //   Exclude order_status {Menunggu Finalisasi, Selesai, Diambil, Dikirim, Dibatalkan},
      //   Real Draft, dan stage "Perlu Diperiksa" (legacy artifact).
      const isOverdue = isOrderLate(o, localDate());
      // Iter 104 — Hitung hari telat (selisih hari kalender dari deadline ke hari ini, WIB).
      const daysLate = isOverdue ? Math.max(1, Math.round((new Date(localDate()) - new Date(o.deadline)) / 86400000)) : 0;
      // Iter 585 — Deadline dekat (1–2 hari lagi) untuk nota aktif yang belum selesai produksi.
      const daysLeft = o.deadline ? Math.round((new Date(o.deadline) - new Date(localDate())) / 86400000) : NaN;
      const isDeadlineSoon = !isOverdue && !isDeadlineToday && !cancelled && pickup !== "Diambil" && !allDone
        && !["Dikirim", "Draft"].includes(o.order_status) && daysLeft >= 1 && daysLeft <= 2;
      return <article key={o.order_number} className="order-card" data-testid={`order-card-${o.order_number}`}>
        {/* Iter 68 — Legacy testid aliases (backward compat dgn OrderTable tests) */}
        <span data-testid={`order-row-${o.order_number}`} style={{position:"absolute",width:0,height:0,overflow:"hidden"}}/>
        <span data-testid={`order-row-prod-${o.order_number}`} style={{position:"absolute",width:0,height:0,overflow:"hidden"}}>{prodTxt}</span>
        <span data-testid={`order-row-pickup-${o.order_number}`} style={{position:"absolute",width:0,height:0,overflow:"hidden"}}>{pickup}</span>
        {isAdminToko ? (
          // Iter 356 — Admin Toko: body pakai <div> (bukan <button>) agar <button>
          //   MonitorThumb di dalam kartu valid secara DOM nesting. Aksesibilitas
          //   tetap terjaga via tombol "Detail" di footer.
          <div
            className="order-card-body order-card-body-at"
            data-testid={`order-card-open-${o.order_number}`}
            data-lihat-nota={idx === 0 ? "true" : undefined}
            onClick={(e)=>{
              // Jangan trigger onOpen bila klik berasal dari elemen interaktif internal.
              const t = e.target;
              if (t && t.closest && t.closest("button, a, [role='button'], details, summary")) return;
              onOpen(o);
            }}
            role="button"
            tabIndex={-1}
            aria-label={`Buka detail pesanan ${o.order_number}`}
          >
            {idx === 0 && <span data-testid="order-card-lihat-nota" style={{position:"absolute",width:0,height:0,overflow:"hidden"}}/>}
            <div className="at-card-identity" data-testid={`at-card-identity-${o.order_number}`}>
              <div className="at-card-thumb-wrap" onClick={e=>e.stopPropagation()}>
                <MonitorThumb orderNumber={o.order_number}
                  onOpen={()=>setMockupPreview({order_number:o.order_number, customer_name:o.customer_name})}/>
              </div>
              <div className="at-card-ident-text">
                <div className="at-card-ident-head">
                  <b className="at-card-customer" data-testid={`order-card-cust-${o.order_number}`}>{o.customer_name || "—"}</b>
                  {frequentSet && frequentSet.has(`${o.customer_name || ""}|${o.whatsapp || ""}`) && <span className="frequent-badge" data-testid={`order-card-frequent-${o.order_number}`} title="Pelanggan Sering (≥ 3 nota)"><Star size={11} aria-hidden="true"/>Sering</span>}
                  <span className={`status status-pill ${payClass}`} data-testid={`order-card-pay-${o.order_number}`}>{payText}</span>
                </div>
                <div className="at-card-ident-sub">
                  <span className="at-card-nota" data-testid={`order-card-nota-${o.order_number}`}>{o.order_number}</span>
                  {o.whatsapp && <span className="at-card-wa">{o.whatsapp}</span>}
                </div>
                <p className="at-card-prod-summary" data-testid={`order-card-products-${o.order_number}`}>
                  {productSummary}{totalQty>0 ? ` · ${totalQty} pcs` : ""}
                </p>
                {(isOverdue || isDeadlineToday || isDeadlineSoon) && <div className="at-card-ident-pins">
                  {isDeadlineSoon && <span className="order-card-soon-pin" data-testid={`order-card-soon-${o.order_number}`}>
                    Deadline {daysLeft === 1 ? "besok" : "2 hari lagi"}</span>}
                  {isOverdue && <span className="order-card-overdue-pin" data-testid={`order-card-overdue-${o.order_number}`} title={`Deadline ${daysLate} hari lalu`}>
                    <span className="order-card-overdue-dot"/>Terlambat {daysLate} hari
                  </span>}
                  {isDeadlineToday && <span className="order-card-today-pin" data-testid={`order-card-today-${o.order_number}`} title="Deadline hari ini">
                    <span className="order-card-today-dot"/>Deadline Hari Ini
                  </span>}
                </div>}
              </div>
            </div>
            <div className="at-card-details">
              {/* Iter 502 — Baris "Proses pengerjaan": tipe kerja (Bordir/Sablon/dst)
                  dari `process_mode` existing. Letaknya tepat SEBELUM "Proses sekarang"
                  supaya Admin Toko langsung tahu jenis pengerjaannya. */}
              {atWorkTypesText && (
                <div className="at-card-row at-card-row-stack" data-testid={`order-card-worktypes-row-${o.order_number}`}>
                  <span className="at-card-row-label">Proses pengerjaan</span>
                  <span className="at-card-row-process at-card-row-worktypes" data-testid={`order-card-worktypes-${o.order_number}`}>{atWorkTypesText}</span>
                </div>
              )}
              <div className="at-card-row at-card-row-stack">
                <span className="at-card-row-label">Proses sekarang</span>
                <span className={`at-card-row-process ${allDone ? "is-done" : (cancelled ? "is-muted" : "")}`} data-testid={`order-card-prod-${o.order_number}`}>{atProcessText}</span>
              </div>
              {/* Iter 372 — Baris Petugas HANYA tampil saat ada tahap aktif. Tahap
                  pasif / produksi selesai / menunggu pengambilan → disembunyikan.
                  Riwayat PIC tetap bisa dibuka lewat tombol detail nota. */}
              {atHasActiveStages && (
                <div className="at-card-row">
                  <span className="at-card-row-label">Operator:</span>
                  <span className="at-card-row-value" data-testid={`order-card-pic-${o.order_number}`}>{atPicText}</span>
                </div>
              )}
              <div className="at-card-row">
                <span className="at-card-row-label">Batas selesai:</span>
                <span className="at-card-row-value at-card-row-deadline" data-testid={`order-card-deadline-${o.order_number}`}>
                  <Calendar size={13} aria-hidden="true"/>
                  <span>{fmtDateID(o.deadline)}</span>
                </span>
              </div>
              {/* Iter 507 — Baris Status pengambilan HANYA tampil saat relevan:
                  - Masih produksi (allDone=false & status aktif) → sembunyi (tidak clutter)
                  - allDone & belum diambil & bukan Dikirim/Dibatalkan → "Siap Diambil"
                  - Sudah Diambil → tampilkan tag "Diambil"
                  - Dikirim / Dibatalkan → sembunyi (bukan menunggu pengambilan)
                  Tidak mengubah status/workflow/data — hanya UI. */}
              {(() => {
                const picked = pickup === "Diambil";
                const terminated = cancelled || o.order_status === "Dikirim";
                const showChip = picked || (allDone && !terminated);
                if (!showChip) return null;
                const chipText = picked ? "Diambil" : "Siap Diambil";
                const chipCls = picked ? "pickup-picked" : "pickup-ready";
                return (
                  <div className="at-card-row at-card-row-pickup">
                    <span className="at-card-row-label">Status pengambilan:</span>
                    <span className={`at-card-pickup-chip ${chipCls}`} data-testid={`order-card-pickup-${o.order_number}`}>{chipText}</span>
                  </div>
                );
              })()}
            </div>
            <div className="order-card-money">
              <div className="order-card-money-item">
                <span>Total</span>
                <b data-testid={`order-card-total-${o.order_number}`}>{money(o.grand_total)}</b>
              </div>
              <div className="order-card-money-item">
                <span>Dibayar</span>
                <b className="paid-txt" data-testid={`order-card-paid-${o.order_number}`}>{money(paid)}</b>
              </div>
              <div className="order-card-money-item">
                <span>Sisa</span>
                <b className={remaining>0?"remain-txt":"paid-txt"} data-testid={`order-card-remaining-${o.order_number}`}>{money(remaining)}</b>
              </div>
            </div>
          </div>
        ) : (
        <button
          type="button"
          className="order-card-body"
          data-testid={`order-card-open-${o.order_number}`}
          data-lihat-nota={idx === 0 ? "true" : undefined}
          onClick={()=>onOpen(o)}
          aria-label={`Buka detail pesanan ${o.order_number}`}
        >
          {/* Iter 81 — Generic anchor testid untuk testing agent (rekomendasi Iter 49) */}
          {idx === 0 && <span data-testid="order-card-lihat-nota" style={{position:"absolute",width:0,height:0,overflow:"hidden"}}/>}
          <header className="order-card-head">
            <img
              className="order-card-thumb"
              data-testid={`order-card-thumb-${o.order_number}`}
              src={`${API}/orders/${encodeURIComponent(o.order_number)}/nota.thumb.png`}
              loading="lazy"
              alt=""
              title="Klik untuk lihat mockup penuh"
              onClick={(e)=>{ e.stopPropagation(); setMockupPreview({order_number:o.order_number, customer_name:o.customer_name}); }}
              onError={(e)=>{ e.currentTarget.style.display="none"; }}
            />
            <div className="order-card-head-left">
              <span className="order-card-nota">{o.order_number}</span>
              <span className="order-card-deadline">Deadline · {fmtDateID(o.deadline)}</span>
            </div>
            <div className="order-card-head-right">
              {isOverdue && <span className="order-card-overdue-pin" data-testid={`order-card-overdue-${o.order_number}`} title={`Deadline ${daysLate} hari lalu`}>
                <span className="order-card-overdue-dot"/>Terlambat · {daysLate} hari
              </span>}
              {isDeadlineToday && <span className="order-card-today-pin" data-testid={`order-card-today-${o.order_number}`} title="Deadline hari ini">
                <span className="order-card-today-dot"/>Deadline Hari Ini
              </span>}
              <span className={`status ${payClass}`} data-testid={`order-card-pay-${o.order_number}`}>{payText}</span>
            </div>
          </header>
          <div className="order-card-cust">
            <b data-testid={`order-card-cust-${o.order_number}`}>{o.customer_name || "—"}</b>
            {/* Iter 214 — Badge Pelanggan Sering (≥ 3 nota) */}
            {frequentSet && frequentSet.has(`${o.customer_name || ""}|${o.whatsapp || ""}`) && <span className="frequent-badge" data-testid={`order-card-frequent-${o.order_number}`} title="Pelanggan Sering (≥ 3 nota)"><Star size={11} aria-hidden="true"/>Sering</span>}
            {o.whatsapp && <small>{o.whatsapp}</small>}
          </div>
          <div className="order-card-prod-line">
            <span className="order-card-prod-summary" data-testid={`order-card-products-${o.order_number}`}>{productSummary}{totalQty>0 && <span className="muted small"> · {totalQty} pcs</span>}</span>
          </div>
          <div className="order-card-tags">
            <span className={`order-card-chip ${prodClass}`} data-testid={`order-card-prod-${o.order_number}`}>{prodTxt}</span>
            <span className={`order-card-chip ${pickupClass}`} data-testid={`order-card-pickup-${o.order_number}`}>{pickup}</span>
          </div>
          <div className="order-card-money">
            <div className="order-card-money-item">
              <span>Total</span>
              <b data-testid={`order-card-total-${o.order_number}`}>{money(o.grand_total)}</b>
            </div>
            <div className="order-card-money-item">
              <span>Dibayar</span>
              <b className="paid-txt" data-testid={`order-card-paid-${o.order_number}`}>{money(paid)}</b>
            </div>
            <div className="order-card-money-item">
              <span>Sisa</span>
              <b className={remaining>0?"remain-txt":"paid-txt"} data-testid={`order-card-remaining-${o.order_number}`}>{money(remaining)}</b>
            </div>
          </div>
        </button>
        )}
        <footer className="order-card-actions">
          <button
            type="button"
            className="soft-btn small-btn"
            data-testid={`order-card-detail-${o.order_number}`}
            onClick={()=>onOpen(o)}
          ><Eye size={14}/>Detail</button>
          {remaining > 0 && !cancelled && <button
            type="button"
            className="primary small-btn"
            data-testid={`order-card-pay-${o.order_number}`}
            onClick={()=>onOpen(o)}
          ><Wallet size={14}/>{o.payment_status==="Belum Bayar" ? "Tambah DP" : "Lunasi"}</button>}
          {canMarkPicked && showTandaiDiambilBtn && <button
            type="button"
            className="primary small-btn order-card-pickup-btn"
            data-testid={`order-card-pickup-${o.order_number}`}
            onClick={()=>onOpen(o)}
          ><Truck size={14}/>Tandai Diambil</button>}
          {/* Iter 320 — Menu Lainnya khusus Admin Toko: Cetak / Salin / Hubungi.
              Native <details> + <summary> → zero deps, aksesibel, auto-close kalau user tap luar.
              Isi tombol memakai logika yang sama persis (print, duplicate, wa) sehingga akses
              dan validasi lama tetap berlaku. */}
          {isAdminToko && <details className="order-card-more" data-testid={`order-card-more-${o.order_number}`} onClick={e=>e.stopPropagation()}>
            <summary className="order-card-more-btn soft-btn small-btn" aria-label="Lainnya">
              <MoreHorizontal size={16} aria-hidden="true"/>
              <span className="visually-hidden">Lainnya</span>
            </summary>
            <div className="order-card-more-menu" role="menu">
              <button
                type="button"
                role="menuitem"
                className="order-card-more-item"
                data-testid={`order-card-print-${o.order_number}`}
                onClick={async (e)=>{
                  e.stopPropagation();
                  const btn = e.currentTarget;
                  const prevHTML = btn.innerHTML;
                  btn.disabled = true;
                  btn.innerHTML = "Menyiapkan…";
                  try {
                    const url = `${API}/orders/${encodeURIComponent(o.order_number)}/nota.pdf`;
                    const r = await printPdfFromUrl(url);
                    if (r?.mode === "mobile-tab") toast.success("PDF dibuka di tab baru — gunakan menu Print browser.");
                    else if (r?.mode === "desktop-tab") toast.success("PDF dibuka di tab baru — Ctrl/⌘+P untuk cetak.");
                    else if (r?.mode === "blocked") toast.warning("Popup diblokir — izinkan popup lalu coba lagi.");
                  } catch (err) {
                    toast.error("Gagal menyiapkan PDF. Coba lewat menu Detail → Nota.");
                  } finally {
                    btn.disabled = false;
                    btn.innerHTML = prevHTML;
                  }
                }}
              ><Printer size={14}/>Cetak Nota</button>
              {onDuplicate && <button
                type="button"
                role="menuitem"
                className="order-card-more-item"
                data-testid={`order-card-duplicate-${o.order_number}`}
                onClick={async (e)=>{
                  e.stopPropagation();
                  const ok = await notify.confirm({
                    title: "Salin ke Nota Baru?",
                    message: `Rincian produk dari ${o.order_number} akan disalin. Deadline, pembayaran, dan status produksi akan direset. Harga otomatis akan dihitung ulang dengan tarif berlaku.`,
                    primaryLabel: "Ya, Salin",
                    secondaryLabel: "Batal",
                  });
                  if (ok) onDuplicate(o);
                }}
              ><Copy size={14}/>Salin ke Nota Baru</button>}
              {wa && <a
                href={wa}
                target="_blank"
                rel="noopener noreferrer"
                role="menuitem"
                className="order-card-more-item"
                data-testid={`order-card-wa-${o.order_number}`}
                onClick={e=>e.stopPropagation()}
              ><Phone size={14}/>Hubungi WhatsApp</a>}
            </div>
          </details>}
          {/* Non-Admin Toko: tombol lama tetap muncul di footer (akses legacy) */}
          {!isAdminToko && <button
            type="button"
            className="soft-btn small-btn"
            data-testid={`order-card-print-${o.order_number}`}
            title="Cetak Nota (PDF A5)"
            onClick={async (e)=>{
              e.stopPropagation();
              const btn = e.currentTarget;
              const prevHTML = btn.innerHTML;
              btn.disabled = true;
              btn.innerHTML = "Menyiapkan…";
              try {
                const url = `${API}/orders/${encodeURIComponent(o.order_number)}/nota.pdf`;
                const r = await printPdfFromUrl(url);
                if (r?.mode === "mobile-tab") toast.success("PDF dibuka di tab baru — gunakan menu Print browser.");
                else if (r?.mode === "desktop-tab") toast.success("PDF dibuka di tab baru — Ctrl/⌘+P untuk cetak.");
                else if (r?.mode === "blocked") toast.warning("Popup diblokir — izinkan popup lalu coba lagi.");
              } catch (err) {
                toast.error("Gagal menyiapkan PDF. Coba lewat menu Detail → Nota.");
              } finally {
                btn.disabled = false;
                btn.innerHTML = prevHTML;
              }
            }}
          ><Printer size={14}/>Cetak</button>}
          {!isAdminToko && onDuplicate && <button
            type="button"
            className="soft-btn small-btn"
            data-testid={`order-card-duplicate-${o.order_number}`}
            title="Salin ke Nota Baru untuk repeat order"
            onClick={async (e)=>{
              e.stopPropagation();
              const ok = await notify.confirm({
                title: "Salin ke Nota Baru?",
                message: `Rincian produk dari ${o.order_number} akan disalin. Deadline, pembayaran, dan status produksi akan direset. Harga otomatis akan dihitung ulang dengan tarif berlaku.`,
                primaryLabel: "Ya, Salin",
                secondaryLabel: "Batal",
              });
              if (ok) onDuplicate(o);
            }}
          ><Copy size={14}/>Salin</button>}
          {!isAdminToko && wa && <a
            href={wa}
            target="_blank"
            rel="noopener noreferrer"
            className="soft-btn small-btn"
            data-testid={`order-card-wa-${o.order_number}`}
            onClick={e=>e.stopPropagation()}
          ><Phone size={14}/>Hubungi</a>}
          {/* Iter 239 — Owner-only Selesai Darurat langsung di card (reuse endpoint /complete-override). */}
          {canOwnerCompleteOverride && <button
            type="button"
            className="soft-btn warn small-btn order-card-selesai-darurat"
            data-testid={`order-card-selesai-darurat-${o.order_number}`}
            title="Owner: tandai Selesai untuk nota lama tanpa memalsukan histori produksi"
            onClick={(e)=>{ e.stopPropagation(); openOverride(o); }}
          ><CheckCircle2 size={14}/>Selesai Darurat</button>}
          {/* Iter 239 — Owner-only Ambil generic (setelah Selesai Darurat atau produk allDone). */}
          {canOwnerQuickAmbil && <button
            type="button"
            className="primary small-btn order-card-owner-ambil"
            data-testid={`order-card-owner-ambil-${o.order_number}`}
            title="Owner: tandai pesanan ini sudah diambil pelanggan"
            disabled={quickBusy === o.order_number}
            onClick={(e)=>{ e.stopPropagation(); quickPickup(o, { ownerGeneric: true }); }}
          ><Truck size={14}/>{quickBusy === o.order_number ? "Memproses…" : "Ambil"}</button>}
          {/* Iter 505 — Admin Toko: Tandai Diambil langsung (bukan Polosan).
              Syarat strict (Lunas + allDone + Selesai + bukan Diambil/Dikirim/Dibatalkan).
              Konfirmasi: "Pastikan barang sudah diserahkan". Backend tetap re-validasi. */}
          {canAdminTokoAmbil && <button
            type="button"
            className="primary small-btn order-card-adminToko-ambil"
            data-testid={`order-card-tandai-diambil-${o.order_number}`}
            title="Tandai pesanan ini sudah diambil pelanggan"
            disabled={quickBusy === o.order_number}
            onClick={(e)=>{ e.stopPropagation(); quickPickup(o, { adminTokoAmbil: true }); }}
          ><Truck size={14}/>{quickBusy === o.order_number ? "Memproses…" : "Tandai Diambil"}</button>}
          {/* Iter 230 — Quick Action "Ambil" khusus Polosan (langsung POST /pickup tanpa buka Detail). */}
          {canQuickAmbil && <button
            type="button"
            className="primary small-btn order-card-quick-ambil"
            data-testid={`order-card-quick-ambil-${o.order_number}`}
            title="Tandai Diambil langsung (Polosan)"
            disabled={quickBusy === o.order_number}
            onClick={(e)=>{ e.stopPropagation(); quickPickup(o); }}
          ><CheckCircle2 size={14}/>{quickBusy === o.order_number ? "Memproses…" : "Ambil"}</button>}
        </footer>
      </article>;
    })}
    {/* Iter 224c — Sentinel utk IntersectionObserver auto-load + tombol fallback. */}
    {hasMore && <div ref={sentinelRef} className="orders-card-loadmore" data-testid="orders-card-loadmore-wrap"
                    style={{gridColumn:"1 / -1", display:"flex", flexDirection:"column", alignItems:"center", gap:6, padding:"14px 0"}}>
      <div className="muted small" style={{fontStyle:"italic"}}>Memuat otomatis saat digulir…</div>
      <button type="button" className="soft-btn" data-testid="orders-card-loadmore"
              onClick={()=>setVisibleCount(v => Math.min(v + ORDERS_CARDS_PAGE, rows.length))}
              style={{padding:"10px 18px", fontWeight:600}}>
        Muat lebih banyak · {Math.min(ORDERS_CARDS_PAGE, rows.length - visibleCount)} nota lagi
        <span className="muted small" style={{marginLeft:8, fontWeight:500}}>({visibleCount} dari {rows.length})</span>
      </button>
    </div>}
    {!hasMore && rows.length > ORDERS_CARDS_PAGE && (
      <div className="orders-card-loadmore-end" data-testid="orders-card-loadmore-end"
           style={{gridColumn:"1 / -1", textAlign:"center", padding:"12px 0", color:"#94a3b8", fontSize:12, fontStyle:"italic"}}>
        Semua {rows.length} nota sudah dimuat.
      </div>
    )}
    {mockupPreview && <MockupPreviewModal
      orderNumber={mockupPreview.order_number}
      customerName={mockupPreview.customer_name}
      onClose={()=>setMockupPreview(null)}
    />}
    {/* Iter 239 — Modal Selesai Darurat Owner langsung dari card list (shape mirror Iter 229). */}
    {overrideOrder && <div className="modal-backdrop" role="dialog" aria-modal="true" data-testid="card-complete-override-modal">
      <div className="modal-card">
        <h3 className="modal-title">Selesai Darurat</h3>
        <p className="modal-lead">Barang ini sudah benar-benar selesai secara fisik?</p>
        <p className="modal-sub">Nota <b>{overrideOrder.order_number}</b> akan ditandai <b>Selesai</b>. Histori produksi per divisi <b>tidak</b> dipalsukan — tetap tampil apa adanya. Tindakan tercatat di Timeline Audit.</p>
        <label className="modal-field">
          <span>Alasan (wajib)</span>
          <textarea
            data-testid="card-complete-override-reason"
            value={overrideReason}
            onChange={e=>setOverrideReason(e.target.value)}
            rows={3}
            placeholder="Contoh: Rekonsiliasi data lama"
            disabled={overrideSaving}
          />
        </label>
        <div className="modal-actions">
          <button type="button" data-testid="card-complete-override-back" className="soft-btn" onClick={closeOverride} disabled={overrideSaving}>Batal</button>
          <button type="button" data-testid="card-complete-override-submit" className="primary" onClick={submitOverride} disabled={overrideSaving || !overrideReason.trim()}>{overrideSaving?"Memproses…":"Ya, Tandai Selesai"}</button>
        </div>
      </div>
    </div>}
  </div>;
}


// Iter 220 — Reset Semua Nota (Owner-only)
// Modal 3-step: (1) tampilkan preview dampak, (2) verifikasi password + frasa,

// Iter 221 — Import Nota Lama (Owner-only) wizard 6-step:
// 1. Pilih file XLSX (template resmi)  2. Preview + review error/selisih
// 3. Konfirmasi (password + phrase)  4. Countdown  5. Result  6. Riwayat batches + Rollback
function ImportNotaModal({ onClose, onDone }) {
  const [step, setStep] = useState(1);
  const [file, setFile] = useState(null);
  const [fileB64, setFileB64] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [preview, setPreview] = useState(null);
  const [pw, setPw] = useState("");
  const [phrase, setPhrase] = useState("");
  const [countdown, setCountdown] = useState(5);
  const [result, setResult] = useState(null);
  const [batches, setBatches] = useState([]);
  const [rollbackBusy, setRollbackBusy] = useState("");
  // Iter 223 — Reclassify Preview (read-only, klasifikasi nota `is_migrated=true`).
  const [reclassifyBusy, setReclassifyBusy] = useState(false);
  const [reclassifyData, setReclassifyData] = useState(null);
  const templateUrl = `${window.location.origin}/templates/template-import-nota-lama.xlsx`;

  const fmtRp = (n) => "Rp " + Number(n||0).toLocaleString("id-ID");

  const readFileAsB64 = (f) => new Promise((res, rej) => {
    const r = new FileReader();
    r.onload = () => { const s = r.result || ""; res(String(s).split(",")[1] || ""); };
    r.onerror = () => rej(r.error);
    r.readAsDataURL(f);
  });

  const doPreview = async () => {
    setErr(""); setBusy(true);
    try {
      const b64 = await readFileAsB64(file);
      setFileB64(b64);
      const fd = new FormData();
      fd.append("file", file);
      const r = await axios.post(`${API}/owner/import/nota-lama/preview`, fd, { withCredentials:true, headers:{"Content-Type":"multipart/form-data"} });
      setPreview(r.data);
      setStep(2);
    } catch (e) { setErr(e.response?.data?.detail || "Gagal parse file."); }
    finally { setBusy(false); }
  };

  useEffect(() => {
    if (step !== 4) return;
    setCountdown(5);
    const iv = setInterval(() => setCountdown(c => c <= 1 ? 0 : c - 1), 1000);
    return () => clearInterval(iv);
  }, [step]);

  const doExecute = async () => {
    setErr(""); setBusy(true);
    try {
      const r = await axios.post(`${API}/owner/import/nota-lama/execute`, {
        current_password: pw, confirm_phrase: phrase.trim(), file_b64: fileB64,
      }, { withCredentials:true });
      setResult(r.data);
      setStep(5);
      setPw(""); setPhrase("");
    } catch (e) { setErr(e.response?.data?.detail || "Gagal execute import."); }
    finally { setBusy(false); }
  };

  const loadBatches = async () => {
    try {
      const r = await axios.get(`${API}/owner/import/nota-lama/batches`, { withCredentials:true });
      setBatches(r.data.batches || []);
    } catch {}
  };

  const doRollback = async (batchId) => {
    const p = prompt("Ketik password Owner untuk rollback batch " + batchId.slice(0,8) + "...");
    if (!p) return;
    setRollbackBusy(batchId);
    try {
      const r = await axios.post(`${API}/owner/import/nota-lama/rollback`, { batch_id: batchId, current_password: p }, { withCredentials:true });
      alert(`Rollback selesai. Dihapus: ${r.data.deleted}. Di-skip: ${r.data.skipped_modified?.length || 0}`);
      await loadBatches();
    } catch (e) { alert(e.response?.data?.detail || "Rollback gagal."); }
    finally { setRollbackBusy(""); }
  };

  // Iter 223 — Panggil `POST /api/owner/migrate/reclassify/preview` (READ-ONLY, no writes).
  const doReclassifyPreview = async () => {
    setErr(""); setReclassifyBusy(true);
    try {
      const r = await axios.post(`${API}/owner/migrate/reclassify/preview`, {}, { withCredentials:true });
      setReclassifyData(r.data);
      setStep(7);
    } catch (e) { setErr(e.response?.data?.detail || "Gagal ambil preview reklasifikasi."); }
    finally { setReclassifyBusy(false); }
  };

  const backdropClick = (e) => { if (e.target === e.currentTarget && !busy) onClose(); };

  return <div className="modal-backdrop" data-testid="import-nota-backdrop" onClick={backdropClick} style={{position:"fixed",inset:0,zIndex:100,background:"rgba(15,23,42,.55)",backdropFilter:"blur(6px)",display:"flex",alignItems:"flex-start",justifyContent:"center",padding:"5vh 16px",overflowY:"auto"}}>
    <div className="modal-card" data-testid="import-nota-modal" style={{background:"#fff",width:"100%",maxWidth:720,borderTop:"4px solid #0891b2",boxShadow:"0 24px 64px rgba(15,23,42,.35)",padding:"24px 22px",fontFamily:"Inter,sans-serif"}}>
      <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:12}}>
        <div style={{width:36,height:36,background:"#cffafe",display:"grid",placeItems:"center",borderRadius:8}}><Package size={18} color="#0891b2"/></div>
        <div>
          <p style={{margin:0,fontSize:11,letterSpacing:".1em",color:"#0891b2",fontWeight:700}}>OWNER · MAINTENANCE</p>
          <h2 style={{margin:"2px 0 0",fontSize:20,fontWeight:800,color:"#0f172a",letterSpacing:"-.02em"}}>Impor Nota Lama</h2>
        </div>
      </div>
      {step===1 && <>
        <p style={{margin:"0 0 10px",fontSize:13,color:"#475569",lineHeight:1.55}}>Upload file Template Import Nota Lama.xlsx yang sudah diisi. File akan dianalisis read-only sebelum eksekusi.</p>
        <div style={{background:"#f8fafc",padding:"10px 12px",fontSize:12,color:"#475569",marginBottom:14,borderLeft:"3px solid #0891b2"}}>Belum punya template? <a href={templateUrl} download style={{color:"#0891b2",fontWeight:600}}>Unduh Template Resmi</a></div>
        <input type="file" accept=".xlsx" onChange={e=>setFile(e.target.files?.[0]||null)} data-testid="import-nota-file" style={{width:"100%",padding:"11px 12px",border:"1px solid #e2e8f0",fontSize:14,marginBottom:12}}/>
        {err && <div style={{padding:10,background:"#fee2e2",color:"#991b1b",fontSize:13,marginBottom:12}}>{err}</div>}
        <div style={{display:"flex",justifyContent:"space-between",gap:8}}>
          <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
            <button type="button" className="soft-btn" data-testid="import-nota-batches" onClick={()=>{loadBatches(); setStep(6);}}>Riwayat Batch</button>
            <button type="button" className="soft-btn" data-testid="reclassify-preview-btn" onClick={doReclassifyPreview} disabled={reclassifyBusy}>{reclassifyBusy?"Menghitung…":"Pratinjau Reklasifikasi"}</button>
          </div>
          <div style={{display:"flex",gap:8}}>
            <button type="button" className="soft-btn" onClick={onClose}>Batal</button>
            <button type="button" data-testid="import-nota-preview-btn" onClick={doPreview} disabled={!file||busy} style={{background:"#0891b2",color:"#fff",fontWeight:700,padding:"11px 16px",border:0}}>{busy?"Menganalisis…":"Preview"}</button>
          </div>
        </div>
      </>}
      {step===2 && preview && <>
        <p style={{fontSize:12,color:"#64748b",margin:"0 0 8px"}}>batch_id: <b data-testid="import-nota-batch-id" style={{fontFamily:"monospace"}}>{preview.batch_id?.slice(0,8)}...</b></p>
        <table data-testid="import-nota-summary" style={{width:"100%",borderCollapse:"collapse",fontSize:13,margin:"6px 0"}}><tbody>
          {Object.entries({"Total nota di file":preview.summary.total_nota_file,"Nota valid siap impor":preview.summary.total_nota_valid,"Error / ditolak":preview.summary.total_error,"Duplikat di database":preview.summary.hard_duplicate_db,"Soft duplicate (customer+tgl+total)":preview.summary.soft_duplicate_count,"Total produk/variasi":preview.summary.total_produk,"Total pembayaran":preview.summary.total_pembayaran,"Total nominal penjualan":fmtRp(preview.summary.total_nominal_penjualan),"Total uang diterima":fmtRp(preview.summary.total_uang_diterima),"Total piutang":fmtRp(preview.summary.total_piutang),"Nota historis":preview.summary.historis,"Nota aktif (needs_review)":preview.summary.aktif_needs_review,"Nota dengan selisih":preview.summary.mismatch_count}).map(([k,v])=><tr key={k}><td style={{padding:"6px 0",color:"#64748b"}}>{k}</td><td style={{textAlign:"right",fontWeight:700}}>{v}</td></tr>)}
        </tbody></table>
        <details style={{marginTop:10,fontSize:12}}><summary style={{cursor:"pointer",fontWeight:600}}>Detail per nota ({preview.notes.length})</summary>
          <div style={{maxHeight:260,overflowY:"auto",marginTop:8,border:"1px solid #e2e8f0",padding:6}}>
            {preview.notes.map(n=><div key={n.no_nota+n.source_row} data-testid={`import-note-${n.no_nota}`} style={{padding:"6px 4px",borderBottom:"1px solid #f1f5f9",fontSize:11}}>
              <b>{n.no_nota}</b> · {n.customer_name} · <span style={{color:n.historical?"#166534":"#d97706"}}>{n.order_status}</span>
              {n.needs_review && <span style={{marginLeft:6,padding:"1px 6px",background:"#fef3c7",color:"#92400e",fontSize:10}}>REVIEW</span>}
              {n.selisih && <span style={{marginLeft:6,padding:"1px 6px",background:"#fee2e2",color:"#991b1b",fontSize:10}}>SELISIH</span>}
              {n.errors?.length>0 && <span style={{marginLeft:6,padding:"1px 6px",background:"#fecaca",color:"#7f1d1d",fontSize:10}}>ERROR</span>}
              <div style={{fontFamily:"monospace",fontSize:10,color:"#64748b",marginTop:2}}>legacy: total={fmtRp(n.legacy_total)} paid={fmtRp(n.legacy_paid)} → computed: total={fmtRp(n.computed_total)} paid={fmtRp(n.computed_paid)} sisa={fmtRp(n.computed_remaining)}</div>
              {n.errors?.map((e,i)=><div key={i} style={{color:"#991b1b",fontSize:10,marginLeft:8}}>✗ {e}</div>)}
              {n.warnings?.map((w,i)=><div key={i} style={{color:"#92400e",fontSize:10,marginLeft:8}}>⚠ {w}</div>)}
            </div>)}
          </div>
        </details>
        <div style={{display:"flex",gap:8,justifyContent:"flex-end",marginTop:14}}>
          <button type="button" className="soft-btn" onClick={()=>{setStep(1); setPreview(null);}}>Kembali</button>
          <button type="button" data-testid="import-nota-next-2" onClick={()=>setStep(3)} disabled={preview.summary.total_nota_valid===0} style={{background:preview.summary.total_nota_valid===0?"#94a3b8":"#0891b2",color:"#fff",fontWeight:700,padding:"11px 16px",border:0}}>Lanjut Konfirmasi</button>
        </div>
      </>}
      {step===3 && <>
        <p style={{margin:"0 0 12px",fontSize:13,color:"#475569"}}>Verifikasi identitas + niat.</p>
        <label style={{display:"block",fontSize:12,color:"#64748b",marginBottom:6,fontWeight:600}}>Password Owner <b style={{color:"#dc2626"}}>*</b></label>
        <input type="password" value={pw} onChange={e=>setPw(e.target.value)} data-testid="import-nota-pw" style={{width:"100%",padding:"11px 12px",border:"1px solid #e2e8f0",fontSize:14,marginBottom:12}}/>
        <label style={{display:"block",fontSize:12,color:"#64748b",marginBottom:6,fontWeight:600}}>Ketik: <b style={{color:"#0891b2"}}>IMPORT NOTA LAMA TAMFARIS</b></label>
        <input type="text" value={phrase} onChange={e=>setPhrase(e.target.value)} data-testid="import-nota-phrase" placeholder="IMPORT NOTA LAMA TAMFARIS" style={{width:"100%",padding:"11px 12px",border:"1px solid #e2e8f0",fontSize:14,marginBottom:12,fontFamily:"monospace"}}/>
        {err && <div style={{padding:10,background:"#fee2e2",color:"#991b1b",fontSize:13,marginBottom:12}}>{err}</div>}
        <div style={{display:"flex",justifyContent:"flex-end",gap:8}}>
          <button type="button" className="soft-btn" onClick={()=>setStep(2)}>Kembali</button>
          <button type="button" data-testid="import-nota-next-3" onClick={()=>{ if(phrase.trim()!=="IMPORT NOTA LAMA TAMFARIS"){setErr("Frasa harus persis.");return;} if(pw.length<4){setErr("Password wajib.");return;} setErr(""); setStep(4);}} style={{background:"#0891b2",color:"#fff",fontWeight:700,padding:"11px 16px",border:0}}>Lanjut Countdown</button>
        </div>
      </>}
      {step===4 && <>
        <p style={{margin:"0 0 12px",fontSize:13,color:"#475569"}}>Tombol aktif dalam <b data-testid="import-nota-countdown">{countdown}</b> detik.</p>
        <div style={{textAlign:"center",padding:"22px 0"}}><div style={{fontSize:64,fontWeight:800,color:countdown>0?"#0891b2":"#166534"}}>{countdown}</div></div>
        {err && <div style={{padding:10,background:"#fee2e2",color:"#991b1b",fontSize:13,marginBottom:12}}>{err}</div>}
        <div style={{display:"flex",justifyContent:"flex-end",gap:8}}>
          <button type="button" className="soft-btn" onClick={()=>setStep(3)} disabled={busy}>Batal</button>
          <button type="button" data-testid="import-nota-execute" onClick={doExecute} disabled={countdown>0||busy} style={{background:countdown>0?"#94a3b8":"#0891b2",color:"#fff",fontWeight:800,padding:"12px 18px",border:0}}>{busy?"Mengimport…":"IMPORT SEKARANG"}</button>
        </div>
      </>}
      {step===5 && result && <>
        <div style={{padding:"14px 12px",background:"#dcfce7",border:"1px solid #86efac",marginBottom:14}}>
          <p style={{margin:0,fontSize:13,color:"#166534",fontWeight:600}}>Import selesai. {result.inserted} nota tersimpan.</p>
          <p style={{margin:"6px 0 0",fontSize:11,color:"#166534",fontFamily:"monospace"}}>batch_id: <b data-testid="import-nota-result-batch">{result.batch_id}</b></p>
        </div>
        {result.errored?.length>0 && <details style={{marginBottom:12}}><summary style={{color:"#991b1b",fontWeight:600}}>Error ({result.errored.length})</summary>
          <div style={{fontSize:12,maxHeight:200,overflowY:"auto",padding:8}}>{result.errored.map((e,i)=><div key={i}>{e.no_nota}: {e.errors.join(", ")}</div>)}</div>
        </details>}
        <div style={{display:"flex",justifyContent:"flex-end"}}>
          <button type="button" data-testid="import-nota-done" onClick={onDone} style={{background:"#0f172a",color:"#fff",fontWeight:700,padding:"11px 16px",border:0}}>Selesai</button>
        </div>
      </>}
      {step===6 && <>
        <p style={{margin:"0 0 10px",fontSize:13,color:"#475569"}}>Riwayat 50 batch import terakhir. Rollback hanya menghapus nota migrasi yang belum diedit manual.</p>
        <div style={{maxHeight:400,overflowY:"auto",border:"1px solid #e2e8f0"}}>
          {batches.length===0 && <p style={{padding:12,fontSize:13,color:"#64748b"}}>Belum ada batch impor.</p>}
          {batches.map(b=><div key={b.id} data-testid={`import-batch-${b.id.slice(0,8)}`} style={{padding:"10px 12px",borderBottom:"1px solid #f1f5f9",fontSize:12}}>
            <div style={{display:"flex",justifyContent:"space-between",marginBottom:4}}>
              <b style={{fontFamily:"monospace"}}>{b.id.slice(0,8)}...</b>
              <span style={{padding:"1px 6px",background:b.status==="rolled_back"?"#fee2e2":"#dcfce7",color:b.status==="rolled_back"?"#991b1b":"#166534",fontSize:10,fontWeight:600}}>{b.status.toUpperCase()}</span>
            </div>
            <div style={{color:"#64748b",fontSize:11}}>{b.at?.slice(0,19)} · {b.owner_name}</div>
            <div style={{color:"#64748b",fontSize:11}}>Inserted: {b.inserted?.length || 0}{b.rolled_back_count?` · Rolled back: ${b.rolled_back_count}`:""}</div>
            {b.status==="done" && <button type="button" data-testid={`import-rollback-${b.id.slice(0,8)}`} onClick={()=>doRollback(b.id)} disabled={rollbackBusy===b.id} style={{marginTop:6,padding:"6px 12px",background:"#dc2626",color:"#fff",fontSize:11,fontWeight:600,border:0}}>{rollbackBusy===b.id?"Rollback…":"Rollback"}</button>}
          </div>)}
        </div>
        <div style={{display:"flex",justifyContent:"flex-end",marginTop:10}}>
          <button type="button" className="soft-btn" onClick={()=>setStep(1)}>Kembali</button>
        </div>
      </>}
      {step===7 && reclassifyData && <>
        <p style={{margin:"0 0 6px",fontSize:13,color:"#475569",lineHeight:1.55}}>
          <b>READ-ONLY.</b> Simulasi klasifikasi ulang nota migrasi berdasarkan data legacy (LUNAS / DP / BELUM BAYAR / BATAL). Tidak mengubah data — hanya menunjukkan rencana perubahan status.
        </p>
        <div data-testid="reclassify-summary" style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:8,margin:"10px 0"}}>
          <div style={{padding:"10px 12px",background:"#f8fafc",borderLeft:"3px solid #0891b2"}}>
            <div style={{fontSize:11,color:"#64748b",letterSpacing:".05em"}}>TOTAL NOTA MIGRASI</div>
            <div style={{fontSize:20,fontWeight:800,color:"#0f172a"}} data-testid="reclassify-total">{reclassifyData.total_migrated?.toLocaleString("id-ID")}</div>
          </div>
          <div style={{padding:"10px 12px",background:"#fef9c3",borderLeft:"3px solid #ca8a04"}}>
            <div style={{fontSize:11,color:"#713f12",letterSpacing:".05em"}}>PERLU DIUBAH</div>
            <div style={{fontSize:20,fontWeight:800,color:"#713f12"}} data-testid="reclassify-changes">{reclassifyData.changes_needed?.toLocaleString("id-ID")}</div>
          </div>
          <div style={{padding:"10px 12px",background:"#dcfce7",borderLeft:"3px solid #16a34a"}}>
            <div style={{fontSize:11,color:"#166534",letterSpacing:".05em"}}>SUDAH TEPAT</div>
            <div style={{fontSize:20,fontWeight:800,color:"#166534"}} data-testid="reclassify-nochange">{reclassifyData.no_change_needed?.toLocaleString("id-ID")}</div>
          </div>
        </div>
        <div style={{fontSize:12,color:"#64748b",marginBottom:6,fontWeight:600,letterSpacing:".05em"}}>DISTRIBUSI PER KATEGORI</div>
        <div style={{maxHeight:280,overflowY:"auto",border:"1px solid #e2e8f0"}}>
          {Object.entries(reclassifyData.buckets || {}).map(([cat, b]) => (
            <div key={cat} data-testid={`reclassify-bucket-${cat.replace(/\s+/g,"-").toLowerCase()}`} style={{padding:"10px 12px",borderBottom:"1px solid #f1f5f9",fontSize:12}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:4}}>
                <b style={{color:"#0f172a"}}>{cat}</b>
                <span style={{padding:"2px 8px",background:"#e0f2fe",color:"#075985",fontWeight:700,fontSize:11}}>{b.count?.toLocaleString("id-ID")} nota</span>
              </div>
              <div style={{color:"#64748b",fontSize:11,marginBottom:4}}>Target status: <b style={{color:"#0891b2"}}>{b.target_status}</b></div>
              {b.note && <div style={{fontSize:11,color:"#b45309",background:"#fef3c7",padding:"4px 8px",marginTop:4,fontStyle:"italic"}}>⚠ {b.note}</div>}
              {b.current_breakdown && Object.keys(b.current_breakdown).length > 0 && (
                <div style={{marginTop:4,fontSize:11,color:"#64748b"}}>
                  Status saat ini: {Object.entries(b.current_breakdown).map(([s,n])=>`${s} (${n})`).join(" · ")}
                </div>
              )}
              {b.samples && b.samples.length > 0 && (
                <details style={{marginTop:6}}><summary style={{cursor:"pointer",fontSize:11,color:"#475569",fontWeight:600}}>Contoh nota ({b.samples.length})</summary>
                  <div style={{marginTop:4,fontSize:11,fontFamily:"monospace"}}>
                    {b.samples.map((s,i)=>(
                      <div key={i} style={{padding:"3px 0",borderTop:i>0?"1px dashed #e2e8f0":"none"}}>
                        <b>{s.order_number}</b> · {s.current_status} → <b style={{color:"#0891b2"}}>{s.target_status}</b>
                        {s.reasons?.length > 0 && <div style={{color:"#64748b",fontSize:10}}>alasan: {s.reasons.join("; ")}</div>}
                      </div>
                    ))}
                  </div>
                </details>
              )}
            </div>
          ))}
        </div>
        {reclassifyData.notes_important && reclassifyData.notes_important.length > 0 && (
          <div style={{marginTop:10,padding:"8px 12px",background:"#fef3c7",borderLeft:"3px solid #d97706",fontSize:11,color:"#78350f",lineHeight:1.6}}>
            <b>Catatan penting:</b>
            <ul style={{margin:"4px 0 0 16px",padding:0}}>
              {reclassifyData.notes_important.map((n,i)=><li key={i}>{n}</li>)}
            </ul>
          </div>
        )}
        <div style={{display:"flex",justifyContent:"space-between",marginTop:10,gap:8}}>
          <button type="button" className="soft-btn" onClick={()=>setStep(1)}>Kembali</button>
          <div style={{fontSize:11,color:"#64748b",alignSelf:"center",fontStyle:"italic"}}>Pratinjau ini read-only. Tombol execute belum tersedia — menunggu approval Owner atas aturan di atas.</div>
        </div>
      </>}
    </div>
  </div>;
}


// (3) countdown 5 detik → eksekusi. Setelah selesai tampilkan ringkasan record dihapus.
function ResetNotaModal({ onClose, onDone }) {
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(true);
  const [preview, setPreview] = useState(null);
  const [err, setErr] = useState("");
  const [pw, setPw] = useState("");
  const [phrase, setPhrase] = useState("");
  const [countdown, setCountdown] = useState(5);
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const r = await axios.post(`${API}/owner/reset-transactions/preview`, {}, { withCredentials:true });
        if (alive) { setPreview(r.data); setLoading(false); }
      } catch (e) {
        if (alive) { setErr(e.response?.data?.detail || "Gagal memuat preview."); setLoading(false); }
      }
    })();
    return () => { alive = false; };
  }, []);

  useEffect(() => {
    if (step !== 3) return;
    setCountdown(5);
    const iv = setInterval(() => setCountdown(c => c <= 1 ? 0 : c - 1), 1000);
    return () => clearInterval(iv);
  }, [step]);

  const fmtRp = (n) => "Rp " + Number(n||0).toLocaleString("id-ID");

  const goToConfirm = () => {
    setErr("");
    if (!preview) return;
    setStep(2);
  };
  const goToCountdown = () => {
    setErr("");
    if (pw.length < 4) { setErr("Password Owner wajib diisi."); return; }
    if (phrase.trim() !== "RESET NOTA TAMFARIS") { setErr("Frasa konfirmasi tidak cocok. Ketik persis: RESET NOTA TAMFARIS"); return; }
    setStep(3);
  };
  const execute = async () => {
    setErr(""); setBusy(true);
    try {
      const r = await axios.post(`${API}/owner/reset-transactions/execute`, {
        current_password: pw,
        confirm_phrase: phrase.trim(),
      }, { withCredentials:true });
      setResult(r.data);
      setStep(4);
      // Clear sensitive state
      setPw(""); setPhrase("");
    } catch (e) {
      setErr(e.response?.data?.detail || "Gagal menjalankan reset.");
    } finally { setBusy(false); }
  };

  const backdropClick = (e) => { if (e.target === e.currentTarget && !busy) onClose(); };

  return <div className="modal-backdrop" data-testid="reset-nota-backdrop" onClick={backdropClick} style={{position:"fixed",inset:0,zIndex:100,background:"rgba(15,23,42,.55)",backdropFilter:"blur(6px)",display:"flex",alignItems:"flex-start",justifyContent:"center",padding:"5vh 16px",overflowY:"auto"}}>
    <div className="modal-card" data-testid="reset-nota-modal" style={{background:"#fff",width:"100%",maxWidth:560,borderTop:"4px solid #dc2626",boxShadow:"0 24px 64px rgba(15,23,42,.35)",padding:"24px 22px",fontFamily:"Inter,sans-serif"}}>
      <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:12}}>
        <div style={{width:36,height:36,background:"#fee2e2",display:"grid",placeItems:"center",borderRadius:8}}>
          <Trash2 size={18} color="#dc2626"/>
        </div>
        <div>
          <p style={{margin:0,fontSize:11,letterSpacing:".1em",color:"#dc2626",fontWeight:700}}>OWNER · MAINTENANCE</p>
          <h2 style={{margin:"2px 0 0",fontSize:20,fontWeight:800,color:"#0f172a",letterSpacing:"-.02em"}}>Reset Semua Nota</h2>
        </div>
      </div>

      {step === 1 && <>
        {loading && <p className="muted" data-testid="reset-nota-loading">Memuat dampak…</p>}
        {err && !loading && <div className="alert warn" data-testid="reset-nota-err" style={{padding:12,background:"#fee2e2",color:"#991b1b",fontSize:13,marginBottom:12}}>{err}</div>}
        {preview && !loading && <>
          <p style={{margin:"0 0 10px",fontSize:13,color:"#475569",lineHeight:1.55}}>Aksi ini akan <b style={{color:"#dc2626"}}>menghapus permanen</b> semua data transaksi berikut. Master data, users, operator, PIN, settings, secrets, dan nomor urut nota <b>tidak</b> disentuh. Snapshot cadangan otomatis disimpan sebelum penghapusan.</p>
          <table data-testid="reset-nota-preview" style={{width:"100%",borderCollapse:"collapse",fontSize:13,margin:"10px 0"}}>
            <tbody>
              <tr><td style={{padding:"7px 0",color:"#64748b"}}>Total Nota</td><td style={{textAlign:"right",fontWeight:700}} data-testid="preview-orders">{preview.orders.total} <span className="muted small">({preview.orders.aktif} aktif)</span></td></tr>
              <tr><td style={{padding:"7px 0",color:"#64748b"}}>Omzet</td><td style={{textAlign:"right",fontWeight:700}} data-testid="preview-omzet">{fmtRp(preview.money.omzet_rp)}</td></tr>
              <tr><td style={{padding:"7px 0",color:"#64748b"}}>Sudah Dibayar</td><td style={{textAlign:"right",fontWeight:700}} data-testid="preview-paid">{fmtRp(preview.money.sudah_dibayar_rp)}</td></tr>
              <tr><td style={{padding:"7px 0",color:"#64748b"}}>Piutang</td><td style={{textAlign:"right",fontWeight:700,color:"#dc2626"}} data-testid="preview-piutang">{fmtRp(preview.money.piutang_rp)}</td></tr>
              <tr><td style={{padding:"7px 0",color:"#64748b"}}>SPK / Baris Produk</td><td style={{textAlign:"right",fontWeight:700}} data-testid="preview-spk">{preview.spk.total_baris}</td></tr>
              <tr><td style={{padding:"7px 0",color:"#64748b"}}>Antrean Produksi Aktif</td><td style={{textAlign:"right",fontWeight:700}} data-testid="preview-queue">{preview.spk.antrian_aktif}</td></tr>
              <tr><td style={{padding:"7px 0",color:"#64748b"}}>Tutup Kas</td><td style={{textAlign:"right"}} data-testid="preview-cash">{preview.cash_closings}</td></tr>
              <tr><td style={{padding:"7px 0",color:"#64748b"}}>Attachment / File Produk</td><td style={{textAlign:"right"}} data-testid="preview-files">{preview.product_files}</td></tr>
              <tr><td style={{padding:"7px 0",color:"#64748b"}}>Audit Log Terkait Order</td><td style={{textAlign:"right"}} data-testid="preview-audit">{preview.audit_logs.yang_akan_dihapus} <span className="muted small">/ total {preview.audit_logs.total}</span></td></tr>
            </tbody>
          </table>
          <div style={{background:"#f8fafc",border:"1px dashed #cbd5e1",padding:"10px 12px",fontSize:12,color:"#475569",lineHeight:1.5,margin:"6px 0 14px"}}>
            <b>Tetap disimpan:</b> {preview.preserved.users} user · {preview.preserved.operators} operator · {preview.preserved.master_products} master produk · {preview.preserved.master_sizes} ukuran · {preview.preserved.master_payments} metode pembayaran · counters nomor nota utuh.
          </div>
          <div style={{display:"flex",gap:8,justifyContent:"flex-end",marginTop:6}}>
            <button type="button" className="soft-btn" data-testid="reset-nota-cancel-1" onClick={onClose}>Batal</button>
            <button type="button" data-testid="reset-nota-next-1" onClick={goToConfirm} style={{background:"#dc2626",color:"#fff",fontWeight:700,padding:"11px 16px",border:0}}>Lanjut</button>
          </div>
        </>}
      </>}

      {step === 2 && <>
        <p style={{margin:"0 0 12px",fontSize:13,color:"#475569",lineHeight:1.55}}>Verifikasi identitas & niat. Setelah lanjut, ada hitung mundur 5 detik sebelum tombol final aktif.</p>
        <label style={{display:"block",fontSize:12,color:"#64748b",marginBottom:6,fontWeight:600}}>Password Owner saat ini <b style={{color:"#dc2626"}}>*</b></label>
        <input type="password" value={pw} onChange={e=>setPw(e.target.value)} autoComplete="current-password" data-testid="reset-nota-password" style={{width:"100%",padding:"11px 12px",border:"1px solid #e2e8f0",fontSize:14,marginBottom:12}}/>
        <label style={{display:"block",fontSize:12,color:"#64748b",marginBottom:6,fontWeight:600}}>Ketik frasa: <b style={{color:"#dc2626"}}>RESET NOTA TAMFARIS</b></label>
        <input type="text" value={phrase} onChange={e=>setPhrase(e.target.value)} autoComplete="off" data-testid="reset-nota-phrase" placeholder="RESET NOTA TAMFARIS" style={{width:"100%",padding:"11px 12px",border:"1px solid #e2e8f0",fontSize:14,marginBottom:12,fontFamily:"monospace"}}/>
        {err && <div className="alert warn" data-testid="reset-nota-step2-err" style={{padding:10,background:"#fee2e2",color:"#991b1b",fontSize:13,marginBottom:12}}>{err}</div>}
        <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
          <button type="button" className="soft-btn" data-testid="reset-nota-back-2" onClick={()=>{setStep(1); setErr("");}}>Kembali</button>
          <button type="button" data-testid="reset-nota-next-2" onClick={goToCountdown} style={{background:"#dc2626",color:"#fff",fontWeight:700,padding:"11px 16px",border:0}}>Lanjut ke Countdown</button>
        </div>
      </>}

      {step === 3 && <>
        <p style={{margin:"0 0 12px",fontSize:13,color:"#475569",lineHeight:1.55}}>Tombol final akan aktif dalam <b data-testid="reset-nota-countdown">{countdown}</b> detik. Anda masih bisa membatalkan.</p>
        <div style={{textAlign:"center",padding:"22px 0"}}>
          <div style={{fontSize:64,fontWeight:800,color:countdown>0?"#dc2626":"#166534",fontFamily:"Manrope,sans-serif",lineHeight:1}}>{countdown}</div>
        </div>
        {err && <div className="alert warn" data-testid="reset-nota-step3-err" style={{padding:10,background:"#fee2e2",color:"#991b1b",fontSize:13,marginBottom:12}}>{err}</div>}
        <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
          <button type="button" className="soft-btn" data-testid="reset-nota-cancel-3" onClick={()=>{setStep(2); setErr("");}} disabled={busy}>Batal</button>
          <button type="button" data-testid="reset-nota-execute" onClick={execute} disabled={countdown>0 || busy} style={{background:countdown>0?"#94a3b8":"#dc2626",color:"#fff",fontWeight:800,padding:"12px 18px",border:0,cursor:countdown>0?"not-allowed":"pointer"}}>
            {busy ? "Memproses…" : "RESET SEKARANG"}
          </button>
        </div>
      </>}

      {step === 4 && result && <>
        <div style={{padding:"14px 12px",background:"#dcfce7",border:"1px solid #86efac",marginBottom:14}}>
          <p style={{margin:0,fontSize:13,color:"#166534",lineHeight:1.5,fontWeight:600}}>{result.message}</p>
          <p style={{margin:"6px 0 0",fontSize:11,color:"#166534",fontFamily:"monospace"}}>snapshot_id: <b data-testid="reset-nota-snapshot-id">{result.snapshot_id}</b></p>
        </div>
        <p style={{margin:"0 0 8px",fontSize:13,color:"#475569",fontWeight:600}}>Jumlah record dihapus per collection:</p>
        <table data-testid="reset-nota-deleted-counts" style={{width:"100%",borderCollapse:"collapse",fontSize:13,margin:"6px 0 14px"}}>
          <tbody>
            {Object.entries(result.deleted_counts).map(([col,n]) => <tr key={col}><td style={{padding:"6px 0",color:"#64748b"}}>{col}</td><td style={{textAlign:"right",fontWeight:700}}>{n}</td></tr>)}
          </tbody>
        </table>
        <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
          <button type="button" data-testid="reset-nota-done" onClick={onDone} style={{background:"#0f172a",color:"#fff",fontWeight:700,padding:"11px 16px",border:0}}>Selesai</button>
        </div>
      </>}
    </div>
  </div>;
}




// Iter 217 — Router shell minimalis. Menghindari React Router demi menjaga bundle size &
// menghindari refactor besar App.js (per larangan user). Deteksi path via window.location.pathname
// hanya sekali saat mount; token setup-password otomatis di-parse oleh SetupPasswordPage.
function AppRoot() {
  const path = typeof window !== "undefined" ? window.location.pathname : "/";
  if (path === "/setup-password" || path.startsWith("/setup-password/")) {
    return <SetupPasswordPage />;
  }
  if (path === "/owner-claim" || path.startsWith("/owner-claim/")) {
    return <OwnerClaimPage />;
  }
  return <App />;
}

export default AppRoot;
